<template>
  <div>
    <div style="margin-top: 20px">
      <slot name="datetime"></slot>
    </div>

    <div v-if="campaign_component === 'list'">
      <div style="margin-top: 30px">
        <div v-if="campaign_type === 'product_homepage'">
          <el-select size="mini" style="width: 350px" multiple filterable collapse-tags class="fix-collapse-tags"
                     v-model="product_placement_list" @visible-change="(e) => {if (!e) m__get_ads_data()}">
            <el-option value="all__search_product" :label="$t('ads.search_within_all')"></el-option>
            <el-option value="all__targeting" :label="$t('ads.discovery_within_all')"></el-option>
            <el-option value="search_product" :label="$t('ads.search')"></el-option>
            <el-option value="targeting" :label="$t('ads.discovery')"></el-option>
          </el-select>
        </div>

        <ComponentMetric :shop="shop"
                         :metrics="c__metrics"
                         :reports="reports"
                         :show_checkout="true"
                         :campaign_type="campaign_type"
                         :is_compare="is_compare_campaign"
                         :compare_metrics="compare_metrics"
                         :compare_reports="compare_reports"
                         :agency_file="agency_file_selected"
                         :show_cancelled="true">
        </ComponentMetric>
      </div>

      <!-- todo: new version      -->
      <!--      <template v-if="array_to_set(new_buttons_fixed_list).has($store.state.userInfo.username)">-->
      <div v-if="is_full" style="margin-top: 20px">
        <div class="text-right">
          <el-button v-if="m__check_marketing_package('add_keywords_x')" type="primary" size="mini"
                     icon="el-icon-plus" @click="m__handle_multiple_command('add_keyword')">
            {{ $t('ads.mass_add_keywords') }}
          </el-button>
          <el-button v-if="m__check_marketing_package('auto_campaign')" size="mini"
                     @click="m__show_auto_condition_action_dialog()">
            {{ $t('ads.conditional_configuration') }}
          </el-button>
          <template v-if="m__check_marketing_package('auto_campaign') && c__has_advanced_ads">
          </template>
          &nbsp;&nbsp;
          <el-tooltip placement="top" effect="light"
                      :disabled="m__check_marketing_package('auto_campaign') && c__has_advanced_ads">
            <div slot="content" style="line-height: 20px; font-size: 13px">
              Bạn cần đăng ký gói Atosa 6 tháng trở lên để sử dụng tính năng này.
              <br>
              Vui lòng liên hệ hotline CSKH
              <a href="tel:0878 354 999" target="_blank" style="font-size: 13px">0878 354 999</a>
              để được hỗ trợ nâng cấp.
            </div>
            <el-dropdown @command="m__handle_multiple_command" trigger="click">
              <el-button size="mini"
                         :disabled="!shopee_shop.selected || loading.get_campaigns || !m__check_marketing_package('auto_campaign') || !c__has_advanced_ads">
                {{ $t('ads.setup_auto_config') }}
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <template
                  v-for="item in setup_auto_config_dropdown_item_list.filter(i => !i.type || campaign_type === 'new_cpc_homepage' || i.type === campaign_type)">
                  <el-dropdown-item
                    v-if="(!item.require_vit_ads || (item.require_vit_ads && c__has_vit_ads)) && !item.hide"
                    :command="item.value" :divided="item.divided">
                    <span :style="item.is_bold ? 'font-weight: bold' : ''">
                      {{ item.label }}
                    </span>
                  </el-dropdown-item>
                </template>
              </el-dropdown-menu>
            </el-dropdown>
          </el-tooltip>
          &nbsp;&nbsp;
          <el-tooltip placement="top" effect="light"
                      :disabled="m__check_marketing_package('auto_campaign') && c__has_advanced_ads">
            <div slot="content" style="line-height: 20px; font-size: 13px">
              Bạn cần đăng ký gói Atosa 6 tháng trở lên để sử dụng tính năng này.
              <br>
              Vui lòng liên hệ hotline CSKH
              <a href="tel:0878 354 999" target="_blank" style="font-size: 13px">0878 354 999</a>
              để được hỗ trợ nâng cấp.
            </div>
            <el-dropdown @command="m__handle_multiple_command" trigger="click">
              <el-button size="mini"
                         :disabled="!shopee_shop.selected || loading.get_campaigns || !m__check_marketing_package('auto_campaign') || !c__has_advanced_ads">
                {{ $t('ads.mass_adjust') }}
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <template
                  v-for="item in mass_adjust_item_list.filter(i => !i.type || campaign_type === 'new_cpc_homepage' || i.type === campaign_type)">
                  <el-dropdown-item v-if="!item.require_vit_ads || (item.require_vit_ads && c__has_vit_ads)"
                                    :command="item.value" :divided="item.divided">{{ item.label }}
                  </el-dropdown-item>
                </template>
              </el-dropdown-menu>
            </el-dropdown>
          </el-tooltip>
          &nbsp;&nbsp;
          <el-button size="mini" @click="m__show_compare_campaign">
            {{ $t('base.compare_data') }}
            <strong style="font-weight: 700" v-if="is_compare_campaign" class="text-success">[ ON ]</strong>
            <strong style="font-weight: 700" v-else class="text-danger">[ OFF ]</strong>
          </el-button>
          <el-button size="mini" @click="m__show_filter_dialog"
                     :disabled="!shopee_shop.selected">
            <i class="ti-panel"></i>&nbsp; {{ $t('base.filter') }}
            <strong style="font-weight: 700" v-if="filter.some(i => i.value)" class="text-success">[ ON ]</strong>
            <strong style="font-weight: 700" v-else class="text-danger">[ OFF ]</strong>
          </el-button>
          <el-button size="mini" icon="el-icon-download" @click="m__export_shopee" :disabled="!shopee_shop.selected"
                     :loading="loading.marketing_report_file">
            {{ $t('base.export_data') }}
          </el-button>
          <el-button size="mini" @click="m__toggle_select_index" :disabled="!shopee_shop.selected">
            <i :class="show_dialog.select_index ? 'el-icon-caret-top' : 'el-icon-caret-bottom'"></i>
            {{ $t('ads.select_metrics') }}
          </el-button>
        </div>
      </div>

      <div v-if="show_dialog.select_index"
           style="margin-top: 10px; border: 1px solid #e5e5e5;border-radius: 4px; padding: 20px 10px 10px 10px">
        <div v-for="flag in flag_list" :key="flag.value"
             style="width: 20%; float: left; margin-bottom: 10px; font-size: 13px">
          <el-checkbox size="mini" v-model="flag.checked" @change="m__update_flag_list" class="cbx-black"
                       :disabled="flag.checked === true && flag_list.filter(i => i.checked === true).length <= 1">
            &nbsp;{{ flag.label }}
          </el-checkbox>
        </div>
        <div style="clear: both!important;"></div>

        <br>

        <div v-for="flag in atosa_flag_list" :key="flag.value"
             style="width: 20%; float: left; margin-bottom: 10px; font-size: 13px">
          <el-checkbox size="mini" v-model="flag.checked" @change="m__set_atosa_flag_list" class="cbx-black">
            &nbsp;{{ flag.label }}
          </el-checkbox>
        </div>
        <div style="clear: both!important;"></div>
      </div>

      <div v-if="is_full" style="margin-top: 40px; padding-left: 10px; padding-bottom: 10px">
        <el-row>
          <el-col :sm="9">
            <strong v-if="loading.get_campaigns" class="text-danger" style="font-size: 14px">
              <i class="el-icon-loading"></i> {{ $t('ads.loading_campaign_list') }}
            </strong>
            <strong
              v-else-if="m__is_checked_all() && c__show_filter_and_group_campaign_list.length > campaign_filter.page_size"
              style="font-size: 14px!important;">
              <a href="javascript:void(0)" style="font-weight: 700; font-size: 13px" class="text-primary"
                 @click="m__checked_by_page">
                {{ $t('base.select') }}
                {{ c__show_display_campaign_list.length }}
                {{ $t('base.x_on_current_page', { x: $t('base.campaign') }) }}
              </a>
            </strong>
            <strong v-else style="font-size: 14px!important;">
              {{ $t('ads.campaign_list') }}
              (<a style="font-size: 14px!important;" href="javascript:void(0)" class="text-primary"
                  @click="m__get_ads_data"> {{ $t('base.reload_data') }} </a>)
            </strong>
          </el-col>
          <el-col :sm="5" style="padding-left: 10px; text-align: right">
            <el-cascader
              size="mini"
              class="full-w"
              v-model="cascader_value"
              :options="cascader_options"
              :props="{ expandTrigger: 'hover' }"
              :placeholder="$t('select.category')"
              clearable @change="m__on_cascader_change"></el-cascader>
            <!--            <template v-if="array_to_set(filter_by_categories_fixed_list).has($store.state.userInfo.username)">-->
            <!--            </template>-->
            <!--            <template v-else>&nbsp;</template>-->
          </el-col>
          <el-col :sm="5" style="padding-left: 10px">
            <el-select
              size="mini" value="" class="full-w" v-model="campaign_optimizer_selected" clearable>
              <el-option-group :label="$t('base.base')">
                <el-option value="" :label="$t('ads.all')"></el-option>
                <el-option value="lowest" :label="$t('ads.with_very_low_performance')"></el-option>
                <el-option value="low" :label="$t('ads.with_low_performance')"></el-option>
                <el-option value="medium" :label="$t('ads.with_average_performance')"></el-option>
                <el-option value="high" :label="$t('ads.with_high_performance')"></el-option>
                <el-option value="duplicated_campaigns" :label="$t('ads.duplicated_campaigns')"></el-option>
              </el-option-group>
              <el-option-group :label="$t('ads.automatic_configuration')">
                <el-option value="auto_condition_action"
                           :label="$t('base.applying_x', {x: $t('ads.conditional_configuration')})"></el-option>
                <el-option value="not_auto_condition_action"
                           :label="$t('base.not_applying_x', {x: $t('ads.conditional_configuration')})"></el-option>
                <el-option value="auto_optimize"
                           :label="$t('base.applying_x', {x: $t('ads.optimize_based_on_cir_advanced')})"></el-option>
                <el-option value="not_auto_optimize"
                           :label="$t('base.not_applying_x', {x: $t('ads.optimize_based_on_cir_advanced')})"></el-option>
                <el-option value="auto_quota"
                           :label="$t('base.applying_x', {x: $t('ads.automatic_budget')})"></el-option>
                <el-option value="not_auto_quota"
                           :label="$t('base.not_applying_x', {x: $t('ads.automatic_budget')})"></el-option>
                <el-option value="atosa_agent"
                           :label="$t('base.applying_x', {x: 'Atosa Agent'})"></el-option>
                <el-option value="not_atosa_agent"
                           :label="$t('base.not_applying_x', {x: 'Atosa Agent'})"></el-option>
              </el-option-group>
            </el-select>
          </el-col>
          <el-col :sm="5" style="padding-left: 10px">
            <el-input v-model="search_keywords_mask" suffix-icon="el-icon-search" clearable size="mini"
                      :placeholder="$t('ads.placeholder_search_by')"
                      @keyup.enter.native="search_keywords = search_keywords_mask"
                      @change="m__on_change_search_keywords_mask()">
            </el-input>
          </el-col>
        </el-row>
      </div>

      <div id="double-scroll-wrapper" style="position: fixed; z-index: 20; bottom: 1px;">
        <div id="double-scroll-bar">
        </div>
      </div>

      <el-table id="main-table-fixed-header" :class="is_group ? 'table-hide-expand' : ''" :data="[]"
                @sort-change="m__sort_change" row-key="id" default-expand-all
                :header-row-style="{'min-height': '40px'}">
        <el-table-column width="40px" :fixed="m__get_fixed_column()">
          <template slot="header" slot-scope="scope">
            <el-checkbox size="mini" :indeterminate="m__is_indeterminate()" v-bind:value="m__is_checked_all()"
                         @change="m__check_all"></el-checkbox>
          </template>
          <template slot-scope="scope">
            <el-checkbox v-if="!scope.row.is_parent" v-model="scope.row.checked" size="mini"></el-checkbox>
          </template>
        </el-table-column>
        <template v-if="is_group">
          <el-table-column width="45px" :fixed="m__get_fixed_column()" class-name="no-padding vertical-middle">
            <template slot-scope="scope">
              <template v-if="scope.row.is_parent">
                <img v-if="scope.row.product.images" style="width:32px; height:32px; border-radius: 4px;"
                     :src="m__map_campaign_image(scope.row)" alt="product_logo"/>
              </template>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.product')" :fixed="m__get_fixed_column()" width="300px"
                           show-tooltip-when-overflow class-name="vertical-middle">
            <template slot-scope="scope" slot="header">
              <el-dropdown @command="m__change_campaign_state" trigger="click">
                <span class="el-dropdown-link">
                  <span v-if="selected_state === 'all'">{{ $t('base.all') }}</span>
                  <span v-if="selected_state === 'ongoing'" class="text-primary">
                    {{ $t('base.ongoing') }}
                    <i class="el-icon-arrow-down" style="margin-left: 3px"></i>
                  </span>
                  <span v-if="selected_state === 'paused'" class="text-warning">
                    {{ $t('base.paused') }}
                    <i class="el-icon-arrow-down" style="margin-left: 3px"></i>
                  </span>
                  <span v-if="selected_state === 'ended'" class="text-danger">
                    {{ $t('base.ended') }}
                    <i class="el-icon-arrow-down" style="margin-left: 3px"></i>
                  </span>
                  <span v-if="selected_state === 'deleted'" class="text-danger">
                    {{ $t('base.deleted') }}
                    <i class="el-icon-arrow-down" style="margin-left: 3px"></i>
                  </span>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="all">{{ $t('base.all') }}</el-dropdown-item>
                  <el-dropdown-item command="ongoing">{{ $t('base.ongoing') }}</el-dropdown-item>
                  <el-dropdown-item command="paused">{{ $t('base.paused') }}</el-dropdown-item>
                  <el-dropdown-item command="ended">{{ $t('base.ended') }}</el-dropdown-item>
                  <el-dropdown-item command="deleted">{{ $t('base.deleted') }}</el-dropdown-item>
                  <hr>
                  <el-dropdown-item v-for="item in group_list" :key="item.id" :command="item.id">
                    {{ item.name }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <template slot-scope="scope">
              <template v-if="scope.row.is_parent">
                <div style="display: flex; gap: 10px; margin-bottom: 4px">
                  <div
                    v-if="m__is_show_auto_condition_action_config(scope.row)"
                    :class="m__is_auto_condition_action_config_running(scope.row) ? 'text-running' : 'text-paused'">
                    <a href="javascript:void(0)" @click="m__show_auto_condition_action_dialog(scope.row)">
                      {{ $t('ads.optimize_based_on_conditional') }}
                    </a>
                  </div>
                  <div v-if="scope.row.tags.has('best_selling')" class="text-blue rounded-[4px]">
                    <a href="javascript:void(0)" style="font-weight: 600">
                      {{ $t('base.best_selling') }}
                    </a>
                  </div>
                  <div v-if="scope.row.tags.has('best_selling')" class="text-blue rounded-[4px]">
                    <a href="javascript:void(0)" style="font-weight: 600">
                      {{ $t('base.potential') }}
                    </a>
                  </div>
                  <div v-if="scope.row.tags.has('able_to_x2')" class="text-x2 rounded-[4px]">
                    <a href="javascript:void(0)" style="font-weight: 700">
                      Sử dụng AI để X2
                    </a>
                  </div>
                </div>
                <a v-if="scope.row.id === 'shop'" style="display: block" :href="`javascript:void(0)`">
                  {{ $t('ads.shop_ads') }}
                </a>
                <a v-else-if="scope.row.id === 'product_mpd'" style="display: block" :href="`javascript:void(0)`">
                  {{ 'Chiến dịch nhóm' }}
                </a>
                <a v-else class="hover-class" style="display: block" href="javascript:void(0)"
                   @click="open_link_fixed(`https://shopee.com/product-i.${shop.shop_id}.${scope.row.product.itemid}`, shop)">
                  {{ scope.row.product.name }}
                </a>
              </template>
              <template v-else>
                <div style="height: 0; width: 100%"></div>
                <div style="display: flex; gap: 10px">
                  <div v-if="scope.row.campaign.state === 'ongoing'" class="text-running">
                    <a href="javascript:void(0)">{{ $t('base.ongoing') }}</a>
                  </div>
                  <div v-else-if="scope.row.campaign.state === 'paused'" class="text-pause">
                    <a href="javascript:void(0)">{{ $t('base.paused') }}</a>
                  </div>
                  <div v-else-if="scope.row.campaign.state === 'ended'" class="text-close">
                    <a href="javascript:void(0)">
                      Kết thúc</a>
                  </div>
                  <div v-else-if="scope.row.campaign.state === 'deleted'" class="text-close">
                    <a href="javascript:void(0)">
                      Đã xóa</a>
                  </div>
                  <div
                    v-if="m__is_show_auto_condition_action_config(scope.row)"
                    :class="m__is_auto_condition_action_config_running(scope.row) ? 'text-running' : 'text-paused'">
                    <a href="javascript:void(0)" @click="m__show_auto_condition_action_dialog(scope.row)">
                      {{ $t('ads.optimize_based_on_conditional') }}
                    </a>
                  </div>
                  <div v-if="scope.row.auto_optimize_search" class="text-running">
                    <a href="javascript:void(0)" @click="m__show_config_auto_optimize(scope.row, 'search')">
                      {{ $t('ads.optimize_keyword_based_on_cir') }}
                    </a>
                  </div>
                  <div v-if="scope.row.auto_optimize_targeting" class="text-running">
                    <a href="javascript:void(0)" @click="m__show_config_auto_optimize(scope.row, 'targeting')">
                      {{ $t('ads.optimize_targeting_based_on_cir') }}
                    </a>
                  </div>
                  <div v-if="scope.row.auto_quota" class="text-running">
                    <a href="javascript:void(0)" @click="m__show_config_auto_quota_dialog(scope.row)">
                      {{ $t('ads.automatic_budget') }}
                    </a>
                  </div>
                  <div v-if="false" class="text-blue">
                    <a href="javascript:void(0)" @click="m__show_auto_by_ai_config_list_dialog(scope.row)">
                      Tối ưu bằng AI
                    </a>
                  </div>
                </div>

                <a v-if="scope.row.campaign.type === 'all'" class="hover-class" style="color: #000"
                   :href="m__get_campaign_in_new_tab_url(scope.row)"
                   @click="m__redirect_detail($event, scope.row)">
                  <i v-if="scope.row.loading" class="el-icon-loading"></i>
                  <strong v-if="scope.row.product.state === 'deleted'">[{{ $t('base.deleted') }}]</strong>
                  <strong v-else-if="scope.row.product.stock === 0">[{{ $t('base.out_stock') }}]</strong>
                  {{ m__map_campaign_name(scope.row) }}
                </a>
                <a v-if="scope.row.campaign.type === 'keyword'" class="hover-class" style="color: #000"
                   :href="m__get_campaign_in_new_tab_url(scope.row)"
                   @click="m__redirect_detail($event, scope.row)">
                  <i v-if="scope.row.loading" class="el-icon-loading"></i>
                  <strong v-if="scope.row.product.state === 'deleted'">[{{ $t('base.deleted') }}]</strong>
                  <strong v-else-if="scope.row.product.stock === 0">[{{ $t('base.out_stock') }}]</strong>
                  {{ m__map_campaign_name(scope.row) }}
                </a>
                <a v-if="scope.row.campaign.type === 'targeting'" class="hover-class" style="color: #000"
                   :href="m__get_campaign_in_new_tab_url(scope.row)"
                   @click="m__redirect_detail($event, scope.row)">
                  <i v-if="scope.row.loading" class="el-icon-loading"></i>
                  <strong v-if="scope.row.product.state === 'deleted'">[{{ $t('base.deleted') }}]</strong>
                  <strong v-else-if="scope.row.product.stock === 0">[{{ $t('base.out_stock') }}]</strong>
                  {{ m__map_campaign_name(scope.row) }}
                </a>
                <a v-if="scope.row.campaign.type === 'shop'" class="hover-class" style="color: #000"
                   :href="m__get_campaign_in_new_tab_url(scope.row)"
                   @click="m__redirect_detail($event, scope.row)">
                  <i v-if="scope.row.loading" class="el-icon-loading"></i>
                  <strong>{{ scope.row.campaign.name }}</strong> &nbsp;&nbsp;
                  {{ m__map_campaign_name(scope.row) }}
                </a>
                <a v-if="scope.row.campaign.type === 'live_stream'" class="hover-class" style="color: #000"
                   :href="m__get_campaign_in_new_tab_url(scope.row)"
                   @click="m__redirect_detail($event, scope.row)">
                  <i v-if="scope.row.loading" class="el-icon-loading"></i>
                  <strong>{{ scope.row.campaign.campaignid }} - {{ scope.row.campaign.name }}</strong>
                </a>
                <a v-if="scope.row.campaign.type === 'product_mpd'" class="hover-class" style="color: #000"
                   :href="m__get_campaign_in_new_tab_url(scope.row)"
                   @click="m__redirect_detail($event, scope.row)">
                  <i v-if="scope.row.loading" class="el-icon-loading"></i>
                  <strong>{{ scope.row.campaign.name }}</strong>
                </a>

                <div style="padding-top: 5px">
                  <a href="javascript:void(0)" style="color: #999"
                     :class="scope.row.campaign.state !== 'ended' ? 'hover-class show-on-hover' : 'hide-icon'"
                     @click="m__show_update_campaign_date(scope.row)">
                    <template v-if="scope.row.campaign.end_time === 0">
                      {{ scope.row.campaign.start_time * 1000 | moment('DD/MM/YYYY') }}
                      -
                      {{ $t('base.no_end_date') }}
                    </template>
                    <template v-else>
                      {{ scope.row.campaign.start_time * 1000 | moment('DD/MM/YYYY') }}
                      -
                      {{ scope.row.campaign.end_time * 1000 | moment('DD/MM/YYYY') }}
                    </template>
                    <i class="el-icon-edit"></i>
                  </a>
                </div>
              </template>
            </template>
          </el-table-column>
        </template>
        <template v-else>
          <el-table-column v-if="!m__get_fixed_column()" type="expand">
            <template slot-scope="scope">
              <div v-if="scope.row.is_expanded"
                   style="padding-left: 20px; padding-bottom: 20px; background-color: #f5f7f8">
                <ComponentTargetingCampaign :key="component_key"
                                            :shop="shop"
                                            :parent_campaign.sync="scope.row"
                                            :sp_user="sp_user"
                                            :start_date="start_date"
                                            :end_date="end_date"
                                            :parent_is_compare_campaign="is_compare_campaign"
                                            :parent_compare_date_range="compare_date_range"
                                            :parent_flag="flag_list"
                                            :is_full="false"
                                            :auto_condition_action_config_list="auto_condition_action_config_list"
                                            :auto_condition_action_detail_config_list="auto_condition_action_detail_config_list"
                                            :ads_config="ads_config"
                                            @back_to_list="m__on_back_to_list"
                                            @change_product_placement="m__on_change_product_placement"
                                            @reload_auto_condition_action="m__get_auto_condition_action">
                </ComponentTargetingCampaign>
              </div>
            </template>
          </el-table-column>
          <el-table-column width="45px" :fixed="m__get_fixed_column()" class-name="no-padding">
            <template slot-scope="scope">
              <img style="width:32px; height:32px; border-radius: 4px;" :src="m__map_campaign_image(scope.row)"
                   alt="product_logo"/>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.product')" :fixed="m__get_fixed_column()" width="300px"
                           show-tooltip-when-overflow>
            <template slot-scope="scope" slot="header">
              <el-dropdown @command="m__change_campaign_state" trigger="click">
                <span class="el-dropdown-link">
                  <span v-if="selected_state === 'all'">{{ $t('base.all') }}</span>
                  <span v-if="selected_state === 'ongoing'" class="text-primary">
                    {{ $t('base.ongoing') }}
                    <i class="el-icon-arrow-down" style="margin-left: 3px"></i>
                  </span>
                  <span v-if="selected_state === 'paused'" class="text-warning">
                    {{ $t('base.paused') }}
                    <i class="el-icon-arrow-down" style="margin-left: 3px"></i>
                  </span>
                  <span v-if="selected_state === 'ended'" class="text-danger">
                    {{ $t('base.ended') }}
                    <i class="el-icon-arrow-down" style="margin-left: 3px"></i>
                  </span>
                  <span v-if="selected_state === 'deleted'" class="text-danger">
                    {{ $t('base.deleted') }}
                    <i class="el-icon-arrow-down" style="margin-left: 3px"></i>
                  </span>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="all">{{ $t('base.all') }}</el-dropdown-item>
                  <el-dropdown-item command="ongoing">{{ $t('base.ongoing') }}</el-dropdown-item>
                  <el-dropdown-item command="paused">{{ $t('base.paused') }}</el-dropdown-item>
                  <el-dropdown-item command="ended">{{ $t('base.ended') }}</el-dropdown-item>
                  <el-dropdown-item command="deleted">{{ $t('base.deleted') }}</el-dropdown-item>
                  <hr>
                  <el-dropdown-item v-for="item in group_list" :key="item.id" :command="item.id">
                    {{ item.name }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <template slot-scope="scope">
              <div style="height: 0; width: 100%"></div>
              <div style="display: flex; gap: 10px">
                <div v-if="scope.row.campaign.state === 'ongoing'" class="text-running">
                  <a href="javascript:void(0)">{{ $t('base.ongoing') }}</a>
                </div>
                <div v-else-if="scope.row.campaign.state === 'paused'" class="text-pause">
                  <a href="javascript:void(0)">{{ $t('base.paused') }}</a>
                </div>
                <div v-else-if="scope.row.campaign.state === 'ended'" class="text-close">
                  <a href="javascript:void(0)">
                    Kết thúc</a>
                </div>
                <div v-else-if="scope.row.campaign.state === 'deleted'" class="text-close">
                  <a href="javascript:void(0)">
                    Đã xóa</a>
                </div>
                <div
                  v-if="m__is_show_auto_condition_action_config(scope.row)"
                  :class="m__is_auto_condition_action_config_running(scope.row) ? 'text-running' : 'text-paused'">
                  <a href="javascript:void(0)" @click="m__show_auto_condition_action_dialog(scope.row)">
                    {{ $t('ads.optimize_based_on_conditional') }}
                  </a>
                </div>
                <div v-if="scope.row.auto_optimize_search" class="text-running">
                  <a href="javascript:void(0)" @click="m__show_config_auto_optimize(scope.row, 'search')">
                    {{ $t('ads.optimize_keyword_based_on_cir') }}
                  </a>
                </div>
                <div v-if="scope.row.auto_optimize_targeting" class="text-running">
                  <a href="javascript:void(0)" @click="m__show_config_auto_optimize(scope.row, 'targeting')">
                    {{ $t('ads.optimize_targeting_based_on_cir') }}
                  </a>
                </div>
                <div v-if="scope.row.auto_quota" class="text-running">
                  <a href="javascript:void(0)" @click="m__show_config_auto_quota_dialog(scope.row)">
                    {{ $t('ads.automatic_budget') }}
                  </a>
                </div>
                <div v-if="false" class="text-blue">
                  <a href="javascript:void(0)" @click="m__show_auto_by_ai_config_list_dialog(scope.row)">
                    Tối ưu bằng AI
                  </a>
                </div>
              </div>

              <a v-if="scope.row.campaign.type === 'all'" class="hover-class" style="color: #000"
                 :href="m__get_campaign_in_new_tab_url(scope.row)"
                 @click="m__redirect_detail($event, scope.row)">
                <i v-if="scope.row.loading" class="el-icon-loading"></i>
                <strong v-if="scope.row.product.state === 'deleted'">[{{ $t('base.deleted') }}]</strong>
                <strong v-else-if="scope.row.product.stock === 0">[{{ $t('base.out_stock') }}]</strong>
                {{ scope.row.product.name }}
              </a>
              <a v-if="scope.row.campaign.type === 'keyword'" class="hover-class" style="color: #000"
                 :href="m__get_campaign_in_new_tab_url(scope.row)"
                 @click="m__redirect_detail($event, scope.row)">
                <i v-if="scope.row.loading" class="el-icon-loading"></i>
                <strong v-if="scope.row.product.state === 'deleted'">[{{ $t('base.deleted') }}]</strong>
                <strong v-else-if="scope.row.product.stock === 0">[{{ $t('base.out_stock') }}]</strong>
                {{ scope.row.product.name }}
              </a>
              <a v-if="scope.row.campaign.type === 'targeting'" class="hover-class" style="color: #000"
                 :href="m__get_campaign_in_new_tab_url(scope.row)"
                 @click="m__redirect_detail($event, scope.row)">
                <i v-if="scope.row.loading" class="el-icon-loading"></i>
                <strong v-if="scope.row.product.state === 'deleted'">[{{ $t('base.deleted') }}]</strong>
                <strong v-else-if="scope.row.product.stock === 0">[{{ $t('base.out_stock') }}]</strong>
                {{ scope.row.product.name }}
              </a>
              <a v-if="scope.row.campaign.type === 'shop'" class="hover-class" style="color: #000"
                 :href="m__get_campaign_in_new_tab_url(scope.row)"
                 @click="m__redirect_detail($event, scope.row)">
                <i v-if="scope.row.loading" class="el-icon-loading"></i>
                <strong>{{ scope.row.campaign.name }}</strong> &nbsp;&nbsp;
                <small style="color: #999">{{
                    scope.row.campaign.name
                  }}</small>
              </a>
              <a v-if="scope.row.campaign.type === 'live_stream'" class="hover-class" style="color: #000"
                 :href="m__get_campaign_in_new_tab_url(scope.row)"
                 @click="m__redirect_detail($event, scope.row)">
                <i v-if="scope.row.loading" class="el-icon-loading"></i>
                <strong>{{ scope.row.campaign.campaignid }} - {{ scope.row.campaign.name }}</strong>
              </a>
              <a v-if="scope.row.campaign.type === 'product_mpd'" class="hover-class" style="color: #000"
                 :href="m__get_campaign_in_new_tab_url(scope.row)"
                 @click="m__redirect_detail($event, scope.row)">
                <i v-if="scope.row.loading" class="el-icon-loading"></i>
                <strong>{{ scope.row.campaign.name }}</strong>
              </a>

              <div style="padding-top: 5px">
                <a href="javascript:void(0)" style="color: #999"
                   :class="scope.row.campaign.state !== 'ended' ? 'hover-class show-on-hover' : 'hide-icon'"
                   @click="m__show_update_campaign_date(scope.row)">
                  <template v-if="scope.row.campaign.end_time === 0">
                    {{ scope.row.campaign.start_time * 1000 | moment('DD/MM/YYYY') }}
                    -
                    {{ $t('base.no_end_date') }}
                  </template>
                  <template v-else>
                    {{ scope.row.campaign.start_time * 1000 | moment('DD/MM/YYYY') }}
                    -
                    {{ scope.row.campaign.end_time * 1000 | moment('DD/MM/YYYY') }}
                  </template>
                  <i class="el-icon-edit"></i>
                </a>
              </div>
            </template>
          </el-table-column>
        </template>
        <el-table-column :label="$t('base.type')" width="100px" :fixed="m__get_fixed_column(true)" prop="campaign.type">
          <template slot-scope="scope" slot="header">
            <el-popover
              placement="top"
              trigger="click">
              <div style="min-width: 600px">
                <div style="display: flex; justify-content: space-between; gap: 20px">
                  <div style="display: flex; flex-direction: column; gap: 20px;">
                    <div style="display: flex">
                      <el-checkbox
                        v-for="item in campaign_type_checkbox.filter(i => campaign_type === 'new_cpc_homepage' || i.type === campaign_type)"
                        :key="item.label"
                        v-model="item.checked"
                        @change="(campaign_type === 'product_homepage') && m__get_campaign_reports()">
                        {{ item.label }}
                      </el-checkbox>
                    </div>
                    <div style="display: flex; align-items: center;">
                      <el-checkbox v-for="item in campaign_placement_checkbox" :key="item.label" v-model="item.checked">
                        {{ item.label }}
                      </el-checkbox>
                    </div>
                  </div>

                  <div style="display: flex; align-items: end; justify-content: end; padding-bottom: 3px">
                    <el-button type="text" size="mini"
                               @click="campaign_type_checkbox.forEach(i => i.checked = false); campaign_placement_checkbox.forEach(i => i.checked = false)">
                      <strong class="text-danger">{{ $t('base.unselect') }}</strong>
                    </el-button>
                  </div>
                </div>
              </div>
              <span slot="reference" style="cursor: pointer;">
                <span style="color: #606266;"
                      :style="campaign_type_checkbox.some(i => i.checked) || campaign_placement_checkbox.some(i => i.checked) ? 'color: #337ab7 !important' : ''">
                  {{ $t('base.optional') }}
                  <i class="el-icon-arrow-down" style="margin-left: 3px"></i>
                </span>
              </span>
            </el-popover>
          </template>
          <template slot-scope="scope">
            <template v-if="scope.row.campaign.type === 'all'">
              <div>{{ $t('base.all') }}</div>
              <template v-if="scope.row.campaign.bidding_type === 'manual'">
                <span style="font-size: 11px; color: #666">{{ $t('ads.manual_bidding') }}</span>
              </template>
              <template v-if="scope.row.campaign.bidding_type === 'auto'">
                <span style="font-size: 11px; color: #666">{{ $t('ads.auto_bidding') }}</span>
              </template>
              <template v-if="scope.row.campaign.bidding_type === 'roi_two'">
                <span style="font-size: 11px; color: #666">{{ $t('ads.auto_bidding') }}</span>
              </template>
            </template>
            <template v-if="scope.row.campaign.type === 'keyword'">
              <div>{{ $t('ads.search') }}</div>
              <template v-if="scope.row.campaign.bidding_type === 'manual'">
                <span style="font-size: 11px; color: #666">{{ $t('ads.manual_bidding') }}</span>
              </template>
              <template v-if="scope.row.campaign.bidding_type === 'auto'">
                <span style="font-size: 11px; color: #666">{{ $t('ads.auto_bidding') }}</span>
              </template>
              <template v-if="scope.row.campaign.bidding_type === 'roi_two'">
                <span style="font-size: 11px; color: #666">{{ $t('ads.auto_bidding') }}</span>
              </template>
            </template>
            <template v-if="scope.row.campaign.type === 'targeting'">
              <div>{{ $t('ads.targeting') }}</div>
              <template v-if="scope.row.campaign.bidding_type === 'manual'">
                <span style="font-size: 11px; color: #666">{{ $t('ads.manual_bidding') }}</span>
              </template>
              <template v-if="scope.row.campaign.bidding_type === 'auto'">
                <span style="font-size: 11px; color: #666">{{ $t('ads.auto_bidding') }}</span>
              </template>
              <template v-if="scope.row.campaign.bidding_type === 'roi_two'">
                <span style="font-size: 11px; color: #666">{{ $t('ads.auto_bidding') }}</span>
              </template>
            </template>
            <template v-if="scope.row.campaign.type === 'shop'">
              <div>Shop</div>
              <template v-if="scope.row.campaign.bidding_type === 'manual'">
                <span style="font-size: 11px; color: #666">{{ $t('ads.manual_bidding') }}</span>
              </template>
              <template v-if="scope.row.campaign.bidding_type === 'auto'">
                <span style="font-size: 11px; color: #666">{{ $t('ads.auto_bidding') }}</span>
              </template>
            </template>
          </template>
        </el-table-column>
        <el-table-column :label="$t('base.budget')" width="140px" :fixed="m__get_fixed_column(true)"
                         show-tooltip-when-overflow>
          <template slot-scope="scope" slot="header">
            <el-dropdown trigger="click" placement="bottom">
              <span class="el-dropdown-link">
                <span v-if="quota_filter === 'all'">
                  {{ $t('base.budget') }}
                  <i class="el-icon-arrow-down" style="margin-left: 3px"></i>
                </span>
                <span v-if="quota_filter === 'low_quota'" class="text-primary">
                  {{ $t('base.low_budget') }}
                  <i class="el-icon-arrow-down" style="margin-left: 3px"></i>
                </span>
                <span v-if="quota_filter === 'sort_desc'" class="text-primary">
                  {{ $t('base.budget') }}
                  <i class="el-icon-arrow-down" style="margin-left: 3px"></i>
                </span>
                <span v-if="quota_filter === 'sort_asc'" class="text-primary">
                  {{ $t('base.budget') }}
                  <i class="el-icon-arrow-down" style="margin-left: 3px"></i>
                </span>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="quota_filter = 'all'">
                  <span :style="quota_filter === 'all' ? 'font-weight: bold' :''">
                    {{ $t('ads.all') }}
                  </span>
                </el-dropdown-item>
                <el-dropdown-item @click.native="quota_filter = 'low_quota'">
                  <span :style="quota_filter === 'low_quota' ? 'font-weight: bold' :''">
                    {{ $t('ads.with_low_budget') }}
                  </span>
                </el-dropdown-item>
                <el-dropdown-item @click.native="quota_filter = 'sort_desc'">
                  <span :style="quota_filter === 'sort_desc' ? 'font-weight: bold' :''">
                    {{ 'Sắp xếp cao → thấp' }}
                  </span>
                </el-dropdown-item>
                <el-dropdown-item @click.native="quota_filter = 'sort_asc'">
                  <span :style="quota_filter === 'sort_asc' ? 'font-weight: bold' :''">
                    {{ 'Sắp xếp thấp → cao' }}
                  </span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
          <template slot-scope="scope">
            <template v-if="!scope.row.is_parent">
              <template
                v-if="m__calculate(scope.row.campaign.daily_quota) === 0 && m__calculate(scope.row.campaign.total_quota) === 0">
                <a href="javascript:void(0)"
                   @click="m__show_update_campaign_quota(scope.row)"
                   :class="scope.row.campaign.state !== 'ended' ? 'hover-class show-on-hover' : 'hide-icon'">
                  <small style="color: #999;">{{ $t('base.unlimited') }} <i class="el-icon-edit"></i></small>
                </a>
              </template>
              <template v-else-if="m__calculate(scope.row.campaign.daily_quota)">
                <a href="javascript:void(0)"
                   @click="m__show_update_campaign_quota(scope.row)"
                   :class="scope.row.campaign.state !== 'ended' ? 'hover-class show-on-hover' : 'hide-icon'">
                  {{ scope.row.campaign.daily_quota | currency }} {{ m__currency() }}
                  &nbsp;
                  <el-tooltip
                    class="item" effect="dark"
                    :content="$t('ads.running_out_of_budget_message')"
                    placement="top">
                    <i v-if="m__is_low_quota(scope.row)" class="text-danger el-icon-warning-outline"
                       style="font-size: 13px !important;"></i>
                  </el-tooltip>
                  <br>
                  <small style="color: #999;">{{ $t('base.daily_budget') }} <i class="el-icon-edit"></i></small>
                </a>
              </template>
              <template v-else>
                <a href="javascript:void(0)"
                   @click="m__show_update_campaign_quota(scope.row)"
                   :class="scope.row.campaign.state !== 'ended' ? 'hover-class show-on-hover' : 'hide-icon'">
                  {{ scope.row.campaign.total_quota | currency }} {{ m__currency() }}
                  &nbsp;
                  <el-tooltip
                    class="item" effect="dark"
                    :content="$t('ads.running_out_of_budget_message')"
                    placement="top">
                    <i v-if="m__is_low_quota(scope.row)" class="text-danger el-icon-warning-outline"
                       style="font-size: 13px !important;"></i>
                  </el-tooltip>
                  <br>
                  <small style="color:#999;">{{ $t('base.total_budget') }} <i class="el-icon-edit"></i></small>
                </a>
              </template>
            </template>
          </template>
        </el-table-column>
        <el-table-column v-if="m__has_agent()" width="180px" show-tooltip-when-overflow>
          <template slot="header" slot-scope="scope">
            <el-dropdown trigger="click" placement="bottom">
              <div class="el-dropdown-link" style="display: flex; gap: 6px; align-items: center;">
                <strong style="color: #8e44ad">Atosa Agent</strong>
                <i class="el-icon-arrow-down" style="font-weight: bold; color: #8e44ad"></i>
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="atosa_agent_filter = 'all'">
                  <div style="display: flex; gap: 10px">
                    <span style="flex: auto">{{ 'Tất cả chiến dịch' }}</span>
                    <span style="width: 10px">
                      <i v-if="atosa_agent_filter === 'all'" class="el-icon-check"></i>
                    </span>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item @click.native="atosa_agent_filter = 'applying'">
                  <div style="display: flex; gap: 10px">
                    <span style="flex: auto">{{ 'Đang cài Atosa Agent' }}</span>
                    <span style="width: 10px">
                      <i v-if="atosa_agent_filter === 'applying'" class="el-icon-check"></i>
                    </span>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item @click.native="atosa_agent_filter = 'not_applying'">
                  <div style="display: flex; gap: 10px">
                    <span style="flex: auto">{{ 'Chưa cài Atosa Agent' }}</span>
                    <span style="width: 10px">
                      <i v-if="atosa_agent_filter === 'not_applying'" class="el-icon-check"></i>
                    </span>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item @click.native="atosa_agent_filter = 'replanning'">
                  <div style="display: flex; gap: 10px">
                    <span style="flex: auto">{{ 'Cần thiết lập lại mục tiêu' }}</span>
                    <span style="width: 10px">
                      <i v-if="atosa_agent_filter === 'replanning'" class="el-icon-check"></i>
                    </span>
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
          <template slot-scope="scope">
            <div v-if="!scope.row.auto && !scope.row.is_parent && m__can_setup_auto_by_ai(scope.row)"
                 style="cursor: pointer" @click="m__show_auto_by_ai_config_list_dialog(scope.row)">
              <template v-if="m__has_auto_by_ai_config(scope.row)">
                <template v-if="m__check_atosa_agent_used_package().result === false">
                  <el-tooltip placement="top" effect="light"
                              :content="`Bạn cần gia hạn gói sản phẩm để tiếp tục sử dụng tính năng`">
                    <span class="paused-tag">
                      <i class="el-icon-warning" style="font-weight: bold !important;"></i>
                      Tạm dừng
                    </span>
                  </el-tooltip>
                </template>
                <template v-else-if="m__check_is_unpaid_operating_cost()">
                  <el-tooltip placement="top" effect="light"
                              :content="`Bạn cần thanh toán phí vận hành để tiếp tục sử dụng tính năng`">
                    <span class="paused-tag">
                      <i class="el-icon-warning" style="font-weight: bold !important;"></i>
                      Tạm dừng
                    </span>
                  </el-tooltip>
                </template>
                <template v-else>
                  <div style="display: flex; align-items: center; gap: 12px">
                    <span class="ai-tag">
                      <i class="el-icon-circle-check" style="font-weight: bold !important;"></i>
                      Đang care
                    </span>

                    <template v-if="m__check_atosa_agent_config_target(scope.row)">
                      <el-tooltip placement="top" effect="light">
                        <div slot="content" style="font-size: 13px">
                          Mục tiêu bạn đặt ra đang cao hơn mức khuyến nghị, điều này có thể ảnh hưởng đến hiệu suất
                          chiến dịch. Hãy cập nhật lại để chiến dịch đạt kết quả tốt nhất.
                        </div>
                        <span style="font-size: 16px">⚠️</span>
                      </el-tooltip>
                    </template>
                  </div>
                </template>
              </template>
              <strong v-else style="color: #a94442">
                Click để cài đặt
              </strong>
            </div>
          </template>
        </el-table-column>
        <el-table-column width="140px" show-tooltip-when-overflow>
          <template slot="header" slot-scope="scope">
            <el-dropdown trigger="click" placement="bottom" @command="m__handle_tag_command">
              <div class="el-dropdown-link">
                <span :class="{'text-primary': tag_ids_selected.length}">
                  {{ $t('base.select_tags') }}
                  <i class="el-icon-arrow-down" style="margin-left: 3px"></i>
                </span>
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="added">
                  <div style="display: flex; gap: 10px">
                    <span style="flex: auto">{{ $t('base.tags_added') }}</span>
                    <span style="width: 10px">
                      <i v-if="m__check_tag_ids_selected('added')" class="el-icon-check"></i>
                    </span>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item command="not_added">
                  <div style="display: flex; gap: 10px">
                    <span style="flex: auto">{{ $t('base.no_tags_added') }}</span>
                    <span style="width: 10px">
                      <i v-if="m__check_tag_ids_selected('not_added')" class="el-icon-check"></i>
                    </span>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item v-for="tag in campaign_tag_list" :key="tag._id" :command="tag._id">
                  <div style="display: flex; gap: 10px">
                    <span style="flex: auto">{{ tag.name }}</span>
                    <span style="width: 10px">
                      <i v-if="m__check_tag_ids_selected(tag._id)" class="el-icon-check"></i>
                    </span>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item command="create_tag" divided>
                  <i class="el-icon-plus"></i> {{ $t('base.create_tags') }}
                </el-dropdown-item>
                <el-dropdown-item command="add_to_keyword">
                  {{ $t('base.add_tags_for_selected_x', { x: $t('base.campaign') }) }}
                </el-dropdown-item>
                <el-dropdown-item command="remove_from_keyword">
                  {{ $t('base.remove_tags_of_selected_x', { x: $t('base.campaign') }) }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
          <template slot-scope="scope">
            <template v-if="!scope.row.auto && !scope.row.is_parent">
              <el-dropdown trigger="click" placement="bottom" @command="m__handle_campaign_tag_command"
                           :disabled="campaign_tag_list.length === 0">
                <template v-if="m__map_campaign_tag(scope.row)">
                  <strong class="text-primary">{{ m__map_campaign_tag(scope.row) }}</strong>
                </template>
                <template v-else>
                  <strong style="color: #3d3d3d">{{ $t('base.add_tags') }}</strong>
                </template>

                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="tag in campaign_tag_list" :key="tag._id"
                                    :command="JSON.stringify({campaign_id:scope.row.campaign.campaignid, tag_id: tag._id})">
                    <div style="display: flex; gap: 10px">
                      <span style="flex: auto">{{ tag.name }}</span>
                      <span style="width: 10px">
                        <i v-if="m__check_campaign_match(scope.row.campaign.campaignid, tag._id)"
                           class="el-icon-check"></i>
                      </span>
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item v-if="m__map_campaign_tag(scope.row)"
                                    :command="JSON.stringify({campaign_id:scope.row.campaign.campaignid, tag_id: 'remove_tag'})"
                                    divided>
                    <i class="el-icon-close"></i> {{ $t('base.remove_tags') }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </template>
        </el-table-column>
        <el-table-column :label="$t('base.target_roas')" prop="campaign.roi_two_target" width="130px" sortable="custom">
          <template slot-scope="scope">
            <div class="roi_two" v-if="target_roas_includes.has(scope.row.campaign.bidding_type)"
                 style="display: flex; gap: 8px; cursor: pointer"
                 @click="m__show_update_target_broad_roi_dialog(scope.row)">
              <div>
                {{ +scope.row.campaign.roi_two_target ? scope.row.campaign.roi_two_target : $t('ads.auto_bidding') }}
              </div>
              <div style="opacity: 0;">
                <i class="el-icon-edit"></i>
              </div>
            </div>
            <div v-else>
              -
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="report.avg_rank.value" :label="$t('metric.avg_rank')" width="120px"
                         v-if="m__is_show_index('avg_rank')" sortable="custom">
          <template slot-scope="scope">
            {{ m__get_report_property(scope.row, 'avg_rank') | currency }} <br>
            <div v-if="is_compare_campaign" class="compare-keyword">
              {{ m__get_compare_report_property(scope.row, 'avg_rank') | currency }}
            </div>
            <template v-else>
              <small v-if="m__check_report_ratio(scope.row, 'avg_rank') > 0" class="text-success">
                +{{ m__get_report_ratio(scope.row, 'avg_rank') }}</small>
              <small v-else class="text-danger">
                {{ m__get_report_ratio(scope.row, 'avg_rank') }}</small>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="report.impression.value" :label="$t('metric.impressions')" width="120px"
                         v-if="m__is_show_index('impression')" sortable="custom">
          <template slot-scope="scope">
            {{ m__get_report_property(scope.row, 'impression') | currency }} <br>
            <div v-if="is_compare_campaign" class="compare-keyword">
              {{ m__get_compare_report_property(scope.row, 'impression') | currency }}
            </div>
            <template v-else>
              <small v-if="m__check_report_ratio(scope.row, 'impression') > 0" class="text-success">
                +{{ m__get_report_ratio(scope.row, 'impression') }}</small>
              <small v-else class="text-danger">
                {{ m__get_report_ratio(scope.row, 'impression') }}</small>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="report.click.value" :label="$t('metric.clicks')" width="120px"
                         v-if="m__is_show_index('click')"
                         sortable="custom">
          <template slot-scope="scope">
            {{ m__get_report_property(scope.row, 'click') | currency }} <br>
            <div v-if="is_compare_campaign" class="compare-keyword">
              {{ m__get_compare_report_property(scope.row, 'click') | currency }}
            </div>
            <template v-else>
              <small v-if="m__check_report_ratio(scope.row, 'click') > 0" class="text-success">
                +{{ m__get_report_ratio(scope.row, 'click') }}</small>
              <small v-else class="text-danger">
                {{ m__get_report_ratio(scope.row, 'click') }}</small>
            </template>

            <div
              v-if="has_agency_plan() && scope.row.plan"
              style="margin-top: 10px">
              <strong style="font-size: 12px !important;" class="text-primary">
                KH: {{ scope.row.plan.target_traffic_search | currency }}
              </strong><br>
              <strong style="font-size: 12px !important;" class="text-success">
                HT: {{ is_percent_of(scope.row.report.click.value, scope.row.plan.target_traffic_search).toFixed(1) }}%
              </strong>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="report.atosa_cpc.value" label="CPC" width="120px"
                         v-if="m__is_show_index('click')"
                         sortable="custom">
          <template slot-scope="scope">
            {{ m__get_report_property(scope.row, 'atosa_cpc') | currency }} <br>
            <div v-if="is_compare_campaign" class="compare-keyword">
              {{ m__get_compare_report_property(scope.row, 'atosa_cpc') | currency }}
            </div>
            <template v-else>
              <small v-if="m__check_report_ratio(scope.row, 'none') > 0" class="text-success">
                +{{ m__get_report_ratio(scope.row, 'none') }}</small>
              <small v-else class="text-danger">
                {{ m__get_report_ratio(scope.row, 'none') }}</small>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="report.ctr.value" :label="$t('metric.ctr')" width="100px" v-if="m__is_show_index('ctr')"
                         sortable="custom">
          <template slot-scope="scope">
            {{ (+m__get_report_property(scope.row, 'ctr') * 100).toFixed(1) }} % <br>
            <div v-if="is_compare_campaign" class="compare-keyword">
              {{ (+m__get_compare_report_property(scope.row, 'ctr') * 100).toFixed(1) }} %
            </div>
            <template v-else>
              <small v-if="m__check_report_ratio(scope.row, 'ctr') > 0" class="text-success">
                +{{ m__get_report_ratio(scope.row, 'ctr') }}</small>
              <small v-else class="text-danger">
                {{ m__get_report_ratio(scope.row, 'ctr') }}</small>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="report.broad_order.value" :label="$t('metric.conversions')" width="140px"
                         v-if="m__is_show_index('broad_order')" sortable="custom">
          <template slot-scope="scope">
            {{ m__get_report_property(scope.row, 'broad_order') | currency }} <br>
            <div v-if="is_compare_campaign" class="compare-keyword">
              {{ m__get_compare_report_property(scope.row, 'broad_order') | currency }}
            </div>
            <template v-else>
              <small v-if="m__check_report_ratio(scope.row, 'broad_order') > 0" class="text-success">
                +{{ m__get_report_ratio(scope.row, 'broad_order') }}</small>
              <small v-else class="text-danger">
                {{ m__get_report_ratio(scope.row, 'broad_order') }}</small>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="report.direct_order.value" :label="$t('metric.direct_conversions')" width="115px"
                         v-if="m__is_show_index('direct_order')" sortable="custom">
          <template slot-scope="scope">
            {{ m__get_report_property(scope.row, 'direct_order') | currency }} <br>
            <div v-if="is_compare_campaign" class="compare-keyword">
              {{ m__get_compare_report_property(scope.row, 'direct_order') | currency }}
            </div>
            <template v-else>
              <small v-if="m__check_report_ratio(scope.row, 'direct_order') > 0" class="text-success">
                +{{ m__get_report_ratio(scope.row, 'direct_order') }}</small>
              <small v-else class="text-danger">
                {{ m__get_report_ratio(scope.row, 'direct_order') }}</small>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="report.broad_order_amount.value" :label="$t('metric.items_sold')" width="150px"
                         v-if="m__is_show_index('broad_order_amount')" sortable="custom">
          <template slot-scope="scope">
            {{ m__get_report_property(scope.row, 'broad_order_amount') | currency }} <br>
            <div v-if="is_compare_campaign" class="compare-keyword">
              {{ m__get_compare_report_property(scope.row, 'broad_order_amount') | currency }}
            </div>
            <template v-else>
              <small v-if="m__check_report_ratio(scope.row, 'broad_order_amount') > 0" class="text-success">
                +{{ m__get_report_ratio(scope.row, 'broad_order_amount') }}</small>
              <small v-else class="text-danger">
                {{ m__get_report_ratio(scope.row, 'broad_order_amount') }}</small>
            </template>

            <div
              v-if="has_agency_plan() && scope.row.plan"
              style="margin-top: 10px">
              <strong style="font-size: 12px !important;" class="text-primary">
                KH: {{ scope.row.plan.target_order_search | currency }}
              </strong><br>
              <strong style="font-size: 12px !important;" class="text-success">
                HT: {{
                  is_percent_of(scope.row.report.broad_order_amount.value, scope.row.plan.target_order_search).toFixed(1)
                }}%
              </strong>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="report.direct_order_amount.value" :label="$t('metric.direct_items_sold')" width="125px"
                         v-if="m__is_show_index('direct_order_amount')" sortable="custom">
          <template slot-scope="scope">
            {{ m__get_report_property(scope.row, 'direct_order_amount') | currency }} <br>
            <div v-if="is_compare_campaign" class="compare-keyword">
              {{ m__get_compare_report_property(scope.row, 'direct_order_amount') | currency }}
            </div>
            <template v-else>
              <small v-if="m__check_report_ratio(scope.row, 'direct_order_amount') > 0" class="text-success">
                +{{ m__get_report_ratio(scope.row, 'direct_order_amount') }}</small>
              <small v-else class="text-danger">
                {{ m__get_report_ratio(scope.row, 'direct_order_amount') }}</small>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="report.broad_gmv.value" label="GMV" width="145px" v-if="m__is_show_index('broad_gmv')"
                         sortable="custom">
          <template slot-scope="scope">
            {{ m__get_report_property(scope.row, 'broad_gmv') | currency }} <br>
            <div v-if="is_compare_campaign" class="compare-keyword">
              {{ m__get_compare_report_property(scope.row, 'broad_gmv') | currency }}
            </div>
            <template v-else>
              <small v-if="m__check_report_ratio(scope.row, 'broad_gmv') > 0" class="text-success">
                +{{ m__get_report_ratio(scope.row, 'broad_gmv') }}</small>
              <small v-else class="text-danger">
                {{ m__get_report_ratio(scope.row, 'broad_gmv') }}</small>
            </template>

            <div v-if="m__can_setup_auto_by_ai(scope.row) && m__has_auto_by_ai_config(scope.row)"
                 style="margin-top: 10px">
              <span class="plan-tag full-w">
                Mục tiêu: {{ m__short_value(m__get_auto_by_ai_target(scope.row, 'gmv')) }}
              </span>
              <el-tooltip placement="top" effect="light"
                          :content="`Đã thực hiện được ${m__calculate_auto_by_ai_target(m__get_auto_by_ai_result(scope.row, 'gmv'), m__get_auto_by_ai_target(scope.row, 'gmv'))}% so với kế hoạch tháng`">
                <span class="plan-tag full-w" style="color: rgb(96, 98, 102) !important;"
                      :style="m__get_css_percent_auto_by_ai(scope.row, 'gmv')">
                  Thực tế: {{ m__short_value(m__get_auto_by_ai_result(scope.row, 'gmv')) }}
                </span>
              </el-tooltip>
            </div>

            <div
              v-if="has_agency_plan() && scope.row.plan"
              style="margin-top: 10px">
              <strong style="font-size: 12px !important;" class="text-primary">
                KH: {{ scope.row.plan.target_gmv_ads_search | currency }}
              </strong><br>
              <strong style="font-size: 12px !important;" class="text-success">
                HT: {{
                  is_percent_of(scope.row.report.broad_gmv.value, scope.row.plan.target_gmv_ads_search).toFixed(1)
                }}%
              </strong>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="report.direct_gmv.value" :label="$t('metric.direct_gmv')" width="130px"
                         v-if="m__is_show_index('direct_gmv')" sortable="custom">
          <template slot-scope="scope">
            {{ m__get_report_property(scope.row, 'direct_gmv') | currency }} <br>
            <div v-if="is_compare_campaign" class="compare-keyword">
              {{ m__get_compare_report_property(scope.row, 'direct_gmv') | currency }}
            </div>
            <template v-else>
              <small v-if="m__check_report_ratio(scope.row, 'direct_gmv') > 0" class="text-success">
                +{{ m__get_report_ratio(scope.row, 'direct_gmv') }}</small>
              <small v-else class="text-danger">
                {{ m__get_report_ratio(scope.row, 'direct_gmv') }}</small>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="report.cost.value" :label="$t('metric.expense')" width="140px"
                         v-if="m__is_show_index('cost')"
                         sortable="custom">
          <template slot-scope="scope">
            {{ m__get_report_property(scope.row, 'cost') | currency }} <br>
            <div v-if="is_compare_campaign" class="compare-keyword">
              {{ m__get_compare_report_property(scope.row, 'cost') | currency }}
            </div>
            <template v-else>
              <small v-if="m__check_report_ratio(scope.row, 'cost') > 0" class="text-success">
                +{{ m__get_report_ratio(scope.row, 'cost') }}</small>
              <small v-else class="text-danger">
                {{ m__get_report_ratio(scope.row, 'cost') }}</small>
            </template>

            <div
              v-if="has_agency_plan() && scope.row.plan"
              style="margin-top: 10px">
              <strong style="font-size: 12px !important;" class="text-primary">
                KH: {{ scope.row.plan.target_cost_search | currency }}
              </strong><br>
              <strong style="font-size: 12px !important;" class="text-success">
                HT: {{ is_percent_of(scope.row.report.cost.value, scope.row.plan.target_cost_search).toFixed(1) }}%
              </strong>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="report.broad_roi.value" label="ROI (ROAS)" width="140px"
                         v-if="m__is_show_index('broad_roi')" sortable="custom">
          <template slot-scope="scope">
            {{ (+m__get_report_property(scope.row, 'broad_roi')).toFixed(2) }} <br>
            <div v-if="is_compare_campaign" class="compare-keyword">
              {{ (+m__get_compare_report_property(scope.row, 'broad_roi')).toFixed(2) }}
            </div>
            <template v-else>
              <small v-if="m__check_report_ratio(scope.row, 'broad_roi') > 0" class="text-success">
                +{{ m__get_report_ratio(scope.row, 'broad_roi') }}</small>
              <small v-else class="text-danger">
                {{ m__get_report_ratio(scope.row, 'broad_roi') }}</small>
            </template>

            <div v-if="m__can_setup_auto_by_ai(scope.row) && m__has_auto_by_ai_config(scope.row)"
                 style="margin-top: 10px">
              <span class="plan-tag full-w">
                Kế hoạch: {{ m__get_auto_by_ai_target(scope.row, 'roas') }}
              </span>
              <el-tooltip placement="top" effect="light"
                          :content="`Đã thực hiện được ${m__calculate_auto_by_ai_target(m__get_auto_by_ai_result(scope.row, 'roas'), m__get_auto_by_ai_target(scope.row, 'roas'))}% so với kế hoạch`">
                <span class="plan-tag full-w" style="color: rgb(96, 98, 102) !important;"
                      :style="m__get_css_percent_auto_by_ai(scope.row, 'roas')">
                  Thực tế: {{ m__get_auto_by_ai_result(scope.row, 'roas').toFixed(1) }}
                </span>
              </el-tooltip>
            </div>

            <div
              v-if="has_agency_plan() && scope.row.plan"
              style="margin-top: 10px">
              <strong style="font-size: 12px !important;" class="text-primary">
                KH: {{ scope.row.plan.target_roas_search | currency }}
              </strong><br>
              <strong style="font-size: 12px !important;" class="text-success">
                HT: {{ is_percent_of(scope.row.report.cost.value, scope.row.plan.target_roas_search).toFixed(1) }}%
              </strong>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="report.direct_roi.value" :label="$t('metric.direct_roi')" width="130px"
                         v-if="m__is_show_index('direct_roi')" sortable="custom">
          <template slot-scope="scope">
            {{ (+m__get_report_property(scope.row, 'direct_roi')).toFixed(2) }} <br>
            <div v-if="is_compare_campaign" class="compare-keyword">
              {{ (+m__get_compare_report_property(scope.row, 'direct_roi')).toFixed(2) }}
            </div>
            <template v-else>
              <small v-if="m__check_report_ratio(scope.row, 'direct_roi') > 0" class="text-success">
                +{{ m__get_report_ratio(scope.row, 'direct_roi') }}</small>
              <small v-else class="text-danger">
                {{ m__get_report_ratio(scope.row, 'direct_roi') }}</small>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="report.broad_cir.value" label="CIR (ACOS)" width="120px"
                         v-if="m__is_show_index('broad_cir')"
                         sortable="custom">
          <template slot-scope="scope">
            {{ (+m__get_report_property(scope.row, 'broad_cir') * 100).toFixed(1) }} % <br>
            <div v-if="is_compare_campaign" class="compare-keyword">
              {{ (+m__get_compare_report_property(scope.row, 'broad_cir') * 100).toFixed(1) }} %
            </div>
            <template v-else>
              <small v-if="m__check_report_ratio(scope.row, 'board_cir') > 0" class="text-success">
                +{{ m__get_report_ratio(scope.row, 'broad_cir') }}</small>
              <small v-else class="text-danger">
                {{ m__get_report_ratio(scope.row, 'broad_cir') }}</small>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="report.direct_cir.value" :label="$t('metric.direct_cir')" width="120px"
                         v-if="m__is_show_index('direct_cir')" sortable="custom">
          <template slot-scope="scope">
            {{ (+m__get_report_property(scope.row, 'direct_cir') * 100).toFixed(1) }} % <br>
            <div v-if="is_compare_campaign" class="compare-keyword">
              {{ (+m__get_compare_report_property(scope.row, 'direct_cir') * 100).toFixed(1) }} %
            </div>
            <template v-else>
              <small v-if="m__check_report_ratio(scope.row, 'direct_cir') > 0" class="text-success">
                +{{ m__get_report_ratio(scope.row, 'direct_cir') }}</small>
              <small v-else class="text-danger">
                {{ m__get_report_ratio(scope.row, 'direct_cir') }}</small>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="report.cr.value" :label="$t('metric.conversion_rate')" width="140px"
                         v-if="m__is_show_index('cr')" sortable="custom">
          <template slot-scope="scope">
            {{ (+m__get_report_property(scope.row, 'cr') * 100).toFixed(1) }} % <br>
            <div v-if="is_compare_campaign" class="compare-keyword">
              {{ (+m__get_compare_report_property(scope.row, 'cr') * 100).toFixed(1) }} %
            </div>
            <template v-else>
              <small v-if="m__check_report_ratio(scope.row, 'cr') > 0" class="text-success">
                +{{ m__get_report_ratio(scope.row, 'cr') }}</small>
              <small v-else class="text-danger">
                {{ m__get_report_ratio(scope.row, 'cr') }}</small>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="report.direct_cir.value" :label="$t('metric.direct_conversion_rate')" width="140px"
                         v-if="m__is_show_index('direct_cr')" sortable="custom">
          <template slot-scope="scope">
            {{ (+m__get_report_property(scope.row, 'direct_cr') * 100).toFixed(1) }} % <br>
            <div v-if="is_compare_campaign" class="compare-keyword">
              {{ (+m__get_compare_report_property(scope.row, 'direct_cr') * 100).toFixed(1) }} %
            </div>
            <template v-else>
              <small v-if="m__check_report_ratio(scope.row, 'direct_cr') > 0" class="text-success">
                +{{ m__get_report_ratio(scope.row, 'direct_cr') }}</small>
              <small v-else class="text-danger">
                {{ m__get_report_ratio(scope.row, 'direct_cr') }}</small>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="report.cpc.value" :label="$t('metric.cost_per_conversion')" width="150px"
                         v-if="m__is_show_index('cpc')" sortable="custom">
          <template slot-scope="scope">
            {{ m__get_report_property(scope.row, 'cpc') | currency }} <br>
            <div v-if="is_compare_campaign" class="compare-keyword">
              {{ m__get_compare_report_property(scope.row, 'cpc') | currency }}
            </div>
            <template v-else>
              <small v-if="m__check_report_ratio(scope.row, 'cpc') > 0" class="text-success">
                +{{ m__get_report_ratio(scope.row, 'cpc') }}</small>
              <small v-else class="text-danger">
                {{ m__get_report_ratio(scope.row, 'cpc') }}</small>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="report.cpdc.value" :label="$t('metric.cost_per_direct_conversion')" width="140px"
                         v-if="m__is_show_index('cpdc')" sortable="custom">
          <template slot-scope="scope">
            {{ m__get_report_property(scope.row, 'cpdc') | currency }} <br>
            <div v-if="is_compare_campaign" class="compare-keyword">
              {{ m__get_compare_report_property(scope.row, 'cpdc') | currency }}
            </div>
            <template v-else>
              <small v-if="m__check_report_ratio(scope.row, 'cpdc') > 0" class="text-success">
                +{{ m__get_report_ratio(scope.row, 'cpdc') }}</small>
              <small v-else class="text-danger">
                {{ m__get_report_ratio(scope.row, 'cpdc') }}</small>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="report.aov.value" label="AOV" width="120px"
                         v-if="m__is_show_atosa_index('aov')"
                         sortable="custom">
          <template slot-scope="scope">
            {{ m__get_report_property(scope.row, 'aov') | currency }} <br>
            <div v-if="is_compare_campaign" class="compare-keyword">
              {{ m__get_compare_report_property(scope.row, 'aov') | currency }}
            </div>
            <template v-else>
              <small v-if="m__check_report_ratio(scope.row, 'none') > 0" class="text-success">
                +{{ m__get_report_ratio(scope.row, 'none') }}</small>
              <small v-else class="text-danger">
                {{ m__get_report_ratio(scope.row, 'none') }}</small>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="report.cpm.value" label="CPM" width="120px"
                         v-if="m__is_show_atosa_index('cpm')"
                         sortable="custom">
          <template slot-scope="scope">
            {{ m__get_report_property(scope.row, 'cpm') | currency }} <br>
            <div v-if="is_compare_campaign" class="compare-keyword">
              {{ m__get_compare_report_property(scope.row, 'cpm') | currency }}
            </div>
            <template v-else>
              <small v-if="m__check_report_ratio(scope.row, 'none') > 0" class="text-success">
                +{{ m__get_report_ratio(scope.row, 'none') }}</small>
              <small v-else class="text-danger">
                {{ m__get_report_ratio(scope.row, 'none') }}</small>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="report.cancelled_gmv.value" :label="$t('metric.cancelled_gmv')" width="120px"
                         v-if="m__is_show_atosa_index('cancelled_gmv')" sortable="custom">
          <template slot-scope="scope">
            {{ m__get_report_property(scope.row, 'cancelled_gmv') | currency }} <br>
            <div v-if="is_compare_campaign" class="compare-keyword">
              {{ m__get_compare_report_property(scope.row, 'cancelled_gmv') | currency }}
            </div>
            <template v-else>
              <small v-if="m__check_report_ratio(scope.row, 'none') > 0" class="text-success">
                +{{ m__get_report_ratio(scope.row, 'none') }}</small>
              <small v-else class="text-danger">
                {{ m__get_report_ratio(scope.row, 'none') }}</small>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="report.cancelled_roi.value" :label="$t('metric.cancelled_roi')" width="140px"
                         v-if="m__is_show_atosa_index('cancelled_roi')" sortable="custom">
          <template slot-scope="scope">
            {{ (+m__get_report_property(scope.row, 'cancelled_roi')).toFixed(2) }} <br>
            <div v-if="is_compare_campaign" class="compare-keyword">
              {{ (+m__get_compare_report_property(scope.row, 'cancelled_roi')).toFixed(2) }}
            </div>
            <template v-else>
              <small v-if="m__check_report_ratio(scope.row, 'none') > 0" class="text-success">
                +{{ m__get_report_ratio(scope.row, 'none') }}</small>
              <small v-else class="text-danger">
                {{ m__get_report_ratio(scope.row, 'none') }}</small>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="report.cancelled_gmv.value" :label="$t('metric.exclude_cancelled_gmv')" width="140px"
                         v-if="m__is_show_atosa_index('exclude_cancelled_gmv')" sortable="custom">
          <template slot-scope="scope">
            {{ m__get_report_property(scope.row, 'exclude_cancelled_gmv') | currency }} <br>
            <div v-if="is_compare_campaign" class="compare-keyword">
              {{ m__get_compare_report_property(scope.row, 'cancelled_gmv') | currency }}
            </div>
            <template v-else>
              <small v-if="m__check_report_ratio(scope.row, 'none') > 0" class="text-success">
                +{{ m__get_report_ratio(scope.row, 'none') }}</small>
              <small v-else class="text-danger">
                {{ m__get_report_ratio(scope.row, 'none') }}</small>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="report.cancelled_roi.value" :label="$t('metric.exclude_cancelled_roi')" width="140px"
                         v-if="m__is_show_atosa_index('exclude_cancelled_roi')" sortable="custom">
          <template slot-scope="scope">
            {{ (+m__get_report_property(scope.row, 'exclude_cancelled_roi')).toFixed(2) }} <br>
            <div v-if="is_compare_campaign" class="compare-keyword">
              {{ (+m__get_compare_report_property(scope.row, 'exclude_cancelled_roi')).toFixed(2) }}
            </div>
            <template v-else>
              <small v-if="m__check_report_ratio(scope.row, 'none') > 0" class="text-success">
                +{{ m__get_report_ratio(scope.row, 'none') }}</small>
              <small v-else class="text-danger">
                {{ m__get_report_ratio(scope.row, 'none') }}</small>
            </template>
          </template>
        </el-table-column>
        <el-table-column :label="$t('base.optional')" width="200px">
          <template slot-scope="scope">
            <template v-if="scope.row.campaign.state === 'ongoing'">
              <a href="javascript:void(0)" class="text-warning" @click="m__pause_campaign(scope.row)">
                <i class="el-icon-video-pause"></i> {{ $t('base.pause') }}
              </a>
              <a href="javascript:void(0)" class="text-danger" @click="m__stop_campaign(scope.row)"
                 style="margin-left: 5px">
                <i class="el-icon-circle-close"></i> {{ $t('base.stop') }}
              </a>
              <br>
              <div style="padding-top: 15px; cursor: pointer" @click="m__show_config_auto_quota_dialog(scope.row)">
                <div style="color: #777;">
                  <i class="el-icon-setting"></i>
                  <strong> {{ $t('base.setup_x', { x: $t('ads.automatic_budget') }) }} </strong>
                </div>
              </div>
            </template>
            <template v-if="scope.row.campaign.state === 'paused'">
              <a href="javascript:void(0)" class="text-success" @click="m__ongoing_campaign(scope.row)">
                <i class="el-icon-refresh-right"></i> {{ $t('base.resume') }}
              </a>
              <a href="javascript:void(0)" class="text-danger" @click="m__stop_campaign(scope.row)"
                 style="margin-left: 5px">
                <i class="el-icon-circle-close"></i> {{ $t('base.stop') }}
              </a>
              <br>
              <div style="padding-top: 15px; cursor: pointer" @click="m__show_config_auto_quota_dialog(scope.row)">
                <div style="color: #777;">
                  <i class="el-icon-setting"></i>
                  <strong> {{ $t('base.setup_x', { x: $t('ads.automatic_budget') }) }} </strong>
                </div>
              </div>
            </template>
            <template v-if="scope.row.campaign.state === 'ended'">
              <a href="javascript:void(0)" class="text-success" @click="m__restart_campaign(scope.row)">
                <i class="el-icon-refresh-right"></i> {{ $t('base.restart') }}
              </a>
            </template>
            <div v-if="m__can_clone_campaign(scope.row)" style="padding-top: 15px; cursor: pointer"
                 @click="m__clone_campaign(scope.row)">
              <div style="color: #777;">
                <i class="el-icon-copy-document"></i>
                <strong> {{ $t('base.clone_x', { x: $t('base.campaign') }) }} </strong>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <el-table id="main-table" :class="{'table-hide-expand': is_group, 'table-vertical-top': m__has_agent()}"
                :data="c__show_display_campaign_list" @sort-change="m__sort_change" :row-key="is_group ? 'id' : null"
                :default-expand-all="is_group" @expand-change="m__on_expand_change">
        <el-table-column width="40px" :fixed="m__get_fixed_column()">
          <template slot="header" slot-scope="scope">
            <el-checkbox size="mini" :indeterminate="m__is_indeterminate()" v-bind:value="m__is_checked_all()"
                         @change="m__check_all"></el-checkbox>
          </template>
          <template slot-scope="scope">
            <el-checkbox v-if="!scope.row.is_parent" v-model="scope.row.checked" size="mini"></el-checkbox>
          </template>
        </el-table-column>
        <template v-if="is_group">
          <el-table-column width="45px" :fixed="m__get_fixed_column()" class-name="no-padding vertical-middle">
            <template slot-scope="scope">
              <template v-if="scope.row.is_parent">
                <img v-if="scope.row.product.images" style="width:32px; height:32px; border-radius: 4px;"
                     :src="m__map_campaign_image(scope.row)" alt="product_logo"/>
              </template>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.product')" :fixed="m__get_fixed_column()" width="300px"
                           show-tooltip-when-overflow class-name="vertical-middle">
            <template slot-scope="scope" slot="header">
              <el-dropdown @command="m__change_campaign_state" trigger="click">
                <span class="el-dropdown-link">
                  <span v-if="selected_state === 'all'">{{ $t('base.all') }}</span>
                  <span v-if="selected_state === 'ongoing'" class="text-primary">
                    {{ $t('base.ongoing') }}
                    <i class="el-icon-arrow-down" style="margin-left: 3px"></i>
                  </span>
                  <span v-if="selected_state === 'paused'" class="text-warning">
                    {{ $t('base.paused') }}
                    <i class="el-icon-arrow-down" style="margin-left: 3px"></i>
                  </span>
                  <span v-if="selected_state === 'ended'" class="text-danger">
                    {{ $t('base.ended') }}
                    <i class="el-icon-arrow-down" style="margin-left: 3px"></i>
                  </span>
                  <span v-if="selected_state === 'deleted'" class="text-danger">
                    {{ $t('base.deleted') }}
                    <i class="el-icon-arrow-down" style="margin-left: 3px"></i>
                  </span>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="all">{{ $t('base.all') }}</el-dropdown-item>
                  <el-dropdown-item command="ongoing">{{ $t('base.ongoing') }}</el-dropdown-item>
                  <el-dropdown-item command="paused">{{ $t('base.paused') }}</el-dropdown-item>
                  <el-dropdown-item command="ended">{{ $t('base.ended') }}</el-dropdown-item>
                  <el-dropdown-item command="deleted">{{ $t('base.deleted') }}</el-dropdown-item>
                  <hr>
                  <el-dropdown-item v-for="item in group_list" :key="item.id" :command="item.id">
                    {{ item.name }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <template slot-scope="scope">
              <template v-if="scope.row.is_parent">
                <div style="display: flex; gap: 10px; margin-bottom: 4px">
                  <div
                    v-if="m__is_show_auto_condition_action_config(scope.row)"
                    :class="m__is_auto_condition_action_config_running(scope.row) ? 'text-running' : 'text-paused'">
                    <a href="javascript:void(0)" @click="m__show_auto_condition_action_dialog(scope.row)">
                      {{ $t('ads.optimize_based_on_conditional') }}
                    </a>
                  </div>
                  <div v-if="scope.row.tags.has('best_selling')" class="text-blue rounded-[4px]">
                    <a href="javascript:void(0)" style="font-weight: 600">
                      {{ $t('base.best_selling') }}
                    </a>
                  </div>
                  <div v-if="scope.row.tags.has('best_selling')" class="text-blue rounded-[4px]">
                    <a href="javascript:void(0)" style="font-weight: 600">
                      {{ $t('base.potential') }}
                    </a>
                  </div>
                  <div v-if="scope.row.tags.has('able_to_x2')" class="text-x2 rounded-[4px]">
                    <a href="javascript:void(0)" style="font-weight: 700">
                      Sử dụng AI để X2
                    </a>
                  </div>
                </div>
                <a v-if="scope.row.id === 'shop'" style="display: block" :href="`javascript:void(0)`">
                  {{ $t('ads.shop_ads') }}
                </a>
                <a v-else-if="scope.row.id === 'product_mpd'" style="display: block" :href="`javascript:void(0)`">
                  {{ 'Chiến dịch nhóm' }}
                </a>
                <a v-else class="hover-class" style="display: block" href="javascript:void(0)"
                   @click="open_link_fixed(`https://shopee.com/product-i.${shop.shop_id}.${scope.row.product.itemid}`, shop)">
                  {{ scope.row.product.name }}
                </a>
              </template>
              <template v-else>
                <div style="height: 0; width: 100%"></div>
                <div style="display: flex; gap: 10px">
                  <div v-if="scope.row.campaign.state === 'ongoing'" class="text-running">
                    <a href="javascript:void(0)">{{ $t('base.ongoing') }}</a>
                  </div>
                  <div v-else-if="scope.row.campaign.state === 'paused'" class="text-pause">
                    <a href="javascript:void(0)">{{ $t('base.paused') }}</a>
                  </div>
                  <div v-else-if="scope.row.campaign.state === 'ended'" class="text-close">
                    <a href="javascript:void(0)">
                      Kết thúc</a>
                  </div>
                  <div v-else-if="scope.row.campaign.state === 'deleted'" class="text-close">
                    <a href="javascript:void(0)">
                      Đã xóa</a>
                  </div>
                  <div
                    v-if="m__is_show_auto_condition_action_config(scope.row)"
                    :class="m__is_auto_condition_action_config_running(scope.row) ? 'text-running' : 'text-paused'">
                    <a href="javascript:void(0)" @click="m__show_auto_condition_action_dialog(scope.row)">
                      {{ $t('ads.optimize_based_on_conditional') }}
                    </a>
                  </div>
                  <div v-if="scope.row.auto_optimize_search" class="text-running">
                    <a href="javascript:void(0)" @click="m__show_config_auto_optimize(scope.row, 'search')">
                      {{ $t('ads.optimize_keyword_based_on_cir') }}
                    </a>
                  </div>
                  <div v-if="scope.row.auto_optimize_targeting" class="text-running">
                    <a href="javascript:void(0)" @click="m__show_config_auto_optimize(scope.row, 'targeting')">
                      {{ $t('ads.optimize_targeting_based_on_cir') }}
                    </a>
                  </div>
                  <div v-if="scope.row.auto_quota" class="text-running">
                    <a href="javascript:void(0)" @click="m__show_config_auto_quota_dialog(scope.row)">
                      {{ $t('ads.automatic_budget') }}
                    </a>
                  </div>
                  <div v-if="false" class="text-blue">
                    <a href="javascript:void(0)" @click="m__show_auto_by_ai_config_list_dialog(scope.row)">
                      Tối ưu bằng AI
                    </a>
                  </div>
                </div>

                <a v-if="scope.row.campaign.type === 'all'" class="hover-class" style="color: #000"
                   :href="m__get_campaign_in_new_tab_url(scope.row)"
                   @click="m__redirect_detail($event, scope.row)">
                  <i v-if="scope.row.loading" class="el-icon-loading"></i>
                  <strong v-if="scope.row.product.state === 'deleted'">[{{ $t('base.deleted') }}]</strong>
                  <strong v-else-if="scope.row.product.stock === 0">[{{ $t('base.out_stock') }}]</strong>
                  {{ m__map_campaign_name(scope.row) }}
                </a>
                <a v-if="scope.row.campaign.type === 'keyword'" class="hover-class" style="color: #000"
                   :href="m__get_campaign_in_new_tab_url(scope.row)"
                   @click="m__redirect_detail($event, scope.row)">
                  <i v-if="scope.row.loading" class="el-icon-loading"></i>
                  <strong v-if="scope.row.product.state === 'deleted'">[{{ $t('base.deleted') }}]</strong>
                  <strong v-else-if="scope.row.product.stock === 0">[{{ $t('base.out_stock') }}]</strong>
                  {{ m__map_campaign_name(scope.row) }}
                </a>
                <a v-if="scope.row.campaign.type === 'targeting'" class="hover-class" style="color: #000"
                   :href="m__get_campaign_in_new_tab_url(scope.row)"
                   @click="m__redirect_detail($event, scope.row)">
                  <i v-if="scope.row.loading" class="el-icon-loading"></i>
                  <strong v-if="scope.row.product.state === 'deleted'">[{{ $t('base.deleted') }}]</strong>
                  <strong v-else-if="scope.row.product.stock === 0">[{{ $t('base.out_stock') }}]</strong>
                  {{ m__map_campaign_name(scope.row) }}
                </a>
                <a v-if="scope.row.campaign.type === 'shop'" class="hover-class" style="color: #000"
                   :href="m__get_campaign_in_new_tab_url(scope.row)"
                   @click="m__redirect_detail($event, scope.row)">
                  <i v-if="scope.row.loading" class="el-icon-loading"></i>
                  <strong>{{ scope.row.campaign.name }}</strong> &nbsp;&nbsp;
                  {{ m__map_campaign_name(scope.row) }}
                </a>
                <a v-if="scope.row.campaign.type === 'live_stream'" class="hover-class" style="color: #000"
                   :href="m__get_campaign_in_new_tab_url(scope.row)"
                   @click="m__redirect_detail($event, scope.row)">
                  <i v-if="scope.row.loading" class="el-icon-loading"></i>
                  <strong>{{ scope.row.campaign.campaignid }} - {{ scope.row.campaign.name }}</strong>
                </a>
                <a v-if="scope.row.campaign.type === 'product_mpd'" class="hover-class" style="color: #000"
                   :href="m__get_campaign_in_new_tab_url(scope.row)"
                   @click="m__redirect_detail($event, scope.row)">
                  <i v-if="scope.row.loading" class="el-icon-loading"></i>
                  <strong>{{ scope.row.campaign.name }}</strong>
                </a>

                <div style="padding-top: 5px">
                  <a href="javascript:void(0)" style="color: #999"
                     :class="scope.row.campaign.state !== 'ended' ? 'hover-class show-on-hover' : 'hide-icon'"
                     @click="m__show_update_campaign_date(scope.row)">
                    <template v-if="scope.row.campaign.end_time === 0">
                      {{ scope.row.campaign.start_time * 1000 | moment('DD/MM/YYYY') }}
                      -
                      {{ $t('base.no_end_date') }}
                    </template>
                    <template v-else>
                      {{ scope.row.campaign.start_time * 1000 | moment('DD/MM/YYYY') }}
                      -
                      {{ scope.row.campaign.end_time * 1000 | moment('DD/MM/YYYY') }}
                    </template>
                    <i class="el-icon-edit"></i>
                  </a>
                </div>
              </template>
            </template>
          </el-table-column>
        </template>
        <template v-else>
          <el-table-column v-if="!m__get_fixed_column()" type="expand">
            <template slot-scope="scope">
              <div v-if="scope.row.is_expanded"
                   style="padding-left: 20px; padding-bottom: 20px; background-color: #f5f7f8">
                <ComponentTargetingCampaign :key="component_key"
                                            :shop="shop"
                                            :parent_campaign.sync="scope.row"
                                            :sp_user="sp_user"
                                            :start_date="start_date"
                                            :end_date="end_date"
                                            :parent_is_compare_campaign="is_compare_campaign"
                                            :parent_compare_date_range="compare_date_range"
                                            :parent_flag="flag_list"
                                            :is_full="false"
                                            :auto_condition_action_config_list="auto_condition_action_config_list"
                                            :auto_condition_action_detail_config_list="auto_condition_action_detail_config_list"
                                            :ads_config="ads_config"
                                            @back_to_list="m__on_back_to_list"
                                            @change_product_placement="m__on_change_product_placement"
                                            @reload_auto_condition_action="m__get_auto_condition_action">
                </ComponentTargetingCampaign>
              </div>
            </template>
          </el-table-column>
          <el-table-column width="45px" :fixed="m__get_fixed_column()" class-name="no-padding">
            <template slot-scope="scope">
              <img style="width:32px; height:32px; border-radius: 4px;" :src="m__map_campaign_image(scope.row)"
                   alt="product_logo"/>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.product')" :fixed="m__get_fixed_column()" width="300px"
                           show-tooltip-when-overflow>
            <template slot-scope="scope" slot="header">
              <el-dropdown @command="m__change_campaign_state" trigger="click">
                <span class="el-dropdown-link">
                  <span v-if="selected_state === 'all'">{{ $t('base.all') }}</span>
                  <span v-if="selected_state === 'ongoing'" class="text-primary">
                    {{ $t('base.ongoing') }}
                    <i class="el-icon-arrow-down" style="margin-left: 3px"></i>
                  </span>
                  <span v-if="selected_state === 'paused'" class="text-warning">
                    {{ $t('base.paused') }}
                    <i class="el-icon-arrow-down" style="margin-left: 3px"></i>
                  </span>
                  <span v-if="selected_state === 'ended'" class="text-danger">
                    {{ $t('base.ended') }}
                    <i class="el-icon-arrow-down" style="margin-left: 3px"></i>
                  </span>
                  <span v-if="selected_state === 'deleted'" class="text-danger">
                    {{ $t('base.deleted') }}
                    <i class="el-icon-arrow-down" style="margin-left: 3px"></i>
                  </span>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="all">{{ $t('base.all') }}</el-dropdown-item>
                  <el-dropdown-item command="ongoing">{{ $t('base.ongoing') }}</el-dropdown-item>
                  <el-dropdown-item command="paused">{{ $t('base.paused') }}</el-dropdown-item>
                  <el-dropdown-item command="ended">{{ $t('base.ended') }}</el-dropdown-item>
                  <el-dropdown-item command="deleted">{{ $t('base.deleted') }}</el-dropdown-item>
                  <hr>
                  <el-dropdown-item v-for="item in group_list" :key="item.id" :command="item.id">
                    {{ item.name }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <template slot-scope="scope">
              <div style="height: 0; width: 100%"></div>
              <div style="display: flex; gap: 10px">
                <div v-if="scope.row.campaign.state === 'ongoing'" class="text-running">
                  <a href="javascript:void(0)">{{ $t('base.ongoing') }}</a>
                </div>
                <div v-else-if="scope.row.campaign.state === 'paused'" class="text-pause">
                  <a href="javascript:void(0)">{{ $t('base.paused') }}</a>
                </div>
                <div v-else-if="scope.row.campaign.state === 'ended'" class="text-close">
                  <a href="javascript:void(0)">
                    Kết thúc</a>
                </div>
                <div v-else-if="scope.row.campaign.state === 'deleted'" class="text-close">
                  <a href="javascript:void(0)">
                    Đã xóa</a>
                </div>
                <div
                  v-if="m__is_show_auto_condition_action_config(scope.row)"
                  :class="m__is_auto_condition_action_config_running(scope.row) ? 'text-running' : 'text-paused'">
                  <a href="javascript:void(0)" @click="m__show_auto_condition_action_dialog(scope.row)">
                    {{ $t('ads.optimize_based_on_conditional') }}
                  </a>
                </div>
                <div v-if="scope.row.auto_optimize_search" class="text-running">
                  <a href="javascript:void(0)" @click="m__show_config_auto_optimize(scope.row, 'search')">
                    {{ $t('ads.optimize_keyword_based_on_cir') }}
                  </a>
                </div>
                <div v-if="scope.row.auto_optimize_targeting" class="text-running">
                  <a href="javascript:void(0)" @click="m__show_config_auto_optimize(scope.row, 'targeting')">
                    {{ $t('ads.optimize_targeting_based_on_cir') }}
                  </a>
                </div>
                <div v-if="scope.row.auto_quota" class="text-running">
                  <a href="javascript:void(0)" @click="m__show_config_auto_quota_dialog(scope.row)">
                    {{ $t('ads.automatic_budget') }}
                  </a>
                </div>
                <div v-if="false" class="text-blue">
                  <a href="javascript:void(0)" @click="m__show_auto_by_ai_config_list_dialog(scope.row)">
                    Tối ưu bằng AI
                  </a>
                </div>
              </div>

              <a v-if="scope.row.campaign.type === 'all'" class="hover-class" style="color: #000"
                 :href="m__get_campaign_in_new_tab_url(scope.row)"
                 @click="m__redirect_detail($event, scope.row)">
                <i v-if="scope.row.loading" class="el-icon-loading"></i>
                <strong v-if="scope.row.product.state === 'deleted'">[{{ $t('base.deleted') }}]</strong>
                <strong v-else-if="scope.row.product.stock === 0">[{{ $t('base.out_stock') }}]</strong>
                {{ scope.row.product.name }}
              </a>
              <a v-if="scope.row.campaign.type === 'keyword'" class="hover-class" style="color: #000"
                 :href="m__get_campaign_in_new_tab_url(scope.row)"
                 @click="m__redirect_detail($event, scope.row)">
                <i v-if="scope.row.loading" class="el-icon-loading"></i>
                <strong v-if="scope.row.product.state === 'deleted'">[{{ $t('base.deleted') }}]</strong>
                <strong v-else-if="scope.row.product.stock === 0">[{{ $t('base.out_stock') }}]</strong>
                {{ scope.row.product.name }}
              </a>
              <a v-if="scope.row.campaign.type === 'targeting'" class="hover-class" style="color: #000"
                 :href="m__get_campaign_in_new_tab_url(scope.row)"
                 @click="m__redirect_detail($event, scope.row)">
                <i v-if="scope.row.loading" class="el-icon-loading"></i>
                <strong v-if="scope.row.product.state === 'deleted'">[{{ $t('base.deleted') }}]</strong>
                <strong v-else-if="scope.row.product.stock === 0">[{{ $t('base.out_stock') }}]</strong>
                {{ scope.row.product.name }}
              </a>
              <a v-if="scope.row.campaign.type === 'shop'" class="hover-class" style="color: #000"
                 :href="m__get_campaign_in_new_tab_url(scope.row)"
                 @click="m__redirect_detail($event, scope.row)">
                <i v-if="scope.row.loading" class="el-icon-loading"></i>
                <strong>{{ scope.row.campaign.name }}</strong> &nbsp;&nbsp;
                <small style="color: #999">{{
                    scope.row.campaign.name
                  }}</small>
              </a>
              <a v-if="scope.row.campaign.type === 'live_stream'" class="hover-class" style="color: #000"
                 :href="m__get_campaign_in_new_tab_url(scope.row)"
                 @click="m__redirect_detail($event, scope.row)">
                <i v-if="scope.row.loading" class="el-icon-loading"></i>
                <strong>{{ scope.row.campaign.campaignid }} - {{ scope.row.campaign.name }}</strong>
              </a>
              <a v-if="scope.row.campaign.type === 'product_mpd'" class="hover-class" style="color: #000"
                 :href="m__get_campaign_in_new_tab_url(scope.row)"
                 @click="m__redirect_detail($event, scope.row)">
                <i v-if="scope.row.loading" class="el-icon-loading"></i>
                <strong>{{ scope.row.campaign.name }}</strong>
              </a>

              <div style="padding-top: 5px">
                <a href="javascript:void(0)" style="color: #999"
                   :class="scope.row.campaign.state !== 'ended' ? 'hover-class show-on-hover' : 'hide-icon'"
                   @click="m__show_update_campaign_date(scope.row)">
                  <template v-if="scope.row.campaign.end_time === 0">
                    {{ scope.row.campaign.start_time * 1000 | moment('DD/MM/YYYY') }}
                    -
                    {{ $t('base.no_end_date') }}
                  </template>
                  <template v-else>
                    {{ scope.row.campaign.start_time * 1000 | moment('DD/MM/YYYY') }}
                    -
                    {{ scope.row.campaign.end_time * 1000 | moment('DD/MM/YYYY') }}
                  </template>
                  <i class="el-icon-edit"></i>
                </a>
              </div>
            </template>
          </el-table-column>
        </template>
        <el-table-column :label="$t('base.type')" width="100px" :fixed="m__get_fixed_column(true)" prop="campaign.type">
          <template slot-scope="scope" slot="header">
            <el-popover
              placement="top"
              trigger="click">
              <div style="min-width: 600px">
                <div style="display: flex; justify-content: space-between; gap: 20px">
                  <div style="display: flex; flex-direction: column; gap: 20px;">
                    <div style="display: flex">
                      <el-checkbox
                        v-for="item in campaign_type_checkbox.filter(i => campaign_type === 'new_cpc_homepage' || i.type === campaign_type)"
                        :key="item.label"
                        v-model="item.checked"
                        @change="(campaign_type === 'product_homepage') && m__get_campaign_reports()">
                        {{ item.label }}
                      </el-checkbox>
                    </div>
                    <div style="display: flex; align-items: center;">
                      <el-checkbox v-for="item in campaign_placement_checkbox" :key="item.label" v-model="item.checked">
                        {{ item.label }}
                      </el-checkbox>
                    </div>
                  </div>

                  <div style="display: flex; align-items: end; justify-content: end; padding-bottom: 3px">
                    <el-button type="text" size="mini"
                               @click="campaign_type_checkbox.forEach(i => i.checked = false); campaign_placement_checkbox.forEach(i => i.checked = false)">
                      <strong class="text-danger">{{ $t('base.unselect') }}</strong>
                    </el-button>
                  </div>
                </div>
              </div>
              <span slot="reference" style="cursor: pointer;">
                <span style="color: #606266;"
                      :style="campaign_type_checkbox.some(i => i.checked) || campaign_placement_checkbox.some(i => i.checked) ? 'color: #337ab7 !important' : ''">
                  {{ $t('base.optional') }}
                  <i class="el-icon-arrow-down" style="margin-left: 3px"></i>
                </span>
              </span>
            </el-popover>
          </template>
          <template slot-scope="scope">
            <template v-if="scope.row.campaign.type === 'all'">
              <div>{{ $t('base.all') }}</div>
              <template v-if="scope.row.campaign.bidding_type === 'manual'">
                <span style="font-size: 11px; color: #666">{{ $t('ads.manual_bidding') }}</span>
              </template>
              <template v-if="scope.row.campaign.bidding_type === 'auto'">
                <span style="font-size: 11px; color: #666">{{ $t('ads.auto_bidding') }}</span>
              </template>
              <template v-if="scope.row.campaign.bidding_type === 'roi_two'">
                <span style="font-size: 11px; color: #666">{{ $t('ads.auto_bidding') }}</span>
              </template>
            </template>
            <template v-if="scope.row.campaign.type === 'keyword'">
              <div>{{ $t('ads.search') }}</div>
              <template v-if="scope.row.campaign.bidding_type === 'manual'">
                <span style="font-size: 11px; color: #666">{{ $t('ads.manual_bidding') }}</span>
              </template>
              <template v-if="scope.row.campaign.bidding_type === 'auto'">
                <span style="font-size: 11px; color: #666">{{ $t('ads.auto_bidding') }}</span>
              </template>
              <template v-if="scope.row.campaign.bidding_type === 'roi_two'">
                <span style="font-size: 11px; color: #666">{{ $t('ads.auto_bidding') }}</span>
              </template>
            </template>
            <template v-if="scope.row.campaign.type === 'targeting'">
              <div>{{ $t('ads.targeting') }}</div>
              <template v-if="scope.row.campaign.bidding_type === 'manual'">
                <span style="font-size: 11px; color: #666">{{ $t('ads.manual_bidding') }}</span>
              </template>
              <template v-if="scope.row.campaign.bidding_type === 'auto'">
                <span style="font-size: 11px; color: #666">{{ $t('ads.auto_bidding') }}</span>
              </template>
              <template v-if="scope.row.campaign.bidding_type === 'roi_two'">
                <span style="font-size: 11px; color: #666">{{ $t('ads.auto_bidding') }}</span>
              </template>
            </template>
            <template v-if="scope.row.campaign.type === 'shop'">
              <div>Shop</div>
              <template v-if="scope.row.campaign.bidding_type === 'manual'">
                <span style="font-size: 11px; color: #666">{{ $t('ads.manual_bidding') }}</span>
              </template>
              <template v-if="scope.row.campaign.bidding_type === 'auto'">
                <span style="font-size: 11px; color: #666">{{ $t('ads.auto_bidding') }}</span>
              </template>
            </template>
          </template>
        </el-table-column>
        <el-table-column :label="$t('base.budget')" width="140px" :fixed="m__get_fixed_column(true)"
                         show-tooltip-when-overflow>
          <template slot-scope="scope" slot="header">
            <el-dropdown trigger="click" placement="bottom">
              <span class="el-dropdown-link">
                <span v-if="quota_filter === 'all'">
                  {{ $t('base.budget') }}
                  <i class="el-icon-arrow-down" style="margin-left: 3px"></i>
                </span>
                <span v-if="quota_filter === 'low_quota'" class="text-primary">
                  {{ $t('base.low_budget') }}
                  <i class="el-icon-arrow-down" style="margin-left: 3px"></i>
                </span>
                <span v-if="quota_filter === 'sort_desc'" class="text-primary">
                  {{ $t('base.budget') }}
                  <i class="el-icon-arrow-down" style="margin-left: 3px"></i>
                </span>
                <span v-if="quota_filter === 'sort_asc'" class="text-primary">
                  {{ $t('base.budget') }}
                  <i class="el-icon-arrow-down" style="margin-left: 3px"></i>
                </span>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="quota_filter = 'all'">
                  <span :style="quota_filter === 'all' ? 'font-weight: bold' :''">
                    {{ $t('ads.all') }}
                  </span>
                </el-dropdown-item>
                <el-dropdown-item @click.native="quota_filter = 'low_quota'">
                  <span :style="quota_filter === 'low_quota' ? 'font-weight: bold' :''">
                    {{ $t('ads.with_low_budget') }}
                  </span>
                </el-dropdown-item>
                <el-dropdown-item @click.native="quota_filter = 'sort_desc'">
                  <span :style="quota_filter === 'sort_desc' ? 'font-weight: bold' :''">
                    {{ 'Sắp xếp cao → thấp' }}
                  </span>
                </el-dropdown-item>
                <el-dropdown-item @click.native="quota_filter = 'sort_asc'">
                  <span :style="quota_filter === 'sort_asc' ? 'font-weight: bold' :''">
                    {{ 'Sắp xếp thấp → cao' }}
                  </span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
          <template slot-scope="scope">
            <template v-if="!scope.row.is_parent">
              <template
                v-if="m__calculate(scope.row.campaign.daily_quota) === 0 && m__calculate(scope.row.campaign.total_quota) === 0">
                <a href="javascript:void(0)"
                   @click="m__show_update_campaign_quota(scope.row)"
                   :class="scope.row.campaign.state !== 'ended' ? 'hover-class show-on-hover' : 'hide-icon'">
                  <small style="color: #999;">{{ $t('base.unlimited') }} <i class="el-icon-edit"></i></small>
                </a>
              </template>
              <template v-else-if="m__calculate(scope.row.campaign.daily_quota)">
                <a href="javascript:void(0)"
                   @click="m__show_update_campaign_quota(scope.row)"
                   :class="scope.row.campaign.state !== 'ended' ? 'hover-class show-on-hover' : 'hide-icon'">
                  {{ scope.row.campaign.daily_quota | currency }} {{ m__currency() }}
                  &nbsp;
                  <el-tooltip
                    class="item" effect="dark"
                    :content="$t('ads.running_out_of_budget_message')"
                    placement="top">
                    <i v-if="m__is_low_quota(scope.row)" class="text-danger el-icon-warning-outline"
                       style="font-size: 13px !important;"></i>
                  </el-tooltip>
                  <br>
                  <small style="color: #999;">{{ $t('base.daily_budget') }} <i class="el-icon-edit"></i></small>
                </a>
              </template>
              <template v-else>
                <a href="javascript:void(0)"
                   @click="m__show_update_campaign_quota(scope.row)"
                   :class="scope.row.campaign.state !== 'ended' ? 'hover-class show-on-hover' : 'hide-icon'">
                  {{ scope.row.campaign.total_quota | currency }} {{ m__currency() }}
                  &nbsp;
                  <el-tooltip
                    class="item" effect="dark"
                    :content="$t('ads.running_out_of_budget_message')"
                    placement="top">
                    <i v-if="m__is_low_quota(scope.row)" class="text-danger el-icon-warning-outline"
                       style="font-size: 13px !important;"></i>
                  </el-tooltip>
                  <br>
                  <small style="color:#999;">{{ $t('base.total_budget') }} <i class="el-icon-edit"></i></small>
                </a>
              </template>
            </template>
          </template>
        </el-table-column>
        <el-table-column v-if="m__has_agent()" width="180px" show-tooltip-when-overflow>
          <template slot="header" slot-scope="scope">
            <el-dropdown trigger="click" placement="bottom">
              <div class="el-dropdown-link" style="display: flex; gap: 6px; align-items: center;">
                <strong style="color: #8e44ad">Atosa Agent</strong>
                <i class="el-icon-arrow-down" style="font-weight: bold; color: #8e44ad"></i>
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="atosa_agent_filter = 'all'">
                  <div style="display: flex; gap: 10px">
                    <span style="flex: auto">{{ 'Tất cả chiến dịch' }}</span>
                    <span style="width: 10px">
                      <i v-if="atosa_agent_filter === 'all'" class="el-icon-check"></i>
                    </span>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item @click.native="atosa_agent_filter = 'applying'">
                  <div style="display: flex; gap: 10px">
                    <span style="flex: auto">{{ 'Đang cài Atosa Agent' }}</span>
                    <span style="width: 10px">
                      <i v-if="atosa_agent_filter === 'applying'" class="el-icon-check"></i>
                    </span>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item @click.native="atosa_agent_filter = 'not_applying'">
                  <div style="display: flex; gap: 10px">
                    <span style="flex: auto">{{ 'Chưa cài Atosa Agent' }}</span>
                    <span style="width: 10px">
                      <i v-if="atosa_agent_filter === 'not_applying'" class="el-icon-check"></i>
                    </span>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item @click.native="atosa_agent_filter = 'replanning'">
                  <div style="display: flex; gap: 10px">
                    <span style="flex: auto">{{ 'Cần thiết lập lại mục tiêu' }}</span>
                    <span style="width: 10px">
                      <i v-if="atosa_agent_filter === 'replanning'" class="el-icon-check"></i>
                    </span>
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
          <template slot-scope="scope">
            <div v-if="!scope.row.auto && !scope.row.is_parent && m__can_setup_auto_by_ai(scope.row)"
                 style="cursor: pointer" @click="m__show_auto_by_ai_config_list_dialog(scope.row)">
              <template v-if="m__has_auto_by_ai_config(scope.row)">
                <template v-if="m__check_atosa_agent_used_package().result === false">
                  <el-tooltip placement="top" effect="light"
                              :content="`Bạn cần gia hạn gói sản phẩm để tiếp tục sử dụng tính năng`">
                    <span class="paused-tag">
                      <i class="el-icon-warning" style="font-weight: bold !important;"></i>
                      Tạm dừng
                    </span>
                  </el-tooltip>
                </template>
                <template v-else-if="m__check_is_unpaid_operating_cost()">
                  <el-tooltip placement="top" effect="light"
                              :content="`Bạn cần thanh toán phí vận hành để tiếp tục sử dụng tính năng`">
                    <span class="paused-tag">
                      <i class="el-icon-warning" style="font-weight: bold !important;"></i>
                      Tạm dừng
                    </span>
                  </el-tooltip>
                </template>
                <template v-else>
                  <div style="display: flex; align-items: center; gap: 12px">
                    <span class="ai-tag">
                      <i class="el-icon-circle-check" style="font-weight: bold !important;"></i>
                      Đang care
                    </span>

                    <template v-if="m__check_atosa_agent_config_target(scope.row)">
                      <el-tooltip placement="top" effect="light">
                        <div slot="content" style="font-size: 13px">
                          Mục tiêu bạn đặt ra đang cao hơn mức khuyến nghị, điều này có thể ảnh hưởng đến hiệu suất
                          chiến dịch. Hãy cập nhật lại để chiến dịch đạt kết quả tốt nhất.
                        </div>
                        <span style="font-size: 16px">⚠️</span>
                      </el-tooltip>
                    </template>
                  </div>
                </template>
              </template>
              <strong v-else style="color: #a94442">
                Click để cài đặt
              </strong>
            </div>
          </template>
        </el-table-column>
        <el-table-column width="140px" show-tooltip-when-overflow>
          <template slot="header" slot-scope="scope">
            <el-dropdown trigger="click" placement="bottom" @command="m__handle_tag_command">
              <div class="el-dropdown-link">
                <span :class="{'text-primary': tag_ids_selected.length}">
                  {{ $t('base.select_tags') }}
                  <i class="el-icon-arrow-down" style="margin-left: 3px"></i>
                </span>
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="added">
                  <div style="display: flex; gap: 10px">
                    <span style="flex: auto">{{ $t('base.tags_added') }}</span>
                    <span style="width: 10px">
                      <i v-if="m__check_tag_ids_selected('added')" class="el-icon-check"></i>
                    </span>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item command="not_added">
                  <div style="display: flex; gap: 10px">
                    <span style="flex: auto">{{ $t('base.no_tags_added') }}</span>
                    <span style="width: 10px">
                      <i v-if="m__check_tag_ids_selected('not_added')" class="el-icon-check"></i>
                    </span>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item v-for="tag in campaign_tag_list" :key="tag._id" :command="tag._id">
                  <div style="display: flex; gap: 10px">
                    <span style="flex: auto">{{ tag.name }}</span>
                    <span style="width: 10px">
                      <i v-if="m__check_tag_ids_selected(tag._id)" class="el-icon-check"></i>
                    </span>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item command="create_tag" divided>
                  <i class="el-icon-plus"></i> {{ $t('base.create_tags') }}
                </el-dropdown-item>
                <el-dropdown-item command="add_to_keyword">
                  {{ $t('base.add_tags_for_selected_x', { x: $t('base.campaign') }) }}
                </el-dropdown-item>
                <el-dropdown-item command="remove_from_keyword">
                  {{ $t('base.remove_tags_of_selected_x', { x: $t('base.campaign') }) }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
          <template slot-scope="scope">
            <template v-if="!scope.row.auto && !scope.row.is_parent">
              <el-dropdown trigger="click" placement="bottom" @command="m__handle_campaign_tag_command"
                           :disabled="campaign_tag_list.length === 0">
                <template v-if="m__map_campaign_tag(scope.row)">
                  <strong class="text-primary">{{ m__map_campaign_tag(scope.row) }}</strong>
                </template>
                <template v-else>
                  <strong style="color: #3d3d3d">{{ $t('base.add_tags') }}</strong>
                </template>

                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="tag in campaign_tag_list" :key="tag._id"
                                    :command="JSON.stringify({campaign_id:scope.row.campaign.campaignid, tag_id: tag._id})">
                    <div style="display: flex; gap: 10px">
                      <span style="flex: auto">{{ tag.name }}</span>
                      <span style="width: 10px">
                        <i v-if="m__check_campaign_match(scope.row.campaign.campaignid, tag._id)"
                           class="el-icon-check"></i>
                      </span>
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item v-if="m__map_campaign_tag(scope.row)"
                                    :command="JSON.stringify({campaign_id:scope.row.campaign.campaignid, tag_id: 'remove_tag'})"
                                    divided>
                    <i class="el-icon-close"></i> {{ $t('base.remove_tags') }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </template>
        </el-table-column>
        <el-table-column :label="$t('base.target_roas')" prop="campaign.roi_two_target" width="130px" sortable="custom">
          <template slot-scope="scope">
            <div class="roi_two" v-if="target_roas_includes.has(scope.row.campaign.bidding_type)"
                 style="display: flex; gap: 8px; cursor: pointer"
                 @click="m__show_update_target_broad_roi_dialog(scope.row)">
              <div>
                {{ +scope.row.campaign.roi_two_target ? scope.row.campaign.roi_two_target : $t('ads.auto_bidding') }}
              </div>
              <div style="opacity: 0;">
                <i class="el-icon-edit"></i>
              </div>
            </div>
            <div v-else>
              -
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="report.avg_rank.value" :label="$t('metric.avg_rank')" width="120px"
                         v-if="m__is_show_index('avg_rank')" sortable="custom">
          <template slot-scope="scope">
            {{ m__get_report_property(scope.row, 'avg_rank') | currency }} <br>
            <div v-if="is_compare_campaign" class="compare-keyword">
              {{ m__get_compare_report_property(scope.row, 'avg_rank') | currency }}
            </div>
            <template v-else>
              <small v-if="m__check_report_ratio(scope.row, 'avg_rank') > 0" class="text-success">
                +{{ m__get_report_ratio(scope.row, 'avg_rank') }}</small>
              <small v-else class="text-danger">
                {{ m__get_report_ratio(scope.row, 'avg_rank') }}</small>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="report.impression.value" :label="$t('metric.impressions')" width="120px"
                         v-if="m__is_show_index('impression')" sortable="custom">
          <template slot-scope="scope">
            {{ m__get_report_property(scope.row, 'impression') | currency }} <br>
            <div v-if="is_compare_campaign" class="compare-keyword">
              {{ m__get_compare_report_property(scope.row, 'impression') | currency }}
            </div>
            <template v-else>
              <small v-if="m__check_report_ratio(scope.row, 'impression') > 0" class="text-success">
                +{{ m__get_report_ratio(scope.row, 'impression') }}</small>
              <small v-else class="text-danger">
                {{ m__get_report_ratio(scope.row, 'impression') }}</small>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="report.click.value" :label="$t('metric.clicks')" width="120px"
                         v-if="m__is_show_index('click')"
                         sortable="custom">
          <template slot-scope="scope">
            {{ m__get_report_property(scope.row, 'click') | currency }} <br>
            <div v-if="is_compare_campaign" class="compare-keyword">
              {{ m__get_compare_report_property(scope.row, 'click') | currency }}
            </div>
            <template v-else>
              <small v-if="m__check_report_ratio(scope.row, 'click') > 0" class="text-success">
                +{{ m__get_report_ratio(scope.row, 'click') }}</small>
              <small v-else class="text-danger">
                {{ m__get_report_ratio(scope.row, 'click') }}</small>
            </template>

            <div
              v-if="has_agency_plan() && scope.row.plan"
              style="margin-top: 10px">
              <strong style="font-size: 12px !important;" class="text-primary">
                KH: {{ scope.row.plan.target_traffic_search | currency }}
              </strong><br>
              <strong style="font-size: 12px !important;" class="text-success">
                HT: {{ is_percent_of(scope.row.report.click.value, scope.row.plan.target_traffic_search).toFixed(1) }}%
              </strong>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="report.atosa_cpc.value" label="CPC" width="120px"
                         v-if="m__is_show_index('click')"
                         sortable="custom">
          <template slot-scope="scope">
            {{ m__get_report_property(scope.row, 'atosa_cpc') | currency }} <br>
            <div v-if="is_compare_campaign" class="compare-keyword">
              {{ m__get_compare_report_property(scope.row, 'atosa_cpc') | currency }}
            </div>
            <template v-else>
              <small v-if="m__check_report_ratio(scope.row, 'none') > 0" class="text-success">
                +{{ m__get_report_ratio(scope.row, 'none') }}</small>
              <small v-else class="text-danger">
                {{ m__get_report_ratio(scope.row, 'none') }}</small>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="report.ctr.value" :label="$t('metric.ctr')" width="100px" v-if="m__is_show_index('ctr')"
                         sortable="custom">
          <template slot-scope="scope">
            {{ (+m__get_report_property(scope.row, 'ctr') * 100).toFixed(1) }} % <br>
            <div v-if="is_compare_campaign" class="compare-keyword">
              {{ (+m__get_compare_report_property(scope.row, 'ctr') * 100).toFixed(1) }} %
            </div>
            <template v-else>
              <small v-if="m__check_report_ratio(scope.row, 'ctr') > 0" class="text-success">
                +{{ m__get_report_ratio(scope.row, 'ctr') }}</small>
              <small v-else class="text-danger">
                {{ m__get_report_ratio(scope.row, 'ctr') }}</small>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="report.broad_order.value" :label="$t('metric.conversions')" width="140px"
                         v-if="m__is_show_index('broad_order')" sortable="custom">
          <template slot-scope="scope">
            {{ m__get_report_property(scope.row, 'broad_order') | currency }} <br>
            <div v-if="is_compare_campaign" class="compare-keyword">
              {{ m__get_compare_report_property(scope.row, 'broad_order') | currency }}
            </div>
            <template v-else>
              <small v-if="m__check_report_ratio(scope.row, 'broad_order') > 0" class="text-success">
                +{{ m__get_report_ratio(scope.row, 'broad_order') }}</small>
              <small v-else class="text-danger">
                {{ m__get_report_ratio(scope.row, 'broad_order') }}</small>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="report.direct_order.value" :label="$t('metric.direct_conversions')" width="115px"
                         v-if="m__is_show_index('direct_order')" sortable="custom">
          <template slot-scope="scope">
            {{ m__get_report_property(scope.row, 'direct_order') | currency }} <br>
            <div v-if="is_compare_campaign" class="compare-keyword">
              {{ m__get_compare_report_property(scope.row, 'direct_order') | currency }}
            </div>
            <template v-else>
              <small v-if="m__check_report_ratio(scope.row, 'direct_order') > 0" class="text-success">
                +{{ m__get_report_ratio(scope.row, 'direct_order') }}</small>
              <small v-else class="text-danger">
                {{ m__get_report_ratio(scope.row, 'direct_order') }}</small>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="report.broad_order_amount.value" :label="$t('metric.items_sold')" width="150px"
                         v-if="m__is_show_index('broad_order_amount')" sortable="custom">
          <template slot-scope="scope">
            {{ m__get_report_property(scope.row, 'broad_order_amount') | currency }} <br>
            <div v-if="is_compare_campaign" class="compare-keyword">
              {{ m__get_compare_report_property(scope.row, 'broad_order_amount') | currency }}
            </div>
            <template v-else>
              <small v-if="m__check_report_ratio(scope.row, 'broad_order_amount') > 0" class="text-success">
                +{{ m__get_report_ratio(scope.row, 'broad_order_amount') }}</small>
              <small v-else class="text-danger">
                {{ m__get_report_ratio(scope.row, 'broad_order_amount') }}</small>
            </template>

            <div
              v-if="has_agency_plan() && scope.row.plan"
              style="margin-top: 10px">
              <strong style="font-size: 12px !important;" class="text-primary">
                KH: {{ scope.row.plan.target_order_search | currency }}
              </strong><br>
              <strong style="font-size: 12px !important;" class="text-success">
                HT: {{
                  is_percent_of(scope.row.report.broad_order_amount.value, scope.row.plan.target_order_search).toFixed(1)
                }}%
              </strong>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="report.direct_order_amount.value" :label="$t('metric.direct_items_sold')" width="125px"
                         v-if="m__is_show_index('direct_order_amount')" sortable="custom">
          <template slot-scope="scope">
            {{ m__get_report_property(scope.row, 'direct_order_amount') | currency }} <br>
            <div v-if="is_compare_campaign" class="compare-keyword">
              {{ m__get_compare_report_property(scope.row, 'direct_order_amount') | currency }}
            </div>
            <template v-else>
              <small v-if="m__check_report_ratio(scope.row, 'direct_order_amount') > 0" class="text-success">
                +{{ m__get_report_ratio(scope.row, 'direct_order_amount') }}</small>
              <small v-else class="text-danger">
                {{ m__get_report_ratio(scope.row, 'direct_order_amount') }}</small>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="report.broad_gmv.value" label="GMV" width="145px" v-if="m__is_show_index('broad_gmv')"
                         sortable="custom">
          <template slot-scope="scope">
            {{ m__get_report_property(scope.row, 'broad_gmv') | currency }} <br>
            <div v-if="is_compare_campaign" class="compare-keyword">
              {{ m__get_compare_report_property(scope.row, 'broad_gmv') | currency }}
            </div>
            <template v-else>
              <small v-if="m__check_report_ratio(scope.row, 'broad_gmv') > 0" class="text-success">
                +{{ m__get_report_ratio(scope.row, 'broad_gmv') }}</small>
              <small v-else class="text-danger">
                {{ m__get_report_ratio(scope.row, 'broad_gmv') }}</small>
            </template>

            <div v-if="m__can_setup_auto_by_ai(scope.row) && m__has_auto_by_ai_config(scope.row)"
                 style="margin-top: 10px">
              <span class="plan-tag full-w">
                Mục tiêu: {{ m__short_value(m__get_auto_by_ai_target(scope.row, 'gmv')) }}
              </span>
              <el-tooltip placement="top" effect="light"
                          :content="`Đã thực hiện được ${m__calculate_auto_by_ai_target(m__get_auto_by_ai_result(scope.row, 'gmv'), m__get_auto_by_ai_target(scope.row, 'gmv'))}% so với kế hoạch tháng`">
                <span class="plan-tag full-w" style="color: rgb(96, 98, 102) !important;"
                      :style="m__get_css_percent_auto_by_ai(scope.row, 'gmv')">
                  Thực tế: {{ m__short_value(m__get_auto_by_ai_result(scope.row, 'gmv')) }}
                </span>
              </el-tooltip>
            </div>

            <div
              v-if="has_agency_plan() && scope.row.plan"
              style="margin-top: 10px">
              <strong style="font-size: 12px !important;" class="text-primary">
                KH: {{ scope.row.plan.target_gmv_ads_search | currency }}
              </strong><br>
              <strong style="font-size: 12px !important;" class="text-success">
                HT: {{
                  is_percent_of(scope.row.report.broad_gmv.value, scope.row.plan.target_gmv_ads_search).toFixed(1)
                }}%
              </strong>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="report.direct_gmv.value" :label="$t('metric.direct_gmv')" width="130px"
                         v-if="m__is_show_index('direct_gmv')" sortable="custom">
          <template slot-scope="scope">
            {{ m__get_report_property(scope.row, 'direct_gmv') | currency }} <br>
            <div v-if="is_compare_campaign" class="compare-keyword">
              {{ m__get_compare_report_property(scope.row, 'direct_gmv') | currency }}
            </div>
            <template v-else>
              <small v-if="m__check_report_ratio(scope.row, 'direct_gmv') > 0" class="text-success">
                +{{ m__get_report_ratio(scope.row, 'direct_gmv') }}</small>
              <small v-else class="text-danger">
                {{ m__get_report_ratio(scope.row, 'direct_gmv') }}</small>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="report.cost.value" :label="$t('metric.expense')" width="140px"
                         v-if="m__is_show_index('cost')"
                         sortable="custom">
          <template slot-scope="scope">
            {{ m__get_report_property(scope.row, 'cost') | currency }} <br>
            <div v-if="is_compare_campaign" class="compare-keyword">
              {{ m__get_compare_report_property(scope.row, 'cost') | currency }}
            </div>
            <template v-else>
              <small v-if="m__check_report_ratio(scope.row, 'cost') > 0" class="text-success">
                +{{ m__get_report_ratio(scope.row, 'cost') }}</small>
              <small v-else class="text-danger">
                {{ m__get_report_ratio(scope.row, 'cost') }}</small>
            </template>

            <div
              v-if="has_agency_plan() && scope.row.plan"
              style="margin-top: 10px">
              <strong style="font-size: 12px !important;" class="text-primary">
                KH: {{ scope.row.plan.target_cost_search | currency }}
              </strong><br>
              <strong style="font-size: 12px !important;" class="text-success">
                HT: {{ is_percent_of(scope.row.report.cost.value, scope.row.plan.target_cost_search).toFixed(1) }}%
              </strong>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="report.broad_roi.value" label="ROI (ROAS)" width="140px"
                         v-if="m__is_show_index('broad_roi')" sortable="custom">
          <template slot-scope="scope">
            {{ (+m__get_report_property(scope.row, 'broad_roi')).toFixed(2) }} <br>
            <div v-if="is_compare_campaign" class="compare-keyword">
              {{ (+m__get_compare_report_property(scope.row, 'broad_roi')).toFixed(2) }}
            </div>
            <template v-else>
              <small v-if="m__check_report_ratio(scope.row, 'broad_roi') > 0" class="text-success">
                +{{ m__get_report_ratio(scope.row, 'broad_roi') }}</small>
              <small v-else class="text-danger">
                {{ m__get_report_ratio(scope.row, 'broad_roi') }}</small>
            </template>

            <div v-if="m__can_setup_auto_by_ai(scope.row) && m__has_auto_by_ai_config(scope.row)"
                 style="margin-top: 10px">
              <span class="plan-tag full-w">
                Kế hoạch: {{ m__get_auto_by_ai_target(scope.row, 'roas') }}
              </span>
              <el-tooltip placement="top" effect="light"
                          :content="`Đã thực hiện được ${m__calculate_auto_by_ai_target(m__get_auto_by_ai_result(scope.row, 'roas'), m__get_auto_by_ai_target(scope.row, 'roas'))}% so với kế hoạch`">
                <span class="plan-tag full-w" style="color: rgb(96, 98, 102) !important;"
                      :style="m__get_css_percent_auto_by_ai(scope.row, 'roas')">
                  Thực tế: {{ m__get_auto_by_ai_result(scope.row, 'roas').toFixed(1) }}
                </span>
              </el-tooltip>
            </div>

            <div
              v-if="has_agency_plan() && scope.row.plan"
              style="margin-top: 10px">
              <strong style="font-size: 12px !important;" class="text-primary">
                KH: {{ scope.row.plan.target_roas_search | currency }}
              </strong><br>
              <strong style="font-size: 12px !important;" class="text-success">
                HT: {{ is_percent_of(scope.row.report.cost.value, scope.row.plan.target_roas_search).toFixed(1) }}%
              </strong>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="report.direct_roi.value" :label="$t('metric.direct_roi')" width="130px"
                         v-if="m__is_show_index('direct_roi')" sortable="custom">
          <template slot-scope="scope">
            {{ (+m__get_report_property(scope.row, 'direct_roi')).toFixed(2) }} <br>
            <div v-if="is_compare_campaign" class="compare-keyword">
              {{ (+m__get_compare_report_property(scope.row, 'direct_roi')).toFixed(2) }}
            </div>
            <template v-else>
              <small v-if="m__check_report_ratio(scope.row, 'direct_roi') > 0" class="text-success">
                +{{ m__get_report_ratio(scope.row, 'direct_roi') }}</small>
              <small v-else class="text-danger">
                {{ m__get_report_ratio(scope.row, 'direct_roi') }}</small>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="report.broad_cir.value" label="CIR (ACOS)" width="120px"
                         v-if="m__is_show_index('broad_cir')"
                         sortable="custom">
          <template slot-scope="scope">
            {{ (+m__get_report_property(scope.row, 'broad_cir') * 100).toFixed(1) }} % <br>
            <div v-if="is_compare_campaign" class="compare-keyword">
              {{ (+m__get_compare_report_property(scope.row, 'broad_cir') * 100).toFixed(1) }} %
            </div>
            <template v-else>
              <small v-if="m__check_report_ratio(scope.row, 'board_cir') > 0" class="text-success">
                +{{ m__get_report_ratio(scope.row, 'broad_cir') }}</small>
              <small v-else class="text-danger">
                {{ m__get_report_ratio(scope.row, 'broad_cir') }}</small>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="report.direct_cir.value" :label="$t('metric.direct_cir')" width="120px"
                         v-if="m__is_show_index('direct_cir')" sortable="custom">
          <template slot-scope="scope">
            {{ (+m__get_report_property(scope.row, 'direct_cir') * 100).toFixed(1) }} % <br>
            <div v-if="is_compare_campaign" class="compare-keyword">
              {{ (+m__get_compare_report_property(scope.row, 'direct_cir') * 100).toFixed(1) }} %
            </div>
            <template v-else>
              <small v-if="m__check_report_ratio(scope.row, 'direct_cir') > 0" class="text-success">
                +{{ m__get_report_ratio(scope.row, 'direct_cir') }}</small>
              <small v-else class="text-danger">
                {{ m__get_report_ratio(scope.row, 'direct_cir') }}</small>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="report.cr.value" :label="$t('metric.conversion_rate')" width="140px"
                         v-if="m__is_show_index('cr')" sortable="custom">
          <template slot-scope="scope">
            {{ (+m__get_report_property(scope.row, 'cr') * 100).toFixed(1) }} % <br>
            <div v-if="is_compare_campaign" class="compare-keyword">
              {{ (+m__get_compare_report_property(scope.row, 'cr') * 100).toFixed(1) }} %
            </div>
            <template v-else>
              <small v-if="m__check_report_ratio(scope.row, 'cr') > 0" class="text-success">
                +{{ m__get_report_ratio(scope.row, 'cr') }}</small>
              <small v-else class="text-danger">
                {{ m__get_report_ratio(scope.row, 'cr') }}</small>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="report.direct_cir.value" :label="$t('metric.direct_conversion_rate')" width="140px"
                         v-if="m__is_show_index('direct_cr')" sortable="custom">
          <template slot-scope="scope">
            {{ (+m__get_report_property(scope.row, 'direct_cr') * 100).toFixed(1) }} % <br>
            <div v-if="is_compare_campaign" class="compare-keyword">
              {{ (+m__get_compare_report_property(scope.row, 'direct_cr') * 100).toFixed(1) }} %
            </div>
            <template v-else>
              <small v-if="m__check_report_ratio(scope.row, 'direct_cr') > 0" class="text-success">
                +{{ m__get_report_ratio(scope.row, 'direct_cr') }}</small>
              <small v-else class="text-danger">
                {{ m__get_report_ratio(scope.row, 'direct_cr') }}</small>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="report.cpc.value" :label="$t('metric.cost_per_conversion')" width="150px"
                         v-if="m__is_show_index('cpc')" sortable="custom">
          <template slot-scope="scope">
            {{ m__get_report_property(scope.row, 'cpc') | currency }} <br>
            <div v-if="is_compare_campaign" class="compare-keyword">
              {{ m__get_compare_report_property(scope.row, 'cpc') | currency }}
            </div>
            <template v-else>
              <small v-if="m__check_report_ratio(scope.row, 'cpc') > 0" class="text-success">
                +{{ m__get_report_ratio(scope.row, 'cpc') }}</small>
              <small v-else class="text-danger">
                {{ m__get_report_ratio(scope.row, 'cpc') }}</small>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="report.cpdc.value" :label="$t('metric.cost_per_direct_conversion')" width="140px"
                         v-if="m__is_show_index('cpdc')" sortable="custom">
          <template slot-scope="scope">
            {{ m__get_report_property(scope.row, 'cpdc') | currency }} <br>
            <div v-if="is_compare_campaign" class="compare-keyword">
              {{ m__get_compare_report_property(scope.row, 'cpdc') | currency }}
            </div>
            <template v-else>
              <small v-if="m__check_report_ratio(scope.row, 'cpdc') > 0" class="text-success">
                +{{ m__get_report_ratio(scope.row, 'cpdc') }}</small>
              <small v-else class="text-danger">
                {{ m__get_report_ratio(scope.row, 'cpdc') }}</small>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="report.aov.value" label="AOV" width="120px"
                         v-if="m__is_show_atosa_index('aov')"
                         sortable="custom">
          <template slot-scope="scope">
            {{ m__get_report_property(scope.row, 'aov') | currency }} <br>
            <div v-if="is_compare_campaign" class="compare-keyword">
              {{ m__get_compare_report_property(scope.row, 'aov') | currency }}
            </div>
            <template v-else>
              <small v-if="m__check_report_ratio(scope.row, 'none') > 0" class="text-success">
                +{{ m__get_report_ratio(scope.row, 'none') }}</small>
              <small v-else class="text-danger">
                {{ m__get_report_ratio(scope.row, 'none') }}</small>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="report.cpm.value" label="CPM" width="120px"
                         v-if="m__is_show_atosa_index('cpm')"
                         sortable="custom">
          <template slot-scope="scope">
            {{ m__get_report_property(scope.row, 'cpm') | currency }} <br>
            <div v-if="is_compare_campaign" class="compare-keyword">
              {{ m__get_compare_report_property(scope.row, 'cpm') | currency }}
            </div>
            <template v-else>
              <small v-if="m__check_report_ratio(scope.row, 'none') > 0" class="text-success">
                +{{ m__get_report_ratio(scope.row, 'none') }}</small>
              <small v-else class="text-danger">
                {{ m__get_report_ratio(scope.row, 'none') }}</small>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="report.cancelled_gmv.value" :label="$t('metric.cancelled_gmv')" width="120px"
                         v-if="m__is_show_atosa_index('cancelled_gmv')" sortable="custom">
          <template slot-scope="scope">
            {{ m__get_report_property(scope.row, 'cancelled_gmv') | currency }} <br>
            <div v-if="is_compare_campaign" class="compare-keyword">
              {{ m__get_compare_report_property(scope.row, 'cancelled_gmv') | currency }}
            </div>
            <template v-else>
              <small v-if="m__check_report_ratio(scope.row, 'none') > 0" class="text-success">
                +{{ m__get_report_ratio(scope.row, 'none') }}</small>
              <small v-else class="text-danger">
                {{ m__get_report_ratio(scope.row, 'none') }}</small>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="report.cancelled_roi.value" :label="$t('metric.cancelled_roi')" width="140px"
                         v-if="m__is_show_atosa_index('cancelled_roi')" sortable="custom">
          <template slot-scope="scope">
            {{ (+m__get_report_property(scope.row, 'cancelled_roi')).toFixed(2) }} <br>
            <div v-if="is_compare_campaign" class="compare-keyword">
              {{ (+m__get_compare_report_property(scope.row, 'cancelled_roi')).toFixed(2) }}
            </div>
            <template v-else>
              <small v-if="m__check_report_ratio(scope.row, 'none') > 0" class="text-success">
                +{{ m__get_report_ratio(scope.row, 'none') }}</small>
              <small v-else class="text-danger">
                {{ m__get_report_ratio(scope.row, 'none') }}</small>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="report.cancelled_gmv.value" :label="$t('metric.exclude_cancelled_gmv')" width="140px"
                         v-if="m__is_show_atosa_index('exclude_cancelled_gmv')" sortable="custom">
          <template slot-scope="scope">
            {{ m__get_report_property(scope.row, 'exclude_cancelled_gmv') | currency }} <br>
            <div v-if="is_compare_campaign" class="compare-keyword">
              {{ m__get_compare_report_property(scope.row, 'cancelled_gmv') | currency }}
            </div>
            <template v-else>
              <small v-if="m__check_report_ratio(scope.row, 'none') > 0" class="text-success">
                +{{ m__get_report_ratio(scope.row, 'none') }}</small>
              <small v-else class="text-danger">
                {{ m__get_report_ratio(scope.row, 'none') }}</small>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="report.cancelled_roi.value" :label="$t('metric.exclude_cancelled_roi')" width="140px"
                         v-if="m__is_show_atosa_index('exclude_cancelled_roi')" sortable="custom">
          <template slot-scope="scope">
            {{ (+m__get_report_property(scope.row, 'exclude_cancelled_roi')).toFixed(2) }} <br>
            <div v-if="is_compare_campaign" class="compare-keyword">
              {{ (+m__get_compare_report_property(scope.row, 'exclude_cancelled_roi')).toFixed(2) }}
            </div>
            <template v-else>
              <small v-if="m__check_report_ratio(scope.row, 'none') > 0" class="text-success">
                +{{ m__get_report_ratio(scope.row, 'none') }}</small>
              <small v-else class="text-danger">
                {{ m__get_report_ratio(scope.row, 'none') }}</small>
            </template>
          </template>
        </el-table-column>
        <el-table-column :label="$t('base.optional')" width="200px">
          <template slot-scope="scope">
            <template v-if="scope.row.campaign.state === 'ongoing'">
              <a href="javascript:void(0)" class="text-warning" @click="m__pause_campaign(scope.row)">
                <i class="el-icon-video-pause"></i> {{ $t('base.pause') }}
              </a>
              <a href="javascript:void(0)" class="text-danger" @click="m__stop_campaign(scope.row)"
                 style="margin-left: 5px">
                <i class="el-icon-circle-close"></i> {{ $t('base.stop') }}
              </a>
              <br>
              <div style="padding-top: 15px; cursor: pointer" @click="m__show_config_auto_quota_dialog(scope.row)">
                <div style="color: #777;">
                  <i class="el-icon-setting"></i>
                  <strong> {{ $t('base.setup_x', { x: $t('ads.automatic_budget') }) }} </strong>
                </div>
              </div>
            </template>
            <template v-if="scope.row.campaign.state === 'paused'">
              <a href="javascript:void(0)" class="text-success" @click="m__ongoing_campaign(scope.row)">
                <i class="el-icon-refresh-right"></i> {{ $t('base.resume') }}
              </a>
              <a href="javascript:void(0)" class="text-danger" @click="m__stop_campaign(scope.row)"
                 style="margin-left: 5px">
                <i class="el-icon-circle-close"></i> {{ $t('base.stop') }}
              </a>
              <br>
              <div style="padding-top: 15px; cursor: pointer" @click="m__show_config_auto_quota_dialog(scope.row)">
                <div style="color: #777;">
                  <i class="el-icon-setting"></i>
                  <strong> {{ $t('base.setup_x', { x: $t('ads.automatic_budget') }) }} </strong>
                </div>
              </div>
            </template>
            <template v-if="scope.row.campaign.state === 'ended'">
              <a href="javascript:void(0)" class="text-success" @click="m__restart_campaign(scope.row)">
                <i class="el-icon-refresh-right"></i> {{ $t('base.restart') }}
              </a>
            </template>
            <div v-if="m__can_clone_campaign(scope.row)" style="padding-top: 15px; cursor: pointer"
                 @click="m__clone_campaign(scope.row)">
              <div style="color: #777;">
                <i class="el-icon-copy-document"></i>
                <strong> {{ $t('base.clone_x', { x: $t('base.campaign') }) }} </strong>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination id="main-pagination" style="margin-top: 10px" :page-sizes="[15, 30, 50]"
                     :current-page.sync="campaign_filter.current_page" :page-size="campaign_filter.page_size"
                     layout="prev, pager, next, total, sizes" :total="c__show_filter_and_group_campaign_list.length"
                     @size-change="(val) => campaign_filter.page_size = val"/>
    </div>

    <div id="campaign-detail">
      <div v-if="['all', 'live_stream', 'product_mpd'].includes(campaign_component)">
        <ComponentSearchCampaign :key="component_key"
                                 :shop="shop"
                                 :parent_campaign.sync="selected_campaign"
                                 :sp_user="sp_user"
                                 :start_date="start_date"
                                 :end_date="end_date"
                                 :spike_days="[]"
                                 :agency_file="null"
                                 :parent_is_compare_campaign="is_compare_campaign"
                                 :parent_compare_date_range="compare_date_range"
                                 :ads_config="ads_config"
                                 :ads_data="ads_data"
                                 :non_ads_data="non_ads_data"
                                 :auto_condition_action_config_list="auto_condition_action_config_list"
                                 :auto_condition_action_detail_config_list="auto_condition_action_detail_config_list"
                                 :fff="fff"
                                 :is_advanced_ads="is_advanced_ads"
                                 :has_atosa_agent="m__check_atosa_agent_used_package().result"
                                 :auto_by_ai_config_list="auto_by_ai_config_list"
                                 @change_state="m__child_change_state"
                                 @back_to_list="m__on_back_to_list"
                                 @change_product_placement="m__on_change_product_placement"
                                 @reload_auto_condition_action="m__get_auto_condition_action"
                                 @show_auto_by_ai_config="m__show_auto_by_ai_config_list_dialog_by_campaign_id">
          <div v-if="selected_campaign" slot="automatic_configuration">
            <el-dropdown v-if="m__check_marketing_package('auto_campaign')" trigger="click">
              <el-button type="info" size="mini" icon="el-icon-s-tools">
                {{ $t('ads.automatic_configuration') }}
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="m__show_auto_condition_action_dialog(selected_campaign)">
                  <div style="display: flex; align-items: center; justify-content: space-between; gap: 20px">
                    <span>{{ $t('ads.conditional_configuration') }}</span>

                    <el-tag v-if="m__is_show_auto_condition_action_config(selected_campaign)"
                            :type="m__is_auto_condition_action_config_running(selected_campaign) ? 'success' : 'info'"
                            size="mini">
                      Đang cài
                    </el-tag>
                    <el-tag v-else type="info" size="mini">Chưa cài</el-tag>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item @click.native="m__show_config_auto_quota_dialog(selected_campaign)">
                  <div style="display: flex; align-items: center; justify-content: space-between; gap: 20px">
                    <span>{{ $t('ads.automatic_budget_configuration') }}</span>

                    <el-tag v-if="selected_campaign.auto_quota" type="success" size="mini">Đang cài</el-tag>
                    <el-tag v-else type="info" size="mini">Chưa cài</el-tag>
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </ComponentSearchCampaign>
      </div>

      <div v-if="campaign_component === 'keyword'">
        <ComponentSearchCampaign :key="component_key"
                                 :shop="shop"
                                 :parent_campaign.sync="selected_campaign"
                                 :sp_user="sp_user"
                                 :start_date="start_date"
                                 :end_date="end_date"
                                 :spike_days="[]"
                                 :agency_file="null"
                                 :parent_is_compare_campaign="is_compare_campaign"
                                 :parent_compare_date_range="compare_date_range"
                                 :ads_config="ads_config"
                                 :ads_data="ads_data"
                                 :non_ads_data="non_ads_data"
                                 :auto_condition_action_config_list="auto_condition_action_config_list"
                                 :auto_condition_action_detail_config_list="auto_condition_action_detail_config_list"
                                 :fff="fff"
                                 :is_advanced_ads="is_advanced_ads"
                                 :has_atosa_agent="m__check_atosa_agent_used_package().result"
                                 :auto_by_ai_config_list="auto_by_ai_config_list"
                                 @change_state="m__child_change_state"
                                 @back_to_list="m__on_back_to_list"
                                 @change_product_placement="m__on_change_product_placement"
                                 @reload_auto_condition_action="m__get_auto_condition_action"
                                 @show_auto_by_ai_config="m__show_auto_by_ai_config_list_dialog_by_campaign_id">
          <div v-if="selected_campaign" slot="automatic_configuration">
            <el-dropdown v-if="m__check_marketing_package('auto_campaign')" trigger="click">
              <el-button type="info" size="mini" icon="el-icon-s-tools">
                {{ $t('ads.automatic_configuration') }}
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="m__show_auto_condition_action_dialog(selected_campaign)">
                  <div style="display: flex; align-items: center; justify-content: space-between; gap: 20px">
                    <span>{{ $t('ads.conditional_configuration') }}</span>

                    <el-tag v-if="m__is_show_auto_condition_action_config(selected_campaign)"
                            :type="m__is_auto_condition_action_config_running(selected_campaign) ? 'success' : 'info'"
                            size="mini">
                      Đang cài
                    </el-tag>
                    <el-tag v-else type="info" size="mini">Chưa cài</el-tag>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item @click.native="m__show_config_auto_quota_dialog(selected_campaign)">
                  <div style="display: flex; align-items: center; justify-content: space-between; gap: 20px">
                    <span>{{ $t('ads.automatic_budget_configuration') }}</span>

                    <el-tag v-if="selected_campaign.auto_quota" type="success" size="mini">Đang cài</el-tag>
                    <el-tag v-else type="info" size="mini">Chưa cài</el-tag>
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </ComponentSearchCampaign>
      </div>

      <div v-if="campaign_component === 'targeting'">
        <ComponentTargetingCampaign :key="component_key"
                                    :shop="shop"
                                    :parent_campaign.sync="selected_campaign"
                                    :sp_user="sp_user"
                                    :start_date="start_date"
                                    :end_date="end_date"
                                    :parent_is_compare_campaign="is_compare_campaign"
                                    :parent_compare_date_range="compare_date_range"
                                    :parent_flag="flag_list"
                                    :is_full="true"
                                    :ads_config="ads_config"
                                    :ads_data="ads_data"
                                    :non_ads_data="non_ads_data"
                                    :show_tags="true"
                                    :auto_condition_action_config_list="auto_condition_action_config_list"
                                    :auto_condition_action_detail_config_list="auto_condition_action_detail_config_list"
                                    @change_state="m__child_change_state"
                                    @back_to_list="m__on_back_to_list"
                                    @change_product_placement="m__on_change_product_placement"
                                    @reload_auto_condition_action="m__get_auto_condition_action">
          <div v-if="selected_campaign" slot="automatic_configuration">
            <el-dropdown v-if="m__check_marketing_package('auto_campaign')" trigger="click">
              <el-button type="info" size="mini" icon="el-icon-s-tools">
                {{ $t('ads.automatic_configuration') }}
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="m__show_auto_condition_action_dialog(selected_campaign)">
                  <div style="display: flex; align-items: center; justify-content: space-between; gap: 20px">
                    <span>{{ $t('ads.conditional_configuration') }}</span>

                    <el-tag v-if="m__is_show_auto_condition_action_config(selected_campaign)"
                            :type="m__is_auto_condition_action_config_running(selected_campaign) ? 'success' : 'info'"
                            size="mini">
                      Đang cài
                    </el-tag>
                    <el-tag v-else type="info" size="mini">Chưa cài</el-tag>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item @click.native="m__show_config_auto_quota_dialog(selected_campaign)">
                  <div style="display: flex; align-items: center; justify-content: space-between; gap: 20px">
                    <span>{{ $t('ads.automatic_budget_configuration') }}</span>

                    <el-tag v-if="selected_campaign.auto_quota" type="success" size="mini">Đang cài</el-tag>
                    <el-tag v-else type="info" size="mini">Chưa cài</el-tag>
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </ComponentTargetingCampaign>
      </div>

      <div v-if="campaign_component === 'shop'">
        <ComponentShopCampaign :shop="shop"
                               :parent_campaign.sync="selected_campaign"
                               :sp_user="sp_user"
                               :start_date="start_date"
                               :end_date="end_date"
                               :spike_days="[]"
                               :agency_file="null"
                               :parent_is_compare_campaign="is_compare_campaign"
                               :parent_compare_date_range="compare_date_range"
                               :auto_condition_action_config_list="auto_condition_action_config_list"
                               :auto_condition_action_detail_config_list="auto_condition_action_detail_config_list"
                               :ads_config="ads_config"
                               :fff="fff"
                               @change_state="m__child_change_state"
                               @back_to_list="m__on_back_to_list"
                               @reload_auto_condition_action="m__get_auto_condition_action">
          <div v-if="selected_campaign" slot="automatic_configuration">
            <el-dropdown v-if="m__check_marketing_package('auto_campaign')" trigger="click">
              <el-button type="info" size="mini" icon="el-icon-s-tools">
                {{ $t('ads.automatic_configuration') }}
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="m__show_auto_condition_action_dialog(selected_campaign)">
                  <div style="display: flex; align-items: center; justify-content: space-between; gap: 20px">
                    <span>{{ $t('ads.conditional_configuration') }}</span>

                    <el-tag v-if="m__is_show_auto_condition_action_config(selected_campaign)"
                            :type="m__is_auto_condition_action_config_running(selected_campaign) ? 'success' : 'info'"
                            size="mini">
                      Đang cài
                    </el-tag>
                    <el-tag v-else type="info" size="mini">Chưa cài</el-tag>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item @click.native="m__show_config_auto_quota_dialog(selected_campaign)">
                  <div style="display: flex; align-items: center; justify-content: space-between; gap: 20px">
                    <span>{{ $t('ads.automatic_budget_configuration') }}</span>

                    <el-tag v-if="selected_campaign.auto_quota" type="success" size="mini">Đang cài</el-tag>
                    <el-tag v-else type="info" size="mini">Chưa cài</el-tag>
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </ComponentShopCampaign>
      </div>
    </div>

    <el-dialog width="1000px" :close-on-click-modal="false" :visible.sync="keyword_manager.show"
               custom-class="no-body">
      <div slot="title" style="padding:10px">
        <component__keyword_file_manager @add_to_recent="m__add_to_recent_keyword"
                                         :user="sp_user" :product_id="add_keyword.product_id" :shop="shop"
                                         ref="component_keyword_file_manager"></component__keyword_file_manager>
      </div>
    </el-dialog>

    <el-dialog width="600px" :close-on-click-modal="false" :visible.sync="add_keyword.show" custom-class="no-body">
      <div slot="title" style="padding:10px;">
        <template v-if="add_keyword.product_id===0">
          <div style="background-color: orangered; color:white; text-align:center; padding:10px; border-radius: 4px;">
            {{ $t('keyword.has_no_connected_message') }}
          </div>
        </template>
        <template v-else>
          <br>

          <el-input size="mini" :placeholder="$t('input.placeholder')"
                    v-model="add_keyword.keyword" style="margin-top: 10px"></el-input>
          <div class="table-responsive">
            <table class="table table-hover" style="margin-top:5px">
              <thead>
              <tr>
                <th>#</th>
                <th>
                </th>
                <th>{{ $t('base.keyword') }}</th>
                <th class="text-right">{{ $t('base.volume') }}</th>
                <th class="text-right">{{ $t('base.recommend_price') }}</th>
              </tr>
              </thead>
              <tbody>
              <template v-for="(item,index) in c__add_keyword_display_list">
                <tr>
                  <td>{{ index + 1 }}</td>
                  <td>
                    <el-checkbox v-model="item.checked"></el-checkbox>
                  </td>
                  <td>{{ item.keyword }}</td>
                  <td class="text-right">{{ item.sp_volume | currency }}</td>
                  <td class="text-right">{{ item.sp_price | currency }}</td>
                </tr>
              </template>
              </tbody>
            </table>
            <el-pagination :current-page.sync="add_keyword_filter.current_page"
                           :page-size="add_keyword_filter.page_size"
                           layout="prev, pager, next, total" :total="add_keyword.data.length"/>
          </div>
          <div style="padding-top:20px;" class="text-right">
            <el-button size="mini" icon="el-icon-close" @click="add_keyword.show=false">{{
                $t('base.close')
              }}
            </el-button>
            <el-button size="mini" icon="el-icon-check" type="primary" @click="m__add_selected_keyword"
                       :disabled="c__add_keyword__data_checked.length===0">
              {{ $t('base.add') }} ({{ c__add_keyword__data_checked.length }})
              {{ $t('base.x_selected', { x: $t('base.keyword') }) }}
            </el-button>
          </div>
        </template>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="save_keyword_file.show" :close-on-click-modal="false" custom-class="no-body"
               width="400px">
      <div slot="title" style="padding:10px">
        <p class="text-title">{{ $t('base.filename') }}</p>
        <el-input size="mini" :placeholder="$t('input.filename')"
                  v-model="save_keyword_file.filename"></el-input>
        <div style="padding-top:20px;" class="text-right">
          <el-button size="mini" icon="el-icon-close" @click="save_keyword_file.show=false">{{
              $t('base.close')
            }}
          </el-button>
          <el-button size="mini" icon="ti-save" :loading="save_keyword_file.loading" type="primary"
                     @click="m__try_save_keyword_file"> &nbsp; {{ $t('base.save_file') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog width="400px" :close-on-click-modal="false" :visible.sync="change_price.show" custom-class="no-body">
      <div slot="title" style="padding:10px;">
        <p class="text-title">{{ $t('base.calculate_from') }}</p>
        <el-radio v-model="change_price.apply_field" label="sp_price">{{ $t('base.shopee_recommend_price') }}</el-radio>
        <el-radio v-model="change_price.apply_field" label="us_price">{{ $t('base.current_price') }}</el-radio>
        <p class="text-title">{{ $t('base.i_or_d') }}</p>
        <el-radio v-model="change_price.func" label="SUB">{{ $t('base.decrease') }}</el-radio>
        <el-radio v-model="change_price.func" label="ADD">{{ $t('base.increase') }}</el-radio>
        <p class="text-title"> {{ $t('base.i_or_d_type') }} </p>
        <el-radio v-model="change_price.type" label="PERCENT">{{ $t('base.percent') }}</el-radio>
        <el-radio v-model="change_price.type" label="VALUE">{{ $t('base.amount') }}</el-radio>
        <template v-if="change_price.type==='PERCENT'">
          <p class="text-title">{{ $t('base.percent') }}</p>
          <el-input-number size="mini" :min="0" :max="2000" v-model="change_price.percent"
                           controls-position="right" class="full-w"></el-input-number>
        </template>
        <template v-else>
          <p class="text-title">{{ $t('base.amount') }}</p>
          <el-input-number size="mini" :min="0" :max="200000" v-model="change_price.value"
                           controls-position="right"
                           class="full-w"></el-input-number>
        </template>
        <div style="padding-top:20px; " class="text-right">
          <el-button size="mini" icon="el-icon-close" @click="change_price.show=false">{{
              $t('base.close')
            }}
          </el-button>
          <el-button size="mini" icon="el-icon-check" type="primary" @click="m__apply_config_for_new_price">
            {{ $t('base.apply') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.update_campaign_date" :close-on-click-modal="false"
               width="500px">
      <div slot="title" style="padding:10px">
        <strong class="strong-title">{{ $t('base.edit') }} {{ $t('ads.duration') }}</strong>

        <el-radio v-model="selected_time_type" label="unlimited">{{ $t('base.no_end_date') }}</el-radio>
        <br>
        <el-radio v-model="selected_time_type" label="from_to">{{ $t('ads.select_duration') }}</el-radio>
        <el-row v-if="selected_time_type === 'from_to'">
          <el-col :sm="12">
            <el-date-picker v-model="campaign_time.start_time" format="dd-MM-yyyy" size="mini"></el-date-picker>
          </el-col>
          <el-col :sm="12">
            <el-date-picker :placeholder="$t('base.select_end_time')" v-model="campaign_time.end_time"
                            format="dd-MM-yyyy"
                            size="mini"></el-date-picker>
          </el-col>
        </el-row>

        <el-row class="text-right" style="margin-top: 10px">
          <el-button size="mini" type="primary" @click="m__update_campaign_date"
                     :loading="loading.update_campaign_date">{{ $t('base.confirm') }}
          </el-button>
        </el-row>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.update_campaign_quota" :close-on-click-modal="false"
               width="500px">
      <div slot="title" style="padding:10px">
        <strong class="strong-title">{{ $t('base.edit') }} {{ $t('base.budget') }}</strong>

        <div>
          <el-radio v-model="selected_quota_type" label="1">{{ $t('base.unlimited') }}</el-radio>
          <br>
          <el-radio v-model="selected_quota_type" label="2">{{ $t('base.set_budget') }}</el-radio>
          <el-row v-if="selected_quota_type === '2'">
            <el-col :sm="12" style="padding-right: 10px">
              <el-input size="mini" type="number" :min="DAILY_BUDGET_MIN" v-model="campaign_quota.quota"></el-input>
            </el-col>
            <el-col :sm="12" style="padding-right: 10px">
              <el-select size="mini" class="full-w" value="" v-model="campaign_quota.type">
                <el-option value="daily" :label="$t('base.daily_budget')"></el-option>
              </el-select>
            </el-col>
          </el-row>

          <el-row class="text-right" style="margin-top: 10px">
            <el-button size="mini" type="primary" :loading="loading.update_campaign_quota"
                       @click="m__update_campaign_quota">{{ $t('base.confirm') }}
            </el-button>
          </el-row>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.add_new_campaign" :close-on-click-modal="false"
               width="1000px">
      <div slot="title" style="padding: 0 10px 10px 10px">
        <strong style="font-size: 15px">
          {{ $t('ads.select_products_for_creating_ad').toUpperCase() }}
          <span v-if="!loading.get_products" class="text-success">({{ $t('product.get_success') }})</span>
          <span v-else class="text-warning">(<i class="el-icon-loading"></i> {{ $t('base.loading_data') }}...)</span>
        </strong>
        <br>
        <br>

        <el-row>
          <el-col :sm="6">
            {{ $t('product.list') }} ({{ $t('base.selected') }}
            {{ product_not_campaign_list.filter(i => i.checked).length }})
          </el-col>
          <el-col :sm="6">
            <el-input size="mini" v-model="product_filter.keyword" :placeholder="$t('input.placeholder')"
                      @keyup.enter.native="m__additional_search_for_product"></el-input>
          </el-col>
        </el-row>

        <el-row style="margin-top: 20px">
          <el-col :sm="6">
            <el-select size="mini" v-model="type_product" value="" @change="m__on_change_type_product">
              <el-option value="all" :label="`${$t('base.all')} ${$t('base.category')}`"></el-option>
              <el-option value="category" :label="$t('base.category')"></el-option>
              <el-option value="shop_category" :label="$t('base.shop_category')"></el-option>
            </el-select>
          </el-col>

          <el-col :sm="6">
            <el-select v-if="type_product !== 'shop_category'" :disabled="type_product !== 'category'" size="mini"
                       v-model="selected_category" value="" class="full-w" filterable>
              <el-option v-for="category in category_list" :key="category.id" :value="category.id"
                         :label="category.display_name"></el-option>
            </el-select>

            <el-select v-if="type_product === 'shop_category'" :disabled="type_product !== 'shop_category'" size="mini"
                       v-model="selected_shop_category" value="" class="full-w" filterable
                       @change="m__on_change_type_product">
              <el-option v-for="category in shop_category_list" :key="category.id" :value="category.id"
                         :label="category.name"></el-option>
            </el-select>
          </el-col>

          <el-col :sm="12" class="text-right">
            <el-checkbox v-model="show_available_product">{{ $t('base.show_eligible_products_only') }}</el-checkbox>
          </el-col>
        </el-row>

        <br>
        <el-table :data="c__product_not_campaign_display_list" @sort-change="m__product_sort_change"
                  @row-click="(row, column) => {if (column.label !== '#') {row.checked = !row.checked}}">
          <el-table-column label="#" width="40px">
            <template slot-scope="scope">
              <el-checkbox size="mini" v-model="scope.row.checked"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.image')" width="50px">
            <template slot-scope="scope">
              <template v-if="scope.row.images.length>0">
                <img :src="SHOPEE_IMAGE(scope.row.images.split(',')[0])" alt="product_logo"
                     style="width:32px; height:32px; border-radius: 4px;"/>
              </template>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.product')" prop="name" show-tooltip-when-overflow>
          </el-table-column>
          <el-table-column :label="$t('base.price')" prop="price" width="100px" :sortable="!loading.get_products">
            <template slot-scope="scope">
              {{ scope.row.price | currency }} {{ m__currency() }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.monthly_sales')" prop="monthly_sales" width="130px"
                           :sortable="!loading.get_products">
          </el-table-column>
          <el-table-column :label="$t('base.sales')" prop="revenue" width="130px" :sortable="!loading.get_products">
            <template slot-scope="scope">
              {{ scope.row.revenue | currency }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.stock')" prop="stock" width="100px" :sortable="!loading.get_products">
          </el-table-column>
        </el-table>
        <br>
        <el-row>
          <el-col :sm="12">
            <el-pagination :current-page.sync="product_filter.current_page" :page-size="product_filter.page_size"
                           layout="prev, pager, next, total" :total="c__product_not_campaign_filter_list.length"/>
          </el-col>
          <el-col :sm="12" class="text-right">
            <el-button size="mini" type="primary" @click="m__confirm_show_add_campaign_dialog" icon="el-icon-check">
              {{ $t('base.confirm') }}
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.config_anti_click" :close-on-click-modal="false" width="1000px">
      <div slot="title" style="padding: 10px">
        <el-row style="background-color: #F1F1F1">
          <el-col :sm="6" style="padding-top: 10px;">
            <div style="padding: 15px 15px; width: 100%; cursor: pointer; margin-bottom: 5px"
                 :class="config_tab === 4 ? 'config-tab-active': ''" @click="config_tab = 4">
              <span style="font-size: 13px; font-weight: 700;">
                {{ $t('ads.anti_click_configuration') }}
              </span>
            </div>
            <div style="padding: 0 30px; width: 100%; margin-top: 10px; margin-bottom: 10px">
              <div style="height: 0; width: 100%; border-top: 1px solid #cecece"></div>
            </div>
            <div style="padding: 15px 15px; width: 100%; cursor: pointer; margin-bottom: 5px"
                 :class="config_tab === 5 ? 'config-tab-active': ''" @click="config_tab = 5">
              <span style="font-size: 13px;  font-weight: 700">
                {{ $t('base.configuration_setup_guide') }}
              </span>
            </div>
          </el-col>
          <el-col :sm="18" style="background-color: #FFF;">
            <template v-if="config_tab === 4">
              <div style="padding: 20px 0 20px 30px">
                <el-row>
                  <el-col :sm="12" style="padding-right: 60px">
                    <p class="text-title" style="">
                      <el-radio v-model="form_anti_click.type" label="1">
                        <strong>1. {{ $t('ads.anti_click_label.type1') }}</strong>
                      </el-radio>
                    </p>
                    <el-input :disabled="form_anti_click.type === '2'" size="mini" type="number"
                              v-model="form_anti_click.ratio"></el-input>

                    <p class="text-title" style=""> {{ $t('ads.anti_click_label.minimum_clicks') }} </p>
                    <el-input :disabled="form_anti_click.type === '2'" size="mini" type="number"
                              v-model="form_anti_click.click_minimum_number"></el-input>

                    <p class="text-title" style=""> {{ $t('ads.anti_click_label.maximum_clicks') }} </p>
                    <el-input :disabled="form_anti_click.type === '2'" size="mini" type="number"
                              v-model="form_anti_click.click_maximum_number"></el-input>
                  </el-col>
                  <el-col :sm="12" style="padding-right: 30px">
                    <p class="text-title" style="">
                      <el-radio v-model="form_anti_click.type" label="2">
                        <strong>2. {{ $t('ads.anti_click_label.type2') }}</strong>
                      </el-radio>
                    </p>
                    <el-row>
                      <el-col :sm="15" style="padding-right: 10px">
                        <el-input :disabled="form_anti_click.type === '1'" size="mini" type="number"
                                  v-model="form_anti_click.cir"></el-input>
                      </el-col>
                      <el-col :sm="9">
                        <el-select size="mini" class="full-w" value="" v-model="form_anti_click.is_direct_cir"
                                   :disabled="form_anti_click.type === '1'">
                          <el-option :value="0" :label="$t('ads.anti_click_label.broad_cir')"></el-option>
                          <el-option :value="1" :label="$t('ads.anti_click_label.direct_cir')"></el-option>
                        </el-select>
                      </el-col>
                    </el-row>

                    <el-row>
                      <el-col :sm="24">
                        <p class="text-title" style="">{{ $t('ads.anti_click_label.maximum_cost') }}
                          ({{ $t('base.not_required') }})</p>
                        <el-input v-model="form_anti_click.max_cost" size="mini" :placeholder="$t('input.max_cost')"
                                  type="number" :disabled="form_anti_click.type === '1'"></el-input>
                      </el-col>
                    </el-row>

                    <p class="text-title" style="">{{ $t('ads.get_cir_by') }}</p>
                    <el-select v-model="form_anti_click.time_type" size="mini" value="" class="full-w"
                               :disabled="form_anti_click.type === '1'">
                      <el-option value="today" :label="$t('base.today')"></el-option>
                      <el-option value="yesterday" :label="$t('base.yesterday')"></el-option>
                      <el-option value="week" :label="$t('base.last_week')"></el-option>
                      <el-option value="month" :label="$t('base.last_month')"></el-option>
                    </el-select>

                    <br>
                    <br>
                    <span style="padding-left: 1px">
                      <el-checkbox v-model="form_anti_click.not_order" :disabled="form_anti_click.type === '1'"
                                   size="small">
                        {{ $t('ads.anti_click_label.check_if_gmv_by_0') }}
                      </el-checkbox>
                    </span>
                    <p class="text-title" style="margin-top: 1px !important;">
                      {{ $t('ads.anti_click_label.max_cost_if_gmv_by_0') }}</p>
                    <el-input v-model="form_anti_click.min_cost" size="mini" :placeholder="$t('input.max_cost')"
                              type="number"
                              :disabled="form_anti_click.type === '1' || !form_anti_click.not_order"></el-input>
                  </el-col>
                </el-row>

                <div style="padding-right: 30px">
                  <p class="text-title" style="">{{ $t('ads.anti_click_label.action_when_detect') }}</p>
                  <el-select value="" v-model="form_anti_click.detect_type" size="mini" class="full-w">
                    <el-option :value="1" :label="$t('ads.general_label.pause_object')"></el-option>
                    <el-option :value="3" :label="$t('ads.general_label.edit_amount')"></el-option>
                  </el-select>

                  <template v-if="form_anti_click.detect_type === 3">
                    <p class="text-title" style="">{{ $t('ads.general_label.edit_amount') }}</p>
                    <el-input size="mini" type="number" v-model="form_anti_click.detect_value_3"></el-input>
                  </template>
                </div>

                <div class="text-right" style="margin-top: 30px; padding-right: 30px">
                  <el-button size="small" type="primary" icon="el-icon-check" :loading="loading.config_anti_click"
                             @click="m__confirm_update_anti_click">{{ $t('base.save_configuration') }}
                  </el-button>
                </div>
              </div>
            </template>

            <template v-if="config_tab === 5">
              <ComponentAntiClickGuide></ComponentAntiClickGuide>
            </template>
          </el-col>
        </el-row>
      </div>
    </el-dialog>

    <el-dialog width="500px" :close-on-click-modal="false" :visible.sync="show_dialog.shop_not_selected"
               custom-class="no-body">
      <div slot="title" style="padding:10px;">
        <div style="background-color: orangered; color:white; text-align:center; padding:10px; border-radius: 4px;">
          {{ $t('keyword.has_no_connected_message') }}.
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.filter" :close-on-click-modal="false" width="700px">
      <div slot="title" style="padding:10px">
        <form @submit.prevent="m__start_filter">
          <div style="height: calc(100vh - 150px); overflow: auto" @keyup.enter.navtive="m__start_filter" tabindex="0">
            <el-table :data="c__filter_show_list">
              <el-table-column :label="$t('base.column')" prop="label">
                <template slot-scope="scope">
                  <span style="font-weight: 700" :class="scope.row.value ? 'text-success' : ''">{{
                      scope.row.label
                    }}</span>
                </template>
              </el-table-column>
              <el-table-column label="" prop="value2" width="110px">
                <template slot-scope="scope">
                  <el-input v-if="scope.row.expression === '< <'" size="mini" v-model="scope.row.value2"
                            type="number"></el-input>
                </template>
              </el-table-column>
              <el-table-column :label="$t('base.expression')" prop="expression" width="110px">
                <template slot-scope="scope">
                  <el-select class="full-w" size="mini" v-model="scope.row.expression">
                    <el-option label=">" value=">"></el-option>
                    <el-option label="<" value="<"></el-option>
                    <el-option label="=" value="==="></el-option>
                    <el-option label="≠" value="!=">
                      <span style="font-size: 16px !important;">≠</span>
                    </el-option>
                    <el-option label="> =" value=">="></el-option>
                    <el-option label="< =" value="<="></el-option>
                    <el-option label="< x <" value="< <"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column :label="$t('base.value')" prop="value" width="110px">
                <template slot-scope="scope">
                  <el-input size="mini" v-model="scope.row.value" type="number"></el-input>
                </template>
              </el-table-column>
              <el-table-column :label="$t('base.optional')" width="100px" align="right">
                <template slot-scope="scope">
                  <div style="height: 3px"></div>
                  <el-button size="mini" type="danger"
                             @click="() => {scope.row.value = null; scope.row.expression = '>'}">Reset
                  </el-button>
                  <div style="height: 3px"></div>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <br><br>
          <el-row>
            <el-col :sm="12" style="padding-left: 10px">
              <el-checkbox v-model="filter_flag">{{ $t('base.display_by_selected_metrics') }}</el-checkbox>
            </el-col>
          </el-row>
          <br>
          <el-row>
            <el-col :sm="24" class="text-right">
              <el-button size="mini" type="success" @click="show_dialog.save_filter = true">
                {{ $t('base.save_filter') }}
              </el-button>
              <el-button size="mini" type="default" @click="show_dialog.filter_list = true">
                {{ $t('base.use_saved_filter') }}
              </el-button>
              <el-button size="mini" type="danger" icon="el-icon-delete" @click="m__delete_filter">
                {{ $t('base.delete_filter') }}
              </el-button>
              <el-button size="mini" type="primary" icon="el-icon-check" @submit.prevent="m__start_filter"
                         native-type="submit"> {{ $t('base.execute') }}
              </el-button>
            </el-col>
          </el-row>
        </form>
      </div>
    </el-dialog>

    <el-dialog id="update_multiple_quota" :visible.sync="show_dialog.update_multiple_quota"
               :close-on-click-modal="false" width="700px">
      <div slot="title" style="padding:10px">
        <strong class="strong-title">{{ $t('base.mass_edit_x', { x: $t('base.budget') }) }}</strong>

        <div style="display: flex; align-items: center; gap: 10px">
          <strong style="font-size: 13px">{{ $t('base.select_budget_type') }}</strong>
          <el-select size="mini" v-model="form_update_multiple_quota.quota_type"
                     :disabled="form_update_multiple_quota.update_type === 6" value="">
            <el-option value="daily" :label="$t('base.daily_budget')"></el-option>
          </el-select>
        </div>

        <div style="margin-top: 30px; display: flex; flex-direction: column; gap: 10px">
          <!-- 1          -->
          <div style="display: flex; align-items: center;">
            <div style="flex: 1">
              <el-radio v-model="form_update_multiple_quota.update_type" :label="1">
                {{ $t('base.i_or_d_x_by_amount', { x: $t('base.budget') }) }}
              </el-radio>
            </div>
            <div style="flex: 1; display: flex; gap: 10px; justify-content: flex-end">
              <div style="flex: 1">
                <el-select size="mini" v-model="form_update_multiple_quota.update_by_cost" class="full-w"
                           :disabled="form_update_multiple_quota.update_type !== 1">
                  <el-option value="increase" :label="$t('base.increase')"></el-option>
                  <el-option value="reduce" :label="$t('base.decrease')"></el-option>
                </el-select>
              </div>
              <div style="flex: 1">
                <el-input size="mini" type="number" :disabled="form_update_multiple_quota.update_type !== 1"
                          v-model="form_update_multiple_quota.update_by_cost_value"></el-input>
              </div>
            </div>
          </div>

          <!-- 2          -->
          <div style="display: flex; align-items: center;">
            <div style="flex: 1">
              <el-radio v-model="form_update_multiple_quota.update_type" :label="2">
                {{ $t('base.i_or_d_x_by_percent', { x: $t('base.budget') }) }}
              </el-radio>
            </div>
            <div style="flex: 1; display: flex; gap: 10px; justify-content: flex-end">
              <div style="flex: 1">
                <el-select size="mini" v-model="form_update_multiple_quota.update_by_percent" class="full-w"
                           :disabled="form_update_multiple_quota.update_type !== 2">
                  <el-option value="increase" :label="$t('base.increase')"></el-option>
                  <el-option value="reduce" :label="$t('base.decrease')"></el-option>
                </el-select>
              </div>
              <div style="flex: 1">
                <el-input size="mini" type="number" :disabled="form_update_multiple_quota.update_type !== 2"
                          v-model="form_update_multiple_quota.update_by_percent_value"></el-input>
              </div>
            </div>
          </div>

          <!-- 7          -->
          <div style="display: flex; align-items: center;">
            <div style="flex: 1">
              <el-radio v-model="form_update_multiple_quota.update_type" :label="7">
                {{ $t('base.i_or_d_x_by_percent', { x: $t('base.budget') }) }}
                {{ $t('metric.expense') }}
              </el-radio>
            </div>
            <div style="flex: 1; display: flex; gap: 10px; justify-content: flex-end">
              <div style="flex: 1">
                <el-select size="mini" v-model="form_update_multiple_quota.update_by_cost_percent" class="full-w"
                           :disabled="form_update_multiple_quota.update_type !== 7">
                  <el-option value="increase" :label="$t('base.increase')"></el-option>
                  <el-option value="reduce" :label="$t('base.decrease')"></el-option>
                </el-select>
              </div>
              <div style="flex: 1">
                <el-input size="mini" type="number" :disabled="form_update_multiple_quota.update_type !== 7"
                          v-model="form_update_multiple_quota.update_by_cost_percent_value"></el-input>
              </div>
            </div>
          </div>

          <!-- 5          -->
          <div style="display: flex; align-items: center;">
            <div style="flex: 1">
              <el-radio v-model="form_update_multiple_quota.update_type" :label="5">
                {{ $t('base.set_x', { x: $t('base.budget') }) }}
              </el-radio>
            </div>
            <div style="flex: 1; display: flex; gap: 10px; justify-content: flex-end">
              <div style="flex: 1">
                &nbsp;
              </div>
              <div style="flex: 1">
                <el-input size="mini" type="number"
                          :disabled="form_update_multiple_quota.update_type !== 5"
                          v-model="form_update_multiple_quota.cost_value"></el-input>
              </div>
            </div>
          </div>

          <!-- 8          -->
          <div style="display: flex; align-items: center;">
            <div style="flex: 1">
              <el-radio v-model="form_update_multiple_quota.update_type" :label="8">
                {{
                  $t('base.set_x_by_y', {
                    x: $t('base.budget'),
                    y: $t('base.cost_percent')
                  })
                }}
              </el-radio>
            </div>
            <div style="flex: 1; display: flex; gap: 10px; justify-content: flex-end">
              <div style="flex: 1">
                &nbsp;
              </div>
              <div style="flex: 1">
                <el-input size="mini" type="number"
                          :disabled="form_update_multiple_quota.update_type !== 8"
                          v-model="form_update_multiple_quota.cost_percent"></el-input>
              </div>
            </div>
          </div>

          <!-- 6          -->
          <div style="display: flex; align-items: center;">
            <div style="flex: 1">
              <el-radio v-model="form_update_multiple_quota.update_type" :label="6">
                {{ $t('base.unlimited') }}
              </el-radio>
            </div>
            <div style="flex: 1; display: flex; gap: 10px; justify-content: flex-end">
              &nbsp;
            </div>
          </div>
        </div>

        <el-row style="margin-top: 10px" class="text-right">
          <el-button size="mini" type="primary" icon="el-icon-check" :loading="loading.update_multiple_quota"
                     @click="m__confirm_update_multiple_quota">{{ $t('base.confirm') }}
          </el-button>
        </el-row>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.config_auto_campaign" :close-on-click-modal="false" width="1250px">
      <div slot="title" style="padding:10px">
        <el-row style="background-color: #F1F1F1">
          <el-col :sm="5" style="padding-top: 10px;">
            <div style="padding: 15px 15px; width: 100%; cursor: pointer; margin-bottom: 5px"
                 :class="config_tab === 2 ? 'config-tab-active': ''" @click="config_tab = 2">
              <span style="font-size: 13px; font-weight: 700;">
                {{ $t('ads.auto_position_configuration') }}
              </span>
            </div>
            <div style="padding: 15px 15px; width: 100%; cursor: pointer; margin-bottom: 5px"
                 :class="config_tab === 1 ? 'config-tab-active': ''" @click="config_tab = 1">
              <span style="font-size: 13px;  font-weight: 700">
                {{ $t('ads.auto_price_configuration') }}
              </span>
            </div>
          </el-col>

          <el-col :sm="19" style="background-color: #FFF;">
            <template v-if="config_tab === 1">
              <div style="padding-top: 10px; padding-left: 10px">

                <el-row style="padding: 0 10px;">
                  <el-col :sm="14" style="padding-right: 30px">
                    <br>
                    <el-row>
                      <el-col :sm="15">
                        <p class="text-title" style="">{{ $t('base.set_bid_price') }}</p>
                      </el-col>
                      <el-col :sm="9" style="padding-top: 20px">
                        <el-select size="mini" value="" class="full-w" v-model="form_config_auto_campaign.type">
                          <el-option value="suggest" :label="$t('base.use_recommend_price')"></el-option>
                          <el-option value="cpc" :label="$t('base.use_cpc')"></el-option>
                        </el-select>
                        <template v-if="this.form_config_auto_campaign.type === 'cpc'">
                          <br>
                          <p class="text-title" style="font-weight: unset; font-size: 13px !important;">
                            {{ $t('base.use_cpc_duration') }}
                          </p>
                          <el-select size="mini" value="" class="full-w" v-model="form_config_auto_campaign.time">
                            <el-option value="today" :label="$t('base.today')"></el-option>
                            <el-option value="yesterday" :label="$t('base.yesterday')"></el-option>
                            <el-option value="week" :label="$t('base.last_week')"></el-option>
                            <el-option value="month" :label="$t('base.last_month')"></el-option>
                          </el-select>
                        </template>
                      </el-col>
                    </el-row>

                    <br>
                    <br>

                    <el-row>
                      <el-col :sm="18">
                        <el-radio v-model="form_config_auto_campaign.quota_type" :label="5" style="margin-top: 7px">
                          {{ $t('ads.general_label.higher_message') }}
                        </el-radio>
                      </el-col>
                      <el-col :sm="6">
                        <el-input size="mini" type="number" v-model="form_config_auto_campaign.increase_value"
                                  :min="1" :max="100" :disabled="form_config_auto_campaign.quota_type !== 5"></el-input>
                      </el-col>
                    </el-row>
                    <el-row style="margin-top: 5px;">
                      <el-col :sm="18" style="padding-left: 20px">
                        <el-checkbox v-model="form_config_auto_campaign.not_exceed_5"
                                     :disabled="form_config_auto_campaign.quota_type !== 5">
                          {{ $t('ads.general_label.not_exceeding_max') }}
                        </el-checkbox>
                      </el-col>
                      <el-col :sm="6">
                        <el-input size="mini" type="number" v-model="form_config_auto_campaign.not_exceed_5_value"
                                  :disabled="form_config_auto_campaign.quota_type !== 5"></el-input>
                      </el-col>
                    </el-row>
                    <br>

                    <el-row style="margin-top: 10px">
                      <el-col :sm="18">
                        <el-radio v-model="form_config_auto_campaign.quota_type" :label="6" style="margin-top: 7px">
                          {{ $t('ads.auto_price_label.lower_message') }}
                        </el-radio>
                      </el-col>
                      <el-col :sm="6">
                        <el-input size="mini" type="number" v-model="form_config_auto_campaign.reduce_value"
                                  :min="1" :max="100" :disabled="form_config_auto_campaign.quota_type !== 6"></el-input>
                      </el-col>
                    </el-row>
                    <el-row style="margin-top: 5px;">
                      <el-col :sm="18" style="padding-left: 20px">
                        <el-checkbox v-model="form_config_auto_campaign.not_exceed_6"
                                     :disabled="form_config_auto_campaign.quota_type !== 6">
                          {{ $t('ads.general_label.not_exceeding_max') }}
                        </el-checkbox>
                      </el-col>
                      <el-col :sm="6">
                        <el-input size="mini" type="number" v-model="form_config_auto_campaign.not_exceed_6_value"
                                  :disabled="form_config_auto_campaign.quota_type !== 6"></el-input>
                      </el-col>
                    </el-row>
                    <br>

                    <el-row style="margin-top: 10px">
                      <el-col :sm="18">
                        <el-radio v-model="form_config_auto_campaign.quota_type" :label="2" style="margin-top: 7px">
                          {{
                            $t('ads.auto_price_label.higher_x_message', { x: form_config_auto_campaign.increase_value })
                          }}
                        </el-radio>
                      </el-col>
                      <el-col :sm="6">
                        <el-input size="mini" type="number" v-model="form_config_auto_campaign.increase_value"
                                  :min="1" :max="100" :disabled="form_config_auto_campaign.quota_type !== 2"></el-input>
                      </el-col>
                    </el-row>
                    <el-row style="margin-top: 5px;">
                      <el-col :sm="18" style="padding-left: 20px">
                        <el-checkbox v-model="form_config_auto_campaign.not_exceed_2"
                                     :disabled="form_config_auto_campaign.quota_type !== 2">
                          {{ $t('ads.general_label.not_exceeding_max') }}
                        </el-checkbox>
                      </el-col>
                      <el-col :sm="6">
                        <el-input size="mini" type="number" v-model="form_config_auto_campaign.not_exceed_2_value"
                                  :disabled="form_config_auto_campaign.quota_type !== 2"></el-input>
                      </el-col>
                    </el-row>
                    <br>

                    <el-row style="margin-top: 5px">
                      <el-col :sm="18">
                        <el-radio v-model="form_config_auto_campaign.quota_type" :label="3" style="margin-top: 7px">
                          {{
                            $t('ads.auto_price_label.lower_x_message', { x: form_config_auto_campaign.reduce_value })
                          }}
                        </el-radio>
                      </el-col>
                      <el-col :sm="6">
                        <el-input size="mini" type="number" v-model="form_config_auto_campaign.reduce_value"
                                  :min="1" :max="100" :disabled="form_config_auto_campaign.quota_type !== 3"></el-input>
                      </el-col>
                    </el-row>
                    <el-row style="margin-top: 5px;" :disabled="form_config_auto_campaign.quota_type !== 2">
                      <el-col :sm="18" style="padding-left: 20px">
                        <el-checkbox v-model="form_config_auto_campaign.not_exceed_3"
                                     :disabled="form_config_auto_campaign.quota_type !== 3">
                          {{ $t('ads.general_label.not_exceeding_max') }}
                        </el-checkbox>
                      </el-col>
                      <el-col :sm="6">
                        <el-input size="mini" type="number" v-model="form_config_auto_campaign.not_exceed_3_value"
                                  :disabled="form_config_auto_campaign.quota_type !== 3"></el-input>
                      </el-col>
                    </el-row>
                    <br>

                    <el-radio v-model="form_config_auto_campaign.quota_type" :label="4" style="margin-top: 5px">
                      {{ $t('ads.auto_price_label.by_amount_or_cpc') }}
                    </el-radio>
                    <el-row style="margin-top: 5px;" :disabled="form_config_auto_campaign.quota_type !== 4">
                      <el-col :sm="18" style="padding-left: 20px">
                        <el-checkbox v-model="form_config_auto_campaign.not_exceed_4"
                                     :disabled="form_config_auto_campaign.quota_type !== 4">
                          {{ $t('ads.general_label.not_exceeding_max') }}
                        </el-checkbox>
                      </el-col>
                      <el-col :sm="6">
                        <el-input size="mini" type="number" v-model="form_config_auto_campaign.not_exceed_4_value"
                                  :disabled="form_config_auto_campaign.quota_type !== 4"></el-input>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col :sm="10" style="padding: 0 15px 0 15px">
                    <br>
                    <p class="text-title" style="">{{ $t('base.configuration_runtime_list') }}</p>
                    <br>
                    <br>

                    <ComponentCustomTimePicker
                      :value.sync="form_config_auto_campaign.times"></ComponentCustomTimePicker>

                    <br>
                    <hr>
                    <p class="text-title" style=""> {{ $t('base.set_when_outside_runtime') }}</p>
                    <el-select size="mini" value="" class="full-w" v-model="form_config_auto_campaign.stop_action">
                      <el-option :value="0" :label="$t('base.keep_bid_price')"></el-option>
                      <el-option :value="1" :label="$t('base.pause_keyword')"></el-option>
                      <el-option :value="3" :label="$t('ads.general_label.edit_amount')"></el-option>
                    </el-select>

                    <template v-if="form_config_auto_campaign.stop_action === 3">
                      <p class="text-title" style="">{{ $t('base.set_bid_price') }}</p>
                      <el-input type="number" size="mini" v-model="form_config_auto_campaign.stop_action_3"
                                :placeholder="$t('input.bid_price')"></el-input>
                    </template>
                  </el-col>
                </el-row>

                <div style="margin-top: 10px" class="text-right">
                  <el-button size="mini" type="primary" icon="el-icon-check" :loading="loading.config_auto_campaign"
                             @click="m__save_config_auto_campaign('RUNNING')">
                    {{ $t('base.save_config') }}
                  </el-button>
                </div>
              </div>
            </template>

            <template v-if="config_tab === 2">
              <el-row style="padding: 0 10px; margin-top: 20px">
                <el-col :sm="13" style="padding-right: 30px">
                  <div style="height: 18px">
                    <el-radio v-model="form_config_auto_position.type" :label="1">
                      {{ $t('ads.auto_position') }}
                    </el-radio>
                  </div>
                  <el-row style="padding-left: 15px">
                    <el-col :sm="12" style="padding-right: 10px">
                      <p class="text-title">{{ $t('ads.auto_position_label.from_position') }}:</p>
                      <el-input v-model="form_config_auto_position.fromValue" size="mini" type="number"
                                :placeholder="$t('ads.auto_position_label.input_from')"></el-input>
                    </el-col>
                    <el-col :sm="12" style="padding-right: 10px">
                      <p class="text-title">{{ $t('ads.auto_position_label.to_position') }}:</p>
                      <el-input v-model="form_config_auto_position.toValue" size="mini" type="number"
                                :placeholder="$t('ads.auto_position_label.input_to')"></el-input>
                    </el-col>
                  </el-row>

                  <br><br>

                  <el-radio v-model="form_config_auto_position.type" :label="2">
                    {{ $t('ads.auto_position_label.always_above') }}
                  </el-radio>
                  <el-row style="padding-left: 15px">
                    <el-col :sm="12" style="padding-right: 10px">
                      <el-input v-model="form_config_auto_position.upValue" size="mini" type="number"
                                :placeholder="$t('ads.auto_position_label.input_position')"></el-input>
                    </el-col>
                  </el-row>

                  <br><br>

                  <el-radio v-model="form_config_auto_position.type" :label="3">
                    {{ $t('ads.auto_position_label.always_below') }}
                  </el-radio>
                  <el-row style="padding-left: 15px">
                    <el-col :sm="12" style="padding-right: 10px">
                      <el-input v-model="form_config_auto_position.downValue" size="mini" type="number"
                                :placeholder="$t('ads.auto_position_label.input_position')"></el-input>
                    </el-col>
                  </el-row>

                  <br>

                  <div style="padding-left: 5px">
                    <p class="text-title">{{ $t('ads.other_setups') }}({{ $t('base.optional') }}):</p>
                    <el-row style="padding-left: 15px">

                      <el-col :sm="12" style="padding-right: 10px">
                        <p class="text-title">{{ $t('ads.check_position_on') }}</p>
                        <el-select size="mini" class="full-w" value="avg_rank"
                                   :placeholder="$t('base.select')">
                          <el-option value="avg_rank" :label="$t('ads.average_ranking')"></el-option>
                        </el-select>
                      </el-col>
                      <el-col :sm="12" style="padding-left: 20px; padding-top: 5px">
                        <p class="text-title text-danger">&nbsp;</p>
                      </el-col>
                    </el-row>
                    <el-row style="padding-left: 15px; padding-top: 5px">
                      <el-col :sm="12" style="padding-right: 10px">
                        <p class="text-title">{{ $t('ads.auto_position_label.bid_price_to_increase') }}:</p>
                        <el-input v-model="form_config_auto_position.maxValue" size="mini" type="number"></el-input>
                      </el-col>
                      <el-col :sm="12" style="padding-right: 10px">
                        <p class="text-title">{{ $t('base.max_bid_price') }}:</p>
                        <el-input v-model="form_config_auto_position.maxPrice" size="mini" type="number"></el-input>
                      </el-col>
                    </el-row>
                    <el-row style="padding-left: 15px; padding-top: 5px">
                      <el-col :sm="12" style="padding-right: 10px">
                        <p class="text-title">{{ $t('ads.auto_position_label.bid_price_to_decrease') }}:</p>
                        <el-input v-model="form_config_auto_position.minValue" size="mini" type="number"></el-input>
                      </el-col>
                      <el-col :sm="12" style="padding-right: 10px">
                        <p class="text-title">{{ $t('base.min_bid_price') }}:</p>
                        <el-input v-model="form_config_auto_position.minPrice" size="mini" type="number"></el-input>
                      </el-col>
                    </el-row>
                    <el-row style="padding-left: 15px">
                      <el-col :sm="24" style="padding-right: 10px">
                        <p class="text-title">{{
                            $t('ads.auto_position_label.deduction_bid_price_when_target_position')
                          }} ({{ $t('base.not_required') }}):</p>
                        <el-input size="mini" type="number" v-model="form_config_auto_position.reduce_if"
                        ></el-input>
                      </el-col>
                    </el-row>
                  </div>
                </el-col>
                <el-col :sm="11" style="padding: 0 15px 15px 15px">
                  <div style="height: 18px">
                  </div>
                  <p class="text-title">{{ $t('base.configuration_runtime_list') }}</p>

                  <ComponentCustomTimePicker style="margin-top: 30px"
                                             :value.sync="form_config_auto_position.times"></ComponentCustomTimePicker>

                  <br>
                  <p class="text-title" style=""> {{ $t('base.set_when_outside_runtime') }} </p>
                  <el-select size="mini" value="" class="full-w" v-model="form_config_auto_position.stop_action">
                    <el-option :value="0" :label="$t('base.keep_bid_price')"></el-option>
                    <el-option :value="1" :label="$t('ads.general_label.pause_object')"></el-option>
                    <el-option :value="3" :label="$t('ads.general_label.edit_amount')"></el-option>
                    <el-option
                      v-if="array_to_set(restricted_keyword_fixed_list).has($store.state.userInfo.username)"
                      :value="4" :label="$t('ads.general_label.edit_by_realtime_cpc')"></el-option>
                  </el-select>

                  <template v-if="form_config_auto_position.stop_action === 3">
                    <p class="text-title" style="">{{ $t('base.set_bid_price') }}</p>
                    <el-input type="number" size="mini" v-model="form_config_auto_position.stop_action_3"
                              :placeholder="$t('input.bid_price')"></el-input>
                  </template>
                </el-col>
              </el-row>
              <br>
              <el-row style="margin-top: 10px">
                <el-col :sm="14" style="padding-left: 25px; padding-top: 5px">
                  <el-checkbox v-model="form_config_auto_position.exact_only">
                    {{ $t('ads.auto_position_label.only_apply_with_exact') }}
                  </el-checkbox>
                </el-col>
                <el-col :sm="10" class="text-right">
                  <el-button v-if="is_advanced_ads"
                             size="mini" type="success" icon="el-icon-star-on"
                             @click="m__show_advanced_dialog">
                    {{ $t('ads.advanced_configuration') }}
                  </el-button>
                  <el-button size="mini" type="primary" icon="el-icon-check" :loading="loading.auto_position"
                             @click="m__save_config_auto_position">
                    {{ $t('base.save_config') }}
                  </el-button>
                </el-col>
              </el-row>
            </template>
          </el-col>
        </el-row>
      </div>
    </el-dialog>

    <el-dialog id="auto-position-advanced" :visible.sync="show_dialog.auto_position_advanced"
               :close-on-click-modal="false" width="1000px" class="dialog-height">
      <div slot="title" style="padding:10px">
        <strong> {{ $t('ads.advanced_configuration') }} </strong>

        <el-row style="margin-top: 10px">
          <el-col :sm="13">
            <p class="text-title"> {{ $t('ads.configuration_active_day') }} </p>
            <el-row style="margin-top: 10px">
              <el-col :sm="10" style="padding-right: 15px">
                <el-select class="full-w" size="mini" value filterable v-model="form_config_auto_position.advanced_day"
                           @change="m__suggest_advanced">
                  <el-option value="flash_sale" :label="$t('day.flash_sale')"></el-option>
                  <el-option value="before_flash_sale" :label="$t('day.before_flash_sale')"></el-option>
                  <el-option value="after_flash_sale" :label="$t('day.after_flash_sale')"></el-option>
                  <el-option value="mini_spike_day" :label="$t('day.mini_spike_day')"></el-option>
                  <el-option value="day" :label="$t('day.specific_day')"></el-option>
                  <el-option value="remain" :label="$t('day.remaining_days')"></el-option>
                </el-select>
              </el-col>
              <el-col :sm="10" style="padding-right: 25px">
                <el-input size="mini" type="number" :label="$t('input.day_numbers')"
                          v-model="form_config_auto_position.advanced_day_number"
                          :disabled="['mini_spike_day', 'flash_sale', 'remain'].includes(form_config_auto_position.advanced_day)">
                </el-input>
              </el-col>
              <el-col :sm="2">
              </el-col>
            </el-row>
            <el-row style="margin-top: 5px">
              <el-col :sm="10" style="padding-right: 15px">
                <p class="text-title"> {{ $t('base.bonus_amount') }}</p>
                <el-input size="mini" type="number" :placeholder="$t('input.bonus_amount')"
                          v-model="form_config_auto_position.advanced_max_value"></el-input>
              </el-col>
              <el-col :sm="10" style="padding-right: 25px">
                <p class="text-title">{{ $t('base.max_bid_price') }}</p>
                <el-input size="mini" type="number" :placeholder="$t('input.max_bid_price')"
                          v-model="form_config_auto_position.advanced_max_price"></el-input>
              </el-col>
              <el-col :sm="2">
              </el-col>
            </el-row>
            <el-row style="margin-top: 5px">
              <el-col :sm="20" style="padding-right: 25px">
                <p class="text-title">{{ $t('base.starting_bid_price') }} ({{ $t('base.not_required') }})</p>
                <el-input size="mini" type="number" :placeholder="$t('input.starting_bid_price')"
                          v-model="form_config_auto_position.advanced_start_price"></el-input>
              </el-col>
              <el-col :sm="2">
                <p class="text-title">&nbsp;</p>
                <el-button type="primary" icon="el-icon-plus" size="mini" @click="m__add_advanced_day"></el-button>
              </el-col>
            </el-row>
          </el-col>
          <el-col :sm="11" style="padding: 0 15px">
            <p class="text-title">{{ $t('base.configuration_runtime_list') }}</p>

            <ComponentCustomTimePicker style="margin-top: 30px"
                                       :value.sync="form_config_auto_position.advanced_times"
                                       :prefix="'advanced_'"></ComponentCustomTimePicker>
          </el-col>
        </el-row>

        <el-row style="margin-top: 20px">
          <p class="text-title">{{ $t('ads.configuration_active_day_list') }}</p>
          <el-table :data="form_config_auto_position.advanced_days" default-expand-all>
            <el-table-column type="expand" width="40px">
              <template slot-scope="scope">
                <div v-if="scope.row.times" style="padding-left: 50px">
                  <div style="margin: 10px 0; color: #000">
                    {{ $t('base.configuration_runtime_list') }}
                  </div>
                  <div v-for="i in scope.row.times" :key="i" style="margin-bottom: 5px; color: #000">
                    {{ i }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('ads.configuration_active_day')">
              <template slot-scope="scope">
                <strong>{{ spike_day_map(scope.row) }}</strong>
                <br>
                <strong class="text-danger">
                  {{ m__row_type_to_text(scope.row) }}
                </strong>
              </template>
            </el-table-column>
            <el-table-column :label="$t('base.starting_bid_price')">
              <template slot-scope="scope">{{ scope.row.start_price | format_currency }}</template>
            </el-table-column>
            <el-table-column :label="$t('base.bonus_amount')">
              <template slot-scope="scope">
                <!--                {{ scope.row.max_value | format_currency }}-->
                <el-input size="mini" v-model="scope.row.max_value"></el-input>
              </template>
            </el-table-column>
            <el-table-column :label="$t('base.max_bid_price')">
              <template slot-scope="scope">
                <el-input size="mini" v-model="scope.row.max_price"></el-input>
              </template>
            </el-table-column>
            <el-table-column :label="$t('base.action')" width="120px">
              <template slot-scope="scope">
                <el-button size="mini" type="text" @click="m__edit_advanced_day(scope.$index)">
                  <strong class="text-warning">{{ $t('base.edit') }}</strong>
                </el-button>
                &nbsp;
                <el-button size="mini" type="text" @click="m__remove_advanced_day(scope.$index)">
                  <strong class="text-danger">{{ $t('base.delete') }}</strong>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-row>

        <el-row class="text-right" style="margin-top: 10px">
          <el-button size="mini" type="primary" icon="el-icon-check"
                     @click="m__confirm_advanced">{{ $t('base.confirm') }}
          </el-button>
        </el-row>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.auto_position_advanced_multiple" :close-on-click-modal="false" width="1000px"
               class="dialog-height">
      <div slot="title" style="padding:10px">
        <strong class="strong-title"> {{ $t('ads.advanced_mass_edit') }} ({{ $t('ads.auto_position') }})</strong>

        <strong class="text-danger" style="font-size: 14px">
          *{{ $t('ads.auto_position_label.advanced_note') }}
        </strong>

        <el-row style="margin-top: 10px">
          <el-col :sm="13">
            <p class="text-title"> {{ $t('ads.configuration_active_day') }} </p>
            <el-row style="margin-top: 10px">
              <el-col :sm="10" style="padding-right: 15px">
                <el-select class="full-w" size="mini" value filterable v-model="form_config_auto_position.advanced_day"
                           @change="m__suggest_advanced">
                  <el-option value="flash_sale" :label="$t('day.flash_sale')"></el-option>
                  <el-option value="before_flash_sale" :label="$t('day.before_flash_sale')"></el-option>
                  <el-option value="after_flash_sale" :label="$t('day.after_flash_sale')"></el-option>
                  <el-option value="mini_spike_day" :label="$t('day.mini_spike_day')"></el-option>
                  <el-option value="day" :label="$t('day.specific_day')"></el-option>
                  <el-option value="remain" :label="$t('day.remaining_days')"></el-option>
                </el-select>
              </el-col>
              <el-col :sm="10" style="padding-right: 25px">
                <el-input size="mini" type="number" :label="$t('input.day_numbers')"
                          v-model="form_config_auto_position.advanced_day_number"
                          :disabled="['mini_spike_day', 'flash_sale', 'remain'].includes(form_config_auto_position.advanced_day)"></el-input>
              </el-col>
              <el-col :sm="2">
              </el-col>
            </el-row>
            <el-row style="margin-top: 5px">
              <el-col :sm="20" style="padding-right: 25px">
                <p class="text-title"> {{ $t('base.bonus_amount') }}</p>
                <el-input size="mini" type="number" :placeholder="$t('input.bonus_amount')"
                          v-model="form_config_auto_position.advanced_max_value"></el-input>
              </el-col>
              <el-col :sm="2">
              </el-col>
            </el-row>
            <el-row style="margin-top: 5px">
              <el-col :sm="20" style="padding-right: 25px">
                <p class="text-title"> {{ $t('base.advanced_max_bid_price') }} </p>
                <el-select class="full-w" size="mini" value filterable
                           v-model="form_config_auto_position.advanced_max_type">
                  <el-option value="value" :label="$t('ads.edit_by_bid_price')"></el-option>
                  <el-option value="price"
                             :label="$t('ads.bonus_by_basic_config')"></el-option>
                  <el-option value="percent"
                             :label="$t('ads.bonus_percent_by_basic_config')"></el-option>
                </el-select>
                <div style="height: 10px"></div>
                <el-input size="mini" type="number" :placeholder="$t('input.value')"
                          v-model="form_config_auto_position.advanced_max_price"></el-input>
              </el-col>
            </el-row>
            <el-row style="margin-top: 5px">
              <el-col :sm="20" style="padding-right: 25px">
                <p class="text-title">{{ $t('base.starting_bid_price') }} ({{ $t('base.not_required') }})</p>
                <el-input size="mini" type="number" :placeholder="$t('input.starting_bid_price')"
                          v-model="form_config_auto_position.advanced_start_price"></el-input>
              </el-col>
              <el-col :sm="2">
                <p class="text-title">&nbsp;</p>
                <el-button type="primary" icon="el-icon-plus" size="mini" @click="m__add_advanced_day"></el-button>
              </el-col>
            </el-row>
          </el-col>
          <el-col :sm="11" style="padding: 0 15px">
            <p class="text-title">{{ $t('base.configuration_runtime_list') }}</p>

            <ComponentCustomTimePicker style="margin-top: 30px"
                                       :value.sync="form_config_auto_position.advanced_times"
                                       :prefix="'advanced_'"></ComponentCustomTimePicker>
          </el-col>
        </el-row>

        <el-row style="margin-top: 20px">
          <p class="text-title">{{ $t('ads.configuration_active_day_list') }}</p>
          <el-table :data="form_config_auto_position.advanced_days" default-expand-all>
            <el-table-column type="expand" width="40px">
              <template slot-scope="scope">
                <div v-if="scope.row.times" style="padding-left: 50px">
                  <div style="margin: 10px 0; color: #000">
                    {{ $t('base.configuration_runtime_list') }}
                  </div>
                  <div v-for="i in scope.row.times" :key="i" style="margin-bottom: 5px; color: #000">
                    {{ i }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('ads.configuration_active_day')">
              <template slot-scope="scope">
                <strong>{{ spike_day_map(scope.row) }}</strong>
                <br>
                <strong class="text-danger">
                  {{ m__row_type_to_text(scope.row) }}
                </strong>
              </template>
            </el-table-column>
            <el-table-column :label="$t('base.starting_bid_price')">
              <template slot-scope="scope">{{ scope.row.start_price | format_currency }}</template>
            </el-table-column>
            <el-table-column :label="$t('base.bonus_amount')">
              <template slot-scope="scope">
                <el-input size="mini" v-model="scope.row.max_price"></el-input>
              </template>
            </el-table-column>
            <el-table-column :label="$t('base.max_bid_price')">
              <template slot-scope="scope">
                <template v-if="scope.row.max_type === 'price'">{{ $t('base.increase') }}</template>
                <template v-if="scope.row.max_type === 'percent'">{{ $t('base.increase') }}</template>
                {{ scope.row.max_price | format_currency }}
                <template v-if="scope.row.max_type === 'price'"> {{ $t('base.from_current_bid_price') }}</template>
                <template v-if="scope.row.max_type === 'percent'"> % {{ $t('base.of_current_bid_price') }}</template>
              </template>
            </el-table-column>
            <el-table-column :label="$t('base.action')" width="120px">
              <template slot-scope="scope">
                <el-button size="mini" type="text" @click="m__edit_advanced_day(scope.$index)">
                  <strong class="text-warning">{{ $t('base.edit') }}</strong>
                </el-button>
                &nbsp;
                <el-button size="mini" type="text" @click="m__remove_advanced_day(scope.$index)">
                  <strong class="text-danger">{{ $t('base.delete') }}</strong>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-row>

        <el-row class="text-right" style="margin-top: 10px">
          <el-button size="mini" type="primary" icon="el-icon-check" :loading="loading.auto_position_advanced_multiple"
                     @click="m__confirm_update_multiple_advanced">{{ $t('base.confirm') }}
          </el-button>
        </el-row>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.compare_campaign" :close-on-click-modal="false" width="450px">
      <div slot="title" style="padding:10px">
        <strong style="font-size:14px">{{ $t('base.compare_data') }}</strong>

        <br>
        <br>
        <div style="line-height: 20px">
          <strong style="font-size:13px"> {{ $t('base.current_duration') }}:</strong>
          <br>
          <strong style="font-size: 13px" class="text-danger"> {{ $t('base.from_date') }}:
            {{ start_date | moment('DD-MM-YYYY') }}
            - {{ $t('base.to_date') }}: {{ end_date | moment('DD-MM-YYYY') }}</strong>

          <br>
          <br>

          <strong style="font-size:13px"> {{ $t('select.compare_duration') }}:</strong>
          <br>
          <el-date-picker v-model="compare_date_range" class="full-w" type="daterange" range-separator="-"
                          :start-placeholder="$t('base.start_time')" :end-placeholder="$t('base.end_time')" size="mini"
                          format="dd-MM-yyyy"
                          :clearable="false" :picker-options="picker_options"
                          @change="$emit('update:parent_compare_date_range', compare_date_range)">
          </el-date-picker>

          <br>
          <br>

          <strong style="font-size:13px"> {{ $t('base.expected_cir') }} ({{ $t('base.not_required') }}):</strong>
          <br>
          <el-input v-model="expected_cir" type="number" size="mini" :placeholder="$t('input.expected_cir')"></el-input>
        </div>

        <div style="margin-top: 30px" class="text-right">
          <el-button size="mini" type="danger"
                     @click="is_compare_campaign = false; $emit('update:parent_is_compare_campaign', false); show_dialog.compare_campaign = false">
            {{ $t('base.disable_compare_data') }}
          </el-button>
          <el-button size="mini" type="primary" icon="el-icon-check" @click="m__confirm_compare_campaign"
                     :loading="loading.compare_campaign">
            {{ $t('base.execute') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.update_multiple_max_price" :close-on-click-modal="false"
               width="700px">
      <div slot="title" style="padding:10px">
        <strong class="strong-title">{{ $t('ads.max_edit_max_bid_price') }} ({{
            $t('ads.apply_for_auto_position')
          }})</strong>
        <br>

        <el-row style="margin-top: 10px">
          <el-col :sm="12">
            <el-radio v-model="form_update_multiple_max_price.update_type" :label="1">
              {{ $t('base.i_or_d_x_by_amount', { x: $t('base.max_bid_price') }) }}
            </el-radio>
          </el-col>
          <el-col :sm="12">
            <el-row>
              <el-col :sm="12">
                <el-select size="mini" v-model="form_update_multiple_max_price.update_by_cost" class="full-w"
                           :disabled="form_update_multiple_max_price.update_type !== 1">
                  <el-option value="increase" :label="$t('base.increase')"></el-option>
                  <el-option value="reduce" :label="$t('base.decrease')"></el-option>
                </el-select>
              </el-col>
              <el-col :sm="12">
                <el-input size="mini" type="number" :disabled="form_update_multiple_max_price.update_type !== 1"
                          v-model="form_update_multiple_max_price.update_by_cost_value"></el-input>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-row style="margin-top: 10px">
          <el-col :sm="12">
            <el-radio v-model="form_update_multiple_max_price.update_type" :label="2">
              {{ $t('base.i_or_d_x_by_percent', { x: $t('base.max_bid_price') }) }}
            </el-radio>
          </el-col>
          <el-col :sm="12">
            <el-row>
              <el-col :sm="12">
                <el-select size="mini" v-model="form_update_multiple_max_price.update_by_percent" class="full-w"
                           :disabled="form_update_multiple_max_price.update_type !== 2">
                  <el-option value="increase" :label="$t('base.increase')"></el-option>
                  <el-option value="reduce" :label="$t('base.decrease')"></el-option>
                </el-select>
              </el-col>
              <el-col :sm="12">
                <el-input size="mini" type="number" :disabled="form_update_multiple_max_price.update_type !== 2"
                          v-model="form_update_multiple_max_price.update_by_percent_value"></el-input>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-row style="margin-top: 10px">
          <el-col :sm="12">
            <el-radio v-model="form_update_multiple_max_price.update_type" :label="5">
              {{ $t('base.set_x', { x: $t('base.max_bid_price') }) }}
            </el-radio>
          </el-col>
          <el-col :sm="12">
            <el-row>
              <el-col :sm="12">
                <div>&nbsp;</div>
              </el-col>
              <el-col :sm="12">
                <el-input size="mini" type="number"
                          :disabled="form_update_multiple_max_price.update_type !== 5"
                          v-model="form_update_multiple_max_price.cost_value"></el-input>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-row style="margin-top: 10px">
          <el-col :sm="12">
            <el-radio v-model="form_update_multiple_max_price.update_type" :label="6">
              {{ $t('base.set_by_x', { x: 'cpc' }) }}
            </el-radio>
          </el-col>
          <el-col :sm="12">
            <el-date-picker v-model="form_update_multiple_max_price.date_range" type="daterange" range-separator="-"
                            :start-placeholder="$t('base.start_time')" :end-placeholder="$t('base.end_time')"
                            size="mini" format="dd-MM-yyyy"
                            :clearable="false" :picker-options="picker_options" class="full-w"
                            :disabled="form_update_multiple_max_price.update_type !== 6">
            </el-date-picker>
          </el-col>
        </el-row>

        <el-row style="margin-top: 10px" class="text-right">
          <el-button size="mini" type="primary" icon="el-icon-check" :loading="loading.update_multiple_max_price"
                     @click="m__confirm_update_multiple_max_price">{{ $t('base.confirm') }}
          </el-button>
        </el-row>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.update_multiple_keyword_price" :close-on-click-modal="false"
               width="700px">
      <div slot="title" style="padding:10px">
        <el-row>
          <el-col :sm="14">
            <strong class="strong-title"> {{ $t('base.mass_edit_x', { x: $t('base.bid_price') }) }} </strong>
          </el-col>
          <el-col :sm="10">
            <el-select size="mini" value="" class="full-w fix-collapse-tags"
                       v-model="form_update_multiple_keyword_price.keyword_types"
                       multiple collapse-tags ref="updateMultipleBidPriceTypes">
              <el-option value="exact" :label="$t('keyword.exact')"></el-option>
              <el-option value="broad" :label="$t('keyword.broad')"></el-option>
              <el-option value="daily_discover" :label="$t('base.daily_discover')"></el-option>
              <el-option value="you_may_also_like" :label="$t('base.you_may_also_like')"></el-option>
            </el-select>
          </el-col>
        </el-row>
        <br>

        <el-row style="margin-top: 10px">
          <el-col :sm="14">
            <el-radio v-model="form_update_multiple_keyword_price.update_type" :label="1">
              {{ $t('base.i_or_d_x_by_amount', { x: $t('base.bid_price') }) }}
            </el-radio>
          </el-col>
          <el-col :sm="10">
            <el-row>
              <el-col :sm="8">
                <el-select size="mini" v-model="form_update_multiple_keyword_price.update_by_cost" class="full-w"
                           :disabled="form_update_multiple_keyword_price.update_type !== 1">
                  <el-option value="increase" :label="$t('base.increase')"></el-option>
                  <el-option value="reduce" :label="$t('base.decrease')"></el-option>
                </el-select>
              </el-col>
              <el-col :sm="16" style="padding-left: 10px">
                <el-input size="mini" type="number" :disabled="form_update_multiple_keyword_price.update_type !== 1"
                          v-model="form_update_multiple_keyword_price.update_by_cost_value"></el-input>
                <div style="height: 5px"></div>
                <el-input v-if="form_update_multiple_keyword_price.update_by_cost === 'increase'"
                          size="mini" type="number" :placeholder="$t('input.max_bid_price')"
                          :disabled="form_update_multiple_keyword_price.update_type !== 1"
                          v-model="form_update_multiple_keyword_price.update_by_cost_value_max"></el-input>
                <el-input v-if="form_update_multiple_keyword_price.update_by_cost === 'reduce'"
                          size="mini" type="number" :placeholder="$t('input.min_bid_price')"
                          :disabled="form_update_multiple_keyword_price.update_type !== 1"
                          v-model="form_update_multiple_keyword_price.update_by_cost_value_min"></el-input>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-row style="margin-top: 10px">
          <el-col :sm="14">
            <el-radio v-model="form_update_multiple_keyword_price.update_type" :label="2">
              {{ $t('base.i_or_d_x_by_percent', { x: $t('base.bid_price') }) }}
            </el-radio>
          </el-col>
          <el-col :sm="10">
            <el-row>
              <el-col :sm="8">
                <el-select size="mini" v-model="form_update_multiple_keyword_price.update_by_percent" class="full-w"
                           :disabled="form_update_multiple_keyword_price.update_type !== 2">
                  <el-option value="increase" :label="$t('base.increase')"></el-option>
                  <el-option value="reduce" :label="$t('base.decrease')"></el-option>
                </el-select>
              </el-col>
              <el-col :sm="16" style="padding-left: 10px">
                <el-input size="mini" type="number" :disabled="form_update_multiple_keyword_price.update_type !== 2"
                          v-model="form_update_multiple_keyword_price.update_by_percent_value"></el-input>
                <div style="height: 5px"></div>
                <el-input v-if="form_update_multiple_keyword_price.update_by_percent === 'increase'"
                          size="mini" type="number" :placeholder="$t('input.max_bid_price')"
                          :disabled="form_update_multiple_keyword_price.update_type !== 2"
                          v-model="form_update_multiple_keyword_price.update_by_percent_value_max"></el-input>
                <el-input v-if="form_update_multiple_keyword_price.update_by_percent === 'reduce'"
                          size="mini" type="number" :placeholder="$t('input.min_bid_price')"
                          :disabled="form_update_multiple_keyword_price.update_type !== 2"
                          v-model="form_update_multiple_keyword_price.update_by_percent_value_min"></el-input>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-row style="margin-top: 10px">
          <el-col :sm="14">
            <el-radio v-model="form_update_multiple_keyword_price.update_type" :label="5">
              {{ $t('base.set_x', { x: $t('base.bid_price') }) }}
            </el-radio>
          </el-col>
          <el-col :sm="10">
            <el-row>
              <el-col :sm="8">
                <div>&nbsp;</div>
              </el-col>
              <el-col :sm="16" style="padding-left: 10px">
                <el-input size="mini" type="number"
                          :disabled="form_update_multiple_keyword_price.update_type !== 5"
                          v-model="form_update_multiple_keyword_price.cost_value"></el-input>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-row style="margin-top:30px" class="text-right">
          <el-button size="mini" type="primary" icon="el-icon-check"
                     :loading="this.loading.update_multiple_keyword_price"
                     @click="m__update_multiple_keyword_price">{{ $t('base.confirm') }}
          </el-button>
        </el-row>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.update_multiple_target_roas" :close-on-click-modal="false"
               width="700px">
      <div slot="title" style="padding:10px">
        <el-row>
          <el-col :sm="14">
            <strong class="strong-title"> {{ $t('base.mass_edit_x', { x: $t('base.bid_price') }) }} </strong>
          </el-col>
          <el-col :sm="10">
            <el-select size="mini" value="" class="full-w fix-collapse-tags"
                       v-model="form_update_multiple_keyword_price.keyword_types"
                       multiple collapse-tags ref="updateMultipleBidPriceTypes">
              <el-option value="target_roas" :label="$t('base.target_roas')"></el-option>
            </el-select>
          </el-col>
        </el-row>
        <br>

        <el-row style="margin-top: 10px">
          <el-col :sm="14">
            <el-radio v-model="form_update_multiple_keyword_price.update_type" :label="1">
              {{ $t('base.i_or_d_x_by_amount', { x: $t('base.target_roas') }) }}
            </el-radio>
          </el-col>
          <el-col :sm="10">
            <el-row>
              <el-col :sm="8">
                <el-select size="mini" v-model="form_update_multiple_keyword_price.update_by_cost" class="full-w"
                           :disabled="form_update_multiple_keyword_price.update_type !== 1">
                  <el-option value="increase" :label="$t('base.increase')"></el-option>
                  <el-option value="reduce" :label="$t('base.decrease')"></el-option>
                </el-select>
              </el-col>
              <el-col :sm="16" style="padding-left: 10px">
                <el-input size="mini" type="number" :disabled="form_update_multiple_keyword_price.update_type !== 1"
                          v-model="form_update_multiple_keyword_price.update_by_cost_value"></el-input>
                <div style="height: 5px"></div>
                <el-input v-if="form_update_multiple_keyword_price.update_by_cost === 'increase'"
                          size="mini" type="number" :placeholder="$t('input.max_bid_value')"
                          :disabled="form_update_multiple_keyword_price.update_type !== 1"
                          v-model="form_update_multiple_keyword_price.update_by_cost_value_max"></el-input>
                <el-input v-if="form_update_multiple_keyword_price.update_by_cost === 'reduce'"
                          size="mini" type="number" :placeholder="$t('input.min_bid_value')"
                          :disabled="form_update_multiple_keyword_price.update_type !== 1"
                          v-model="form_update_multiple_keyword_price.update_by_cost_value_min"></el-input>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-row style="margin-top: 10px">
          <el-col :sm="14">
            <el-radio v-model="form_update_multiple_keyword_price.update_type" :label="2">
              {{ $t('base.i_or_d_x_by_percent', { x: $t('base.target_roas') }) }}
            </el-radio>
          </el-col>
          <el-col :sm="10">
            <el-row>
              <el-col :sm="8">
                <el-select size="mini" v-model="form_update_multiple_keyword_price.update_by_percent" class="full-w"
                           :disabled="form_update_multiple_keyword_price.update_type !== 2">
                  <el-option value="increase" :label="$t('base.increase')"></el-option>
                  <el-option value="reduce" :label="$t('base.decrease')"></el-option>
                </el-select>
              </el-col>
              <el-col :sm="16" style="padding-left: 10px">
                <el-input size="mini" type="number" :disabled="form_update_multiple_keyword_price.update_type !== 2"
                          v-model="form_update_multiple_keyword_price.update_by_percent_value"></el-input>
                <div style="height: 5px"></div>
                <el-input v-if="form_update_multiple_keyword_price.update_by_percent === 'increase'"
                          size="mini" type="number" :placeholder="$t('input.max_bid_value')"
                          :disabled="form_update_multiple_keyword_price.update_type !== 2"
                          v-model="form_update_multiple_keyword_price.update_by_percent_value_max"></el-input>
                <el-input v-if="form_update_multiple_keyword_price.update_by_percent === 'reduce'"
                          size="mini" type="number" :placeholder="$t('input.min_bid_value')"
                          :disabled="form_update_multiple_keyword_price.update_type !== 2"
                          v-model="form_update_multiple_keyword_price.update_by_percent_value_min"></el-input>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-row style="margin-top: 10px">
          <el-col :sm="14">
            <el-radio v-model="form_update_multiple_keyword_price.update_type" :label="5">
              {{ $t('base.set_x', { x: $t('base.target_roas') }) }}
            </el-radio>
          </el-col>
          <el-col :sm="10">
            <el-row>
              <el-col :sm="8">
                <div>&nbsp;</div>
              </el-col>
              <el-col :sm="16" style="padding-left: 10px">
                <el-input size="mini" type="number"
                          :disabled="form_update_multiple_keyword_price.update_type !== 5"
                          v-model="form_update_multiple_keyword_price.cost_value"></el-input>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-row style="margin-top:30px" class="text-right">
          <el-button size="mini" type="primary" icon="el-icon-check"
                     :loading="this.loading.update_multiple_keyword_price"
                     @click="m__update_multiple_keyword_price">{{ $t('base.confirm') }}
          </el-button>
        </el-row>
      </div>
    </el-dialog>

    <el-dialog id="auto-quota" :visible.sync="show_dialog.config_auto_quota" :close-on-click-modal="false"
               width="990px">
      <div slot="title" style="padding: 0 10px 10px 10px">
        <div style="padding-top: 10px">
          <strong class="strong-title">
            {{ $t('ads.automatic_budget_configuration') }}
          </strong>
        </div>

        <div>
          <div>
            <el-radio v-model="form_config_auto_quota.mode" label="auto">
              <strong style="font-size: 13px">{{ 'Cấu hình ngân sách tự động theo CIR' }}</strong>
            </el-radio>
          </div>
          <div style="margin-top: 10px">
            <el-radio v-model="form_config_auto_quota.mode" label="manual">
              <strong style="font-size: 13px">{{ 'Cấu hình ngân sách tùy chỉnh (Cấu hình nâng cao)' }}</strong>
            </el-radio>
          </div>

          <div v-if="form_config_auto_quota.mode === 'auto'" style="margin-top: 30px; display: flex; gap: 20px">
            <div
              style="flex: 1; padding: 20px 15px; background-color: #f5f5f5; border-radius: 4px; display: flex; flex-direction: column; gap: 20px; position: relative">
              <div
                style="position: absolute; background-color: #fff; top: -8px; left: 12px; border-radius: 4px; padding: 0 8px">
                <span style="font-size: 12px" class="text-primary">Cấu hình ngày thường</span>
              </div>

              <div style="margin-top: 5px">
                <strong v-if="false" class="strong-label">{{ $t('base.expected_cir') }}</strong>
                <el-dropdown v-if="true" trigger="click">
                  <div style="display: flex; align-items: center; gap: 5px">
                    <strong v-if="form_config_auto_quota.check_type === 'cir'"
                            class="strong-label">{{ $t('base.expected_cir') }}</strong>
                    <strong v-if="form_config_auto_quota.check_type === 'roi'"
                            class="strong-label">{{ $t('base.expected_roas') }}</strong>
                    <strong v-if="form_config_auto_quota.check_type === 'exclude_cancelled_roi'"
                            class="strong-label">{{ $t('base.expected_exclude_cancelled_roi') }}</strong>
                    <i class="el-icon-caret-bottom"></i>
                  </div>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="form_config_auto_quota.check_type = 'cir'">
                      <div style="display: flex; align-items: center; justify-content: space-between">
                        <span>
                          {{ $t('base.expected_cir') }}
                        </span>
                        <i v-if="form_config_auto_quota.check_type === 'cir'" class="el-icon-check"></i>
                      </div>
                    </el-dropdown-item>
                    <el-dropdown-item @click.native="form_config_auto_quota.check_type = 'roi'">
                      <div style="display: flex; align-items: center; justify-content: space-between">
                        <span>
                          {{ $t('base.expected_roas') }}
                        </span>
                        <i v-if="form_config_auto_quota.check_type === 'roi'" class="el-icon-check"></i>
                      </div>
                    </el-dropdown-item>
                    <el-dropdown-item @click.native="form_config_auto_quota.check_type = 'exclude_cancelled_roi'">
                      <div style="display: flex; align-items: center; justify-content: space-between">
                        <span>
                          {{ $t('base.expected_exclude_cancelled_roi') }}
                        </span>
                        <i v-if="form_config_auto_quota.check_type === 'exclude_cancelled_roi'"
                           class="el-icon-check"></i>
                      </div>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <el-input v-model="form_config_auto_quota.cir" :placeholder="$t('input.value')"
                          type="number" size="small"></el-input>
              </div>

              <div>
                <strong class="strong-label">Kiểu tăng ngân sách</strong>
                <div style="display: flex; gap: 10px">
                  <el-select v-model="form_config_auto_quota.auto_type" size="mini" value="" style="flex: 1">
                    <el-option :value="'auto'" :label="'Tự động'"></el-option>
                    <el-option :value="'value'" :label="'Theo số tiền'"></el-option>
                    <el-option :value="'percent'" :label="'Theo phần trăm'"></el-option>
                  </el-select>

                  <el-input v-if="['value', 'percent'].includes(form_config_auto_quota.auto_type)"
                            v-model="form_config_auto_quota.auto_value" size="mini" style="flex: 1"
                            type="number"></el-input>
                </div>
              </div>

              <div>
                <strong class="strong-label"> {{ $t('base.starting_budget') }} </strong>
                <el-input v-model="form_config_auto_quota.start" :placeholder="$t('input.starting_budget')"
                          type="number" size="small"></el-input>
              </div>

              <div>
                <strong class="strong-label">
                  {{ 'Ngân sách tối đa khi CIR trong mức mong muốn (Không bắt buộc)' }}
                </strong>
                <el-input v-model="form_config_auto_quota.max" :placeholder="`Nhập ngân sách tối đa`"
                          type="number" size="small"></el-input>
              </div>
            </div>

            <div
              style="flex: 1; padding: 20px 15px; background-color: #f5f5f5; border-radius: 4px; display: flex; flex-direction: column; gap: 20px; position: relative">
              <div
                style="position: absolute; background-color: #fff; top: -8px; left: 12px; border-radius: 4px; padding: 0 8px">
                <span style="font-size: 12px" class="text-primary">
                  Cấu hình ngày sale
                  <el-tooltip
                    class="item" effect="dark"
                    :content="'Bạn có thể không cần điền cấu hình cho ngày sale, hệ thống sẽ mặc định sử dụng cấu hình ngày thường để chạy. Hệ thống sẽ áp dụng cho cả ngày sale lớn và sale nhỏ.'"
                    placement="top">
                    <i class="el-icon-question" style="font-size: 12px"></i>
                  </el-tooltip>
                </span>
              </div>

              <div style="margin-top: 5px">
                <strong v-if="false" class="strong-label">{{ $t('base.expected_cir') }}</strong>
                <el-dropdown v-if="true" trigger="click">
                  <div style="display: flex; align-items: center; gap: 5px">
                    <strong v-if="form_config_auto_quota.check_type === 'cir'"
                            class="strong-label">{{ $t('base.expected_cir') }}</strong>
                    <strong v-if="form_config_auto_quota.check_type === 'roi'"
                            class="strong-label">{{ $t('base.expected_roas') }}</strong>
                    <strong v-if="form_config_auto_quota.check_type === 'exclude_cancelled_roi'"
                            class="strong-label">{{ $t('base.expected_exclude_cancelled_roi') }}</strong>
                    <i class="el-icon-caret-bottom"></i>
                  </div>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="form_config_auto_quota.check_type = 'cir'">
                      <div style="display: flex; align-items: center; justify-content: space-between">
                        <span>
                          {{ $t('base.expected_cir') }}
                        </span>
                        <i v-if="form_config_auto_quota.check_type === 'cir'" class="el-icon-check"></i>
                      </div>
                    </el-dropdown-item>
                    <el-dropdown-item @click.native="form_config_auto_quota.check_type = 'roi'">
                      <div style="display: flex; align-items: center; justify-content: space-between">
                        <span>
                          {{ $t('base.expected_roas') }}
                        </span>
                        <i v-if="form_config_auto_quota.check_type === 'roi'" class="el-icon-check"></i>
                      </div>
                    </el-dropdown-item>
                    <el-dropdown-item @click.native="form_config_auto_quota.check_type = 'exclude_cancelled_roi'">
                      <div style="display: flex; align-items: center; justify-content: space-between">
                        <span>
                          {{ $t('base.expected_exclude_cancelled_roi') }}
                        </span>
                        <i v-if="form_config_auto_quota.check_type === 'exclude_cancelled_roi'"
                           class="el-icon-check"></i>
                      </div>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <el-input v-model="form_config_auto_quota.spike_cir" :placeholder="$t('input.value')"
                          type="number" size="small"></el-input>
              </div>

              <div>
                <strong class="strong-label">Kiểu tăng ngân sách</strong>
                <div style="display: flex; gap: 10px">
                  <el-select v-model="form_config_auto_quota.spike_auto_type" size="mini" value="" style="flex: 1">
                    <el-option :value="'auto'" :label="'Tự động'"></el-option>
                    <el-option :value="'value'" :label="'Theo số tiền'"></el-option>
                    <el-option :value="'percent'" :label="'Theo phần trăm'"></el-option>
                  </el-select>

                  <el-input v-if="['value', 'percent'].includes(form_config_auto_quota.spike_auto_type)"
                            v-model="form_config_auto_quota.spike_auto_value" size="mini" style="flex: 1"
                            type="number"></el-input>
                </div>
              </div>

              <div>
                <strong class="strong-label"> {{ $t('base.starting_budget') }} </strong>
                <el-input v-model="form_config_auto_quota.spike_start" :placeholder="$t('input.starting_budget')"
                          type="number" size="small"></el-input>
              </div>

              <div>
                <strong class="strong-label">
                  {{ 'Ngân sách tối đa khi CIR trong mức mong muốn (Không bắt buộc)' }}
                </strong>
                <el-input v-model="form_config_auto_quota.spike_max" :placeholder="`Nhập ngân sách tối đa`"
                          type="number" size="small"></el-input>
              </div>
            </div>
          </div>
          <div v-if="form_config_auto_quota.mode === 'auto'" style="margin-top: 20px">
            <div style="display: flex; align-items: center">
              <el-switch
                v-model="form_config_auto_quota.alwaysOngoing"
                size="small"
                active-color="#13ce66"
                inactive-color="#b7b7b7"
                :active-value="true"
                :inactive-value="false">
              </el-switch>
              <div style="margin-left: 15px; font-size: 13px; padding-top: 2px">
                {{ $t('ads.always_ongoing') }}
              </div>
            </div>
            <div style="margin-top: 8px; color: #999; font-size: 12px; line-height: 20px">
              {{ $t('ads.always_ongoing_message') }}
            </div>
          </div>

          <div style="margin-top: 20px" v-if="!form_config_auto_quota.mode || form_config_auto_quota.mode === 'manual'">
            <div style="width: 800px; display: flex; flex-direction: column; gap: 20px">
              <el-row>
                <el-col :sm="18" style="padding-right: 25px">
                  <el-select v-model="form_config_auto_quota.active_day" value="" size="mini"
                             placeholder="Chọn ngày hoạt động" class="full-w">
                    <el-option value="remain" :label="$t('day.every_day')"></el-option>
                    <el-option value="flash_sale" :label="$t('day.flash_sale')"></el-option>
                    <el-option value="before_flash_sale" :label="$t('day.before_flash_sale')"></el-option>
                    <!-- <el-option value="mini_spike_day" :label="$t('day.mini_spike_day')"></el-option> -->
                    <el-option value="exclude_sale" :label="$t('day.exclude_sale')"></el-option>
                  </el-select>
                </el-col>
                <el-col :sm="6">
                </el-col>
              </el-row>
              <el-row>
                <el-col :sm="9" style="padding-right: 15px">
                  <el-time-select
                    class="full-w"
                    v-model="form_config_auto_quota.start_time"
                    size="mini"
                    :picker-options="{start: '00:00',step: '00:15',end: '24:00'}"
                    :placeholder="$t('base.starting_time')">
                  </el-time-select>
                </el-col>
                <el-col :sm="9" style="padding-right: 25px">
                  <el-time-select
                    class="full-w"
                    v-model="form_config_auto_quota.end_time"
                    size="mini"
                    :picker-options="{start: '00:00',step: '00:15',end: '24:00'}"
                    :placeholder="$t('base.ending_time')">
                  </el-time-select>
                </el-col>
                <el-col :sm="6">
                </el-col>
              </el-row>
              <el-row>
                <el-col :sm="9" style="padding-right: 15px">
                  <el-select size="mini" v-model="form_config_auto_quota.action"
                             :placeholder="$t('base.select_budget_type')" class="full-w">
                    <el-option value="daily_quota"
                               :label="$t('base.adjust_x', {x: $t('base.daily_budget')})"></el-option>
                    <el-option value="auto_quota_cir"
                               :label="`Điều chỉnh Ngân sách tự động theo CIR (ACOS)`"></el-option>
                    <el-option value="auto_quota_roi"
                               :label="`Điều chỉnh Ngân sách tự động theo ROI (ROAS)`"></el-option>
                    <el-option value="auto_quota_exclude_cancelled_roi"
                               :label="`Điều chỉnh Ngân sách tự động theo ROI (ROAS) đã trừ hủy`"></el-option>
                  </el-select>
                </el-col>
                <el-col :sm="9" style="padding-right: 25px">
                  <el-input v-if="form_config_auto_quota.action === 'daily_quota'" size="mini"
                            v-model="form_config_auto_quota.daily_quota" :placeholder="$t('input.budget')"></el-input>
                  <el-input v-if="form_config_auto_quota.action === 'total_quota'" size="mini"
                            v-model="form_config_auto_quota.total_quota" :placeholder="$t('input.budget')"></el-input>
                  <el-input
                    v-if="array_to_set(['auto_quota', 'auto_quota_cir', 'auto_quota_roi', 'auto_quota_exclude_cancelled_roi']).has(form_config_auto_quota.action)"
                    size="mini"
                    v-model="form_config_auto_quota.cir_quota"
                    :placeholder="$t('input.value')"></el-input>
                </el-col>
                <el-col :sm="6">
                </el-col>
              </el-row>
              <el-row
                v-if="array_to_set(['auto_quota', 'auto_quota_cir', 'auto_quota_roi', 'auto_quota_exclude_cancelled_roi']).has(form_config_auto_quota.action)">
                <el-col :sm="9" style="padding-right: 15px">
                  <el-select v-model="form_config_auto_quota.auto_type" size="mini" value="" class="full-w">
                    <el-option :value="'auto'" :label="'Tự động điều chỉnh'"></el-option>
                    <el-option :value="'value'" :label="'Điều chỉnh theo số tiền'"></el-option>
                    <el-option :value="'percent'" :label="'Điều chỉnh theo phần trăm'"></el-option>
                  </el-select>
                </el-col>
                <el-col :sm="9" style="padding-right: 25px">
                  <el-input v-if="['value', 'percent'].includes(form_config_auto_quota.auto_type)"
                            v-model="form_config_auto_quota.auto_value"
                            size="mini" style="flex: 1" type="number"
                            :placeholder="!['value', 'percent'].includes(form_config_auto_quota.auto_type) ? 'Không cần nhập giá trị' : $t('input.value')"></el-input>
                  <el-input v-else size="mini" value="Hệ thống tự điều chỉnh" :disabled="true"></el-input>
                </el-col>
                <el-col :sm="6">
                </el-col>
              </el-row>
              <el-row
                v-if="array_to_set(['auto_quota', 'auto_quota_cir', 'auto_quota_roi', 'auto_quota_exclude_cancelled_roi']).has(form_config_auto_quota.action)">
                <el-col :sm="9" style="padding-right: 15px">
                  <el-select size="mini" value="" class="full-w">
                    <el-option value="" :label="'Ngân sách khởi điểm'"></el-option>
                  </el-select>
                </el-col>
                <el-col :sm="9" style="padding-right: 25px">
                  <el-input v-model="form_config_auto_quota.start" size="mini" style="flex: 1" type="number"
                            placeholder="Không bắt buộc"></el-input>
                </el-col>
                <el-col :sm="6">
                </el-col>
              </el-row>
              <el-row
                v-if="array_to_set(['auto_quota', 'auto_quota_cir', 'auto_quota_roi', 'auto_quota_exclude_cancelled_roi']).has(form_config_auto_quota.action)">
                <el-col :sm="9" style="padding-right: 15px">
                  <el-select size="mini" value="" class="full-w">
                    <el-option value="" :label="'Ngân sách tối đa khi chỉ số trong mức mong muốn'"></el-option>
                  </el-select>
                </el-col>
                <el-col :sm="9" style="padding-right: 25px">
                  <el-input v-model="form_config_auto_quota.max" size="mini" style="flex: 1" type="number"
                            placeholder="Không bắt buộc"></el-input>
                </el-col>
                <el-col :sm="6">
                </el-col>
              </el-row>
              <el-row>
                <el-col :sm="9" style="padding-right: 15px">
                  &nbsp;
                </el-col>
                <el-col :sm="9" style="padding-right: 25px; text-align: right">
                  <el-button type="primary" icon="el-icon-plus" size="mini" @click="m__add_item_auto_quota">
                    {{ $t('base.add_config') }}
                  </el-button>
                </el-col>
                <el-col :sm="6">
                </el-col>
              </el-row>
            </div>

            <div style="margin-top: 20px">
              <div v-if="Object.keys(c__form_config_auto_quota_data).length > 0"
                   style="display: flex; flex-direction: column; gap: 20px">
                <div v-for="key in Object.keys(c__form_config_auto_quota_data)">
                  <p class="text-title">
                    🚀&nbsp;
                    {{ $t('base.configuration_list') }}
                    {{ spike_day_map({ type: key }, false) }}
                  </p>
                  <el-table :data="c__form_config_auto_quota_data[key]">
                    <el-table-column :label="$t('ads.from')" prop="start_time" width="70px"></el-table-column>
                    <el-table-column :label="$t('ads.to')" prop="end_time" width="70px"></el-table-column>
                    <el-table-column v-if="false" :label="$t('base.adjust_type')" prop="action">
                      <template slot-scope="scope">
                        <el-select size="mini" v-model="scope.row.action" class="full-w">
                          <el-option value="daily_quota"
                                     :label="$t('base.adjust_x', {x: $t('base.daily_budget')})"></el-option>
                          <el-option value="auto_quota"
                                     :label="`Điều chỉnh Ngân sách tự động`"></el-option>
                        </el-select>
                      </template>
                    </el-table-column>
                    <el-table-column :label="$t('base.adjust_type')" prop="action" show-tooltip-when-overflow
                                     width="200px">
                      <template slot-scope="scope">
                        <template v-if="scope.row.action === 'daily_quota'">
                          {{ $t('base.adjust_x', { x: $t('base.daily_budget') }) }}
                        </template>
                        <template v-if="scope.row.action === 'total_quota'">
                          {{ $t('base.adjust_x', { x: $t('base.total_budget') }) }}
                        </template>
                        <template v-if="scope.row.action === 'auto_quota'">
                          {{ `Điều chỉnh Ngân sách tự động` }}
                        </template>
                      </template>
                    </el-table-column>
                    <el-table-column :label="'Mục tiêu'" width="120px" show-tooltip-when-overflow>
                      <template slot-scope="scope">
                        <template v-if="scope.row.action === 'daily_quota'">
                          Ngân sách ngày
                        </template>
                        <template v-if="scope.row.action === 'total_quota'">
                          Ngân sách ngày
                        </template>
                        <template v-if="scope.row.action === 'auto_quota'">
                          <template v-if="scope.row.check_type === 'cir'">
                            CIR (ACOS)
                          </template>
                          <template v-else-if="scope.row.check_type === 'roi'">
                            ROI (ROAS)
                          </template>
                          <template v-else-if="scope.row.check_type === 'exclude_cancelled_roi'">
                            ROI (ROAS) đã trừ hủy
                          </template>
                          <template v-else>
                            CIR (ACOS)
                          </template>
                        </template>
                      </template>
                    </el-table-column>
                    <el-table-column :label="$t('base.value')" width="140px">
                      <template slot-scope="scope">
                        <template v-if="scope.row.action === 'daily_quota'">
                          <el-input size="mini" type="number" v-model="scope.row.daily_quota"></el-input>
                        </template>
                        <template v-if="scope.row.action === 'total_quota'">
                          <el-input size="mini" type="number" v-model="scope.row.total_quota"></el-input>
                        </template>
                        <template v-if="scope.row.action === 'auto_quota'">
                          <el-input size="mini" type="number" v-model="scope.row.cir_quota"></el-input>
                        </template>
                      </template>
                    </el-table-column>
                    <el-table-column :label="'Tuỳ chọn'" width="200px" show-tooltip-when-overflow>
                      <template slot-scope="scope">
                        <template v-if="scope.row.action === 'auto_quota'">
                          Kiểu điều chỉnh:
                          <template v-if="scope.row.auto_type === 'auto'">Tự động</template>
                          <template v-if="scope.row.auto_type === 'value'">
                            Tăng {{ scope.row.auto_value | currency }}
                          </template>
                          <template v-if="scope.row.auto_type === 'percent'">
                            Tăng {{ scope.row.auto_value }}%
                          </template>
                          <br>
                          Ngân sách khởi điểm:
                          {{ +scope.row.start ? format_currency(scope.row.start) : 'Không cấu hình' }}
                          <br>
                          Ngân sách tối đa:
                          {{ +scope.row.max ? format_currency(scope.row.max) : 'Không cấu hình' }}
                        </template>
                      </template>
                    </el-table-column>
                    <el-table-column width="90px">
                      <template slot-scope="scope">
                        <el-button type="text" size="mini"
                                   @click="m__update_item_auto_quota(scope.row.config_id)">
                          <strong class="text-primary">{{ $t('base.edit') }}</strong>
                        </el-button>
                        <br>
                        <el-button type="text" size="mini"
                                   @click="m__remove_item_auto_quota_by_id(scope.row.config_id)">
                          <strong class="text-danger">{{ $t('base.delete') }}</strong>
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
              <div v-else style="background-color: #f5f5f5; padding: 10px; border-radius: 4px; text-align: center">
                Chưa có cấu hình
              </div>
            </div>

            <div style="margin-top: 40px">
              <p class="text-title"> {{ $t('base.set_when_outside_runtime') }}</p>

              <el-row style="margin-top: 10px; width: 530px">
                <el-col :sm="18" style="padding-right: 25px">
                  <el-select size="mini" v-model="form_config_auto_quota.action2" :placeholder="$t('select.action')"
                             class="full-w">
                    <el-option value="nothing" :label="$t('ads.auto_quota_label.nothing')"></el-option>
                    <el-option value="unlimited" :label="$t('ads.auto_quota_label.unlimited')"></el-option>
                    <el-option value="pause" :label="$t('ads.auto_quota_label.pause')"></el-option>
                  </el-select>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>

        <div style="margin-top: 35px" class="text-right">
          <el-button v-if="selected_campaign && selected_campaign.auto_quota" size="mini" type="danger"
                     icon="el-icon-delete" @click="m__delete_config_auto_quota">
            {{ $t('base.delete_config') }}
          </el-button>
          <el-button size="mini" type="primary" icon="el-icon-check" :loading="loading.auto_quota"
                     @click="m__save_config_auto_quota">
            {{ $t('base.save_config') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.add_keywords" :close-on-click-modal="false" width="1350px"
               class="dialog-height-keyword">
      <div slot="title" style="padding:10px">
        <el-row>
          <el-col :sm="14" style="padding-right: 10px">
            <strong style="font-size: 14px">{{ $t('keyword.add_keywords') }} </strong>
            <br>
            <br>
            <br>

            <div class="atosa-tab">
              <div class="atosa-tab-item" :class="radio === '1' ? 'atosa-tab-item-active': ''" @click="radio = '1'">
                {{ $t('base.shopee_recommend') }}
              </div>
              <div class="atosa-tab-item" :class="radio === '4' ? 'atosa-tab-item-active': ''" @click="radio = '4'">
                {{ $t('menu.atosa_keyword_tool') }}
              </div>
              <div class="atosa-tab-item" :class="radio === '2' ? 'atosa-tab-item-active': ''" @click="radio = '2'">
                {{ $t('keyword.file') }} (Atosa)
              </div>
              <div class="atosa-tab-item" :class="radio === '3' ? 'atosa-tab-item-active': ''" @click="radio = '3'">
                {{ $t('base.search_keywords') }}
              </div>
              <div class="atosa-tab-item" :class="radio === '5' ? 'atosa-tab-item-active': ''" @click="radio = '5'">
                Import Excel
              </div>
            </div>
          </el-col>
          <el-col :sm="10" style="padding: 0 10px 0 40px">
            <strong style="font-size: 14px"> {{ $t('keyword.added_keywords') }} ({{ added_keywords.length }})</strong>
            <br>
            <br>
            <br>
            <el-row>
              <el-col :sm="24">
                <el-select v-model="added_keywords_type" size="mini" style="border: none !important;">
                  <el-option :value="0" :label="$t('keyword.exact')"></el-option>
                  <el-option :value="1" :label="$t('keyword.broad')"></el-option>
                </el-select>
                &nbsp;
                <el-button size="mini" @click="m__show_update_added_keyword_dialog"> {{ $t('base.edit_bid_price') }}
                </el-button>
                <el-button size="mini" type="info" @click="added_keywords = []">Clear</el-button>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-row style="height: 50px">
          <el-col :sm="14" style="padding-right: 10px">

            <div v-if="radio === '2'">
              <div>
                <el-select size="mini" value="" v-model="selected_keyword_file" @change="m__get_keyword_file_detail"
                           style="width: 250px" filterable :placeholder="$t('select.keyword_file')">
                  <el-option v-for="keyword in keyword_file_list" :key="keyword._id" :value="keyword._id"
                             :label="keyword.filename"></el-option>
                </el-select> &nbsp;&nbsp;
                <strong style="color: orangered; cursor: pointer"
                        @click="m__get_keyword_file(); m__get_keyword_file_detail()">
                  ({{ $t('base.update') }})</strong>
              </div>
            </div>

            <div v-if="radio === '3'">
              <div>
                <el-autocomplete size="mini" :placeholder="$t('input.placeholder')" v-model="keyword"
                                 style="width: 250px" :fetch-suggestions="m__suggest_keyword" :debounce="800"
                                 @select="m__search_sp_keyword" @keyup.enter.native="m__search_sp_keyword">
                </el-autocomplete>
              </div>
            </div>

            <div v-if="radio === '4'">
              <div>
                <el-input size="mini" :placeholder="$t('input.placeholder')"
                          v-model="base_keyword" style="width: 250px"
                          @keyup.enter.native="m__enter_input"></el-input>
                &nbsp;
                <el-button size="mini" type="primary" icon="el-icon-search" :loading="fff_loading"
                           @click="m__try_get_keyword_result"> {{ $t('base.search') }}
                </el-button>
              </div>
            </div>

            <div v-if="radio === '5'">
              <div>
                <el-button size="mini" type="primary" icon="ti-harddrives" @click="m__show_import_excel_file">
                  &nbsp;&nbsp;&nbsp;{{ $t('base.import_excel_file') }}
                </el-button>
                &nbsp;&nbsp;&nbsp;<strong class="text-danger">*{{ $t('keyword.import_note') }}</strong>
              </div>
            </div>
          </el-col>
          <el-col :sm="10" style="padding: 0 10px 0 40px">
          </el-col>
        </el-row>

        <el-row>
          <el-col :sm="14" style="padding-right: 10px">
            <div v-if="radio === '1'">
              <el-table :data="shopee_suggest_keywords">
                <el-table-column :label="$t('base.keyword')" prop="keyword">
                  <template slot-scope="scope">{{ scope.row.keyword.normalize() }}</template>
                </el-table-column>
                <el-table-column :label="$t('base.volume')" prop="search_volume" sortable>
                  <template slot-scope="scope">{{ scope.row.search_volume | currency }}</template>
                </el-table-column>
                <el-table-column :label="$t('base.relevance')" prop="relevance" sortable>
                  <template slot-scope="scope">{{ scope.row.relevance | currency }}/10</template>
                </el-table-column>
                <el-table-column :label="$t('base.recommend_price')" prop="recommend_price" sortable>
                  <template slot-scope="scope">{{ m__calculate(scope.row.recommend_price) | currency }}</template>
                </el-table-column>
                <el-table-column :label="$t('base.action')" width="110px" align="right">
                  <template slot-scope="scope">
                    <strong v-if="m__can_add(scope.row)" href="javascript:void(0)" @click="m__add_keyword(scope.row)"
                            class="text-info">{{ $t('base.add') }} ></strong>
                    <strong v-else href="javascript:void(0)" class="text-grey">{{ $t('base.added') }}</strong>
                  </template>
                </el-table-column>
              </el-table>
            </div>

            <div v-if="radio === '2'">
              <el-table :data="c__mipee_suggest_keywords_display"
                        @sort-change="({prop, order}) => {mipee_suggest_keywords_filter.sort_option.order = order; mipee_suggest_keywords_filter.sort_option.prop = prop}">
                <el-table-column :label="$t('base.keyword')" prop="keyword">
                  <template slot-scope="scope">{{ scope.row.keyword.normalize() }}</template>
                </el-table-column>
                <el-table-column :label="$t('base.volume')" prop="now_volume" sortable="custom">
                  <template slot-scope="scope">{{ scope.row.now_volume | currency }}</template>
                </el-table-column>
                <el-table-column :label="$t('base.recommend_price')" prop="recommend_price" sortable="custom">
                  <template slot-scope="scope">{{ m__calculate(scope.row.recommend_price) | currency }}</template>
                </el-table-column>
                <el-table-column :label="$t('base.action')" width="110px" align="right">
                  <template slot-scope="scope">
                    <strong v-if="m__can_add(scope.row)" href="javascript:void(0)" @click="m__add_keyword(scope.row)"
                            class="text-info">{{ $t('base.add') }} ></strong>
                    <strong v-else href="javascript:void(0)">{{ $t('base.added') }}</strong>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination :current-page.sync="mipee_suggest_keywords_filter.current_page"
                             :page-size="mipee_suggest_keywords_filter.page_size"
                             layout="prev, pager, next, total" :total="mipee_suggest_keywords.length"/>
            </div>

            <div v-if="radio === '3'">
              <el-table :data="c__add_keyword_display_list"
                        @sort-change="({prop, order}) => {add_keyword_filter.sort_option.order = order; add_keyword_filter.sort_option.prop = prop}">
                <el-table-column :label="$t('base.keyword')" prop="keyword" show-overflow-tooltip>
                  <template slot-scope="scope">{{ scope.row.keyword.normalize() }}</template>
                </el-table-column>
                <el-table-column :label="$t('base.volume')" prop="sp_volume" sortable="custom">
                  <template slot-scope="scope">{{ scope.row.sp_volume | currency }}</template>
                </el-table-column>
                <el-table-column :label="$t('base.relevance')" prop="relevance" sortable="custom">
                  <template slot-scope="scope">{{ scope.row.relevance | currency }}/10</template>
                </el-table-column>
                <el-table-column :label="$t('base.recommend_price')" prop="sp_price" sortable="custom">
                  <template slot-scope="scope">{{ scope.row.sp_price | currency }}</template>
                </el-table-column>
                <el-table-column :label="$t('base.action')" width="110px" align="right">
                  <template slot-scope="scope">
                    <strong v-if="m__can_add(scope.row)" href="javascript:void(0)" @click="m__add_keyword(scope.row)"
                            class="text-info">{{ $t('base.add') }} ></strong>
                    <strong v-else href="javascript:void(0)" class="text-grey">{{ $t('base.added') }}</strong>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination :current-page.sync="add_keyword_filter.current_page"
                             :page-size="add_keyword_filter.page_size"
                             layout="prev, pager, next, total" :total="add_keyword.data.length"/>
            </div>

            <div v-if="radio === '4'">
              <el-table :data="c__fff_result_display_list" @sort-change="m__fff_sort_change" class="fff-table">
                <el-table-column :label="$t('base.keyword')" show-tooltip-when-overflow>
                  <template slot-scope="scope">
                    {{ scope.row.keyword.normalize() }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="sp_volume"
                  :label="$t('base.volume')" sortable="custom">
                  <template slot-scope="scope">
                    {{ scope.row.sp_volume | currency }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="sp_price"
                  :label="$t('base.recommend_price')" sortable="custom">
                  <template slot-scope="scope">
                    {{ scope.row.sp_price | currency }}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('base.action')" width="110px" align="right">
                  <template slot-scope="scope">
                    <div style="padding-top: 5px">
                      <strong v-if="m__can_add(scope.row)" href="javascript:void(0)" type="text" class="text-info"
                              @click="m__add_keyword(scope.row, 'shopee_suggest_keywords')">
                        <strong>{{ $t('base.add') }} ></strong></strong>
                      <strong v-else href="javascript:void(0)" class="text-grey">{{ $t('base.added') }}</strong>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination :current-page.sync="add_keyword_filter.current_page"
                             :page-size="add_keyword_filter.page_size"
                             layout="prev, pager, next, total" :total="fff_result.length"/>
            </div>

            <div v-if="radio === '5'">
              <el-table
                :data="c__excel_keyword_display_list">
                <el-table-column
                  :label="$t('base.keyword')">
                  <template slot-scope="scope">
                    {{ scope.row.keyword.normalize() }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="search_volume"
                  :label="$t('base.volume')" sortable>
                  <template slot-scope="scope">
                    {{ scope.row.search_volume | currency }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="recommend_price"
                  :label="$t('base.recommend_price')" sortable>
                  <template slot-scope="scope">
                    {{ scope.row.recommend_price | currency }}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('base.action')" width="110px" align="right">
                  <template slot-scope="scope">
                    <div style="padding-top: 5px">
                      <strong v-if="m__can_add(scope.row)" href="javascript:void(0)" type="text" class="text-info"
                              @click="m__add_keyword(scope.row, 'shopee_suggest_keywords')">
                        <strong>{{ $t('base.add') }} ></strong></strong>
                      <strong v-else href="javascript:void(0)" class="text-grey">{{ $t('base.added') }}</strong>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination :current-page.sync="excel_keyword_filter.current_page"
                             :page-size="excel_keyword_filter.page_size"
                             layout="prev, pager, next, total" :total="excel_keyword.length"/>
            </div>
          </el-col>
          <el-col :sm="10" style="padding: 0 10px 0 40px">
            <el-table :data="c__added_keyword_display_list">
              <el-table-column :label="$t('base.keyword')" prop="keyword">
                <template slot-scope="scope">{{ scope.row.keyword.normalize() }}</template>
              </el-table-column>
              <el-table-column :label="$t('base.bid_price')" prop="recommend_price" width="150px">
                <template slot-scope="scope">
                  <el-input type="number" size="mini" v-model="scope.row.recommend_price"></el-input>
                </template>
              </el-table-column>
              <el-table-column :label="$t('base.action')" width="110px" align="right">
                <template slot-scope="scope">
                  <strong href="javascript:void(0)" class="text-danger"
                          @click="m__remove_keyword(scope.row)">{{ $t('base.delete') }}</strong>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination :current-page.sync="added_keyword_filter.current_page"
                           :page-size="added_keyword_filter.page_size"
                           layout="prev, pager, next, total" :total="added_keywords.length"/>
          </el-col>
        </el-row>

        <el-row style="margin-top: 20px">
          <el-col :sm="12">
            <el-button size="mini" type="primary" @click="m__add_all">
              {{ radio !== '4' ? $t('keyword.add_all') : $t('keyword.add_top_x', { x: '100' }) }}
            </el-button>
            &nbsp;
            &nbsp;
            &nbsp;
            <el-checkbox v-model="omit_duplicated_keyword">{{ $t('base.remove_duplicated_keywords') }}</el-checkbox>
          </el-col>
          <el-col :sm="12" class="text-right">
            <el-button size="mini" type="info" icon="ti-save" @click="m__initial_save_keyword_file(true)">
              {{ $t('keyword.save_file') }}
            </el-button>
            <el-button size="mini" type="primary" :disabled="!added_keywords.length" icon="el-icon-check"
                       :loading="this.loading.add_keywords" @click="m__add_keyword_campaign_multiple">
              {{ $t('keyword.confirm_and_add') }}
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.update_added_keyword_price" :close-on-click-modal="false"
               width="800px">
      <div slot="title" style="padding:10px">
        <strong class="strong-title"> {{ $t('base.mass_edit_x', { x: $t('base.bid_price') }) }} </strong>

        <el-row>
          <el-col :sm="12">
            <el-radio v-model="form_update_multiple_added_keyword_price.update_type" :label="1">
              {{ $t('base.i_or_d_x_by_amount', { x: $t('base.bid_price') }) }}
            </el-radio>
          </el-col>
          <el-col :sm="12">
            <el-row>
              <el-col :sm="12">
                <el-select size="mini" v-model="form_update_multiple_added_keyword_price.update_by_cost" class="full-w"
                           :disabled="form_update_multiple_added_keyword_price.update_type !== 1">
                  <el-option value="increase" :label="$t('base.increase')"></el-option>
                  <el-option value="reduce" :label="$t('base.decrease')"></el-option>
                </el-select>
              </el-col>
              <el-col :sm="12">
                <el-input size="mini" type="number"
                          :disabled="form_update_multiple_added_keyword_price.update_type !== 1"
                          v-model="form_update_multiple_added_keyword_price.update_by_cost_value"></el-input>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-row style="margin-top: 10px">
          <el-col :sm="12">
            <el-radio v-model="form_update_multiple_added_keyword_price.update_type" :label="2">
              {{ $t('base.i_or_d_x_by_percent', { x: $t('base.bid_price') }) }}
            </el-radio>
          </el-col>
          <el-col :sm="12">
            <el-row>
              <el-col :sm="12">
                <el-select size="mini" v-model="form_update_multiple_added_keyword_price.update_by_percent"
                           class="full-w"
                           :disabled="form_update_multiple_added_keyword_price.update_type !== 2">
                  <el-option value="increase" :label="$t('base.increase')"></el-option>
                  <el-option value="reduce" :label="$t('base.decrease')"></el-option>
                </el-select>
              </el-col>
              <el-col :sm="12">
                <el-input size="mini" type="number"
                          :disabled="form_update_multiple_added_keyword_price.update_type !== 2"
                          v-model="form_update_multiple_added_keyword_price.update_by_percent_value"></el-input>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-row style="margin-top: 10px">
          <el-col :sm="12">
            <el-radio v-model="form_update_multiple_added_keyword_price.update_type" :label="3">
              {{ $t('base.set_x', { x: $t('base.bid_price') }) }}
            </el-radio>
          </el-col>
          <el-col :sm="12">
            <el-row>
              <el-col :sm="12">
                &nbsp;
              </el-col>
              <el-col :sm="12">
                <el-input size="mini" type="number"
                          :disabled="form_update_multiple_added_keyword_price.update_type !== 3"
                          v-model="form_update_multiple_added_keyword_price.price"></el-input>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <div style="margin-top: 10px" class="text-right">
          <el-button size="mini" type="primary" icon="el-icon-check" @click="m__update_added_keyword_price">
            {{ $t('base.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.config_auto_cir" :close-on-click-modal="false" width="800px">
      <div slot="title" style="padding:10px">
        <el-row style="background-color: #F1F1F1">
          <el-col :sm="7" style="padding-top: 10px;">
            <div style="padding: 15px 15px; width: 100%; cursor: pointer; margin-bottom: 5px"
                 :class="config_tab === 6 ? 'config-tab-active': ''" @click="config_tab = 6">
              <span style="font-size: 13px; font-weight: 700"> {{
                  $t('ads.optimize_based_on_cir_configuration')
                }}</span>
            </div>
            <div style="padding: 0 30px; width: 100%; margin-top: 10px; margin-bottom: 10px">
              <div style="height: 0; width: 100%; border-top: 1px solid #cecece"></div>
            </div>
            <div style="padding: 15px 15px; width: 100%; cursor: pointer; margin-bottom: 5px"
                 :class="config_tab === 7 ? 'config-tab-active': ''" @click="config_tab = 7">
              <span style="font-size: 13px;  font-weight: 700">{{ $t('base.configuration_setup_guide') }}</span>
            </div>
          </el-col>
          <el-col :sm="17" style="background-color: #FFF;">
            <template v-if="config_tab === 6">
              <div style="padding: 10px 10px 10px 30px">
                <el-row>
                  <el-col :sm="16" style="padding-right: 10px">
                    <p class="text-title"> {{ $t('base.expected_cir') }}(%):</p>
                    <el-input v-model="form_config_auto_cir.fromCir" size="mini" type="number"
                              :placeholder="$t('input.expected_cir')"></el-input>
                  </el-col>
                  <el-col :sm="8">
                    <p class="text-title">&nbsp</p>
                    <el-select v-model="form_config_auto_cir.cirType" size="mini" value="" class="full-w">
                      <el-option value="broad" :label="$t('ads.anti_click_label.broad_cir')"></el-option>
                      <el-option value="direct" :label="$t('ads.anti_click_label.direct_cir')"></el-option>
                    </el-select>
                  </el-col>
                </el-row>

                <el-row style="margin-top: 15px">
                  <strong class="strong-label">{{ $t('ads.get_cir_by') }}</strong>
                  <el-select v-model="form_config_auto_cir.timeType" size="mini" value="" class="full-w">
                    <el-option value="today" :label="$t('base.today')"></el-option>
                    <el-option value="yesterday" :label="$t('base.yesterday')"></el-option>
                    <el-option value="week" :label="$t('base.last_week')"></el-option>
                    <el-option value="month" :label="$t('base.last_month')"></el-option>
                  </el-select>
                </el-row>

                <hr>
                <div style="margin-top: 15px"></div>
                <strong> {{ $t('base.edit_bid_price') }} {{ $t('ads.auto_cir_label.to_reach_target') }}</strong>
                <el-row>
                  <el-col :sm="14" style="padding-right: 10px">
                    <p class="text-title"> {{ $t('base.bonus_amount') }}:</p>
                    <el-input v-model="form_config_auto_cir.price" size="mini" type="number"
                              :placeholder="$t('input.bonus_amount')"
                              :disabled="!form_config_auto_cir.allowBidPrice"></el-input>
                  </el-col>
                  <el-col :sm="10">
                    <p class="text-title">{{ $t('base.max_bid_price') }}:</p>
                    <el-input v-model="form_config_auto_cir.maxPrice" size="mini" type="number"
                              :placeholder="$t('input.max_bid_price')"
                              :disabled="!form_config_auto_cir.allowBidPrice"></el-input>
                  </el-col>
                </el-row>

                <div style="margin-top: 15px"></div>
                <hr>
                <el-checkbox v-model="form_config_auto_cir.allowAtCase1" size="small">
                  {{ $t('ads.auto_cir_label.allow_when_above_target') }}
                </el-checkbox>
                <p class="text-title">{{ $t('base.action_plan') }}</p>
                <div>
                  <el-select v-model="form_config_auto_cir.case1Type" value="" size="mini" class="full-w"
                             :disabled="!form_config_auto_cir.allowAtCase1">
                    <el-option value="stop" :label="$t('base.pause_keyword')"></el-option>
                    <el-option value="value" :label="$t('ads.general_label.edit_amount')"></el-option>
                    <el-option value="reduce" :label="$t('ads.time_based_bid_reduction')"></el-option>
                  </el-select>
                </div>
                <div v-if="form_config_auto_cir.case1Type === 'value'" style="margin-top: 10px">
                  <el-input v-model="form_config_auto_cir.case1Value"
                            size="mini" type="number" :placeholder="$t('input.amount')"
                            :disabled="!form_config_auto_cir.allowAtCase1"></el-input>
                </div>
                <div v-if="form_config_auto_cir.case1Type === 'reduce'" style="margin-top: 10px">
                  <el-row>
                    <el-col :sm="12" style="padding-right: 5px">
                      <el-input v-model="form_config_auto_cir.case1Reduce"
                                size="mini" type="number" :placeholder="$t('input.deduction_amount')"
                                :disabled="!form_config_auto_cir.allowAtCase1"></el-input>
                    </el-col>
                    <el-col :sm="12" style="padding-left: 5px">
                      <el-input v-model="form_config_auto_cir.case1ReduceMin"
                                size="mini" type="number" :placeholder="$t('input.min_bid_price')"
                                :disabled="!form_config_auto_cir.allowAtCase1"></el-input>
                    </el-col>
                  </el-row>
                </div>

                <hr>
                <el-row style="margin-top: 15px">
                  <el-checkbox v-model="form_config_auto_cir.allowAtCase2" size="small">
                    {{ $t('ads.anti_click_label.check_if_gmv_by_0') }}
                  </el-checkbox>
                  <p class="text-title">{{ $t('ads.anti_click_label.max_cost_if_gmv_by_0') }}</p>
                  <el-input v-model="form_config_auto_cir.case2Min" size="mini" :placeholder="$t('input.max_cost')"
                            type="number"
                            :disabled="!form_config_auto_cir.allowAtCase2"></el-input>

                  <br>
                  <p class="text-title" style="margin-top: 10px !important;">{{ $t('base.action_plan') }}</p>
                  <div>
                    <el-select v-model="form_config_auto_cir.case2Type" value="" size="mini" class="full-w"
                               :disabled="!form_config_auto_cir.allowAtCase2">
                      <el-option value="stop" :label="$t('base.pause_keyword')"></el-option>
                      <el-option value="value" :label="$t('ads.general_label.edit_amount')"></el-option>
                      <el-option value="reduce" :label="$t('ads.time_based_bid_reduction')"></el-option>
                    </el-select>
                  </div>
                  <div v-if="form_config_auto_cir.case2Type === 'value'" style="margin-top: 10px">
                    <el-input v-model="form_config_auto_cir.case2Value"
                              size="mini" type="number" :placeholder="$t('input.amount')"
                              :disabled="!form_config_auto_cir.allowAtCase2"></el-input>
                  </div>
                  <div v-if="form_config_auto_cir.case2Type === 'reduce'" style="margin-top: 10px">
                    <el-row>
                      <el-col :sm="12" style="padding-right: 5px">
                        <el-input v-model="form_config_auto_cir.case2Reduce"
                                  size="mini" type="number" :placeholder="$t('input.deduction_amount')"
                                  :disabled="!form_config_auto_cir.allowAtCase2"></el-input>
                      </el-col>
                      <el-col :sm="12" style="padding-left: 5px">
                        <el-input v-model="form_config_auto_cir.case2ReduceMin"
                                  size="mini" type="number" :placeholder="$t('input.min_bid_price')"
                                  :disabled="!form_config_auto_cir.allowAtCase2"></el-input>
                      </el-col>
                    </el-row>
                  </div>
                </el-row>

                <el-row style="margin-top: 30px">
                  <el-col :sm="24" class="text-right">
                    <el-button v-if="c__has_vit_ads"
                               @click="m__show_cir_advanced_dialog" size="mini" type="success" icon="el-icon-star-on">
                      {{ $t('ads.advanced_configuration') }}
                    </el-button>
                    <el-button size="mini" type="primary" icon="el-icon-check" @click="m__confirm_update_auto_cir"
                               :loading="loading.config_auto_cir">
                      {{ $t('base.save_config') }}
                    </el-button>
                  </el-col>
                </el-row>
              </div>
            </template>

            <template v-if="config_tab === 7">
              <ComponentAutoCirGuide></ComponentAutoCirGuide>
            </template>
          </el-col>
        </el-row>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.auto_cir_advanced" :close-on-click-modal="false" width="1000px"
               class="dialog-height">
      <div slot="title" style="padding:10px">
        <strong class="strong-title">{{ $t('ads.optimize_based_on_cir_advanced_configuration') }}</strong>

        <el-row style="margin-top: 10px">
          <el-col :sm="13">
            <p class="text-title"> {{ $t('ads.configuration_active_day') }} </p>
            <el-row style="margin-top: 10px">
              <el-col :sm="10" style="padding-right: 15px">
                <el-select class="full-w" size="mini" value="" filterable v-model="form_config_auto_cir.advanced_day"
                           @change="m__suggest_cir_advanced">
                  <el-option value="flash_sale" :label="$t('day.flash_sale')"></el-option>
                  <el-option value="before_flash_sale" :label="$t('day.before_flash_sale')"></el-option>
                  <el-option value="after_flash_sale" :label="$t('day.after_flash_sale')"></el-option>
                  <el-option value="mini_spike_day" :label="$t('day.mini_spike_day')"></el-option>
                  <el-option value="day" :label="$t('day.specific_day')"></el-option>
                  <el-option value="remain" :label="$t('day.remaining_days')"></el-option>
                </el-select>
              </el-col>
              <el-col :sm="10" style="padding-right: 25px">
                <el-input size="mini" type="number" :label="$t('input.day_numbers')"
                          v-model="form_config_auto_cir.advanced_day_number"
                          :disabled="['mini_spike_day', 'flash_sale', 'remain'].includes(form_config_auto_cir.advanced_day)">
                </el-input>
              </el-col>
              <el-col :sm="2">
              </el-col>
            </el-row>
            <el-row style="margin-top: 5px">
              <el-col :sm="10" style="padding-right: 15px">
                <p class="text-title"> {{ $t('base.expected_cir') }}(%):</p>
                <el-input v-model="form_config_auto_cir.advanced_cir" size="mini" type="number"
                          :placeholder="$t('input.expected_cir')"></el-input>
              </el-col>
              <el-col :sm="10" style="padding-right: 25px">
                <p class="text-title">&nbsp</p>
                <el-select v-model="form_config_auto_cir.advanced_cir_type" size="mini" value="" class="full-w">
                  <el-option value="broad" :label="$t('ads.anti_click_label.broad_cir')"></el-option>
                  <el-option value="direct" :label="$t('ads.anti_click_label.direct_cir')"></el-option>
                </el-select>
              </el-col>
              <el-col :sm="2">
              </el-col>
            </el-row>
            <el-row style="margin-top: 20px">
              <el-col :sm="20" style="padding-right: 25px">
                <el-select v-model="form_config_auto_cir.advanced_cir_type2" size="mini" value="" class="full-w">
                  <el-option value="" :label="$t('ads.auto_cir_label.use_keyword_cir')"></el-option>
                  <el-option value="campaign" :label="$t('ads.auto_cir_label.use_campaign_cir')"></el-option>
                </el-select>
              </el-col>
              <el-col :sm="2">
              </el-col>
            </el-row>
            <el-row style="margin-top: 5px">
              <el-col :sm="10" style="padding-right: 15px">
                <p class="text-title">{{ $t('base.increase_type') }}</p>
                <el-select size="mini" class="full-w" v-model="form_config_auto_cir.advanced_price_type">
                  <el-option value="" :label="$t('base.increase_by_amount')"></el-option>
                  <el-option value="percent" :label="$t('base.increase_by_percent')"></el-option>
                </el-select>
              </el-col>
              <el-col :sm="10" style="padding-right: 25px">
                <p class="text-title">&nbsp;</p>
                <el-input v-model="form_config_auto_cir.advanced_price" size="mini" type="number"></el-input>
              </el-col>
              <el-col :sm="2">
              </el-col>
            </el-row>
            <el-row style="margin-top: 5px">
              <el-col :sm="20" style="padding-right: 25px">
                <p class="text-title"> {{ $t('base.advanced_max_bid_price') }} </p>
                <el-input size="mini" type="number" :placeholder="$t('input.max_bid_price')"
                          v-model="form_config_auto_cir.advanced_max_price"></el-input>
              </el-col>
            </el-row>
            <el-row style="margin-top: 5px">
              <el-col :sm="20" style="padding-right: 25px">
                <p class="text-title">{{ $t('ads.anti_click_label.max_cost_if_gmv_by_0') }} ({{
                    $t('base.not_required')
                  }})</p>
                <el-input size="mini" type="number" :placeholder="$t('input.max_cost')"
                          v-model="form_config_auto_cir.advanced_max_cost"></el-input>
              </el-col>
            </el-row>
            <el-row style="margin-top: 5px">
              <p class="text-title">{{ $t('ads.action_when_exceeding_cost') }} ({{ $t('base.not_required') }})</p>
              <template v-if="form_config_auto_cir.advanced_max_cost_type === 'stop'">
                <el-col :sm="20" style="padding-right: 25px">
                  <el-select size="mini" class="full-w" v-model="form_config_auto_cir.advanced_max_cost_type">
                    <el-option value="value" :label="$t('ads.edit_by_bid_price')"></el-option>
                    <el-option value="stop" :label="$t('base.pause_keyword')"></el-option>
                  </el-select>
                </el-col>
              </template>
              <template v-if="form_config_auto_cir.advanced_max_cost_type === 'value'">
                <el-col :sm="10" style="padding-right: 15px">
                  <el-select size="mini" class="full-w" v-model="form_config_auto_cir.advanced_max_cost_type">
                    <el-option value="stop" :label="$t('base.pause_keyword')"></el-option>
                    <el-option value="value" :label="$t('ads.edit_by_bid_price')"></el-option>
                  </el-select>
                </el-col>
                <el-col :sm="10" style="padding-right: 25px">
                  <el-input size="mini" type="number" :placeholder="$t('input.amount')"
                            v-model="form_config_auto_cir.advanced_max_cost_value"></el-input>
                </el-col>
              </template>
            </el-row>
            <el-row style="margin-top: 5px">
              <el-col :sm="20" style="padding-right: 25px">
                <p class="text-title">{{ $t('base.starting_bid_price') }} ({{ $t('base.not_required') }})</p>
                <el-input size="mini" type="number" :placeholder="$t('input.starting_bid_price')"
                          v-model="form_config_auto_cir.advanced_start_price"></el-input>
              </el-col>
            </el-row>
            <el-row style="margin-top: 20px">
              <el-col :sm="20" style="padding-right: 25px;" class="text-right">
                <el-button type="primary" icon="el-icon-plus" size="mini" @click="m__add_cir_advanced_day">
                  {{ $t('base.add_config') }}
                </el-button>
              </el-col>
            </el-row>
          </el-col>
          <el-col :sm="11" style="padding: 0 15px">
            <p class="text-title">{{ $t('base.configuration_runtime_list') }}</p>

            <ComponentCustomTimePicker style="margin-top: 30px"
                                       :value.sync="form_config_auto_cir.advanced_times"
                                       :prefix="'advanced_'"></ComponentCustomTimePicker>

            <div style="margin-top: 40px; font-size: 13px" class="text-danger">
            </div>

            <hr>

            <div style="margin-top: 20px; font-size: 13px; font-weight: 600" class="text-danger">
              - {{ $t('ads.auto_cir_label.advanced_note_1') }}
              <br>
              <br>
              - {{ $t('ads.auto_cir_label.advanced_note_2') }}
            </div>
          </el-col>
        </el-row>

        <el-row style="margin-top: 20px">
          <p class="text-title">{{ $t('ads.configuration_active_day_list') }}</p>
          <el-table :data="form_config_auto_cir.advanced_days" default-expand-all>
            <el-table-column type="expand" width="40px">
              <template slot-scope="scope">
                <div v-if="scope.row.times" style="padding-left: 50px">
                  <div style="margin: 10px 0; color: #000">
                    {{ $t('base.configuration_runtime_list') }}
                  </div>
                  <div v-for="i in scope.row.times" :key="i" style="margin-bottom: 5px; color: #000">
                    {{ i }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('ads.configuration_active_day')" width="200px">
              <template slot-scope="scope">
                <strong>{{ spike_day_map(scope.row) }}</strong>
                <br>
                <strong class="text-danger">
                  {{ m__row_type_to_text(scope.row) }}
                </strong>
              </template>
            </el-table-column>
            <el-table-column :label="$t('base.expected_cir')" width="150px">
              <template slot-scope="scope">{{ scope.row.cir }} %</template>
            </el-table-column>
            <el-table-column :label="$t('base.starting_bid_price')" width="150px">
              <template slot-scope="scope">{{ scope.row.start_price | format_currency }}</template>
            </el-table-column>
            <el-table-column :label="$t('base.bonus_amount')" width="150px">
              <template slot-scope="scope">
                {{ scope.row.price_type === 'percent' ? `${scope.row.price}%` : scope.row.price }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('base.max_bid_price')" width="130px">
              <template slot-scope="scope">
                <el-input size="mini" v-model="scope.row.max_price"></el-input>
              </template>
            </el-table-column>
            <el-table-column :label="$t('base.max_cost')" width="130px">
              <template slot-scope="scope">{{ scope.row.max_cost | format_currency }}</template>
            </el-table-column>
            <el-table-column :label="$t('ads.action_when_running_out_of_cost')" width="180px">
              <template slot-scope="scope">
                {{
                  scope.row.max_cost_type === 'stop' ? $t('keyword.pause') : $t('base.bid_price') + ': ' +
                    scope.row.max_cost_value
                }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('base.action')" width="120px" fixed="right">
              <template slot-scope="scope">
                <el-button size="mini" type="text" @click="m__remove_cir_advanced_day(scope.$index)">
                  <strong class="text-danger">{{ $t('base.delete') }}</strong>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-row>

        <el-row class="text-right" style="margin-top: 10px">
          <el-button size="mini" type="primary" icon="el-icon-check"
                     @click="m__confirm_cir_advanced">{{ $t('base.confirm') }}
          </el-button>
        </el-row>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.select_hour" :close-on-click-modal="false" width="500px">
      <div slot="title" style="padding:10px">
        <strong class="strong-title">{{ $t('select.report_duration') }}</strong>

        <div style="margin-top: 30px">
          <el-select v-model="selected_hour" size="mini" class="full-w" value="">
            <el-option v-for="item in hour_list" :key="item.value" :value="item.value" :label="item.label"></el-option>
          </el-select>
        </div>

        <div style="margin-top: 30px;" class="text-right">
          <el-button size="mini" type="danger" icon="el-icon-close"
                     @click="() => {show_dialog.select_hour = false; $emit('update:hour_mode', false); m__get_ads_data()}">
            {{ $t('ads.viewing_data_by_hour') }}
          </el-button>
          <el-button size="mini" type="primary" icon="el-icon-check" :loading="loading.select_hour"
                     @click="m__select_data_by_hour">
            {{ loading.select_hour ? $t('base.loading_data') : $t('base.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog id="search-auto-optimize" :visible.sync="show_dialog.config_auto_optimize"
               :close-on-click-modal="false" width="1050px">
      <div slot="title" style="padding:10px">
        <el-row>
          <el-col :sm="24">
            <strong class="strong-title">
              {{ $t('ads.optimize_based_on_cir_advanced_configuration') }}
              ({{ $t('base.keyword') }})
            </strong>
          </el-col>
        </el-row>

        <el-row style="margin-top: 15px">
          <el-col :sm="13" style="padding-right: 60px">
            <div>
              <div>
                <p class="text-title"> {{ $t('ads.configuration_active_day') }} </p>
                <el-row style="margin-top: 10px">
                  <el-col :sm="12" style="padding-right: 15px">
                    <el-select class="full-w" size="mini" value filterable
                               v-model="form_config_auto_optimize.advanced_day">
                      <el-option value="flash_sale" :label="$t('day.flash_sale')"></el-option>
                      <el-option value="before_flash_sale" :label="$t('day.before_flash_sale')"></el-option>
                      <el-option value="after_flash_sale" :label="$t('day.after_flash_sale')"></el-option>
                      <el-option value="mini_spike_day" :label="$t('day.mini_spike_day')"></el-option>
                      <el-option value="day" :label="$t('day.specific_day')"></el-option>
                      <el-option value="remain" :label="$t('day.remaining_days')"></el-option>
                    </el-select>
                  </el-col>
                  <el-col :sm="12" style="padding-right: 25px">
                    <el-input size="mini" type="number" :label="$t('input.day_numbers')"
                              v-model="form_config_auto_optimize.advanced_day_number"
                              :disabled="['mini_spike_day', 'flash_sale', 'remain'].includes(form_config_auto_optimize.advanced_day)">
                    </el-input>
                  </el-col>
                  <el-col :sm="2">
                  </el-col>
                </el-row>

                <el-row style="margin-top: 5px">
                  <el-col :sm="12" style="padding-right: 15px">
                    <p class="text-title"> {{ $t('base.expected_cir') }}(%):</p>
                    <el-input v-model="form_config_auto_optimize.cir" size="mini" type="number"
                              :placeholder="$t('input.expected_cir')"></el-input>
                  </el-col>
                  <el-col :sm="12" style="padding-right: 25px">
                    <p class="text-title">&nbsp</p>
                    <el-select v-model="form_config_auto_optimize.cir_type" size="mini" value=""
                               class="full-w">
                      <el-option value="broad" :label="$t('ads.anti_click_label.broad_cir')"></el-option>
                      <el-option value="direct" :label="$t('ads.anti_click_label.direct_cir')"></el-option>
                    </el-select>
                  </el-col>
                  <el-col :sm="2">
                  </el-col>
                </el-row>

                <br>
                <br>

                <strong class="strong-label">{{ $t('base.applied_keyword_type') }}:</strong>
                <el-checkbox v-model="form_config_auto_optimize.include_exact">
                  {{ $t('keyword.exact') }}
                </el-checkbox>
                &nbsp;&nbsp;&nbsp;
                <el-checkbox v-model="form_config_auto_optimize.include_broad">
                  {{ $t('keyword.broad') }}
                </el-checkbox>

                <br>
                <br>

                <strong class="strong-label"> {{ $t('base.conditions_for_applying') }}:</strong>
                <el-select size="mini" value="" class="full-w" multiple
                           v-model="form_config_auto_optimize.target_keywords">
                  <el-option value="lte" :label="$t('ads.auto_cir_label.advanced_type_lte')"></el-option>
                  <el-option value="gt" :label="$t('ads.auto_cir_label.advanced_type_gt')"></el-option>
                  <el-option value="not" :label="$t('ads.auto_cir_label.advanced_type_not')"></el-option>
                </el-select>

                <br>
                <br>

                <strong class="strong-label"> {{ $t('base.i_or_d_type') }}</strong>
                <el-select size="mini" value="" class="full-w"
                           v-model="form_config_auto_optimize.condition">
                  <el-option value="auto" :label="$t('base.automatic_i_or_d')"></el-option>
                  <el-option value="value" :label="$t('base.i_or_d_by_amount')"></el-option>
                </el-select>
                <div v-if="form_config_auto_optimize.condition === 'value'" style="margin-top: 10px">
                  <el-row>
                    <el-col :sm="12" style="padding-right: 10px">
                      <el-select size="mini" value="" class="full-w"
                                 v-model="form_config_auto_optimize.condition_type">
                        <el-option value="value" :label="$t('base.i_or_d_by_amount')"></el-option>
                        <el-option value="percent" :label="$t('base.i_or_d_by_percent')"></el-option>
                      </el-select>
                    </el-col>
                    <el-col :sm="12" style="padding-left: 10px">
                      <el-input v-model="form_config_auto_optimize.condition_value" size="mini"
                                type="number" :placeholder="$t('input.value')"></el-input>
                    </el-col>
                  </el-row>
                </div>

                <br>
                <br>

                <div style="display: flex">
                  <div v-if="form_config_auto_optimize.include_exact" style="padding-right: 10px; flex: 1">
                    <strong class="strong-label"> {{ $t('base.max_bid_price') }} ({{ $t('keyword.exact') }}):</strong>
                    <el-input v-model="form_config_auto_optimize.max_price_0" size="mini" type="number"
                              :placeholder="$t('input.max_bid_price')"></el-input>
                  </div>
                  <div v-if="form_config_auto_optimize.include_broad" style="padding-left: 10px; flex: 1">
                    <strong class="strong-label"> {{ $t('base.max_bid_price') }} ({{ $t('keyword.broad') }}):</strong>
                    <el-input v-model="form_config_auto_optimize.max_price_1" size="mini" type="number"
                              :placeholder="$t('input.max_bid_price')"></el-input>
                  </div>
                </div>

                <br>
                <br>

                <strong class="strong-label">{{ $t('ads.action_when_running_out_of_cir') }}:</strong>
                <el-select size="mini" value="" class="full-w"
                           v-model="form_config_auto_optimize.condition2">
                  <el-option value="auto" :label="$t('base.automatic_i_or_d')"></el-option>
                  <el-option value="value" :label="$t('base.i_or_d_by_amount')"></el-option>
                </el-select>
                <div v-if="form_config_auto_optimize.condition2 === 'value'" style="margin-top: 10px">
                  <el-input v-model="form_config_auto_optimize.condition2_value" size="mini"
                            type="number" :placeholder="$t('input.amount')"></el-input>
                </div>

                <br>
                <br>

                <strong class="strong-label">{{ $t('base.min_bid_price') }}:</strong>
                <el-input v-model="form_config_auto_optimize.min_price" size="mini" type="number"
                          :placeholder="$t('input.min_bid_price')"></el-input>

                <br>
                <br>

                <strong class="strong-label">{{ $t('ads.anti_click_label.max_cost_if_gmv_by_0') }}:</strong>
                <el-input v-model="form_config_auto_optimize.max_cost" size="mini" type="number"
                          :placeholder="$t('input.max_cost')"></el-input>

                <br>
                <br>

                <strong class="strong-label">{{ $t('base.starting_bid_price') }} ({{
                    $t('base.not_required')
                  }}):</strong>
                <el-input v-model="form_config_auto_optimize.start_price" size="mini" type="number"
                          :placeholder="$t('input.starting_bid_price')"></el-input>

                <br>
                <br>

                <div class="text-right">
                  <el-button type="primary" icon="el-icon-plus" size="mini" @click="m__add_optimize_advanced_day">
                    {{ $t('base.add_config') }}
                  </el-button>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :sm="11" style="padding: 0 15px">
            <p class="text-title">{{ $t('base.configuration_runtime_list') }}</p>

            <ComponentCustomTimePicker style="margin-top: 30px"
                                       :value.sync="form_config_auto_optimize.advanced_times"
                                       :prefix="'advanced_'"></ComponentCustomTimePicker>

            <br>
            <br>

            <div style="padding-right: 30px">
              <p class="text-title" style=""> {{ $t('base.set_when_outside_runtime') }}</p>
              <el-select size="mini" value="" class="full-w" v-model="form_config_auto_optimize.stop_action">
                <el-option :value="1" :label="$t('base.update_to_starting_bid_price')"></el-option>
                <el-option :value="3" :label="$t('ads.general_label.edit_amount')"></el-option>
              </el-select>

              <template v-if="form_config_auto_optimize.stop_action === 3">
                <p class="text-title" style="">{{ $t('base.set_bid_price') }}</p>
                <el-input type="number" size="mini" v-model="form_config_auto_optimize.stop_action_value"
                          :placeholder="$t('input.bid_price')"></el-input>
              </template>
            </div>
          </el-col>
        </el-row>

        <el-row style="margin-top: 20px">
          <p class="text-title">{{ $t('ads.configuration_active_day_list') }}</p>
          <el-table :data="form_config_auto_optimize.advanced_days" default-expand-all>
            <el-table-column type="expand" width="40px">
              <template slot-scope="scope">
                <div v-if="scope.row.times" style="padding-left: 50px">
                  <div style="margin: 10px 0; color: #000">
                    {{ $t('base.configuration_runtime_list') }}
                  </div>
                  <div v-for="i in scope.row.times" :key="i" style="margin-bottom: 5px; color: #000">
                    {{ i }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('ads.configuration_active_day')" width="200px">
              <template slot-scope="scope">
                <strong>{{ spike_day_map(scope.row) }}</strong>
                <br>
                <strong class="text-danger">
                  {{ m__row_type_to_text(scope.row) }}
                </strong>
              </template>
            </el-table-column>
            <el-table-column :label="$t('base.expected_cir')" width="150px">
              <template slot-scope="scope">{{ scope.row.cir }} %</template>
            </el-table-column>
            <el-table-column :label="$t('keyword.type')" width="150px" show-tooltip-when-overflow>
              <template slot-scope="scope">
                <template v-if="scope.row.include_exact && scope.row.include_broad">
                  {{ $t('keyword.all') }}
                </template>
                <template v-else-if="scope.row.include_exact">
                  {{ $t('keyword.exact') }}
                </template>
                <template v-else-if="scope.row.include_broad">
                  {{ $t('keyword.broad') }}
                </template>
              </template>
            </el-table-column>
            <el-table-column :label="$t('base.conditions_for_applying')" width="150px" show-tooltip-when-overflow>
              <template slot-scope="scope">
                <div v-if="scope.row.target_keywords && scope.row.target_keywords.length">
                  <div v-if="scope.row.target_keywords.includes('lte')">
                    {{ $t('ads.auto_cir_label.advanced_type_lte') }}
                  </div>
                  <div v-if="scope.row.target_keywords.includes('gt')">
                    {{ $t('ads.auto_cir_label.advanced_type_gt') }}
                  </div>
                  <div v-if="scope.row.target_keywords.includes('not')">
                    {{ $t('ads.auto_cir_label.advanced_type_not') }}
                  </div>
                </div>
                <div v-else>
                  <template v-if="scope.row.target_keyword === 'lte'">
                    {{ $t('ads.auto_cir_label.advanced_type_lte') }}
                  </template>
                  <template v-if="scope.row.target_keyword === 'gt'">
                    {{ $t('ads.auto_cir_label.advanced_type_gt') }}
                  </template>
                  <template v-if="scope.row.target_keyword === 'not'">
                    {{ $t('ads.auto_cir_label.advanced_type_not') }}
                  </template>
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('base.i_or_d_type')" width="150px">
              <template slot-scope="scope">
                <template v-if="scope.row.condition === 'auto'">
                  {{ $t('base.automatic') }}
                </template>
                <template v-if="scope.row.condition === 'value'">
                  {{ $t('base.by_amount') }}
                </template>
              </template>
            </el-table-column>
            <el-table-column :label="$t('base.value')" width="150px">
              <template slot-scope="scope">
                <template v-if="scope.row.condition === 'auto'">
                  {{ $t('base.automatic') }}
                </template>
                <template v-if="scope.row.condition === 'value'">
                  <template v-if="scope.row.condition_type === 'value'">
                    {{ scope.row.condition_value }}
                  </template>
                  <template v-if="scope.row.condition_type === 'percent'">
                    {{ scope.row.condition_value }}%
                  </template>
                </template>
              </template>
            </el-table-column>
            <el-table-column :label="$t('ads.auto_cir_label.max_bid_price_for_exact')" width="150px">
              <template slot-scope="scope">
                <el-input size="mini" v-model="scope.row.max_price_0"></el-input>
              </template>
            </el-table-column>
            <el-table-column :label="$t('ads.auto_cir_label.max_bid_price_for_broad')" width="150px">
              <template slot-scope="scope">
                <el-input size="mini" v-model="scope.row.max_price_1"></el-input>
              </template>
            </el-table-column>
            <el-table-column :label="$t('base.min_bid_price')" width="150px">
              <template slot-scope="scope">
                <el-input size="mini" v-model="scope.row.min_price"></el-input>
              </template>
            </el-table-column>
            <el-table-column :label="$t('ads.anti_click_label.max_cost_if_gmv_by_0')" width="150px">
              <template slot-scope="scope">
                <el-input size="mini" v-model="scope.row.max_cost"></el-input>
              </template>
            </el-table-column>
            <el-table-column :label="$t('base.starting_bid_price')" width="150px">
              <template slot-scope="scope">{{ scope.row.start_price }}</template>
            </el-table-column>
            <el-table-column :label="$t('ads.auto_cir_label.bid_price_when_outside_runtime')" width="150px">
              <template slot-scope="scope">
                {{
                  scope.row.stop_action === 3 ? scope.row.stop_action_value : $t('base.starting_bid_price')
                }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('base.action')" width="120px" fixed="right">
              <template slot-scope="scope">
                <el-button size="mini" type="text" @click="m__edit_optimize_advanced_day(scope.$index)">
                  <strong class="text-warning">{{ $t('base.edit') }}</strong>
                </el-button>
                <br>
                <el-button size="mini" type="text" @click="m__remove_optimize_advanced_day(scope.$index)">
                  <strong class="text-danger">{{ $t('base.delete') }}</strong>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-row>

        <el-row class="text-right" style="margin-top: 10px">
          <el-button size="mini" type="danger"
                     v-if="selected_campaign && selected_campaign.auto_optimize"
                     @click="m__delete_config_auto_optimize('search')" icon="el-icon-delete">
            {{ $t('base.delete_config') }}
          </el-button>
          <el-button type="primary" size="mini" icon="el-icon-check" @click="m__update_config_auto_optimize"
                     :loading="loading.config_auto_optimize">
            {{ $t('base.confirm') }}
          </el-button>
        </el-row>
      </div>
    </el-dialog>

    <el-dialog id="update_keyword_by_condition" :visible.sync="show_dialog.update_keyword_by_condition"
               :close-on-click-modal="false" width="1000px">
      <div slot="title" style="padding:10px">
        <el-tabs v-model="condition_action_tab">
          <el-tab-pane :label="$t('base.update_keywords_by_conditions')" name="main">
            <div style="margin-top: 30px">
              <div v-for="(item, index) in condition_action_list" :key="`item-${index}`">
                <div
                  style="background-color: #f7f7f7; padding: 10px; padding-top: 15px; padding-bottom: 6px; margin-bottom: 30px; position: relative">
                  <div style="display: flex; gap: 20px">
                    <div style="width: 100px">
                      <strong class="strong-label">&nbsp;</strong>
                      <div
                        style="display: flex; height: 29px; background-color: #faedbb; align-items: center; justify-content: center; font-size: 13px; font-weight: bold; border-top-right-radius: 10px; border-bottom-right-radius: 10px">
                        {{ $t('base.conditions') }}
                      </div>
                    </div>
                    <div>
                      <div style="display: flex; gap: 10px">
                        <div style="flex: 1">
                          <strong class="strong-label">{{ $t('base.column') }}</strong>
                        </div>
                        <div style="flex: 1">
                          <strong class="strong-label">{{ $t('base.expression') }}</strong>
                        </div>
                        <div style="flex: 1">
                          <strong class="strong-label">{{ $t('base.value') }}</strong>
                        </div>
                        <div style="flex: 1">
                          <strong class="strong-label">{{ $t('keyword.type') }}</strong>
                        </div>
                        <div style="width: 45px">
                          <strong class="strong-label">&nbsp;</strong>
                        </div>
                        <div style="width: 45px">
                          <strong class="strong-label">&nbsp;</strong>
                        </div>
                      </div>
                      <div v-for="(condition, index) of item.condition_list" :key="`item-${index}`"
                           style="display: flex; gap: 10px; margin-bottom: 10px">
                        <div style="flex: 1">
                          <el-select size="mini" class="full-w" value="" v-model="condition.label" filterable>
                            <el-option value="price" :label="$t('base.bid_price')"></el-option>
                            <el-option v-for="i in filter" :key="i.camel_key" :value="i.camel_key" :label="i.label">
                            </el-option>
                            <el-option value="include_keywords" :label="$t('base.include_keywords')"></el-option>
                          </el-select>
                        </div>
                        <div style="flex: 1">
                          <el-select :style="{opacity: array_to_set(['include_keywords']).has(condition.label) ? 0 : 1}"
                                     size="mini" class="full-w" value="" v-model="condition.expression" filterable>
                            <el-option label=">" value=">"></el-option>
                            <el-option label="<" value="<"></el-option>
                            <el-option label="=" value="==="></el-option>
                            <el-option label="≠" value="!=">
                              <span style="font-size: 16px !important;">≠</span>
                            </el-option>
                            <el-option label=">=" value=">="></el-option>
                            <el-option label="<=" value="<="></el-option>
                          </el-select>
                        </div>
                        <div style="flex: 1">
                          <el-input v-if="!array_to_set(['include_keywords']).has(condition.label)"
                                    type="number" size="mini" v-model="condition.value"></el-input>
                          <el-input v-else
                                    type="textarea" :rows="1" size="mini" v-model="condition.value_s"></el-input>
                        </div>
                        <div style="flex: 1">
                          <el-select size="mini" class="full-w" value="" v-model="condition.match_type">
                            <el-option value="all" :label="$t('base.all')"></el-option>
                            <el-option value="match_type_0" :label="$t('base.exact')"></el-option>
                            <el-option value="match_type_1" :label="$t('base.broad')"></el-option>
                          </el-select>
                        </div>
                        <div style="width: 45px">
                          <el-button type="soft-grey" size="mini" icon="el-icon-copy-document"
                                     @click="m__copy_condition(item.condition_list, index, condition)">
                          </el-button>
                        </div>
                        <div style="width: 45px">
                          <el-button type="danger" size="mini" icon="el-icon-delete"
                                     :disabled="item.condition_list.length <= 1"
                                     @click="m__remove_condition(item.condition_list, index)">
                          </el-button>
                        </div>
                      </div>
                      <div>
                        <el-button type="text" size="mini" @click="m__add_condition(item.condition_list)">
                          <span class="text-primary"><i class="el-icon-plus"></i> {{ $t('base.add_condition') }}</span>
                        </el-button>
                      </div>
                    </div>
                  </div>
                  <div style="display: flex; gap: 20px; margin-top: 20px">
                    <div style="width: 100px">
                      <div
                        style="display: flex; height: 29px; background-color: #e1e5fa; align-items: center; justify-content: center; font-size: 13px; font-weight: bold; border-top-right-radius: 10px; border-bottom-right-radius: 10px">
                        {{ $t('base.actions') }}
                      </div>
                    </div>
                    <div style="flex: 1; display: flex; justify-content: space-between; align-items: center;">
                      <div style="flex: 1; display: flex; gap: 10px">
                        <el-select style="flex: 1; max-width: 180px" size="mini" value="" v-model="item.action">
                          <el-option value="value"
                                     :label="$t('base.set_bid_price')"></el-option>
                          <el-option value="increase"
                                     :label="$t('base.increase_bid_price')"></el-option>
                          <el-option value="reduce"
                                     :label="$t('base.decrease_bid_price')"></el-option>
                          <el-option value="cpc"
                                     :label="$t('base.set_by_cpc')"></el-option>
                          <el-option value="match_type_0"
                                     :label="$t('base.change_to_exact')"></el-option>
                          <el-option value="match_type_1"
                                     :label="$t('base.change_to_broad')"></el-option>
                          <el-option value="ongoing"
                                     :label="$t('base.resume_keyword')"></el-option>
                          <el-option value="pause"
                                     :label="$t('base.pause_keyword')"></el-option>
                          <el-option value="ongoing_both"
                                     :label="$t('base.resume_keyword_and_auto_configuration')"></el-option>
                          <el-option value="pause_both"
                                     :label="$t('base.pause_keyword_and_auto_configuration')"></el-option>
                          <el-option value="add_tags"
                                     :label="$t('base.add_tags')"></el-option>
                        </el-select>

                        <div v-if="['value'].includes(item.action)"
                             style="flex: 1; max-width: 180px; display: flex; flex-direction: column; gap: 10px">
                          <el-input size="mini" type="number" v-model="item.value"></el-input>
                        </div>

                        <div v-if="['increase', 'reduce'].includes(item.action)"
                             style="flex: 1; max-width: 180px; display: flex; flex-direction: column; gap: 10px">
                          <el-select
                            size="mini"
                            value=""
                            class="full-w"
                            v-model="item.update_price_type">
                            <el-option value="value" :label="$t('base.by_amount')"></el-option>
                            <el-option value="percent" :label="$t('base.by_percent')"></el-option>
                          </el-select>

                          <div v-if="item.action === 'increase'"
                               style="height: 100%; display: flex; align-items: center; font-size: 13px">
                            {{ $t('base.max_bid_price') }}
                          </div>
                          <div v-if="item.action === 'reduce'"
                               style="height: 100%; display: flex; align-items: center; font-size: 13px">
                            {{ $t('base.min_bid_price') }}
                          </div>
                        </div>

                        <div v-if="['increase', 'reduce'].includes(item.action)"
                             style="flex: 1; max-width: 180px; display: flex; flex-direction: column; gap: 10px">
                          <el-input size="mini" type="number" v-model="item.update_price_value"></el-input>

                          <el-input v-if="item.action === 'increase'" size="mini" type="number"
                                    v-model="item.max_bid_price"></el-input>
                          <el-input v-if="item.action === 'reduce'" size="mini" type="number"
                                    v-model="item.min_bid_price"></el-input>
                        </div>

                        <el-date-picker
                          v-if="item.action === 'cpc'"
                          style="flex: 1; max-width: 360px" v-model="item.cpc_range" type="daterange"
                          range-separator="-"
                          :start-placeholder="$t('base.start_time')" :end-placeholder="$t('base.end_time')" size="mini"
                          format="dd-MM-yyyy"
                          :clearable="false" :picker-options="picker_options">
                        </el-date-picker>

                        <el-select v-if="item.action === 'add_tags'" size="mini" v-model="item.tag_id"
                                   :placeholder="$t('select.tags')">
                          <el-option v-for="tag in keyword_tag_list" :key="tag._id"
                                     :value="tag._id" :label="tag.name"></el-option>
                        </el-select>
                        <el-select v-if="item.action === 'remove_tags'" size="mini" v-model="item.tag_id"
                                   :placeholder="$t('select.tags')">
                          <el-option v-for="tag in keyword_tag_list" :key="tag._id"
                                     :value="tag._id" :label="tag.name"></el-option>
                        </el-select>
                      </div>
                      <div style="width: 60px; text-align: right">
                        <el-button type="soft-grey" size="mini" icon="el-icon-copy-document"
                                   @click="m__copy_condition_action_item(item, index)">
                        </el-button>
                      </div>
                    </div>
                  </div>
                  <div style="margin-top: 20px">
                    <strong v-if="item.error_msg" class="text-danger" style="font-size: 13px">
                      {{ $t('base.error') }}: {{ item.error_msg }}
                    </strong>
                  </div>
                  <span
                    v-if="condition_action_list.length > 1"
                    style="position: absolute; top: 7px; right: 7px; cursor: pointer"
                    @click="m__remove_condition_action(index)">
                    <i class="el-icon-close" style="font-size: 16px"></i>
                  </span>
                </div>
              </div>
              <div>
                <el-button type="text" size="mini" @click="m__add_condition_action(false)">
                  <span class="text-primary" style="font-size: 14px">
                    <i class="el-icon-plus"></i> {{ $t('base.add_conditions_actions') }}</span>
                </el-button>
              </div>
            </div>

            <div style="margin-top: 30px" class="text-right">
              <el-button size="mini" @click="m__show__action_select_file_dialog">
                {{ $t('base.use_file') }}
              </el-button>
              <el-button size="mini" icon="el-icon-document-checked" @click="m__show_condition_action_save_file_dialog">
                {{ $t('base.save_file') }}
              </el-button>
              <el-button type="primary" size="mini" icon="el-icon-check" @click="m__confirm_condition_action"
                         :loading="loading.update_keyword_by_condition">
                {{ $t('base.confirm') }}
              </el-button>
            </div>
          </el-tab-pane>
          <el-tab-pane :label="$t('base.saved_files')" name="file">
            <div class="text-right">
              <el-input size="mini" style="width: 250px" prefix-icon="el-icon-search"
                        :placeholder="$t('input.placeholder')" v-model="condition_action_file_filter">
              </el-input>
            </div>

            <el-table :data="c__condition_action_file_filter_list" style="margin-top: 20px">
              <el-table-column :label="$t('base.filename')" prop="filename"></el-table-column>
              <el-table-column :label="$t('base.created_at')" prop="created_at">
                <template slot-scope="scope">
                  {{ scope.row.created_at | moment('DD/MM/YYYY') }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('base.optional')" prop="created_at" width="200px">
                <template slot-scope="scope">
                  <el-button type="text" size="mini" @click="m__confirm_action_select_file(scope.row)">
                    <strong class="text-info">{{ $t('base.use') }}</strong>
                  </el-button>
                  <el-button type="text" size="mini" @click="m__delete_condition_action_file(scope.row)">
                    <strong class="text-danger">{{ $t('base.delete') }}</strong>
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.action_condition_save_file" :close-on-click-modal="false"
               custom-class="no-body"
               width="400px">
      <div slot="title" style="padding:10px">
        <div>
          <el-radio v-model="condition_action_radio" label="1">
            <strong>{{ $t('base.create_new_file') }}</strong>
          </el-radio>
          <el-input size="mini" :placeholder="$t('input.filename')" :disabled="condition_action_radio !== '1'"
                    v-model="condition_action_filename"></el-input>
        </div>
        <div style="margin-top: 30px">
          <el-radio v-model="condition_action_radio" label="2">
            <strong>{{ $t('base.update_existed_file') }}</strong>
          </el-radio>
          <el-select size="mini" class="full-w" value="" :disabled="condition_action_radio !== '2'"
                     v-model="condition_action_file_selected">
            <el-option v-for="file in condition_action_file_list" :key="file._id" :value="file._id"
                       :label="file.filename"></el-option>
          </el-select>
        </div>

        <div style="padding-top: 30px;" class="text-right">
          <el-button type="primary" size="mini" icon="el-icon-check" :loading="loading.action_condition_save_file"
                     @click="m__confirm_action_save_file">{{ $t('base.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.action_condition_select_file" :close-on-click-modal="false"
               custom-class="no-body"
               width="400px">
      <div slot="title" style="padding:10px">
        <div>
          <strong class="strong-label">{{ $t('select.file') }}</strong>
          <el-select size="mini" class="full-w" value="" v-model="condition_action_file_selected">
            <el-option v-for="file in condition_action_file_list" :key="file._id" :value="file._id"
                       :label="file.filename"></el-option>
          </el-select>
        </div>

        <div style="padding-top: 30px;" class="text-right">
          <el-button type="primary" size="mini" icon="el-icon-check" :loading="loading.action_condition_save_file"
                     @click="m__confirm_action_select_file(null)">{{ $t('base.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.update_campaign_state" :close-on-click-modal="false"
               custom-class="no-body"
               width="400px">
      <div slot="title" style="padding:10px">
        <strong class="strong-title">{{ $t('base.update_campaign_status') }}</strong>

        <div style="display: flex; flex-direction: column; gap: 15px">
          <div>
            <el-radio v-model="campaign_state_radio" label="ongoing">{{ $t('base.resume') }}</el-radio>
          </div>
          <div>
            <el-radio v-model="campaign_state_radio" label="pause">{{ $t('base.paused') }}</el-radio>
          </div>
          <div>
            <el-radio v-model="campaign_state_radio" label="stop">{{ $t('base.stop') }}</el-radio>
          </div>
          <div>
            <el-radio v-model="campaign_state_radio" label="restart">{{ $t('base.restart') }}</el-radio>
            <div v-if="campaign_state_radio === 'restart'">
              <strong class="text-danger">{{ $t('base.update_campaign_status_message') }}</strong>
            </div>
          </div>
        </div>
        <div style="margin-top: 30px" class="text-right">
          <el-button type="primary" size="mini" icon="el-icon-check" :loading="loading.update_campaign_state"
                     @click="m__confirm_update_campaign_state">
            {{ $t('base.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog id="targeting-auto-optimize" :visible.sync="show_dialog.config_auto_optimize_targeting"
               :close-on-click-modal="false" width="1000px">
      <div slot="title" style="padding: 10px">
        <strong class="strong-title"> {{ $t('ads.optimize_based_on_cir_advanced_configuration') }}
          ({{ $t('ads.targeting') }})</strong>

        <el-row style="margin-top: 10px">
          <el-col :sm="13">
            <p class="text-title"> {{ $t('ads.configuration_active_day') }} </p>
            <el-row style="margin-top: 10px">
              <el-col :sm="10" style="padding-right: 15px">
                <el-select class="full-w" size="mini" value="" filterable
                           v-model="form_config_auto_optimize_targeting.advanced_day">
                  <el-option value="flash_sale" :label="$t('day.flash_sale')"></el-option>
                  <el-option value="before_flash_sale" :label="$t('day.before_flash_sale')"></el-option>
                  <el-option value="after_flash_sale" :label="$t('day.after_flash_sale')"></el-option>
                  <el-option value="mini_spike_day" :label="$t('day.mini_spike_day')"></el-option>
                  <el-option value="day" :label="$t('day.specific_day')"></el-option>
                  <el-option value="remain" :label="$t('day.remaining_days')"></el-option>
                </el-select>
              </el-col>
              <el-col :sm="10" style="padding-right: 25px">
                <el-input size="mini" type="number" :label="$t('input.day_numbers')"
                          v-model="form_config_auto_optimize_targeting.advanced_day_number"
                          :disabled="['mini_spike_day', 'flash_sale', 'remain'].includes(form_config_auto_optimize_targeting.advanced_day)">
                </el-input>
              </el-col>
              <el-col :sm="2">
              </el-col>
            </el-row>
            <el-row style="margin-top: 5px">
              <el-col :sm="10" style="padding-right: 15px">
                <p class="text-title"> {{ $t('base.expected_cir') }}(%):</p>
                <el-input v-model="form_config_auto_optimize_targeting.advanced_cir" size="mini" type="number"
                          :placeholder="$t('input.expected_cir')"></el-input>
              </el-col>
              <el-col :sm="10" style="padding-right: 25px">
                <p class="text-title">&nbsp</p>
                <el-select v-model="form_config_auto_optimize_targeting.advanced_cir_type" size="mini" value=""
                           class="full-w">
                  <el-option value="broad" :label="$t('ads.anti_click_label.broad_cir')"></el-option>
                  <el-option value="direct" :label="$t('ads.anti_click_label.direct_cir')"></el-option>
                </el-select>
              </el-col>
              <el-col :sm="2">
              </el-col>
            </el-row>
            <el-row style="margin-top: 5px">
              <el-col :sm="10" style="padding-right: 15px">
                <p class="text-title">{{ $t('base.max_bid_price') }}</p>
                <el-input size="mini" type="number" :placeholder="$t('input.max_bid_price')"
                          v-model="form_config_auto_optimize_targeting.advanced_max_price"></el-input>
              </el-col>
              <el-col :sm="10" style="padding-right: 25px">
                <p class="text-title">{{ $t('base.min_bid_price') }}</p>
                <el-input size="mini" type="number" :placeholder="$t('input.min_bid_price')"
                          v-model="form_config_auto_optimize_targeting.advanced_min_price"></el-input>
              </el-col>
              <el-col :sm="2">
              </el-col>
            </el-row>
            <el-row style="margin-top: 5px">
              <el-col :sm="20" style="padding-right: 25px">
                <p class="text-title">{{ $t('ads.auto_cir_label.max_cost_if_gmv_by_0') }}</p>
                <el-input size="mini" type="number" :placeholder="$t('input.max_cost')"
                          v-model="form_config_auto_optimize_targeting.advanced_max_cost"></el-input>
              </el-col>
              <el-col :sm="2">
              </el-col>
            </el-row>
            <el-row style="margin-top: 5px">
              <p class="text-title">{{ $t('ads.action_when_exceeding_cost') }} ({{ $t('base.not_required') }})</p>
              <template v-if="form_config_auto_optimize_targeting.advanced_max_cost_type === 'stop'">
                <el-col :sm="20" style="padding-right: 25px">
                  <el-select size="mini" class="full-w"
                             v-model="form_config_auto_optimize_targeting.advanced_max_cost_type">
                    <el-option value="value" :label="$t('base.set_bid_price')"></el-option>
                  </el-select>
                </el-col>
              </template>
              <template v-if="form_config_auto_optimize_targeting.advanced_max_cost_type === 'value'">
                <el-col :sm="10" style="padding-right: 15px">
                  <el-select size="mini" class="full-w"
                             v-model="form_config_auto_optimize_targeting.advanced_max_cost_type">
                    <el-option value="value" :label="$t('base.set_bid_price')"></el-option>
                  </el-select>
                </el-col>
                <el-col :sm="10" style="padding-right: 25px">
                  <el-input size="mini" type="number" :placeholder="$t('input.bid_price')"
                            v-model="form_config_auto_optimize_targeting.advanced_max_cost_value"></el-input>
                </el-col>
              </template>
            </el-row>
            <el-row style="margin-top: 5px">
              <el-col :sm="20" style="padding-right: 25px">
                <p class="text-title">{{ $t('base.starting_bid_price') }} ({{ $t('base.not_required') }})</p>
                <el-input size="mini" type="number" :placeholder="$t('input.starting_bid_price')"
                          v-model="form_config_auto_optimize_targeting.advanced_start_price"></el-input>
              </el-col>
              <el-col :sm="2">
              </el-col>
            </el-row>
            <el-row style="margin-top: 20px">
              <el-col :sm="20" style="padding-right: 25px;" class="text-right">
                <el-button type="primary" icon="el-icon-plus" size="mini"
                           @click="m__add_optimize_advanced_day_targeting">
                  {{ $t('base.add_config') }}
                </el-button>
              </el-col>
            </el-row>
          </el-col>
          <el-col :sm="11" style="padding: 0 15px">
            <p class="text-title">{{ $t('base.configuration_runtime_list') }}</p>

            <ComponentCustomTimePicker style="margin-top: 30px"
                                       :value.sync="form_config_auto_optimize_targeting.advanced_times"
                                       :prefix="'advanced_'"></ComponentCustomTimePicker>

            <br>
            <br>

            <div style="padding-right: 30px">
              <p class="text-title" style=""> {{ $t('base.set_when_outside_runtime') }}</p>
              <el-select size="mini" value="" class="full-w" v-model="form_config_auto_optimize_targeting.stop_action">
                <el-option :value="1" :label="$t('base.update_to_starting_bid_price')"></el-option>
                <el-option :value="3" :label="$t('ads.general_label.edit_amount')"></el-option>
              </el-select>

              <template v-if="form_config_auto_optimize_targeting.stop_action === 3">
                <p class="text-title" style="">{{ $t('base.set_bid_price') }}</p>
                <el-input type="number" size="mini" v-model="form_config_auto_optimize_targeting.stop_action_value"
                          :placeholder="$t('input.bid_price')"></el-input>
              </template>
            </div>
          </el-col>
        </el-row>

        <el-row style="margin-top: 20px">
          <p class="text-title">{{ $t('ads.configuration_active_day_list') }}</p>
          <el-table :data="form_config_auto_optimize_targeting.advanced_days" default-expand-all>
            <el-table-column type="expand" width="40px">
              <template slot-scope="scope">
                <div v-if="scope.row.times" style="padding-left: 50px">
                  <div style="margin: 10px 0; color: #000">
                    {{ $t('base.configuration_runtime_list') }}
                  </div>
                  <div v-for="i in scope.row.times" :key="i" style="margin-bottom: 5px; color: #000">
                    {{ i }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('ads.configuration_active_day')" width="200px">
              <template slot-scope="scope">
                <strong>{{ spike_day_map(scope.row) }}</strong>
                <br>
                <strong class="text-danger">
                  {{ m__row_type_to_text(scope.row) }}
                </strong>
              </template>
            </el-table-column>
            <el-table-column :label="$t('base.expected_cir')" width="150px">
              <template slot-scope="scope">{{ scope.row.cir }} %</template>
            </el-table-column>
            <el-table-column :label="$t('base.starting_bid_price')" width="150px">
              <template slot-scope="scope">{{ scope.row.start_price | format_currency }}</template>
            </el-table-column>
            <el-table-column :label="$t('base.bonus_amount')" width="150px">
              <template slot-scope="scope">{{ $t('base.automatic') }}</template>
            </el-table-column>
            <el-table-column :label="$t('base.max_bid_price')" width="130px">
              <template slot-scope="scope">
                <el-input size="mini" v-model="scope.row.max_price"></el-input>
              </template>
            </el-table-column>
            <el-table-column :label="$t('base.min_bid_price')" width="130px">
              <template slot-scope="scope">
                <el-input size="mini" v-model="scope.row.min_price"></el-input>
              </template>
            </el-table-column>
            <el-table-column :label="$t('ads.auto_cir_label.max_cost_if_gmv_by_0')" width="150px">
              <template slot-scope="scope">
                <el-input size="mini" v-model="scope.row.max_cost"></el-input>
              </template>
            </el-table-column>
            <el-table-column :label="$t('ads.action_when_running_out_of_cost')" width="180px">
              <template slot-scope="scope">
                {{
                  scope.row.max_cost_type === 'stop' ? $t('base.pause_ad') : $t('base.bid_price') + ': ' +
                    scope.row.max_cost_value
                }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('ads.auto_cir_label.bid_price_when_outside_runtime')" width="150px">
              <template slot-scope="scope">
                {{
                  scope.row.stop_action === 3 ? scope.row.stop_action_value : $t('base.starting_bid_price')
                }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('base.action')" width="120px" fixed="right">
              <template slot-scope="scope">
                <el-button size="mini" type="text" @click="m__edit_optimize_advanced_day_targeting(scope.$index)">
                  <strong class="text-warning">{{ $t('base.edit') }}</strong>
                </el-button>
                <br>
                <el-button size="mini" type="text" @click="m__remove_optimize_advanced_day_targeting(scope.$index)">
                  <strong class="text-danger">{{ $t('base.delete') }}</strong>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-row>

        <el-row class="text-right" style="margin-top: 10px">
          <el-button size="mini" type="danger"
                     v-if="selected_campaign && selected_campaign.auto_optimize"
                     @click="m__delete_config_auto_optimize('targeting')" icon="el-icon-delete">
            {{ $t('base.delete_config') }}
          </el-button>
          <el-button type="primary" size="mini" icon="el-icon-check" @click="m__update_config_auto_optimize_targeting"
                     :loading="loading.config_auto_optimize">
            {{ $t('base.confirm') }}
          </el-button>
        </el-row>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.update_multiple_premium" :close-on-click-modal="false"
               width="700px">
      <div slot="title" style="padding:10px">
        <strong class="strong-title"> {{ $t('base.edit_bid_price') }} {{ $t('base.targeting') }}</strong>

        <div style="margin-top: 30px">
          <el-checkbox v-model="form_update_multiple_premium.placement2">
            {{ $t('base.daily_discover') }}
          </el-checkbox>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <el-checkbox v-model="form_update_multiple_premium.placement5">
            {{ $t('base.you_may_also_like') }}
          </el-checkbox>
        </div>

        <el-row style="margin-top: 30px">
          <el-col :sm="12">
            <el-radio v-model="form_update_multiple_premium.update_type" :label="1">
              {{ $t('base.i_or_d_x_by_amount', { x: $t('base.bid_price') }) }}
            </el-radio>
          </el-col>
          <el-col :sm="12">
            <el-row>
              <el-col :sm="8">
                <el-select size="mini" v-model="form_update_multiple_premium.update_by_cost" class="full-w"
                           :disabled="form_update_multiple_premium.update_type !== 1">
                  <el-option value="increase" :label="$t('base.increase')"></el-option>
                  <el-option value="reduce" :label="$t('base.decrease')"></el-option>
                </el-select>
              </el-col>
              <el-col :sm="16" style="padding-left: 5px">
                <el-input size="mini" type="number" :disabled="form_update_multiple_premium.update_type !== 1"
                          v-model="form_update_multiple_premium.update_by_cost_value"></el-input>
                <div style="height: 5px"></div>
                <el-input v-if="form_update_multiple_premium.update_by_cost === 'increase'"
                          size="mini" type="number" :placeholder="$t('input.max_bid_price')"
                          :disabled="form_update_multiple_premium.update_type !== 1"
                          v-model="form_update_multiple_premium.update_by_cost_value_max"></el-input>
                <el-input v-if="form_update_multiple_premium.update_by_cost === 'reduce'"
                          size="mini" type="number" :placeholder="$t('input.min_bid_price')"
                          :disabled="form_update_multiple_premium.update_type !== 1"
                          v-model="form_update_multiple_premium.update_by_cost_value_min"></el-input>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-row style="margin-top: 30px">
          <el-col :sm="12">
            <el-radio v-model="form_update_multiple_premium.update_type" :label="2">
              {{ $t('base.i_or_d_x_by_percent', { x: $t('base.bid_price') }) }}
            </el-radio>
          </el-col>
          <el-col :sm="12">
            <el-row>
              <el-col :sm="8">
                <el-select size="mini" v-model="form_update_multiple_premium.update_by_percent" class="full-w"
                           :disabled="form_update_multiple_premium.update_type !== 2">
                  <el-option value="increase" :label="$t('base.increase')"></el-option>
                  <el-option value="reduce" :label="$t('base.decrease')"></el-option>
                </el-select>
              </el-col>
              <el-col :sm="16" style="padding-left: 5px">
                <el-input size="mini" type="number" :disabled="form_update_multiple_premium.update_type !== 2"
                          v-model="form_update_multiple_premium.update_by_percent_value"></el-input>
                <div style="height: 5px"></div>
                <el-input v-if="form_update_multiple_premium.update_by_percent === 'increase'"
                          size="mini" type="number" :placeholder="$t('input.max_bid_price')"
                          :disabled="form_update_multiple_premium.update_type !== 2"
                          v-model="form_update_multiple_premium.update_by_percent_value_max"></el-input>
                <el-input v-if="form_update_multiple_premium.update_by_percent === 'reduce'"
                          size="mini" type="number" :placeholder="$t('input.min_bid_price')"
                          :disabled="form_update_multiple_premium.update_type !== 2"
                          v-model="form_update_multiple_premium.update_by_percent_value_min"></el-input>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-row style="margin-top: 30px">
          <el-col :sm="12">
            <el-radio v-model="form_update_multiple_premium.update_type" :label="5">
              {{ $t('base.set_bid_price') }}
            </el-radio>
          </el-col>
          <el-col :sm="12">
            <el-row>
              <el-col :sm="12">
                <div>&nbsp;</div>
              </el-col>
              <el-col :sm="12">
                <el-input size="mini" type="number"
                          :disabled="form_update_multiple_premium.update_type !== 5"
                          v-model="form_update_multiple_premium.cost_value"></el-input>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-row style="margin-top: 30px" class="text-right">
          <el-button size="mini" type="primary" icon="el-icon-check" :loading="loading.update_multiple_premium"
                     @click="m__confirm_update_multiple_premium">{{ $t('base.confirm') }}
          </el-button>
        </el-row>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.resume_multiple_config" :close-on-click-modal="false"
               width="400px">
      <div slot="title" style="padding:10px">
        <strong class="strong-title">{{ $t('base.mass_resume_configuration') }}</strong>

        <div>
          <div v-for="item in resume_multiple_config_checkbox_list" :key="item.name"
               style="margin-bottom: 10px">
            <el-checkbox v-model="item.value">{{ item.name }}</el-checkbox>
          </div>
        </div>

        <div class="text-right" style="margin-top: 30px">
          <el-button type="primary" size="mini" icon="el-icon-check" :loading="loading.resume_multiple_config"
                     @click="m__confirm_resume_multiple_config">
            {{ $t('base.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.pause_multiple_config" :close-on-click-modal="false"
               width="400px">
      <div slot="title" style="padding:10px">
        <strong class="strong-title">{{ $t('base.mass_pause_configuration') }}</strong>

        <div>
          <div
            v-for="item in pause_multiple_config_checkbox_list" :key="item.name"
            style="margin-bottom: 10px">
            <el-checkbox v-model="item.value">{{ item.name }}</el-checkbox>
          </div>
        </div>

        <div class="text-right" style="margin-top: 30px">
          <el-button type="primary" size="mini" icon="el-icon-check" :loading="loading.pause_multiple_config"
                     @click="m__confirm_pause_multiple_config">
            {{ $t('base.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.delete_multiple_config" :close-on-click-modal="false"
               width="400px">
      <div slot="title" style="padding:10px">
        <strong class="strong-title">{{ $t('base.mass_delete_configuration') }}</strong>

        <div>
          <div
            v-for="item in delete_multiple_config_checkbox_list" :key="item.name"
            style="margin-bottom: 10px">
            <el-checkbox v-model="item.value">{{ item.name }}</el-checkbox>
          </div>
        </div>

        <div class="text-right" style="margin-top: 30px">
          <el-button type="primary" size="mini" icon="el-icon-check" :loading="loading.delete_multiple_config"
                     @click="m__confirm_delete_multiple_config">
            {{ $t('base.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog id="auto_by_condition" ref="auto_by_condition" :visible.sync="show_dialog.auto_by_condition"
               :close-on-click-modal="false"
               width="1200px">
      <div slot="title" style="padding:10px">
        <el-tabs v-model="condition_action_tab">
          <el-tab-pane
            :label="auto_condition_action_state.type === 'update_file' ? $t('base.update_config_file') : $t('base.setup_x', {x: $t('base.config')})"
            name="main">
            <div style="margin-top: 30px">
              <div>
                <strong style="font-size: 14px">
                  <i class="el-icon-info"></i> {{ $t('base.conditions_actions_template') }}</strong>
              </div>
              <div style="margin-top: 20px; display: flex; gap: 10px">
                <div
                  style="flex: 1; border: 1px solid #e4e7eb; padding: 10px; border-radius: 6px; cursor: pointer; max-width: 280px"
                  :style="selected_template === 'manual' ? 'border: 1px solid orangered' : ''"
                  @click="m__use_template('manual')">
                  <strong>{{ $t('base.create_manual_rules') }}</strong>
                </div>
                <div
                  style="flex: 1; border: 1px solid #e4e7eb; padding: 10px; border-radius: 6px; cursor: pointer; max-width: 280px"
                  :style="selected_template === 'auto_position' ? 'border: 1px solid orangered' : ''"
                  @click="m__use_template('auto_position')">
                  <strong>{{ $t('base.auto_position_and_optimize_cir_template') }}</strong>
                </div>
                <div
                  style="flex: 1; border: 1px solid #e4e7eb; padding: 10px; border-radius: 6px; cursor: pointer; max-width: 280px"
                  :style="selected_template === 'auto_quota' ? 'border: 1px solid orangered' : ''"
                  @click="m__use_template('auto_quota')">
                  <strong>{{ $t('base.auto_budget_template') }}</strong>
                </div>
              </div>
            </div>

            <div style="margin-top: 30px">
              <div style="margin-top: 10px" v-for="(item, ca_index) in condition_action_list" :key="`item-${ca_index}`">
                <div style="margin-bottom: 5px; cursor: pointer;">
                  <strong style="font-size: 14px">
                    <i class="el-icon-s-operation"></i>
                    {{ $t('base.conditions_and_actions') }} {{ ca_index + 1 }}</strong>
                </div>
                <div
                  style="background-color: #f7f7f7; padding: 10px; margin-bottom: 30px; position: relative; border-radius: 4px">
                  <div v-for="(group, group_index) in item.condition_group" :key="`item-${group_index}`"
                       style="display: flex; gap: 20px; margin-bottom: 20px">
                    <div style="flex: 1; min-width: 160px">
                      <strong class="strong-label">&nbsp;</strong>
                      <div
                        style="display: flex; height: 29px; background-color: #faedbb; align-items: center; justify-content: left; padding-left: 10px; font-size: 13px; font-weight: bold; border-top-right-radius: 10px; border-bottom-right-radius: 10px">
                        {{ $t('base.conditions_groups') }} {{ group_index + 1 }}
                      </div>
                      <div v-if="false" style="margin-top: 30px; display: flex; justify-content: center">
                        <div style="width: 70px; height: 40px; display: flex; flex-direction: column">
                          <span role="button"
                                @click="m__swap_condition_group(item.condition_group, group_index, 'up')"
                                style="width: 100%; height: 20px; border: 1px solid gray; text-align: center; border-radius: 4px 4px 0 0; display: flex; align-items: center; justify-content: center; background: #fff; cursor: pointer">
                            <i class="el-icon-arrow-up" style="font-size: 11px"></i>
                          </span>
                          <span role="button"
                                @click="m__swap_condition_group(item.condition_group, group_index, 'down')"
                                style="width: 100%; height: 20px; text-align: center; border-radius: 0 0 4px 4px; border: 1px solid gray; border-top: 0; display: flex; align-items: center; justify-content: center; background: #fff; cursor: pointer">
                            <i class="el-icon-arrow-down" style="font-size: 11px"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div style="display: flex; gap: 10px">
                        <div style="flex: 1; min-width: 140px">
                          <strong class="strong-label">{{ $t('base.level') }}</strong>
                        </div>
                        <div style="flex: 1; min-width: 140px">
                          <strong class="strong-label">{{ $t('base.metric') }}</strong>
                        </div>
                        <div style="flex: 1; min-width: 140px;">
                          <strong class="strong-label">{{ $t('base.time') }}</strong>
                        </div>
                        <div style="width: 101px">
                          <strong class="strong-label">{{ $t('base.expression') }}</strong>
                        </div>
                        <div style="flex: 1; min-width: 140px">
                          <strong class="strong-label">{{ $t('base.value') }}</strong>
                        </div>
                        <div style="width: 150px">
                          <strong class="strong-label">&nbsp;</strong>
                        </div>
                      </div>
                      <div v-for="(condition, index) of group.condition_list" :key="`item-${index}`"
                           style="margin-bottom: 10px">
                        <div style="display: flex; gap: 10px;">
                          <div style="flex: 1; min-width: 140px">
                            <el-select size="mini" class="full-w" value="" v-model="condition.level" filterable>
                              <el-option :label="$t('base.campaign')" value="campaign"></el-option>
                              <el-option :label="$t('base.campaign_detail')" value="detail"></el-option>
                              <el-option :label="$t('keyword.exact')" value="match_type_0"></el-option>
                              <el-option :label="$t('keyword.broad')" value="match_type_1"></el-option>
                              <el-option :label="$t('base.daily_discover')" value="placement_2"></el-option>
                              <el-option :label="$t('base.you_may_also_like')" value="placement_5"></el-option>
                              <el-option :label="$t('base.product')" value="product"></el-option>
                              <!--                              <el-option :label="$t('base.shop')" value="shop"></el-option>-->
                              <el-option :label="$t('base.audience')" value="target_audience"></el-option>
                              <el-option :label="$t('keyword.report')" value="keyword_report"></el-option>
                              <el-option :label="$t('base.system')" value="system"></el-option>
                            </el-select>
                          </div>
                          <div style="flex: 1; min-width: 140px">
                            <template v-if="condition.level === 'system'">
                              <el-select size="mini" class="full-w" value="" v-model="condition.label" filterable>
                                <el-option :value="'datetime'" :label="$t('base.datetime')"></el-option>
                              </el-select>
                            </template>
                            <template v-else>
                              <el-select size="mini" class="full-w" value="" v-model="condition.label" filterable>
                                <el-option
                                  v-if="['campaign'].includes(condition.level)"
                                  value="daily_budget" :label="$t('base.daily_budget')">
                                </el-option>
                                <el-option
                                  v-if="['detail', 'match_type_0', 'match_type_1', 'placement_2', 'placement_5'].includes(condition.level)"
                                  value="price" :label="$t('base.bid_price')">
                                </el-option>
                                <el-option v-for="i in filter" :key="i.camel_key" :value="i.camel_key" :label="i.label">
                                </el-option>
                                <el-option
                                  v-if="['campaign', 'detail', 'match_type_0', 'match_type_1'].includes(condition.level)"
                                  value="tag" :label="$t('base.include_tags')">
                                </el-option>
                                <el-option
                                  v-if="['detail', 'match_type_0', 'match_type_1'].includes(condition.level)"
                                  value="split_keyword" :label="$t('keyword.word_count')">
                                </el-option>
                                <el-option
                                  v-if="['campaign'].includes(condition.level)"
                                  value="target_roas" :label="$t('base.target_roas')">
                                </el-option>
                                <el-option
                                  v-if="['campaign'].includes(condition.level)"
                                  value="cancelled_gmv" :label="$t('metric.cancelled_gmv')">
                                </el-option>
                                <el-option
                                  v-if="['campaign'].includes(condition.level)"
                                  value="cancelled_roi" :label="$t('metric.cancelled_roi')">
                                </el-option>
                                <el-option
                                  v-if="['campaign'].includes(condition.level)"
                                  value="exclude_cancelled_gmv" :label="$t('metric.exclude_cancelled_gmv')">
                                </el-option>
                                <el-option
                                  v-if="['campaign'].includes(condition.level)"
                                  value="exclude_cancelled_roi" :label="$t('metric.exclude_cancelled_roi')">
                                </el-option>
                                <el-option
                                  v-if="['campaign'].includes(condition.level)"
                                  value="cost_x_budget" :label="$t('base.cost_and_budget_rate')">
                                </el-option>
                              </el-select>
                            </template>
                          </div>
                          <div style="flex: 1; min-width: 140px;">
                            <template v-if="condition.level === 'system'">
                              <el-select size="mini" class="full-w" value="" v-model="condition.time" filterable>
                                <el-option :label="$t('base.day')" value="day"></el-option>
                                <el-option :label="$t('base.hour')" value="hour"></el-option>
                                <el-option :label="$t('base.minute')" value="minute"></el-option>
                              </el-select>
                            </template>
                            <template v-else>
                              <el-select v-if="!['tag', 'price', 'split_keyword'].includes(condition.label)"
                                         size="mini" class="full-w" value="" v-model="condition.time" filterable>
                                <el-option label="Hôm nay" value="today"></el-option>
                                <el-option :label="$t('base.yesterday')" value="yesterday"></el-option>
                                <el-option :label="$t('day.past3days')" value="`past3days`"></el-option>
                                <el-option :label="$t('day.past5days')" value="past5days"></el-option>
                                <el-option :label="$t('day.past7days')" value="past7days"></el-option>
                                <el-option :label="$t('day.past14days')" value="past14days"></el-option>
                                <el-option :label="$t('day.past21days')" value="past21days"></el-option>
                                <el-option :label="$t('day.past30days')" value="past30days"></el-option>
                                <el-option :label="$t('day.past60days')" value="past60days"></el-option>
                                <el-option :label="$t('day.past90days')" value="past90days"></el-option>
                                <el-option :label="$t('day.from_start_month')" value="month"></el-option>
                                <el-option :label="$t('day.past_x_hours', {x: 1})" value="past1hour"></el-option>
                                <el-option :label="$t('day.past_x_hours', {x: 2})" value="past2hours"></el-option>
                                <el-option :label="$t('day.past_x_hours', {x: 3})" value="past3hours"></el-option>
                                <el-option :label="$t('day.range')" value="range"></el-option>
                              </el-select>
                            </template>
                          </div>
                          <div style="width: 101px">
                            <el-select v-if="!['tag'].includes(condition.label)"
                                       size="mini" class="full-w" value="" v-model="condition.expression" filterable>
                              <el-option label=">" value=">"></el-option>
                              <el-option label="<" value="<"></el-option>
                              <el-option label="=" value="==="></el-option>
                              <el-option label="≠" value="!=">
                                <span style="font-size: 16px !important;">≠</span>
                              </el-option>
                              <el-option label="> =" value=">="></el-option>
                              <el-option label="< =" value="<="></el-option>
                              <template v-if="condition.level === 'campaign' && condition.label === 'cost'">
                                <el-option :label="$t('ads.x_value_with_budget', {x: '> ='})"
                                           value=">=xcost"></el-option>
                                <el-option :label="$t('ads.x_value_with_budget', {x: '< ='})"
                                           value="<=xcost"></el-option>
                              </template>
                              <template v-if="condition.level === 'product'">
                                <el-option :label="$t('ads.x_with_ads_planning', {x: '>'})" value=">p"></el-option>
                                <el-option :label="$t('ads.x_with_ads_planning', {x: '<'})" value="<p"></el-option>
                                <el-option :label="$t('ads.x_with_ads_planning', {x: '='})" value="===p"></el-option>
                              </template>
                            </el-select>
                          </div>
                          <div style="flex: 1; min-width: 140px">
                            <template v-if="!['tag'].includes(condition.label)">
                              <el-select v-if="condition.expression.includes('p')" size="mini"
                                         v-model="condition.value_p" :placeholder="$t('base.select_plan_file')">
                                <el-option v-for="file in agency_files.filter(i => i.shopId === shopee_shop.selected)"
                                           :key="file.id" :value="file.id" :label="file.filename"></el-option>
                              </el-select>
                              <el-input v-if="!condition.expression.includes('p')" type="number" size="mini"
                                        v-model="condition.value"></el-input>
                            </template>
                            <template v-else>
                              <el-select v-if="condition.level === 'campaign'" size="mini" v-model="condition.value_t"
                                         :placeholder="$t('select.tags')" multiple>
                                <el-option v-for="tag in campaign_tag_list" :key="tag._id"
                                           :value="tag._id" :label="tag.name"></el-option>
                              </el-select>
                              <el-select v-else size="mini" v-model="condition.value_t"
                                         :placeholder="$t('select.tags')" multiple>
                                <el-option v-for="tag in keyword_tag_list" :key="tag._id"
                                           :value="tag._id" :label="tag.name"></el-option>
                              </el-select>
                            </template>
                          </div>
                          <div style="width: 150px; display: flex; align-items: center; gap: 10px">
                            <el-button type="info" size="mini" icon="el-icon-copy-document"
                                       @click="m__copy_condition(group.condition_list, index, condition)">
                            </el-button>
                            <div style="width: 45px; height: 29px; display: flex; flex-direction: column">
                              <span role="button" @click="m__swap_condition(group.condition_list, index, 'up')"
                                    style="width: 100%; height: 14px; border: 1px solid gray; text-align: center; border-radius: 4px 4px 0 0; display: flex; align-items: center; justify-content: center; background: #fff; cursor: pointer">
                                <i class="el-icon-arrow-up" style="font-size: 11px"></i>
                              </span>
                              <span role="button" @click="m__swap_condition(group.condition_list, index, 'down')"
                                    style="width: 100%; height: 14px; text-align: center; border-radius: 0 0 4px 4px; border: 1px solid gray; border-top: 0; display: flex; align-items: center; justify-content: center; background: #fff; cursor: pointer">
                                <i class="el-icon-arrow-down" style="font-size: 11px"></i>
                              </span>
                            </div>
                            <el-button type="danger" size="mini" icon="el-icon-delete"
                                       :disabled="item.condition_group.length <= 1 && group.condition_list.length <= 1"
                                       @click="m__remove_condition(group.condition_list, index, item)">
                            </el-button>
                          </div>
                        </div>
                        <div v-if="group.condition_list[index + 1] || condition.time === 'range'"
                             style="display: flex; margin-bottom: 10px">
                          <div style="flex: 2; display: flex; align-items: center; padding-top: 10px; max-width: 325px">
                            <el-dropdown v-if="group.condition_list[index + 1]" trigger="click" placement="bottom">
                              <strong class="text-warning">
                                <el-tag v-if="!condition.post_expression || condition.post_expression === '&&'"
                                        type="primary" size="mini">
                                  {{ $t('base.condition') }}: {{ $t('base.and') }}
                                </el-tag>
                                <el-tag v-if="condition.post_expression === '||'" type="warning" size="mini">
                                  {{ $t('base.condition') }}: {{ $t('base.or') }}
                                </el-tag>
                              </strong>
                              <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item @click.native="condition.post_expression = '&&'">
                                  {{ $t('base.condition') }}: {{ $t('base.and') }}
                                </el-dropdown-item>
                                <el-dropdown-item @click.native="condition.post_expression = '||'">
                                  {{ $t('base.condition') }}: {{ $t('base.or') }}
                                </el-dropdown-item>
                              </el-dropdown-menu>
                            </el-dropdown>
                          </div>
                          <div style="flex: 2; margin-top: 10px; max-width: 315px">
                            <el-date-picker v-if="condition.time === 'range'" v-model="condition.time_range"
                                            type="daterange" range-separator="-"
                                            :start-placeholder="$t('base.start_time')"
                                            :end-placeholder="$t('base.end_time')" size="mini"
                                            format="dd-MM-yyyy" class="full-w"
                                            :clearable="false" :picker-options="picker_options">
                            </el-date-picker>
                          </div>
                        </div>
                      </div>
                      <div>
                        <el-row>
                          <el-col :sm="12">
                            <el-button type="text" size="mini" @click="m__add_condition(group.condition_list)">
                              <span class="text-primary"><i class="el-icon-plus"></i> {{
                                  $t('base.add_condition')
                                }}</span>
                            </el-button>
                          </el-col>
                          <el-col :sm="12" class="text-right">
                            <el-button type="text" size="mini"
                                       @click="m__copy_condition_group(group, group_index, item)">
                              <span class="text-primary"><i class="el-icon-copy-document"></i>
                                {{ $t('base.clone_x', { x: $t('base.conditions_group') }) }}
                              </span>
                            </el-button>
                          </el-col>
                        </el-row>
                      </div>
                    </div>
                  </div>
                  <div style="display: flex; gap: 20px; margin-top: 20px">
                    <el-button type="text" size="mini" @click="m__add_condition_group(item.condition_group)">
                      <strong class="text-warning" style="font-size:13px">
                        <i class="el-icon-plus text-warning"></i>
                        {{ $t('base.add_x', { x: $t('base.conditions_group') }) }}
                      </strong>
                    </el-button>
                  </div>
                  <div style="display: flex; gap: 20px; margin-top: 40px">
                    <div style="width: 160px">
                      <div
                        style="display: flex; height: 29px; background-color: #e1e5fa; align-items: center; justify-content: left; padding-left: 10px; font-size: 13px; font-weight: bold; border-top-right-radius: 10px; border-bottom-right-radius: 10px;">
                        {{ $t('base.actions') }}
                      </div>
                    </div>
                    <div id="new_actions" style="margin-bottom: 20px; flex: 1">
                      <div v-for="(action, action_index) in item.actions" style="display: flex">
                        <div style="width: 800px">
                          <div v-if="action.type === 'campaign'" style="display: flex">
                            <div style="display: flex; gap: 10px; margin-bottom: 20px">
                              <div style="width: 160px; padding-top: 8px">
                                {{ $t('base.campaign') }}
                              </div>
                              <div style="display: flex; gap: 10px">
                                <div style="flex: 1; min-width: 182px">
                                  <el-select size="mini" value="" v-model="action.action_campaign">
                                    <el-option value=""
                                               :label="$t('base.do_nothing')"></el-option>
                                    <el-option value="value"
                                               :label="$t('base.set_budget')"></el-option>
                                    <el-option value="increase"
                                               :label="$t('base.increase_budget')"></el-option>
                                    <el-option value="reduce"
                                               :label="$t('base.decrease_budget')"></el-option>
                                    <el-option value="ongoing"
                                               :label="$t('base.resume_campaign')"></el-option>
                                    <el-option value="pause"
                                               :label="$t('base.pause_campaign')"></el-option>
                                    <el-option value="set_by_cost"
                                               :label="$t('base.set_budget_by_realtime_cost')"></el-option>
                                    <el-option value="increase_from_cost"
                                               :label="$t('base.increase_budget_from_realtime_cost')"></el-option>
                                    <el-option value="set_by_cost_percent"
                                               :label="$t('base.set_budget_by_cost_percent')"></el-option>
                                    <el-option value="clone"
                                               :label="$t('base.clone_campaign')"></el-option>
                                    <el-option value="set_roas"
                                               :label="$t('base.set_roas') + ' (GMV Max)'"></el-option>
                                    <el-option value="set_roas_by_exclude_cancelled_roi_percent"
                                               :label="'Thiết lập mục tiêu ROAS theo % của ROI (ROAS) đã trừ huỷ' + ' (GMV Max)'"></el-option>
                                    <el-option value="increase_roas"
                                               :label="$t('base.increase_roas') + ' (GMV Max)'"></el-option>
                                    <el-option value="reduce_roas"
                                               :label="$t('base.reduce_roas') + ' (GMV Max)'"></el-option>
                                    <el-option value="set_yesterday_roas"
                                               :label="'Sử dụng ROAS ngày hôm qua (GMV Max)'"></el-option>
                                    <el-option value="set_past7days_roas"
                                               :label="'Sử dụng ROAS 7 ngày qua (GMV Max)'"></el-option>
                                    <el-option value="set_past30days_roas"
                                               :label="'Sử dụng ROAS 30 ngày qua (GMV Max)'"></el-option>
                                    <el-option value="rapid_boost_on"
                                               :label="`Bật Đẩy nhanh hàng loạt`"></el-option>
                                    <el-option value="rapid_boost_off"
                                               :label="`Tắt Đẩy nhanh hàng loạt`"></el-option>
                                  </el-select>

                                  <div
                                    v-if="['increase', 'reduce', 'increase_roas', 'reduce_roas'].includes(action.action_campaign)"
                                    style="flex: 1; min-width: 182px; height: 24px">
                                  </div>

                                  <span v-if="action.action_campaign === 'increase'">
                                    {{ $t('base.max_budget') }}
                                  </span>
                                  <span v-if="action.action_campaign === 'reduce'">
                                    {{ $t('base.min_budget') }}
                                  </span>
                                  <span v-if="action.action_campaign === 'increase_roas'">
                                    {{ $t('base.max_roas') }}
                                  </span>
                                  <span v-if="action.action_campaign === 'reduce_roas'">
                                    {{ $t('base.min_roas') }}
                                  </span>
                                </div>

                                <div v-if="['increase', 'reduce'].includes(action.action_campaign)"
                                     style="flex: 1; min-width: 182px">
                                  <el-select size="mini" value="" v-model="action.update_price_type_campaign">
                                    <el-option value="value" :label="$t('base.by_amount')"></el-option>
                                    <el-option value="percent" :label="$t('base.by_percent')"></el-option>
                                    <el-option value="cost_percent" :label="'Theo % chi phí'"></el-option>
                                  </el-select>

                                  <br>
                                  <br>
                                  <el-input v-if="action.action_campaign === 'increase'" type="number" size="mini"
                                            v-model="action.update_max_price_campaign"></el-input>
                                  <el-select v-if="action.action_campaign === 'reduce'" size="mini" value=""
                                             v-model="action.update_min_price_campaign_type">
                                    <el-option :value="undefined"
                                               :label="$t('base.by_value')"></el-option>
                                    <el-option value="set_by_cost"
                                               :label="$t('ads.use_realtime_cost')"></el-option>
                                  </el-select>
                                </div>

                                <div v-if="['increase_roas', 'reduce_roas'].includes(action.action_campaign)"
                                     style="flex: 1; min-width: 182px">
                                  <el-select size="mini" value="" v-model="action.update_price_type_campaign">
                                    <el-option value="value" :label="$t('base.by_value')"></el-option>
                                    <el-option value="percent" :label="$t('base.by_percent')"></el-option>
                                  </el-select>

                                  <br>
                                  <br>

                                  <el-input v-if="action.action_campaign === 'increase_roas'" type="number" size="mini"
                                            v-model="action.update_max_price_campaign "></el-input>
                                  <el-input v-if="action.action_campaign === 'reduce_roas'" type="number" size="mini"
                                            v-model="action.update_min_price_campaign"></el-input>
                                </div>

                                <div
                                  v-if="['value', 'increase', 'reduce', 'set_roas', 'increase_roas', 'reduce_roas', 'set_by_cost_percent', 'increase_from_cost', 'set_roas_by_exclude_cancelled_roi_percent'].includes(action.action_campaign)"
                                  style="flex: 1; min-width: 182px">
                                  <el-input size="mini" type="number"
                                            v-model="action.update_price_value_campaign"></el-input>

                                  <br>
                                  <br>

                                  <el-input
                                    v-if="action.action_campaign === 'reduce' && (!action.update_min_price_campaign_type || action.update_min_price_campaign_type === 'value')"
                                    type="number" size="mini" v-model="action.update_min_price_campaign"></el-input>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div v-if="action.type === 'match_type_0'" style="display: flex">
                            <div style="display: flex; gap: 10px; margin-bottom: 20px">
                              <div style="width: 160px; padding-top: 8px">
                                {{ $t('keyword.exact') }}
                              </div>
                              <div style="display: flex; gap: 10px">
                                <div style="flex: 1; min-width: 182px">
                                  <el-select size="mini" value="" v-model="action.action_match_type_0">
                                    <el-option value="" :label="$t('base.do_nothing')"></el-option>
                                    <el-option value="value" :label="$t('base.set_bid_price')"></el-option>
                                    <el-option value="increase" :label="$t('base.increase_bid_price')"></el-option>
                                    <el-option value="reduce" :label="$t('base.decrease_bid_price')"></el-option>
                                    <el-option value="cpc" :label="$t('base.set_by_cpc')"></el-option>
                                    <el-option value="match_type_1" :label="$t('base.change_to_broad')"></el-option>
                                    <el-option value="ongoing" :label="$t('base.resume_keyword')"></el-option>
                                    <el-option value="pause" :label="$t('base.pause_keyword')"></el-option>
                                    <el-option value="start" :label="$t('base.use_starting_bid_price')"></el-option>
                                  </el-select>

                                  <br v-if="['increase', 'reduce'].includes(action.action_match_type_0)"
                                      style="flex: 1; min-width: 182px">
                                  <br v-if="['increase', 'reduce'].includes(action.action_match_type_0)"
                                      style="flex: 1; min-width: 182px">
                                  <span v-if="action.action_match_type_0 === 'increase'">
                                    {{ $t('base.max_bid_price') }}
                                  </span>
                                  <span v-if="action.action_match_type_0 === 'reduce'">
                                    {{ $t('base.min_bid_price') }}
                                  </span>
                                </div>

                                <div v-if="['increase', 'reduce'].includes(action.action_match_type_0)"
                                     style="flex: 1; min-width: 182px">
                                  <el-select size="mini" value="" v-model="action.update_price_type_match_type_0">
                                    <el-option value="value" :label="$t('base.by_amount')"></el-option>
                                    <el-option value="percent" :label="$t('base.by_percent')"></el-option>
                                  </el-select>
                                  <br>
                                  <br>
                                  <el-select v-if="action.action_match_type_0 === 'increase'" value="" size="mini"
                                             v-model="action.update_type_max_price_match_type_0">
                                    <el-option value="value" :label="$t('base.by_amount')"></el-option>
                                    <el-option value="cpc_today"
                                               :label="$t('ads.condition_label.cpc_today')"></el-option>
                                    <el-option value="cpc_week" :label="$t('ads.condition_label.cpc_week')"></el-option>
                                    <el-option value="cpc_month"
                                               :label="$t('ads.condition_label.cpc_month')"></el-option>
                                    <el-option value="cpc_campaign_today"
                                               :label="$t('ads.condition_label.cpc_campaign_today')"></el-option>
                                    <el-option value="cpc_campaign_week"
                                               :label="$t('ads.condition_label.cpc_campaign_month')"></el-option>
                                    <el-option value="cpc_campaign_month"
                                               :label="$t('ads.condition_label.cpc_campaign_month')"></el-option>
                                    <!--                              <el-option value="cpc_shop_today"-->
                                    <!--                                         :label="$t('ads.condition_label.cpc_shop_today')"></el-option>-->
                                    <!--                              <el-option value="cpc_shop_week"-->
                                    <!--                                         :label="$t('ads.condition_label.cpc_shop_week')"></el-option>-->
                                    <!--                              <el-option value="cpc_shop_month"-->
                                    <!--                                         :label="$t('ads.condition_label.cpc_shop_month')"></el-option>-->
                                  </el-select>
                                  <el-select v-if="action.action_match_type_0 === 'reduce'" value="" size="mini"
                                             v-model="action.update_type_min_price_match_type_0">
                                    <el-option value="value" :label="$t('base.by_amount')"></el-option>
                                    <el-option value="cpc_today"
                                               :label="$t('ads.condition_label.cpc_today')"></el-option>
                                    <el-option value="cpc_week" :label="$t('ads.condition_label.cpc_week')"></el-option>
                                    <el-option value="cpc_month"
                                               :label="$t('ads.condition_label.cpc_month')"></el-option>
                                    <el-option value="cpc_campaign_today"
                                               :label="$t('ads.condition_label.cpc_campaign_today')"></el-option>
                                    <el-option value="cpc_campaign_week"
                                               :label="$t('ads.condition_label.cpc_campaign_month')"></el-option>
                                    <el-option value="cpc_campaign_month"
                                               :label="$t('ads.condition_label.cpc_campaign_month')"></el-option>
                                    <!--                              <el-option value="cpc_shop_today"-->
                                    <!--                                         :label="$t('ads.condition_label.cpc_shop_today')"></el-option>-->
                                    <!--                              <el-option value="cpc_shop_week"-->
                                    <!--                                         :label="$t('ads.condition_label.cpc_shop_week')"></el-option>-->
                                    <!--                              <el-option value="cpc_shop_month"-->
                                    <!--                                         :label="$t('ads.condition_label.cpc_shop_month')"></el-option>-->
                                  </el-select>
                                </div>

                                <div v-if="['increase', 'reduce'].includes(action.action_match_type_0)"
                                     style="flex: 1; min-width: 182px">
                                  <el-input size="mini" type="number"
                                            v-model="action.update_price_value_match_type_0"></el-input>
                                  <br>
                                  <br>
                                  <el-input v-if="action.action_match_type_0 === 'increase'" type="number" size="mini"
                                            v-model="action.update_max_price_match_type_0"></el-input>
                                  <el-input v-if="action.action_match_type_0 === 'reduce'" type="number" size="mini"
                                            v-model="action.update_min_price_match_type_0"></el-input>
                                </div>

                                <div v-if="['cpc'].includes(action.action_match_type_0)"
                                     style="flex: 1; min-width: 182px">
                                  <el-select size="mini" value="" v-model="action.cpc_type_match_type_0">
                                    <el-option value="keyword_past7days"
                                               :label="$t('ads.keyword_cpc_past7days')"></el-option>
                                    <el-option value="keyword_past30days"
                                               :label="$t('ads.keyword_cpc_past30days')"></el-option>
                                    <el-option value="keyword"
                                               :label="$t('ads.keyword_cpc_optional')"></el-option>
                                    <el-option value="campaign_past7days"
                                               :label="$t('ads.campaign_cpc_past7days')"></el-option>
                                    <el-option value="campaign_past30days"
                                               :label="$t('ads.campaign_cpc_past30days')"></el-option>
                                    <el-option value="campaign"
                                               :label="$t('ads.campaign_cpc_optional')"></el-option>
                                  </el-select>
                                </div>
                                <div
                                  v-if="['cpc'].includes(action.action_match_type_0) && array_to_set(['keyword', 'campaign']).has(action.cpc_type_match_type_0)"
                                  style="flex: 1; max-width: 200px">
                                  <el-date-picker
                                    v-model="action.cpc_range_match_type_0" type="daterange" range-separator="-"
                                    :start-placeholder="$t('base.start_time')" :end-placeholder="$t('base.end_time')"
                                    size="mini" format="dd-MM-yyyy"
                                    :clearable="false" :picker-options="picker_options">
                                  </el-date-picker>
                                </div>

                                <div v-if="['value'].includes(action.action_match_type_0)"
                                     style="flex: 1; min-width: 182px">
                                  <el-input size="mini" type="number"
                                            v-model="action.update_price_value_match_type_0"></el-input>
                                </div>

                                <div v-if="['match_type_1'].includes(action.action_match_type_0)"
                                     style="flex: 1; min-width: 182px">
                                  <el-select size="mini" value=""
                                             v-model="action.action_match_type_0_to_match_type_1_type">
                                    <el-option value="" :label="$t('base.do_nothing')"></el-option>
                                    <el-option value="value" :label="$t('base.set_bid_price')"></el-option>
                                  </el-select>
                                </div>
                                <div
                                  v-if="['match_type_1'].includes(action.action_match_type_0) && action.action_match_type_0_to_match_type_1_type === 'value'"
                                  style="flex: 1; min-width: 182px">
                                  <el-input type="number" size="mini"
                                            v-model="action.action_match_type_0_to_match_type_1_value"></el-input>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div v-if="action.type === 'match_type_1'">
                            <div style="display: flex; gap: 10px; margin-bottom: 20px">
                              <div style="width: 160px; padding-top: 8px">
                                {{ $t('keyword.broad') }}
                              </div>
                              <div style="display: flex; gap: 10px">
                                <div style="flex: 1; min-width: 182px">
                                  <el-select size="mini" value="" v-model="action.action_match_type_1">
                                    <el-option value="" :label="$t('base.do_nothing')"></el-option>
                                    <el-option value="value" :label="$t('base.set_bid_price')"></el-option>
                                    <el-option value="increase" :label="$t('base.increase_bid_price')"></el-option>
                                    <el-option value="reduce" :label="$t('base.decrease_bid_price')"></el-option>
                                    <el-option value="cpc" :label="$t('base.set_by_cpc')"></el-option>
                                    <el-option value="match_type_0" :label="$t('base.change_to_exact')"></el-option>
                                    <el-option value="ongoing" :label="$t('base.resume_keyword')"></el-option>
                                    <el-option value="pause" :label="$t('base.pause_keyword')"></el-option>
                                    <el-option value="start" :label="$t('base.use_starting_bid_price')"></el-option>
                                    <el-option value="add_keyword"
                                               :label="$t('ads.condition_label.add_search_keyword')"></el-option>
                                  </el-select>

                                  <br v-if="['increase', 'reduce'].includes(action.action_match_type_1)"
                                      style="flex: 1; min-width: 182px">
                                  <br v-if="['increase', 'reduce'].includes(action.action_match_type_1)"
                                      style="flex: 1; min-width: 182px">
                                  <span v-if="action.action_match_type_1 === 'increase'">
                                    {{ $t('base.max_bid_price') }}
                                  </span>
                                  <span v-if="action.action_match_type_1 === 'reduce'">
                                    {{ $t('base.min_bid_price') }}
                                  </span>
                                </div>

                                <div v-if="['increase', 'reduce'].includes(action.action_match_type_1)"
                                     style="flex: 1; min-width: 182px">
                                  <el-select size="mini" value="" v-model="action.update_price_type_match_type_1">
                                    <el-option value="value" :label="$t('base.by_amount')"></el-option>
                                    <el-option value="percent" :label="$t('base.by_percent')"></el-option>
                                  </el-select>
                                  <br>
                                  <br>
                                  <el-select v-if="action.action_match_type_1 === 'increase'" value="" size="mini"
                                             v-model="action.update_type_max_price_match_type_1">
                                    <el-option value="value" :label="$t('base.by_amount')"></el-option>
                                    <el-option value="cpc_today"
                                               :label="$t('ads.condition_label.cpc_today')"></el-option>
                                    <el-option value="cpc_week" :label="$t('ads.condition_label.cpc_week')"></el-option>
                                    <el-option value="cpc_month"
                                               :label="$t('ads.condition_label.cpc_month')"></el-option>
                                    <el-option value="cpc_campaign_today"
                                               :label="$t('ads.condition_label.cpc_campaign_today')"></el-option>
                                    <el-option value="cpc_campaign_week"
                                               :label="$t('ads.condition_label.cpc_campaign_month')"></el-option>
                                    <el-option value="cpc_campaign_month"
                                               :label="$t('ads.condition_label.cpc_campaign_month')"></el-option>
                                  </el-select>
                                  <el-select v-if="action.action_match_type_1 === 'reduce'" value="" size="mini"
                                             v-model="action.update_type_min_price_match_type_1">
                                    <el-option value="value" :label="$t('base.by_amount')"></el-option>
                                    <el-option value="cpc_today"
                                               :label="$t('ads.condition_label.cpc_today')"></el-option>
                                    <el-option value="cpc_week" :label="$t('ads.condition_label.cpc_week')"></el-option>
                                    <el-option value="cpc_month"
                                               :label="$t('ads.condition_label.cpc_month')"></el-option>
                                    <el-option value="cpc_campaign_today"
                                               :label="$t('ads.condition_label.cpc_campaign_today')"></el-option>
                                    <el-option value="cpc_campaign_week"
                                               :label="$t('ads.condition_label.cpc_campaign_month')"></el-option>
                                    <el-option value="cpc_campaign_month"
                                               :label="$t('ads.condition_label.cpc_campaign_month')"></el-option>
                                  </el-select>
                                </div>

                                <div v-if="['increase', 'reduce'].includes(action.action_match_type_1)"
                                     style="flex: 1; min-width: 182px">
                                  <el-input size="mini" type="number"
                                            v-model="action.update_price_value_match_type_1"></el-input>
                                  <br>
                                  <br>
                                  <el-input v-if="action.action_match_type_1 === 'increase'" type="number" size="mini"
                                            v-model="action.update_max_price_match_type_1"></el-input>
                                  <el-input v-if="action.action_match_type_1 === 'reduce'" type="number" size="mini"
                                            v-model="action.update_min_price_match_type_1"></el-input>
                                </div>

                                <div v-if="['cpc'].includes(action.action_match_type_1)"
                                     style="flex: 1; min-width: 182px">
                                  <el-select size="mini" value="" v-model="action.cpc_type_match_type_1">
                                    <el-option value="keyword_past7days"
                                               :label="$t('ads.keyword_cpc_past7days')"></el-option>
                                    <el-option value="keyword_past30days"
                                               :label="$t('ads.keyword_cpc_past30days')"></el-option>
                                    <el-option value="keyword"
                                               :label="$t('ads.keyword_cpc_optional')"></el-option>
                                    <el-option value="campaign_past7days"
                                               :label="$t('ads.campaign_cpc_past7days')"></el-option>
                                    <el-option value="campaign_past30days"
                                               :label="$t('ads.campaign_cpc_past30days')"></el-option>
                                    <el-option value="campaign"
                                               :label="$t('ads.campaign_cpc_optional')"></el-option>
                                  </el-select>
                                </div>
                                <div
                                  v-if="['cpc'].includes(action.action_match_type_1) && array_to_set(['keyword', 'campaign']).has(action.cpc_type_match_type_1)"
                                  style="flex: 1; max-width: 200px">
                                  <el-date-picker
                                    v-model="action.cpc_range_match_type_1" type="daterange" range-separator="-"
                                    :start-placeholder="$t('base.start_time')" :end-placeholder="$t('base.end_time')"
                                    size="mini" format="dd-MM-yyyy"
                                    :clearable="false" :picker-options="picker_options">
                                  </el-date-picker>
                                </div>

                                <div v-if="['value'].includes(action.action_match_type_1)"
                                     style="flex: 1; min-width: 182px">
                                  <el-input size="mini" type="number"
                                            v-model="action.update_price_value_match_type_1"></el-input>
                                </div>

                                <div v-if="['match_type_0'].includes(action.action_match_type_1)"
                                     style="flex: 1; min-width: 182px">
                                  <el-select size="mini" value=""
                                             v-model="action.action_match_type_1_to_match_type_0_type">
                                    <el-option value="" :label="$t('base.do_nothing')"></el-option>
                                    <el-option value="value" :label="$t('base.set_bid_price')"></el-option>
                                  </el-select>
                                </div>
                                <div
                                  v-if="['match_type_0'].includes(action.action_match_type_1) && action.action_match_type_1_to_match_type_0_type === 'value'"
                                  style="flex: 1; min-width: 182px">
                                  <el-input type="number" size="mini"
                                            v-model="action.action_match_type_1_to_match_type_0_value"></el-input>
                                </div>

                                <div v-if="['add_keyword'].includes(action.action_match_type_1)"
                                     style="flex: 1; min-width: 182px">
                                  <el-input type="number" size="mini" :placeholder="$t('input.min_bid_price')"
                                            v-model="action.update_min_price_match_type_1"></el-input>
                                </div>
                                <div v-if="['add_keyword'].includes(action.action_match_type_1)"
                                     style="flex: 1; min-width: 182px">
                                  <el-input type="number" size="mini" :placeholder="$t('input.max_bid_price')"
                                            v-model="action.update_max_price_match_type_1"></el-input>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div v-if="action.type === 'placement_2'">
                            <div style="display: flex; gap: 10px; margin-bottom: 20px">
                              <div style="width: 160px; padding-top: 8px">
                                {{ $t('base.daily_discover') }}
                              </div>
                              <div style="display: flex; gap: 10px">
                                <div style="flex: 1; min-width: 182px">
                                  <el-select size="mini" value="" v-model="action.action_placement_2">
                                    <el-option value="" :label="$t('base.do_nothing')"></el-option>
                                    <el-option value="value" :label="$t('base.set_bid_price')"></el-option>
                                    <el-option value="increase" :label="$t('base.increase_bid_price')"></el-option>
                                    <el-option value="reduce" :label="$t('base.decrease_bid_price')"></el-option>
                                    <el-option value="cpc" :label="$t('base.set_by_cpc')"></el-option>
                                    <el-option value="ongoing" :label="$t('base.resume_ad')"></el-option>
                                    <el-option value="pause" :label="$t('base.pause_ad')"></el-option>
                                    <el-option value="start" :label="$t('base.use_starting_bid_price')"></el-option>
                                  </el-select>

                                  <br v-if="['increase', 'reduce'].includes(action.action_placement_2)"
                                      style="flex: 1; min-width: 182px">
                                  <br v-if="['increase', 'reduce'].includes(action.action_placement_2)"
                                      style="flex: 1; min-width: 182px">
                                  <span v-if="action.action_placement_2 === 'increase'">
                                    {{ $t('base.max_bid_price') }}
                                  </span>
                                  <span v-if="action.action_placement_2 === 'reduce'">
                                    {{ $t('base.min_bid_price') }}
                                  </span>
                                </div>

                                <div v-if="['increase', 'reduce'].includes(action.action_placement_2)"
                                     style="flex: 1; min-width: 182px">
                                  <el-select size="mini" value="" v-model="action.update_price_type_placement_2">
                                    <el-option value="value" :label="$t('base.by_amount')"></el-option>
                                    <el-option value="percent" :label="$t('base.by_percent')"></el-option>
                                  </el-select>
                                  <br>
                                  <br>
                                  <el-select v-if="action.action_placement_2 === 'increase'" value="" size="mini"
                                             v-model="action.update_type_max_price_placement_2">
                                    <el-option value="value" :label="$t('base.by_amount')"></el-option>
                                    <el-option value="cpc_today"
                                               :label="$t('ads.condition_label.cpc_ad_today')"></el-option>
                                    <el-option value="cpc_week"
                                               :label="$t('ads.condition_label.cpc_ad_week')"></el-option>
                                    <el-option value="cpc_month"
                                               :label="$t('ads.condition_label.cpc_ad_month')"></el-option>
                                    <el-option value="cpc_campaign_today"
                                               :label="$t('ads.condition_label.cpc_campaign_today')"></el-option>
                                    <el-option value="cpc_campaign_week"
                                               :label="$t('ads.condition_label.cpc_campaign_month')"></el-option>
                                    <el-option value="cpc_campaign_month"
                                               :label="$t('ads.condition_label.cpc_campaign_month')"></el-option>
                                    <!--                              <el-option value="cpc_shop_today"-->
                                    <!--                                         :label="$t('ads.condition_label.cpc_shop_today')"></el-option>-->
                                    <!--                              <el-option value="cpc_shop_week"-->
                                    <!--                                         :label="$t('ads.condition_label.cpc_shop_week')"></el-option>-->
                                    <!--                              <el-option value="cpc_shop_month"-->
                                    <!--                                         :label="$t('ads.condition_label.cpc_shop_month')"></el-option>-->
                                  </el-select>
                                  <el-select v-if="action.action_placement_2 === 'reduce'" value="" size="mini"
                                             v-model="action.update_type_min_price_placement_2">
                                    <el-option value="value" :label="$t('base.by_amount')"></el-option>
                                    <el-option value="cpc_today"
                                               :label="$t('ads.condition_label.cpc_ad_today')"></el-option>
                                    <el-option value="cpc_week"
                                               :label="$t('ads.condition_label.cpc_ad_week')"></el-option>
                                    <el-option value="cpc_month"
                                               :label="$t('ads.condition_label.cpc_ad_month')"></el-option>
                                    <el-option value="cpc_campaign_today"
                                               :label="$t('ads.condition_label.cpc_campaign_today')"></el-option>
                                    <el-option value="cpc_campaign_week"
                                               :label="$t('ads.condition_label.cpc_campaign_month')"></el-option>
                                    <el-option value="cpc_campaign_month"
                                               :label="$t('ads.condition_label.cpc_campaign_month')"></el-option>
                                    <!--                              <el-option value="cpc_shop_today"-->
                                    <!--                                         :label="$t('ads.condition_label.cpc_shop_today')"></el-option>-->
                                    <!--                              <el-option value="cpc_shop_week"-->
                                    <!--                                         :label="$t('ads.condition_label.cpc_shop_week')"></el-option>-->
                                    <!--                              <el-option value="cpc_shop_month"-->
                                    <!--                                         :label="$t('ads.condition_label.cpc_shop_month')"></el-option>-->
                                  </el-select>
                                </div>

                                <div v-if="['increase', 'reduce'].includes(action.action_placement_2)"
                                     style="flex: 1; min-width: 182px">
                                  <el-input size="mini" type="number"
                                            v-model="action.update_price_value_placement_2"></el-input>
                                  <br>
                                  <br>
                                  <el-input v-if="action.action_placement_2 === 'increase'" type="number" size="mini"
                                            v-model="action.update_max_price_placement_2"></el-input>
                                  <el-input v-if="action.action_placement_2 === 'reduce'" type="number" size="mini"
                                            v-model="action.update_min_price_placement_2"></el-input>
                                </div>

                                <div v-if="['cpc'].includes(action.action_placement_2)"
                                     style="flex: 1; min-width: 182px">
                                  <el-select size="mini" value="" v-model="action.cpc_type_placement_2">
                                    <el-option value="keyword_past7days"
                                               :label="$t('ads.ad_cpc_past7days')"></el-option>
                                    <el-option value="keyword_past30days"
                                               :label="$t('ads.ad_cpc_past30days')"></el-option>
                                    <el-option value="keyword"
                                               :label="$t('ads.ad_cpc_optional')"></el-option>
                                    <el-option value="campaign_past7days"
                                               :label="$t('ads.campaign_cpc_past7days')"></el-option>
                                    <el-option value="campaign_past30days"
                                               :label="$t('ads.campaign_cpc_past30days')"></el-option>
                                    <el-option value="campaign"
                                               :label="$t('ads.campaign_cpc_optional')"></el-option>
                                  </el-select>
                                </div>
                                <div
                                  v-if="['cpc'].includes(action.action_placement_2) && array_to_set(['keyword', 'campaign']).has(action.cpc_type_placement_2)"
                                  style="flex: 1; max-width: 200px">
                                  <el-date-picker
                                    v-model="action.cpc_range_placement_2" type="daterange" range-separator="-"
                                    :start-placeholder="$t('base.start_time')" :end-placeholder="$t('base.end_time')"
                                    size="mini" format="dd-MM-yyyy"
                                    :clearable="false" :picker-options="picker_options">
                                  </el-date-picker>
                                </div>

                                <div v-if="['value'].includes(action.action_placement_2)"
                                     style="flex: 1; min-width: 182px">
                                  <el-input size="mini" type="number"
                                            v-model="action.update_price_value_placement_2"></el-input>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div v-if="action.type === 'placement_5'">
                            <div style="display: flex; gap: 10px; margin-bottom: 20px">
                              <div style="width: 160px; padding-top: 8px">
                                {{ $t('base.you_may_also_like') }}
                              </div>
                              <div style="display: flex; gap: 10px">
                                <div style="flex: 1; min-width: 182px">
                                  <el-select size="mini" value="" v-model="action.action_placement_5">
                                    <el-option value="" :label="$t('base.do_nothing')"></el-option>
                                    <el-option value="value" :label="$t('base.set_bid_price')"></el-option>
                                    <el-option value="increase" :label="$t('base.increase_bid_price')"></el-option>
                                    <el-option value="reduce" :label="$t('base.decrease_bid_price')"></el-option>
                                    <el-option value="cpc" :label="$t('base.set_by_cpc')"></el-option>
                                    <el-option value="ongoing" :label="$t('base.resume_ad')"></el-option>
                                    <el-option value="pause" :label="$t('base.pause_ad')"></el-option>
                                    <el-option value="start" :label="$t('base.use_starting_bid_price')"></el-option>
                                  </el-select>

                                  <br v-if="['increase', 'reduce'].includes(action.action_placement_5)"
                                      style="flex: 1; min-width: 182px">
                                  <br v-if="['increase', 'reduce'].includes(action.action_placement_5)"
                                      style="flex: 1; min-width: 182px">
                                  <span v-if="action.action_placement_5 === 'increase'">
                                    {{ $t('base.max_bid_price') }}
                                  </span>
                                  <span v-if="action.action_placement_5 === 'reduce'">
                                    {{ $t('base.min_bid_price') }}
                                  </span>
                                </div>

                                <div v-if="['increase', 'reduce'].includes(action.action_placement_5)"
                                     style="flex: 1; min-width: 182px">
                                  <el-select size="mini" value="" v-model="action.update_price_type_placement_5">
                                    <el-option value="value" :label="$t('base.by_amount')"></el-option>
                                    <el-option value="percent" :label="$t('base.by_percent')"></el-option>
                                  </el-select>
                                  <br>
                                  <br>
                                  <el-select v-if="action.action_placement_5 === 'increase'" value="" size="mini"
                                             v-model="action.update_type_max_price_placement_5">
                                    <el-option value="value" :label="$t('base.by_amount')"></el-option>
                                    <el-option value="cpc_today"
                                               :label="$t('ads.condition_label.cpc_ad_today')"></el-option>
                                    <el-option value="cpc_week"
                                               :label="$t('ads.condition_label.cpc_ad_week')"></el-option>
                                    <el-option value="cpc_month"
                                               :label="$t('ads.condition_label.cpc_month')"></el-option>
                                    <el-option value="cpc_campaign_today"
                                               :label="$t('ads.condition_label.cpc_campaign_today')"></el-option>
                                    <el-option value="cpc_campaign_week"
                                               :label="$t('ads.condition_label.cpc_campaign_month')"></el-option>
                                    <el-option value="cpc_campaign_month"
                                               :label="$t('ads.condition_label.cpc_campaign_month')"></el-option>
                                    <!--                              <el-option value="cpc_shop_today"-->
                                    <!--                                         :label="$t('ads.condition_label.cpc_shop_today')"></el-option>-->
                                    <!--                              <el-option value="cpc_shop_week"-->
                                    <!--                                         :label="$t('ads.condition_label.cpc_shop_week')"></el-option>-->
                                    <!--                              <el-option value="cpc_shop_month"-->
                                    <!--                                         :label="$t('ads.condition_label.cpc_shop_month')"></el-option>-->
                                  </el-select>
                                  <el-select v-if="action.action_placement_5 === 'reduce'" value="" size="mini"
                                             v-model="action.update_type_min_price_placement_5">
                                    <el-option value="value" :label="$t('base.by_amount')"></el-option>
                                    <el-option value="cpc_today"
                                               :label="$t('ads.condition_label.cpc_ad_today')"></el-option>
                                    <el-option value="cpc_week"
                                               :label="$t('ads.condition_label.cpc_ad_week')"></el-option>
                                    <el-option value="cpc_month"
                                               :label="$t('ads.condition_label.cpc_ad_month')"></el-option>
                                    <el-option value="cpc_campaign_today"
                                               :label="$t('ads.condition_label.cpc_campaign_today')"></el-option>
                                    <el-option value="cpc_campaign_week"
                                               :label="$t('ads.condition_label.cpc_campaign_month')"></el-option>
                                    <el-option value="cpc_campaign_month"
                                               :label="$t('ads.condition_label.cpc_campaign_month')"></el-option>
                                    <!--                              <el-option value="cpc_shop_today"-->
                                    <!--                                         :label="$t('ads.condition_label.cpc_shop_today')"></el-option>-->
                                    <!--                              <el-option value="cpc_shop_week"-->
                                    <!--                                         :label="$t('ads.condition_label.cpc_shop_week')"></el-option>-->
                                    <!--                              <el-option value="cpc_shop_month"-->
                                    <!--                                         :label="$t('ads.condition_label.cpc_shop_month')"></el-option>-->
                                  </el-select>
                                </div>

                                <div v-if="['increase', 'reduce'].includes(action.action_placement_5)"
                                     style="flex: 1; min-width: 182px">
                                  <el-input size="mini" type="number"
                                            v-model="action.update_price_value_placement_5"></el-input>
                                  <br>
                                  <br>
                                  <el-input v-if="action.action_placement_5 === 'increase'" type="number" size="mini"
                                            v-model="action.update_max_price_placement_5"></el-input>
                                  <el-input v-if="action.action_placement_5 === 'reduce'" type="number" size="mini"
                                            v-model="action.update_min_price_placement_5"></el-input>
                                </div>

                                <div v-if="['cpc'].includes(action.action_placement_5)"
                                     style="flex: 1; min-width: 182px">
                                  <el-select size="mini" value="" v-model="action.cpc_type_placement_5">
                                    <el-option value="keyword_past7days"
                                               :label="$t('ads.ad_cpc_past7days')"></el-option>
                                    <el-option value="keyword_past30days"
                                               :label="$t('ads.ad_cpc_past30days')"></el-option>
                                    <el-option value="keyword"
                                               :label="$t('ads.ad_cpc_optional')"></el-option>
                                    <el-option value="campaign_past7days"
                                               :label="$t('ads.campaign_cpc_past7days')"></el-option>
                                    <el-option value="campaign_past30days"
                                               :label="$t('ads.campaign_cpc_past30days')"></el-option>
                                    <el-option value="campaign"
                                               :label="$t('ads.campaign_cpc_optional')"></el-option>
                                  </el-select>
                                </div>
                                <div
                                  v-if="['cpc'].includes(action.action_placement_5) && array_to_set(['keyword', 'campaign']).has(action.cpc_type_placement_5)"
                                  style="flex: 1; max-width: 200px">
                                  <el-date-picker
                                    v-model="action.cpc_range_placement_5" type="daterange" range-separator="-"
                                    :start-placeholder="$t('base.start_time')" :end-placeholder="$t('base.end_time')"
                                    size="mini" format="dd-MM-yyyy"
                                    :clearable="false" :picker-options="picker_options">
                                  </el-date-picker>
                                </div>

                                <div v-if="['value'].includes(action.action_placement_5)"
                                     style="flex: 1; min-width: 182px">
                                  <el-input size="mini" type="number"
                                            v-model="action.update_price_value_placement_5"></el-input>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div style="flex: 1; text-align: right">
                          <el-button type="danger" size="mini" icon="el-icon-delete"
                                     @click="m__remove_action(item.actions, action_index)"></el-button>
                        </div>
                      </div>

                      <el-dropdown trigger="click">
                        <el-button type="text" size="mini">
                          <strong class="text-primary" style="font-size:13px">
                            <i class="el-icon-plus text-primary"></i>
                            {{ $t('base.add_x', { x: $t('base.action') }) }}
                          </strong>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item @click.native="m__add_action(item, 'campaign')">
                            {{ $t('base.campaign') }}
                          </el-dropdown-item>
                          <el-dropdown-item @click.native="m__add_action(item, 'match_type_0')">
                            {{ $t('keyword.exact') }}
                          </el-dropdown-item>
                          <el-dropdown-item @click.native="m__add_action(item, 'match_type_1')">
                            {{ $t('keyword.broad') }}
                          </el-dropdown-item>
                          <el-dropdown-item @click.native="m__add_action(item, 'placement_2')">
                            {{ $t('base.daily_discover') }}
                          </el-dropdown-item>
                          <el-dropdown-item @click.native="m__add_action(item, 'placement_5')">
                            {{ $t('base.you_may_also_like') }}
                          </el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                  </div>
                  <div style="margin-top: 20px; display: flex">
                    <div style="flex: 1; min-width: 182px">
                      <el-input size="mini" v-model="item.note" class="unset-left"
                                :placeholder="'Nhập ghi chú cho cấu hình'">
                        <template slot="prepend">{{ $t('base.note') }}</template>
                      </el-input>
                    </div>
                    <div style="flex: 1; text-align: right">
                      <el-button v-if="$store.state.userInfo.username === 'vuducminhdev07'" type="info" size="mini"
                                 icon="el-icon-upload"
                                 @click="copy_text(JSON.stringify(item))"></el-button>
                      <el-button type="info" size="mini" icon="el-icon-copy-document"
                                 @click="m__copy_condition_action_item(item, ca_index)"></el-button>
                    </div>
                  </div>
                  <span
                    v-if="condition_action_list.length > 1"
                    style="position: absolute; top: 10px; right: 15px; cursor: pointer"
                    @click="m__remove_condition_action(ca_index)">
                    <i class="el-icon-close" style="font-size: 16px"></i>
                  </span>
                </div>
              </div>
              <div>
                <el-button type="text" size="mini" @click="m__add_condition_action">
                  <strong class="text-primary" style="font-size: 14px">
                    <i class="el-icon-plus"></i> {{ $t('base.add_conditions_actions') }}</strong>
                </el-button>
              </div>

              <div style="margin-top: 30px">
                <div>
                  <strong style="font-size: 14px">
                    <i class="el-icon-s-tools"></i> {{ $t('base.setup_operation_rules') }}</strong>
                </div>

                <div style="margin-top: 20px">
                  <p class="text-title"> {{ $t('ads.configuration_active_day') }} </p>
                  <div style="display: flex; gap: 10px; margin-top: 10px">
                    <el-select v-model="form_auto_condition_action.advanced_day"
                               style="width: 200px" size="mini" value="" filterable>
                      <el-option value="flash_sale" :label="$t('day.flash_sale')"></el-option>
                      <el-option value="before_flash_sale" :label="$t('day.before_flash_sale')"></el-option>
                      <el-option value="after_flash_sale" :label="$t('day.after_flash_sale')"></el-option>
                      <el-option value="mini_spike_day" :label="$t('day.mini_spike_day')"></el-option>
                      <el-option value="day" :label="$t('day.specific_day')"></el-option>
                      <el-option value="remain" :label="$t('day.every_day')"></el-option>
                      <el-option value="exclude_sale" :label="$t('day.exclude_sale')"></el-option>
                      <el-option value="after_x_days" :label="$t('day.after_every')"></el-option>
                    </el-select>
                    <el-input
                      v-if="array_to_set(['before_flash_sale', 'after_flash_sale', 'day', 'after_x_days']).has(form_auto_condition_action.advanced_day)"
                      style="width: 200px" size="mini" type="number" :label="$t('input.day_numbers')"
                      class="fix_input_append" v-model="form_auto_condition_action.advanced_day_number"
                      :disabled="array_to_set(['mini_spike_day', 'flash_sale', 'remain', 'exclude_sale']).has(form_auto_condition_action.advanced_day)">
                      <template
                        v-if="array_to_set(['before_flash_sale', 'after_flash_sale', 'after_x_days']).has(form_auto_condition_action.advanced_day)"
                        slot="append">{{ $t('base.days') }}
                      </template>
                    </el-input>
                  </div>
                </div>

                <div style="margin-top: 30px">
                  <p class="text-title">{{ $t('ads.activity_frequency') }}</p>

                  <div style="margin-top: 20px">
                    <div>
                      <el-radio v-model="form_auto_condition_action.radio" label="1">Liên tục mỗi 30 phút</el-radio>
                    </div>
                    <div>
                      {{ $t('ads.each_30_minutes') }}
                    </div>
                  </div>

                  <div style="margin-top: 20px">
                    <div>
                      <el-radio v-model="form_auto_condition_action.radio" label="1.1">Liên tục mỗi 1 tiếng</el-radio>
                    </div>
                    <div>
                      {{ 'Chạy quy tắc 1 tiếng một lần và mỗi lần chạy sẽ mất chút thời gian.' }}
                    </div>
                  </div>

                  <div style="margin-top: 30px">
                    <div>
                      <el-radio v-model="form_auto_condition_action.radio" label="2">
                        {{ $t('base.optional') }}
                      </el-radio>
                    </div>
                    <div>
                      {{ $t('ads.each_30_minutes_with_specific') }}
                    </div>
                    <div v-if="form_auto_condition_action.radio === '2'" style="margin-top: 20px">
                      <ComponentCustomTimePicker :value.sync="form_auto_condition_action.times"
                                                 :show_period="true"></ComponentCustomTimePicker>
                    </div>
                  </div>

                  <div v-if="false" style="margin-top: 30px">
                    <div>
                      <el-radio v-model="form_auto_condition_action.radio" label="2.1">
                        {{ $t('base.optional') }}
                      </el-radio>
                    </div>
                    <div>
                      {{ 'Chạy quy tắc 1 tiếng một lần vào khoảng thời gian cụ thể.' }}
                    </div>
                    <div v-if="form_auto_condition_action.radio === '2.1'" style="margin-top: 20px">
                      <ComponentCustomTimePicker :value.sync="form_auto_condition_action.times">
                      </ComponentCustomTimePicker>
                    </div>
                  </div>

                  <div style="margin-top: 30px">
                    <div>
                      <el-radio v-model="form_auto_condition_action.radio" label="3">
                        {{ $t('base.once_a_day') }}
                      </el-radio>
                    </div>
                    <div>
                      {{ $t('ads.once_a_day') }}
                    </div>

                    <div v-if="form_auto_condition_action.radio === '3'" style="margin-top: 20px">
                      <el-time-select
                        style="width: 200px"
                        v-model="form_auto_condition_action.time"
                        size="mini"
                        :picker-options="{start: '00:00',step: '00:15',end: '24:00'}"
                        :placeholder="$t('select.time')">
                      </el-time-select>
                    </div>
                  </div>

                  <template v-if="array_to_set(auto_condition_action_fixed_list).has($store.state.userInfo.username)">
                    <div style="margin-top: 30px">
                      <div>
                        <el-radio v-model="form_auto_condition_action.radio" label="4">
                          <!--                          {{ $t('day.flash_sale') }} ({{ $t('base.advanced') }})-->
                          Cài đặt nâng cao Atosa
                        </el-radio>
                      </div>
                      <div>
                        <!--                        {{ $t('ads.each_5_minutes_on_flash_sale_day') }}-->
                        Chạy quy tắc 10 phút một lần theo khung thời gian chỉ định.
                      </div>
                    </div>

                    <div v-if="form_auto_condition_action.radio === '4'" style="margin-top: 20px">
                      <ComponentCustomTimePicker
                        :value.sync="form_auto_condition_action.times"></ComponentCustomTimePicker>
                    </div>
                  </template>

                  <template
                    v-if="array_to_set(advanced_auto_condition_action_fixed_list).has($store.state.userInfo.username)">
                    <div style="margin-top: 30px">
                      <el-radio v-model="form_auto_condition_action.radio" label="5">
                        {{ $t('base.advanced_settings') }} 1
                      </el-radio>
                    </div>
                    <div>
                      {{ $t('ads.advanced_auto_condition_action_note') }}
                    </div>
                    <div style="margin-top: 30px">
                      <el-radio v-model="form_auto_condition_action.radio" label="6">
                        {{ $t('base.advanced_settings') }} 2
                      </el-radio>
                    </div>
                    <div>
                      {{ $t('ads.advanced_auto_condition_action_note_2') }}
                    </div>

                    <div v-if="form_auto_condition_action.radio === '6'" style="margin-top: 20px">
                      <el-time-select
                        style="width: 200px"
                        v-model="form_auto_condition_action.start_time"
                        size="mini"
                        :picker-options="{start: '00:00',step: '00:15',end: '24:00'}"
                        :placeholder="$t('base.start_hour')">
                      </el-time-select>
                      <el-time-select
                        style="width: 200px"
                        v-model="form_auto_condition_action.end_time"
                        size="mini"
                        :picker-options="{start: '00:00',step: '00:15',end: '24:00'}"
                        :placeholder="$t('base.end_hour')">
                      </el-time-select>
                    </div>

                    <div style="margin-top: 30px">
                      <el-radio v-model="form_auto_condition_action.radio" label="7">
                        {{ $t('base.advanced_settings') }} 3
                      </el-radio>
                    </div>
                    <div>
                      {{ $t('ads.advanced_auto_condition_action_note_3') }}
                    </div>

                    <div v-if="form_auto_condition_action.radio === '7'" style="margin-top: 20px">
                      <el-time-select
                        style="width: 200px"
                        v-model="form_auto_condition_action.start_time"
                        size="mini"
                        :picker-options="{start: '00:00',step: '00:15',end: '24:00'}"
                        :placeholder="$t('base.start_hour')">
                      </el-time-select>
                      <el-time-select
                        style="width: 200px"
                        v-model="form_auto_condition_action.end_time"
                        size="mini"
                        :picker-options="{start: '00:00',step: '00:15',end: '24:00'}"
                        :placeholder="$t('base.end_hour')">
                      </el-time-select>
                    </div>
                  </template>
                </div>

                <div v-if="['2'].includes(form_auto_condition_action.radio)" id="not-in" style="margin-top: 30px">
                  <p class="text-title">{{ $t('base.set_when_outside_runtime') }}</p>

                  <div style="margin-top: 20px">
                    <div
                      style="display: flex; gap: 10px; margin-bottom: 20px">
                      <div style="width: 200px">
                        {{ $t('base.campaign') }}
                      </div>
                      <div style="display: flex; gap: 10px">
                        <div style="flex: 1; min-width: 182px">
                          <el-select size="mini" value="" v-model="form_auto_condition_action.not_in.action_campaign">
                            <el-option value="" :label="$t('base.do_nothing')"></el-option>
                            <el-option value="value" :label="$t('base.set_budget')"></el-option>
                            <el-option value="increase" :label="$t('base.increase_budget')"></el-option>
                            <el-option value="reduce" :label="$t('base.decrease_budget')"></el-option>
                            <el-option value="ongoing" :label="$t('base.resume_campaign')"></el-option>
                            <el-option value="pause" :label="$t('base.pause_campaign')"></el-option>
                            <el-option value="clone" :label="$t('base.clone_campaign')"></el-option>
                            <el-option value="set_by_cost" :label="$t('base.set_budget_by_realtime_cost')"></el-option>
                          </el-select>

                          <br v-if="['increase', 'reduce'].includes(form_auto_condition_action.not_in.action_campaign)"
                              style="flex: 1; min-width: 182px">
                          <br v-if="['increase', 'reduce'].includes(form_auto_condition_action.not_in.action_campaign)"
                              style="flex: 1; min-width: 182px">
                          <span v-if="form_auto_condition_action.not_in.action_campaign === 'increase'">
                            {{ $t('base.max_budget') }}
                          </span>
                          <span v-if="form_auto_condition_action.not_in.action_campaign === 'reduce'">
                            {{ $t('base.min_budget') }}
                          </span>
                        </div>

                        <div v-if="['increase', 'reduce'].includes(form_auto_condition_action.not_in.action_campaign)"
                             style="flex: 1; min-width: 182px">
                          <el-select size="mini" value=""
                                     v-model="form_auto_condition_action.not_in.update_price_type_campaign">
                            <el-option value="value" :label="$t('base.by_amount')"></el-option>
                            <el-option value="percent" :label="$t('base.by_percent')"></el-option>
                          </el-select>

                          <br>
                          <br>
                          <el-input v-if="form_auto_condition_action.not_in.action_campaign === 'increase'"
                                    type="number" size="mini"
                                    v-model="form_auto_condition_action.not_in.update_max_price_campaign"></el-input>
                          <el-input v-if="form_auto_condition_action.not_in.action_campaign === 'reduce'"
                                    type="number" size="mini"
                                    v-model="form_auto_condition_action.not_in.update_min_price_campaign"></el-input>
                        </div>

                        <div
                          v-if="['value', 'increase', 'reduce'].includes(form_auto_condition_action.not_in.action_campaign)"
                          style="flex: 1; min-width: 182px">
                          <el-input size="mini" type="number"
                                    v-model="form_auto_condition_action.not_in.update_price_value_campaign"></el-input>
                        </div>

                        <el-date-picker
                          v-if="form_auto_condition_action.not_in.action_campaign === 'cpc'"
                          style="flex: 1; min-width: 182px"
                          v-model="form_auto_condition_action.not_in.cpc_range_campaign"
                          type="daterange" range-separator="-"
                          :start-placeholder="$t('base.start_time')" :end-placeholder="$t('base.end_time')" size="mini"
                          format="dd-MM-yyyy"
                          :clearable="false" :picker-options="picker_options">
                        </el-date-picker>
                        <el-date-picker
                          v-if="form_auto_condition_action.not_in.action_campaign === 'cpc'"
                          style="flex: 1; min-width: 182px"
                          v-model="form_auto_condition_action.not_in.cpc_range_campaign"
                          type="daterange" range-separator="-"
                          :start-placeholder="$t('base.start_time')" :end-placeholder="$t('base.end_time')" size="mini"
                          format="dd-MM-yyyy"
                          :clearable="false" :picker-options="picker_options">
                        </el-date-picker>
                      </div>
                    </div>

                    <div
                      style="display: flex; gap: 10px; margin-bottom: 20px">
                      <div style="width: 200px">
                        {{ $t('keyword.exact') }}
                      </div>
                      <div style="display: flex; gap: 10px">
                        <div style="flex: 1; min-width: 182px">
                          <el-select size="mini" value=""
                                     v-model="form_auto_condition_action.not_in.action_match_type_0">
                            <el-option value="" :label="$t('base.do_nothing')"></el-option>
                            <el-option value="value" :label="$t('base.set_bid_price')"></el-option>
                            <el-option value="increase" :label="$t('base.increase_bid_price')"></el-option>
                            <el-option value="reduce" :label="$t('base.decrease_bid_price')"></el-option>
                            <el-option value="cpc" :label="$t('base.set_by_cpc')"></el-option>
                            <el-option value="match_type_1" :label="$t('base.change_to_broad')"></el-option>
                            <el-option value="ongoing" :label="$t('base.resume_keyword')"></el-option>
                            <el-option value="pause" :label="$t('base.pause_keyword')"></el-option>
                            <el-option value="start" :label="$t('base.use_starting_bid_price')"></el-option>
                          </el-select>

                          <br
                            v-if="['increase', 'reduce'].includes(form_auto_condition_action.not_in.action_match_type_0)"
                            style="flex: 1; min-width: 182px">
                          <br
                            v-if="['increase', 'reduce'].includes(form_auto_condition_action.not_in.action_match_type_0)"
                            style="flex: 1; min-width: 182px">
                          <span v-if="form_auto_condition_action.not_in.action_match_type_0 === 'increase'">
                            {{ $t('base.max_bid_price') }}
                          </span>
                          <span v-if="form_auto_condition_action.not_in.action_match_type_0 === 'reduce'">
                            {{ $t('base.min_bid_price') }}
                          </span>
                        </div>

                        <div
                          v-if="['increase', 'reduce'].includes(form_auto_condition_action.not_in.action_match_type_0)"
                          style="flex: 1; min-width: 182px">
                          <el-select size="mini" value=""
                                     v-model="form_auto_condition_action.not_in.update_price_type_match_type_0">
                            <el-option value="value" :label="$t('base.by_amount')"></el-option>
                            <el-option value="percent" :label="$t('base.by_percent')"></el-option>
                          </el-select>
                          <br>
                          <br>
                          <el-select v-if="form_auto_condition_action.not_in.action_match_type_0 === 'increase'"
                                     value="" size="mini"
                                     v-model="form_auto_condition_action.not_in.update_type_max_price_match_type_0">
                            <el-option value="value" :label="$t('base.by_amount')"></el-option>
                          </el-select>
                          <el-select v-if="form_auto_condition_action.not_in.action_match_type_0 === 'reduce'" value=""
                                     size="mini"
                                     v-model="form_auto_condition_action.not_in.update_type_min_price_match_type_0">
                            <el-option value="value" :label="$t('base.by_amount')"></el-option>
                          </el-select>
                        </div>

                        <div
                          v-if="['increase', 'reduce'].includes(form_auto_condition_action.not_in.action_match_type_0)"
                          style="flex: 1; min-width: 182px">
                          <el-input size="mini" type="number"
                                    v-model="form_auto_condition_action.not_in.update_price_value_match_type_0"></el-input>
                          <br>
                          <br>
                          <el-input v-if="form_auto_condition_action.not_in.action_match_type_0 === 'increase'"
                                    type="number" size="mini"
                                    v-model="form_auto_condition_action.not_in.update_max_price_match_type_0"></el-input>
                          <el-input v-if="form_auto_condition_action.not_in.action_match_type_0 === 'reduce'"
                                    type="number" size="mini"
                                    v-model="form_auto_condition_action.not_in.update_min_price_match_type_0"></el-input>
                        </div>

                        <div v-if="['cpc'].includes(form_auto_condition_action.not_in.action_match_type_0)"
                             style="flex: 1; min-width: 182px">
                          <el-select size="mini" value=""
                                     v-model="form_auto_condition_action.not_in.cpc_type_match_type_0">
                            <el-option value="keyword_past7days"
                                       :label="$t('ads.keyword_cpc_past7days')"></el-option>
                            <el-option value="keyword_past30days"
                                       :label="$t('ads.keyword_cpc_past30days')"></el-option>
                            <el-option value="keyword"
                                       :label="$t('ads.keyword_cpc_optional')"></el-option>
                            <el-option value="campaign_past7days"
                                       :label="$t('ads.campaign_cpc_past7days')"></el-option>
                            <el-option value="campaign_past30days"
                                       :label="$t('ads.campaign_cpc_past30days')"></el-option>
                            <el-option value="campaign"
                                       :label="$t('ads.campaign_cpc_optional')"></el-option>
                          </el-select>
                        </div>
                        <div
                          v-if="['cpc'].includes(form_auto_condition_action.not_in.action_match_type_0) && array_to_set(['keyword', 'campaign']).has(form_auto_condition_action.not_in.cpc_type_match_type_0)"
                          style="flex: 1; max-width: 200px">
                          <el-date-picker
                            v-model="form_auto_condition_action.not_in.cpc_range_match_type_0" type="daterange"
                            range-separator="-"
                            :start-placeholder="$t('base.start_time')" :end-placeholder="$t('base.end_time')"
                            size="mini" format="dd-MM-yyyy"
                            :clearable="false" :picker-options="picker_options">
                          </el-date-picker>
                        </div>
                        <div v-if="['value'].includes(form_auto_condition_action.not_in.action_match_type_0)"
                             style="flex: 1; min-width: 182px">
                          <el-input size="mini" type="number"
                                    v-model="form_auto_condition_action.not_in.update_price_value_match_type_0"></el-input>
                        </div>
                      </div>
                    </div>

                    <div
                      style="display: flex; gap: 10px; margin-bottom: 20px">
                      <div style="width: 200px">
                        {{ $t('keyword.broad') }}
                      </div>
                      <div style="display: flex; gap: 10px">
                        <div style="flex: 1; min-width: 182px">
                          <el-select size="mini" value=""
                                     v-model="form_auto_condition_action.not_in.action_match_type_1">
                            <el-option value="" :label="$t('base.do_nothing')"></el-option>
                            <el-option value="value" :label="$t('base.set_bid_price')"></el-option>
                            <el-option value="increase" :label="$t('base.increase_bid_price')"></el-option>
                            <el-option value="reduce" :label="$t('base.decrease_bid_price')"></el-option>
                            <el-option value="cpc" :label="$t('base.set_by_cpc')"></el-option>
                            <el-option value="match_type_0" :label="$t('base.change_to_exact')"></el-option>
                            <el-option value="ongoing" :label="$t('base.resume_keyword')"></el-option>
                            <el-option value="pause" :label="$t('base.pause_keyword')"></el-option>
                            <el-option value="start" :label="$t('base.use_starting_bid_price')"></el-option>
                          </el-select>

                          <br
                            v-if="['increase', 'reduce'].includes(form_auto_condition_action.not_in.action_match_type_1)"
                            style="flex: 1; min-width: 182px">
                          <br
                            v-if="['increase', 'reduce'].includes(form_auto_condition_action.not_in.action_match_type_1)"
                            style="flex: 1; min-width: 182px">
                          <span v-if="form_auto_condition_action.not_in.action_match_type_1 === 'increase'">
                            {{ $t('base.max_bid_price') }}
                          </span>
                          <span v-if="form_auto_condition_action.not_in.action_match_type_1 === 'reduce'">
                            {{ $t('base.min_bid_price') }}
                          </span>
                        </div>

                        <div
                          v-if="['increase', 'reduce'].includes(form_auto_condition_action.not_in.action_match_type_1)"
                          style="flex: 1; min-width: 182px">
                          <el-select size="mini" value=""
                                     v-model="form_auto_condition_action.not_in.update_price_type_match_type_1">
                            <el-option value="value" :label="$t('base.by_amount')"></el-option>
                            <el-option value="percent" :label="$t('base.by_percent')"></el-option>
                          </el-select>
                          <br>
                          <br>
                          <el-select v-if="form_auto_condition_action.not_in.action_match_type_1 === 'increase'"
                                     value="" size="mini"
                                     v-model="form_auto_condition_action.not_in.update_type_max_price_match_type_1">
                            <el-option value="value" :label="$t('base.by_amount')"></el-option>
                          </el-select>
                          <el-select v-if="form_auto_condition_action.not_in.action_match_type_1 === 'reduce'" value=""
                                     size="mini"
                                     v-model="form_auto_condition_action.not_in.update_type_min_price_match_type_1">
                            <el-option value="value" :label="$t('base.by_amount')"></el-option>
                          </el-select>
                        </div>

                        <div
                          v-if="['increase', 'reduce'].includes(form_auto_condition_action.not_in.action_match_type_1)"
                          style="flex: 1; min-width: 182px">
                          <el-input size="mini" type="number"
                                    v-model="form_auto_condition_action.not_in.update_price_value_match_type_1"></el-input>
                          <br>
                          <br>
                          <el-input v-if="form_auto_condition_action.not_in.action_match_type_1 === 'increase'"
                                    type="number" size="mini"
                                    v-model="form_auto_condition_action.not_in.update_max_price_match_type_1"></el-input>
                          <el-input v-if="form_auto_condition_action.not_in.action_match_type_1 === 'reduce'"
                                    type="number" size="mini"
                                    v-model="form_auto_condition_action.not_in.update_min_price_match_type_1"></el-input>
                        </div>

                        <div v-if="['cpc'].includes(form_auto_condition_action.not_in.action_match_type_1)"
                             style="flex: 1; min-width: 182px">
                          <el-select size="mini" value=""
                                     v-model="form_auto_condition_action.not_in.cpc_type_match_type_1">
                            <el-option value="keyword_past7days"
                                       :label="$t('ads.keyword_cpc_past7days')"></el-option>
                            <el-option value="keyword_past30days"
                                       :label="$t('ads.keyword_cpc_past30days')"></el-option>
                            <el-option value="keyword"
                                       :label="$t('ads.keyword_cpc_optional')"></el-option>
                            <el-option value="campaign_past7days"
                                       :label="$t('ads.campaign_cpc_past7days')"></el-option>
                            <el-option value="campaign_past30days"
                                       :label="$t('ads.campaign_cpc_past30days')"></el-option>
                            <el-option value="campaign"
                                       :label="$t('ads.campaign_cpc_optional')"></el-option>
                          </el-select>
                        </div>
                        <div
                          v-if="['cpc'].includes(form_auto_condition_action.not_in.action_match_type_1) && array_to_set(['keyword', 'campaign']).has(form_auto_condition_action.not_in.cpc_type_match_type_1)"
                          style="flex: 1; max-width: 200px">
                          <el-date-picker
                            v-model="form_auto_condition_action.not_in.cpc_range_match_type_1" type="daterange"
                            range-separator="-"
                            :start-placeholder="$t('base.start_time')" :end-placeholder="$t('base.end_time')"
                            size="mini" format="dd-MM-yyyy"
                            :clearable="false" :picker-options="picker_options">
                          </el-date-picker>
                        </div>
                        <div v-if="['value'].includes(form_auto_condition_action.not_in.action_match_type_1)"
                             style="flex: 1; min-width: 182px">
                          <el-input size="mini" type="number"
                                    v-model="form_auto_condition_action.not_in.update_price_value_match_type_1"></el-input>
                        </div>
                      </div>
                    </div>

                    <div
                      style="display: flex; gap: 10px; margin-bottom: 20px">
                      <div style="width: 200px">
                        {{ $t('base.daily_discover') }}
                      </div>
                      <div style="display: flex; gap: 10px">
                        <div style="flex: 1; min-width: 182px">
                          <el-select size="mini" value=""
                                     v-model="form_auto_condition_action.not_in.action_placement_2">
                            <el-option value="" :label="$t('base.do_nothing')"></el-option>
                            <el-option value="value" :label="$t('base.set_bid_price')"></el-option>
                            <el-option value="increase" :label="$t('base.increase_bid_price')"></el-option>
                            <el-option value="reduce" :label="$t('base.decrease_bid_price')"></el-option>
                            <el-option value="cpc" :label="$t('base.set_by_cpc')"></el-option>
                            <el-option value="ongoing" :label="$t('base.resume_ad')"></el-option>
                            <el-option value="pause" :label="$t('base.pause_ad')"></el-option>
                            <el-option value="start" :label="$t('base.use_starting_bid_price')"></el-option>
                          </el-select>

                          <br
                            v-if="['increase', 'reduce'].includes(form_auto_condition_action.not_in.action_placement_2)"
                            style="flex: 1; min-width: 182px">
                          <br
                            v-if="['increase', 'reduce'].includes(form_auto_condition_action.not_in.action_placement_2)"
                            style="flex: 1; min-width: 182px">
                          <span v-if="form_auto_condition_action.not_in.action_placement_2 === 'increase'">
                            {{ $t('base.max_bid_price') }}
                          </span>
                          <span v-if="form_auto_condition_action.not_in.action_placement_2 === 'reduce'">
                            {{ $t('base.min_bid_price') }}
                          </span>
                        </div>

                        <div
                          v-if="['increase', 'reduce'].includes(form_auto_condition_action.not_in.action_placement_2)"
                          style="flex: 1; min-width: 182px">
                          <el-select size="mini" value=""
                                     v-model="form_auto_condition_action.not_in.update_price_type_placement_2">
                            <el-option value="value" :label="$t('base.by_amount')"></el-option>
                            <el-option value="percent" :label="$t('base.by_percent')"></el-option>
                          </el-select>
                          <br>
                          <br>
                          <el-select v-if="form_auto_condition_action.not_in.action_placement_2 === 'increase'" value=""
                                     size="mini"
                                     v-model="form_auto_condition_action.not_in.update_type_max_price_placement_2">
                            <el-option value="value" :label="$t('base.by_amount')"></el-option>
                          </el-select>
                          <el-select v-if="form_auto_condition_action.not_in.action_placement_2 === 'reduce'" value=""
                                     size="mini"
                                     v-model="form_auto_condition_action.not_in.update_type_min_price_placement_2">
                            <el-option value="value" :label="$t('base.by_amount')"></el-option>
                          </el-select>
                        </div>

                        <div
                          v-if="['increase', 'reduce'].includes(form_auto_condition_action.not_in.action_placement_2)"
                          style="flex: 1; min-width: 182px">
                          <el-input size="mini" type="number"
                                    v-model="form_auto_condition_action.not_in.update_price_value_placement_2"></el-input>
                          <br>
                          <br>
                          <el-input v-if="form_auto_condition_action.not_in.action_placement_2 === 'increase'"
                                    type="number" size="mini"
                                    v-model="form_auto_condition_action.not_in.update_max_price_placement_2"></el-input>
                          <el-input v-if="form_auto_condition_action.not_in.action_placement_2 === 'reduce'"
                                    type="number" size="mini"
                                    v-model="form_auto_condition_action.not_in.update_min_price_placement_2"></el-input>
                        </div>

                        <div v-if="['cpc'].includes(form_auto_condition_action.not_in.action_placement_2)"
                             style="flex: 1; min-width: 182px">
                          <el-select size="mini" value=""
                                     v-model="form_auto_condition_action.not_in.cpc_type_placement_2">
                            <el-option value="keyword_past7days"
                                       :label="$t('ads.ad_cpc_past7days')"></el-option>
                            <el-option value="keyword_past30days"
                                       :label="$t('ads.ad_cpc_past30days')"></el-option>
                            <el-option value="keyword"
                                       :label="$t('ads.ad_cpc_optional')"></el-option>
                            <el-option value="campaign_past7days"
                                       :label="$t('ads.campaign_cpc_past7days')"></el-option>
                            <el-option value="campaign_past30days"
                                       :label="$t('ads.campaign_cpc_past30days')"></el-option>
                            <el-option value="campaign"
                                       :label="$t('ads.campaign_cpc_optional')"></el-option>
                          </el-select>
                        </div>
                        <div
                          v-if="['cpc'].includes(form_auto_condition_action.not_in.action_placement_2) && array_to_set(['keyword', 'campaign']).has(form_auto_condition_action.not_in.cpc_type_placement_2)"
                          style="flex: 1; max-width: 200px">
                          <el-date-picker
                            v-model="form_auto_condition_action.not_in.cpc_range_placement_2" type="daterange"
                            range-separator="-"
                            :start-placeholder="$t('base.start_time')" :end-placeholder="$t('base.end_time')"
                            size="mini" format="dd-MM-yyyy"
                            :clearable="false" :picker-options="picker_options">
                          </el-date-picker>
                        </div>

                        <div v-if="['value'].includes(form_auto_condition_action.not_in.action_placement_2)"
                             style="flex: 1; min-width: 182px">
                          <el-input size="mini" type="number"
                                    v-model="form_auto_condition_action.not_in.update_price_value_placement_2"></el-input>
                        </div>
                      </div>
                    </div>

                    <div
                      style="display: flex; gap: 10px; margin-bottom: 20px">
                      <div style="width: 200px">
                        {{ $t('base.you_may_also_like') }}
                      </div>
                      <div style="display: flex; gap: 10px">
                        <div style="flex: 1; min-width: 182px">
                          <el-select size="mini" value=""
                                     v-model="form_auto_condition_action.not_in.action_placement_5">
                            <el-option value="" :label="$t('base.do_nothing')"></el-option>
                            <el-option value="value" :label="$t('base.set_bid_price')"></el-option>
                            <el-option value="increase" :label="$t('base.increase_bid_price')"></el-option>
                            <el-option value="reduce" :label="$t('base.decrease_bid_price')"></el-option>
                            <el-option value="cpc" :label="$t('base.set_by_cpc')"></el-option>
                            <el-option value="ongoing" :label="$t('base.resume_ad')"></el-option>
                            <el-option value="pause" :label="$t('base.pause_ad')"></el-option>
                            <el-option value="start" :label="$t('base.use_starting_bid_price')"></el-option>
                          </el-select>

                          <br
                            v-if="['increase', 'reduce'].includes(form_auto_condition_action.not_in.action_placement_5)"
                            style="flex: 1; min-width: 182px">
                          <br
                            v-if="['increase', 'reduce'].includes(form_auto_condition_action.not_in.action_placement_5)"
                            style="flex: 1; min-width: 182px">
                          <span v-if="form_auto_condition_action.not_in.action_placement_5 === 'increase'">
                            {{ $t('base.max_bid_price') }}
                          </span>
                          <span v-if="form_auto_condition_action.not_in.action_placement_5 === 'reduce'">
                            {{ $t('base.min_bid_price') }}
                          </span>
                        </div>

                        <div
                          v-if="['increase', 'reduce'].includes(form_auto_condition_action.not_in.action_placement_5)"
                          style="flex: 1; min-width: 182px">
                          <el-select size="mini" value=""
                                     v-model="form_auto_condition_action.not_in.update_price_type_placement_5">
                            <el-option value="value" :label="$t('base.by_amount')"></el-option>
                            <el-option value="percent" :label="$t('base.by_percent')"></el-option>
                          </el-select>
                          <br>
                          <br>
                          <el-select v-if="form_auto_condition_action.not_in.action_placement_5 === 'increase'" value=""
                                     size="mini"
                                     v-model="form_auto_condition_action.not_in.update_type_max_price_placement_5">
                            <el-option value="value" :label="$t('base.by_amount')"></el-option>
                          </el-select>
                          <el-select v-if="form_auto_condition_action.not_in.action_placement_5 === 'reduce'" value=""
                                     size="mini"
                                     v-model="form_auto_condition_action.not_in.update_type_min_price_placement_5">
                            <el-option value="value" :label="$t('base.by_amount')"></el-option>
                          </el-select>
                        </div>

                        <div
                          v-if="['increase', 'reduce'].includes(form_auto_condition_action.not_in.action_placement_5)"
                          style="flex: 1; min-width: 182px">
                          <el-input size="mini" type="number"
                                    v-model="form_auto_condition_action.not_in.update_price_value_placement_5"></el-input>
                          <br>
                          <br>
                          <el-input v-if="form_auto_condition_action.not_in.action_placement_5 === 'increase'"
                                    type="number" size="mini"
                                    v-model="form_auto_condition_action.not_in.update_max_price_placement_5"></el-input>
                          <el-input v-if="form_auto_condition_action.not_in.action_placement_5 === 'reduce'"
                                    type="number" size="mini"
                                    v-model="form_auto_condition_action.not_in.update_min_price_placement_5"></el-input>
                        </div>

                        <div v-if="['cpc'].includes(form_auto_condition_action.not_in.action_placement_5)"
                             style="flex: 1; min-width: 182px">
                          <el-select size="mini" value=""
                                     v-model="form_auto_condition_action.not_in.cpc_type_placement_5">
                            <el-option value="keyword_past7days"
                                       :label="$t('ads.ad_cpc_past7days')"></el-option>
                            <el-option value="keyword_past30days"
                                       :label="$t('ads.ad_cpc_past30days')"></el-option>
                            <el-option value="keyword"
                                       :label="$t('ads.ad_cpc_optional')"></el-option>
                            <el-option value="campaign_past7days"
                                       :label="$t('ads.campaign_cpc_past7days')"></el-option>
                            <el-option value="campaign_past30days"
                                       :label="$t('ads.campaign_cpc_past30days')"></el-option>
                            <el-option value="campaign"
                                       :label="$t('ads.campaign_cpc_optional')"></el-option>
                          </el-select>
                        </div>
                        <div
                          v-if="['cpc'].includes(form_auto_condition_action.not_in.action_placement_5) && array_to_set(['keyword', 'campaign']).has(form_auto_condition_action.not_in.cpc_type_placement_5)"
                          style="flex: 1; max-width: 200px">
                          <el-date-picker
                            v-model="form_auto_condition_action.not_in.cpc_range_placement_5" type="daterange"
                            range-separator="-"
                            :start-placeholder="$t('base.start_time')" :end-placeholder="$t('base.end_time')"
                            size="mini" format="dd-MM-yyyy"
                            :clearable="false" :picker-options="picker_options">
                          </el-date-picker>
                        </div>

                        <div v-if="['value'].includes(form_auto_condition_action.not_in.action_placement_5)"
                             style="flex: 1; min-width: 182px">
                          <el-input size="mini" type="number"
                                    v-model="form_auto_condition_action.not_in.update_price_value_placement_5"></el-input>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div style="margin-top: 30px">
                  <p class="text-title">{{ $t('base.config_name') }}</p>
                  <el-input style="width: 450px" size="mini" :placeholder="$t('input.config_name')"
                            v-model="form_auto_condition_action.name">
                  </el-input>
                </div>
              </div>
            </div>

            <div
              style="margin-top: 30px; margin-bottom: 5px; display: flex; gap: 30px; align-items: center; justify-content: right">
              <div v-if="auto_condition_action_state.type === 'update_file'"
                   style="display: flex; align-items: center; gap: 10px">
                <el-switch v-model="sync_to_applied_config"></el-switch>
                <span style="font-size: 13px">
                  {{ $t('base.sync_to_applied_config') }}
                </span>
              </div>

              <el-button v-if="auto_condition_action_state.type === 'add'"
                         type="primary" size="mini" icon="el-icon-check" @click="m__add_auto_condition_action_config">
                {{ $t('base.save_config') }}
              </el-button>
              <el-button
                v-if="auto_condition_action_state.type === 'update'"
                type="primary" size="mini" icon="el-icon-check" @click="m__update_auto_condition_action_config">
                {{ $t('base.save_config') }}
              </el-button>
              <el-button
                v-if="auto_condition_action_state.type === 'update_file'"
                type="primary" size="mini" icon="el-icon-check"
                :loading="loading.update_auto_condition_action_config_file"
                @click="m__update_auto_condition_action_config_file">
                {{ $t('base.update_config_file') }}
              </el-button>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-dialog>

    <el-dialog id="auto-condition-action" :visible.sync="show_dialog.auto_by_condition_list"
               :close-on-click-modal="false" width="1000px">
      <div slot="title" style="padding:10px">
        <el-row>
          <el-col :sm="24">
            <el-tabs v-model="auto_condition_action_tab">
              <el-tab-pane :label="$t('base.applying_config_list')" name="configs">
              </el-tab-pane>
              <el-tab-pane :label="$t('base.saved_config_list')" name="files">
              </el-tab-pane>
              <el-tab-pane :label="$t('base.installed_config_list')" name="list">
              </el-tab-pane>
            </el-tabs>
          </el-col>
        </el-row>

        <div v-if="auto_condition_action_tab === 'configs'">
          <div style="margin-top: 30px">
            <div>
              <strong style="font-size: 14px">
                <i class="el-icon-s-operation"></i> {{ $t('base.automatic_by_condition_configuration_list') }}
              </strong>
            </div>

            <template v-for="config in auto_condition_action_list.filter(i => i.config_list && i.config_list.length)">
              <div style="margin-top: 40px">
                <strong>🚀&nbsp; {{ spike_day_map(config, false) }}</strong>
                <strong v-if="spike_day_to_text(spike_days, config)">
                  - {{ spike_day_to_text(spike_days, config) }}
                </strong>
                <br>
                <br>
                <el-table :data="config.config_list">
                  <el-table-column :label="$t('ads.activity_frequency')">
                    <template slot-scope="scope">
                      <div v-if="scope.row.radio === '1'">
                        {{ $t('base.continuously') }}
                      </div>
                      <div v-if="scope.row.radio === '2'">
                        {{ $t('base.optional') }}
                        <div>
                          <template v-for="time in m__sort_time_object_ranges(scope.row.times)">
                            <div>
                              {{ time.start_time }} - {{ time.end_time }}
                            </div>
                          </template>
                        </div>
                      </div>
                      <div v-if="scope.row.radio === '3'">
                        {{ $t('base.once_a_day') }}
                        <div>
                          {{ $t('ads.from') }}: {{ scope.row.time }}
                        </div>
                      </div>
                      <div v-if="scope.row.radio === '4'">
                        <div>
                          {{ $t('base.advanced_settings') }} Atosa
                        </div>
                        <div>
                          <template v-for="time in m__sort_time_object_ranges(scope.row.times)">
                            <div>
                              {{ time.start_time }} - {{ time.end_time }}
                            </div>
                          </template>
                        </div>
                      </div>
                      <div v-if="scope.row.radio === '5'">
                        <div>
                          {{ $t('base.advanced_settings') }} 1
                        </div>
                        00:00 - 01:00
                      </div>
                      <div v-if="scope.row.radio === '6'">
                        <div>
                          {{ $t('base.advanced_settings') }} 2
                        </div>
                        {{ scope.row.start_time }} - {{ scope.row.end_time }}
                      </div>

                      <div v-if="scope.row.link_to" style="margin-top: 10px">
                        <el-tag type="primary" class="el-tag-multiple-row" @click="auto_condition_action_tab = 'files'">
                          {{ $t('base.link_to_file') }}: <br>
                          {{ m__get_auto_condition_action_filename(scope.row.link_to) }}
                        </el-tag>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('base.config_name')">
                    <template slot-scope="scope">
                      <div v-if="scope.row.name">{{ scope.row.name }}</div>
                      <div v-else>{{ $t('base.config') }} {{ scope.$index + 1 }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('base.condition_action_number')">
                    <template slot-scope="scope">
                      {{ scope.row.condition_action_list.length }}
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('base.status')" width="140px">
                    <template slot-scope="scope">
                      <el-switch
                        v-model="scope.row.enable"
                        active-color="#13ce66"
                        inactive-color="#b7b7b7"
                        :active-value="true"
                        :inactive-value="false">
                      </el-switch>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('base.optional')" width="100px" fixed="right">
                    <template slot-scope="scope">
                      <div style="display: flex; flex-direction: column; justify-content: end">
                        <el-button type="text" size="mini"
                                   @click="m__show_update_auto_condition_action_config_dialog(scope.row, scope.$index, config)">
                          <strong class="text-primary">{{ $t('base.edit') }}</strong>
                        </el-button>
                        <el-button type="text" size="mini"
                                   @click="m__show_duplicate_auto_condition_action_config_dialog(scope.row, scope.$index, config)">
                          <strong class="text-primary">{{ $t('base.copy') }}</strong>
                        </el-button>
                        <el-button v-if="!scope.row.link_to" type="text" size="mini"
                                   @click="m__show_save_auto_condition_action_file_dialog(scope.row, scope.$index, config)">
                          <strong class="text-primary">{{ $t('base.save_file') }}</strong>
                        </el-button>
                        <el-button type="text" size="mini"
                                   @click="m__delete_auto_condition_action_config(config, scope.$index)">
                          <strong class="text-danger" v-if="!scope.row.link_to">{{ $t('base.delete') }}</strong>
                          <strong class="text-danger" v-else>{{ 'Bỏ áp dụng' }}</strong>
                        </el-button>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </template>
          </div>

          <div v-if="auto_condition_action_list.filter(i => i.config_list && i.config_list.length).length"
               style="margin-top: 20px">
            <el-checkbox v-model="auto_condition_action_only_show_me">
              {{ $t('base.only_show_me') }}
            </el-checkbox>
          </div>

          <div style="margin-top: 50px; display: flex">
            <div>
              <el-button size="mini" @click="m__open_auto_condition_log_page()">
                {{ $t('base.view_activity_history') }}
              </el-button>
            </div>
            <div style="flex: 1; text-align: right">
              <el-button
                v-if="auto_condition_action_state.selected_item_id || auto_condition_action_state.selected_campaign_id"
                type="danger" size="mini" @click="m__delete_auto_condition_action">
                {{ $t('base.delete_config') }}
              </el-button>
              <el-button type="primary" size="mini" icon="el-icon-plus" @click="m__show_auto_by_condition_dialog">
                {{ $t('base.add_config') }}
              </el-button>
              <el-button type="primary" size="mini" icon="el-icon-check" @click="m__update_auto_condition_action"
                         :loading="loading.config_auto_optimize">
                {{ $t('base.save_config') }}
              </el-button>
            </div>
          </div>
        </div>

        <div v-if="auto_condition_action_tab === 'list'">
          <div style="margin-top: 30px">
            <div class="text-right">
              <el-input :placeholder="$t('input.placeholder')" suffix-icon="el-icon-search" style="width: 250px"
                        clearable
                        size="mini" v-model="auto_condition_action_search_keyword"></el-input>
            </div>

            <template v-for="config in c__all_auto_condition_action_config_list">
              <div style="margin-top: 40px">
                <div>
                  <strong v-if="config.type === 'product'" style="font-size: 13px">
                    {{ $t('base.product') }}: {{ config.product_name }}
                  </strong>
                  <strong v-if="config.type === 'campaign'" style="font-size: 13px">
                    {{ $t('base.campaign') }}: {{ config.campaign_detail ? config.campaign_detail.name : '' }}
                  </strong>
                </div>

                <el-table :data="config.config_list" style="margin-top: 20px">
                  <el-table-column :label="$t('ads.activity_frequency')">
                    <template slot-scope="scope">
                      <div>
                        <strong>{{ spike_day_map(scope.row, false) }}</strong>
                        <strong v-if="spike_day_to_text(spike_days, scope.row)">- {{
                            spike_day_to_text(spike_days, scope.row)
                          }}</strong>
                      </div>
                      <div v-if="scope.row.radio === '1'">
                        {{ $t('base.continuously') }}
                      </div>
                      <div v-if="scope.row.radio === '2'">
                        {{ $t('base.optional') }}
                        <div>
                          <template v-for="time in scope.row.times">
                            <div>
                              {{ time.start_time }} - {{ time.end_time }}
                            </div>
                          </template>
                        </div>
                      </div>
                      <div v-if="scope.row.radio === '3'">
                        {{ $t('base.once_a_day') }}
                        <div>
                          {{ $t('ads.from') }}: {{ scope.row.time }}
                        </div>
                      </div>
                      <div v-if="scope.row.radio === '4'">
                        {{ $t('day.flash_sale') }} ({{ $t('base.advanced') }})
                        <div>
                          00:00 - 01:00
                        </div>
                      </div>
                      <div v-if="scope.row.radio === '5'">
                        <div>
                          {{ $t('base.advanced_settings') }} 1
                        </div>
                        00:00 - 01:00
                      </div>
                      <div v-if="scope.row.radio === '6'">
                        <div>
                          {{ $t('base.advanced_settings') }} 2
                        </div>
                        {{ scope.row.start_time }} - {{ scope.row.end_time }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('base.config_name')">
                    <template slot-scope="scope">
                      <div v-if="scope.row.name">{{ scope.row.name }}</div>
                      <div v-else>{{ $t('base.config') }} {{ scope.$index + 1 }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('base.condition_action_number')">
                    <template slot-scope="scope">
                      {{ scope.row.condition_action_list.length }}
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('base.optional')" width="100px" fixed="right">
                    <template slot-scope="scope">
                      <el-button type="text" size="mini"
                                 @click="m__duplicate_auto_condition_action_from_object(scope.row)">
                        <strong class="text-primary">{{ $t('base.use') }}</strong>
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </template>
          </div>
        </div>

        <div v-if="auto_condition_action_tab === 'files'">
          <div style="margin-top: 30px">
            <div class="text-right">
              <el-input :placeholder="$t('input.placeholder')" suffix-icon="el-icon-search" style="width: 250px"
                        clearable
                        size="mini" v-model="auto_condition_action_file_search_keyword"></el-input>
              <el-button type="primary" size="mini" icon="el-icon-upload" style="margin-left: 10px"
                         @click="show_dialog.get_link = true; auto_condition_action_file_code = ''">
                Import {{ $t('base.config_code') }}
              </el-button>
            </div>

            <div>
              <template v-for="file in c__auto_condition_action_config_file_list">
                <div style="margin-top: 30px">
                  <div style="background-color: #f5f5f5; padding: 10px 10px 20px;border-radius: 4px">
                    <div style="display: flex; align-items: center; justify-content: space-between">
                      <div>
                        <el-tooltip v-if="false" effect="dark" :content="`Tạo lúc ${ file.created_at }`"
                                    placement="right">
                          <span style="font-size: 14px">📄&nbsp; {{ file.filename }}</span>
                        </el-tooltip>

                        <el-tooltip effect="dark" :content="`Tạo lúc ${ file.created_at }`" placement="right">
                          <div style="display: flex; align-items: center; gap: 10px">
                            <el-checkbox v-model="file.selected" style="margin-bottom: 0 !important;"></el-checkbox>
                            <span style="font-size: 14px">{{ file.filename }}</span>
                          </div>
                        </el-tooltip>
                      </div>

                      <div style="display: flex">
                        <el-button type="text" size="mini"
                                   @click="m__show_update_auto_condition_action_config_filename_dialog(file)">
                          <i class="el-icon-edit"
                             style="color: #409EFF !important; font-size: 13px !important; font-weight: bold !important"></i>
                        </el-button>
                        <el-button type="text" size="mini"
                                   @click="m__confirm_copy_auto_condition_action_config(file)">
                          <i class="el-icon-copy-document"
                             style="color: #409EFF !important; font-size: 13px !important; font-weight: bold !important"></i>
                        </el-button>
                        <el-button type="text" size="mini"
                                   @click="m__show_create_auto_condition_action_link_dialog(file)">
                          <i class="el-icon-share"
                             style="color: #409EFF !important; font-size: 14px !important; font-weight: bold !important"></i>
                        </el-button>
                        <el-button type="text" size="mini"
                                   @click="m__delete_auto_condition_action_config_file(file)">
                          <i class="el-icon-delete"
                             style="color: #F56C6C !important; font-size: 13px !important; font-weight: bold !important"></i>
                        </el-button>
                      </div>
                    </div>

                    <div>
                      <el-table :data="file.config_list" style="margin-top: 15px">
                        <el-table-column :label="$t('ads.activity_frequency')">
                          <template slot-scope="scope">
                            <div>
                              <strong>{{ spike_day_map(scope.row, false) }}</strong>
                              <strong v-if="spike_day_to_text(spike_days, scope.row)">- {{
                                  spike_day_to_text(spike_days, scope.row)
                                }}</strong>
                            </div>
                            <div v-if="scope.row.radio === '1'">
                              {{ $t('base.continuously') }}
                            </div>
                            <div v-if="scope.row.radio === '2'">
                              {{ $t('base.optional') }}
                              <div>
                                <template v-for="time in scope.row.times">
                                  <div>
                                    {{ time.start_time }} - {{ time.end_time }}
                                  </div>
                                </template>
                              </div>
                            </div>
                            <div v-if="scope.row.radio === '3'">
                              {{ $t('base.once_a_day') }}
                              <div>
                                {{ $t('ads.from') }}: {{ scope.row.time }}
                              </div>
                            </div>
                            <div v-if="scope.row.radio === '4'">
                              {{ $t('day.flash_sale') }} ({{ $t('base.advanced') }})
                              <div>
                                00:00 - 01:00
                              </div>
                            </div>
                            <div v-if="scope.row.radio === '5'">
                              <div>
                                {{ $t('base.advanced_settings') }} 1
                              </div>
                              00:00 - 01:00
                            </div>
                            <div v-if="scope.row.radio === '6'">
                              <div>
                                {{ $t('base.advanced_settings') }} 2
                              </div>
                              {{ scope.row.start_time }} - {{ scope.row.end_time }}
                            </div>
                          </template>
                        </el-table-column>
                        <el-table-column :label="$t('base.config_name')">
                          <template slot-scope="scope">
                            <div v-if="scope.row.name">{{ scope.row.name }}</div>
                            <div v-else>{{ $t('base.config') }} {{ scope.$index + 1 }}</div>
                          </template>
                        </el-table-column>
                        <el-table-column :label="$t('base.condition_action_number')">
                          <template slot-scope="scope">
                            {{ scope.row.condition_action_list.length }}
                          </template>
                        </el-table-column>
                        <el-table-column :label="$t('base.optional')" width="140px" fixed="right">
                          <template slot-scope="scope">
                            <el-button type="text" size="mini"
                                       @click="m__show_update_auto_condition_action_config_file_dialog(scope.row, file)">
                              <strong class="text-primary">{{ $t('base.edit') }}</strong>
                            </el-button>
                            <br>
                            <el-button type="text" size="mini"
                                       @click="m__duplicate_auto_condition_action_from_object(scope.row, file)">
                              <strong class="text-primary">{{ $t('base.use') }}</strong>
                            </el-button>
                            <br>
                            <el-button type="text" size="mini"
                                       @click="m__delete_auto_condition_action_config_file_link(file)">
                              <strong class="text-danger">{{ $t('base.delete_link') }}</strong>
                            </el-button>
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>
                  </div>
                </div>
              </template>
            </div>

            <div style="margin-top: 30px; text-align: right">
              <el-button v-if="c__auto_condition_action_config_file_list.some(i => i.selected)"
                         type="danger" size="mini" icon="el-icon-delete"
                         @click="m__batch_delete_auto_condition_action_config_file()">Xóa file đã chọn
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.convert_to_auto_condition_action" :close-on-click-modal="false"
               width="400px">
      <div slot="title" style="padding:10px">
        <strong class="strong-title">{{ $t('base.convert_automatic_config_to_automatic_condition') }}</strong>

        <div>
          <template v-for="item in auto_condition_action_checkbox_list">
            <div style="margin-bottom: 10px">
              <el-checkbox v-model="item.value">{{ item.name }}</el-checkbox>
            </div>
          </template>
        </div>

        <div class="text-right" style="margin-top: 30px">
          <el-button type="primary" size="mini" icon="el-icon-check"
                     :loading="loading.m__confirm_convert_to_auto_action_condition"
                     @click="m__confirm_convert_to_auto_action_condition">
            {{ $t('base.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.create_tag" :close-on-click-modal="false" width="400px">
      <div slot="title" style="padding:10px">
        <strong class="strong-title">{{ $t('base.manage_tags') }}</strong>

        <div style="margin-top: 30px">
          <div v-for="tag in campaign_tag_list" :key="tag._id"
               style="background-color: #eef0f1; padding: 10px; margin-bottom: 10px; border-radius: 4px; display: flex; align-items: center">
            <div style="flex: auto; font-size: 14px; padding-right: 10px">
              <template v-if="tag.editable">
                <el-input size="mini" v-model="tag.temp_name"></el-input>
              </template>
              <template v-else>
                {{ tag.name }}
              </template>
            </div>
            <div style="width: 60px">
              <template v-if="tag.editable">
                <a href="javascript:void(0)" @click="m__update_campaign_tag(tag)">
                  <i class="el-icon-check" style="font-size: 14px; color: #000"></i>
                </a>
                &nbsp;&nbsp;
                <a href="javascript:void(0)" @click="m__toggle_update_campaign_tag(tag, false)">
                  <i class="el-icon-close" style="font-size: 14px; color: #000"></i>
                </a>
              </template>
              <template v-else>
                <a href="javascript:void(0)" @click="m__toggle_update_campaign_tag(tag, true)">
                  <i class="el-icon-edit" style="font-size: 14px; color: #000"></i>
                </a>
                &nbsp;&nbsp;
                <a href="javascript:void(0)">
                  <i class="el-icon-delete" style="font-size: 14px; color: #000"
                     @click="m__delete_campaign_tag(tag)"></i>
                </a>
              </template>
            </div>
          </div>
        </div>

        <div style="margin-top: 30px; display: flex; gap: 10px">
          <div style="flex: auto">
            <el-input size="mini" :placeholder="$t('input.tag_name')" v-model="campaign_tag_name"></el-input>
          </div>
          <div style="flex: 1">
            <el-button type="primary" size="mini" icon="el-icon-plus" :loading="loading.create_tag"
                       @click="m__create_campaign_tag"> {{ $t('base.create_tags') }}
            </el-button>
          </div>
        </div>

        <div style="margin-top: 10px"></div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.add_tag_to_campaigns" :close-on-click-modal="false" width="400px">
      <div slot="title" style="padding:10px">
        <strong class="strong-title">{{ $t('select.tags') }}</strong>

        <div style="margin-top: 30px">
          <el-radio-group v-model="campaign_tag_id_selected" class="full-w">
            <div v-for="tag in campaign_tag_list" :key="tag._id"
                 style="background-color: #eef0f1; padding: 10px; margin-bottom: 10px; border-radius: 4px; display: flex; align-items: center">
              <div style="flex: auto; font-size: 14px; padding-right: 10px">
                <el-radio :label="tag._id">
                  {{ tag.name }}
                </el-radio>
              </div>
            </div>
          </el-radio-group>
        </div>

        <div style="margin-top: 30px" class="text-right">
          <el-button size="mini" type="primary" icon="el-icon-check" :loading="loading.add_tag_to_campaigns"
                     @click="m__add_tag_to_campaigns">{{ $t('base.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.save_filter" :close-on-click-modal="false" custom-class="no-body"
               width="400px">
      <div slot="title" style="padding:10px">
        <p class="text-title">{{ $t('base.filter_name') }}</p>
        <el-input size="mini" :placeholder="$t('input.filter_name')" v-model="filter_name"></el-input>

        <div style="margin-top: 30px" class="text-right">
          <el-button type="primary" size="mini" icon="el-icon-check" :loading="loading.save_filter"
                     @click="m__save_filter">
            {{ $t('base.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.filter_list" :close-on-click-modal="false" width="500px">
      <div slot="title" style="padding:10px">
        <strong class="strong-title">{{ $t('base.saved_filter_list') }}</strong>

        <div style="margin-top: 30px">
          <el-table :data="filter_list">
            <el-table-column label="Tên" prop="name"></el-table-column>
            <el-table-column :label="$t('base.optional')" width="150px">
              <template slot-scope="scope">
                <el-button type="text" size="mini" @click="m__use_filter(scope.row)">
                  <strong class="text-primary">{{ $t('base.use') }}</strong>
                </el-button>
                <el-button type="text" size="mini" @click="m__delete_atosa_filter(scope.row)">
                  <strong class="text-danger">{{ $t('base.delete') }}</strong>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.save_auto_condition_action_file" :close-on-click-modal="false"
               custom-class="no-body"
               width="400px">
      <div slot="title" style="padding:10px">
        <p class="text-title">{{ $t('base.config_file_name') }}:</p>
        <el-input size="mini" :placeholder="$t('input.config_file_name')"
                  v-model="auto_condition_action_filename"></el-input>

        <div style="margin-top: 30px" class="text-right">
          <el-button type="primary" size="mini" icon="el-icon-check" :loading="loading.save_auto_condition_action_file"
                     @click="m__save_auto_condition_action_file">
            {{ $t('base.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.update_auto_condition_action_filename" :close-on-click-modal="false"
               custom-class="no-body"
               width="400px">
      <div slot="title" style="padding:10px">
        <p class="text-title">{{ $t('base.config_file_name') }}:</p>
        <el-input size="mini" :placeholder="$t('input.config_file_name')"
                  v-model="auto_condition_action_filename"></el-input>

        <div style="margin-top: 30px" class="text-right">
          <el-button type="primary" size="mini" icon="el-icon-check"
                     :loading="loading.update_auto_condition_action_filename"
                     @click="m__update_auto_condition_action_config_filename">
            {{ $t('base.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.create_link" :close-on-click-modal="false"
               custom-class="no-body"
               width="500px">
      <div slot="title" style="padding: 10px 10px 10px 20px;">
        <p class="text-title"> {{ $t('base.config_code') }}:</p>
        <div style="display: flex; gap: 30px; align-items: center; margin: 10px 0">
          <div>
            <strong class="text-primary" style="font-size: 14px">{{ auto_condition_action_file_code }}</strong>
          </div>
          <div>
            <el-button size="mini" icon="el-icon-copy-document"
                       @click="copy_text(auto_condition_action_file_code); show_dialog.create_link = false"></el-button>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.get_link" :close-on-click-modal="false"
               custom-class="no-body"
               width="400px">
      <div slot="title" style="padding:10px">
        <p class="text-title"> {{ $t('base.config_code') }}:</p>
        <el-input size="mini" :placeholder="$t('input.config_code')"
                  v-model="auto_condition_action_file_code"></el-input>

        <div style="margin-top: 30px" class="text-right">
          <el-button type="primary" size="mini" icon="el-icon-check"
                     :loading="loading.get_link" @click="m__get_auto_condition_action_link">
            {{ $t('base.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.paste_auto_condition_action_item" :close-on-click-modal="false"
               custom-class="no-body"
               width="400px">
      <div slot="title" style="padding:10px">
        <p class="text-title">Code:</p>
        <el-input size="mini" :placeholder="$t('input.config_code')" v-model="paste_auto_condition_action_item_text"
                  type="textarea" :rows="4"></el-input>

        <div style="margin-top: 30px" class="text-right">
          <el-button type="primary" size="mini" icon="el-icon-check" @click="m__paste_auto_condition_action_item">
            {{ $t('base.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.clone_campaign_result" :close-on-click-modal="false" custom-class="no-body"
               width="700px">
      <div slot="title" style="padding:10px">
        <strong class="strong-title">{{ $t('ads.clone_campaign_result') }}</strong>

        <div>
          <el-table :data="clone_campaign_results">
            <el-table-column :label="$t('base.product')" show-tooltip-when-overflow>
              <template slot-scope="scope">{{ scope.row.name }}</template>
            </el-table-column>
            <el-table-column :label="$t('base.status')">
              <template slot-scope="scope">
                <div v-if="scope.row.code === 0">
                  <strong class="text-success">{{ $t('ads.clone_success') }}</strong>
                </div>
                <div v-else>
                  <strong class="text-danger">{{ $t('ads.cannot_clone') }}</strong>
                  <br>
                  <strong class="text-danger"> {{ $t('base.error_code') }}: {{ scope.row.code }}</strong>
                  <br>
                  <template v-for="item in scope.row.validation_error_list">
                    <div>
                      <strong v-if="typeof item === 'string'">{{ item }}</strong>
                      <strong v-if="typeof item === 'object'">field: {{ item.field }} - msg: {{ item.msg }}</strong>
                    </div>
                  </template>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div style="margin-top: 30px" class="text-right">
          <el-button
            v-if="clone_campaign_results.length && clone_campaign_results.filter(i => i.code === 0).length === clone_campaign_results.length"
            size="mini" type="primary" @click="show_dialog.clone_campaign_result = false; m__get_ads_data()">
            {{ $t('base.reload_data') }}
          </el-button>
          <el-button size="mini" type="default" icon="el-icon-close" @click="show_dialog.clone_campaign_result = false">
            {{ $t('base.close') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.clone_campaign_result" :close-on-click-modal="false" custom-class="no-body"
               width="700px">
      <div slot="title" style="padding:10px">
        <strong class="strong-title">{{ $t('ads.clone_campaign_result') }}</strong>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.update_target_broad_roi" :close-on-click-modal="false"
               width="500px">
      <div slot="title" style="padding:10px">
        <strong class="strong-title">{{ $t('base.edit_target_roas') }}</strong>

        <div>
          <div>
            <el-radio v-model="form_update_target_broad_roi.type" :label="'auto'">
              {{ $t('ads.gmv_max_auto_title') }}
            </el-radio>
            <div>
              {{ $t('ads.gmv_max_auto_description') }}
            </div>
          </div>

          <div style="margin-top: 30px">
            <el-radio v-model="form_update_target_broad_roi.type" :label="'custom'">
              {{ $t('ads.gmv_max_custom_title') }}
            </el-radio>
            <div>
              {{ $t('ads.gmv_max_custom_description') }}
            </div>
          </div>
          <div v-if="form_update_target_broad_roi.type === 'custom'"
               style="margin-top: 20px; padding-left: 10px; display: flex; flex-direction: column; gap: 10px">
            <div v-for="item in form_update_target_broad_roi.custom_type_list" :key="item" style="display: flex">
              <div style="width: 150px">
                <el-radio v-model="form_update_target_broad_roi.custom_type" :label="item">
                  ROAS = {{ item / 100000 }}
                </el-radio>
              </div>
              <div>

              </div>
            </div>
            <div style="display: flex">
              <div style="width: 150px; padding-top: 6px">
                <el-radio v-model="form_update_target_broad_roi.custom_type" :label="'custom'">
                  {{ $t('create_ads.custom') }}
                </el-radio>
              </div>
              <div style="flex: 1; padding-right: 12px">
                <el-input type="number" v-model="form_update_target_broad_roi.custom_value" :min="1" :max="50"
                          size="mini" placeholder="1.0 ~ 50.0">
                </el-input>
              </div>
            </div>
          </div>
        </div>

        <div style="margin-top: 30px" class="text-right">
          <el-button type="primary" size="mini" icon="el-icon-check" :loading="loading.update_target_broad_roi"
                     @click="m__confirm_update_target_broad_roi">{{ $t('base.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.convert_json_to_automatic_condition" :close-on-click-modal="false"
               width="500px">
      <div slot="title" style="padding:10px">
        <strong class="strong-title">{{ $t('base.convert_json_to_automatic_condition') }}</strong>

        <div style="margin-top: 30px">
          <el-input type="textarea" :rows="10" :autosize="false" v-model="auto_condition_action_json"></el-input>
        </div>

        <div style="margin-top: 30px; text-align: right">
          <el-button type="primary" size="mini" icon="el-icon-check"
                     @click="m__convert_json_to_automatic_condition()">{{ $t('base.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.convert_json_to_automatic_budget" :close-on-click-modal="false"
               width="500px">
      <div slot="title" style="padding:10px">
        <strong class="strong-title">{{ $t('base.convert_json_to_automatic_budget') }}</strong>

        <div style="margin-top: 30px">
          <el-input type="textarea" :rows="10" :autosize="false" v-model="auto_quota_json"></el-input>
        </div>

        <div style="margin-top: 30px; text-align: right">
          <el-button type="primary" size="mini" icon="el-icon-check"
                     @click="m__convert_json_to_automatic_budget()">{{ $t('base.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.auto_by_ai" :close-on-click-modal="false"
               width="900px">
      <div v-if="show_dialog.auto_by_ai" slot="title" style="padding:15px 30px">
        <ComponentAutoByAI :key="show_dialog.auto_by_ai_key"
                           :shop="shop"
                           :campaign_id="selected_campaign.campaign.campaignid"
                           :selected_config="selected_auto_by_ai_config"
                           :atosa_agent_package="atosa_agent_package"
                           :recommend_roas="atosa_agent_recommend_roas"
                           :recommend_gmv="atosa_agent_recommend_gmv"
                           @close_dialog="show_dialog.auto_by_ai = false"
                           @confirm_add_auto_by_ai_config="m__add_auto_by_ai_config"></ComponentAutoByAI>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.auto_by_ai_config_list" :close-on-click-modal="false"
               width="900px">
      <div slot="title" style="padding:15px" v-loading="loading.recommend_target">
        <div style="color: #333; text-align: center; padding: 0 140px">
          <strong style="font-size: 20px; color: #6C63FF;">
            🎉 Chào mừng bạn đến với Atosa Agent AI
          </strong>
          <p style="font-size: 13px; color: #555; margin-top: 8px; font-weight: 700">
            AI của chúng tôi sẽ giúp bạn tự động phân tích, điều chỉnh ngân sách, tối ưu từ khóa và chiến dịch theo thời
            gian thực – từ đó tăng hiệu quả, giảm chi phí và tiết kiệm thời gian.
          </p>
        </div>

        <div v-if="m__check_atosa_agent_used_package().result === true"
             style="margin-top: 50px; display: flex; flex-direction: column; gap: 15px">
          <div
            style="background-color: rgba(51,127,248,.15); padding: 10px; display: flex; align-items: start; border-radius: 4px;">
            <div style="width: 25px; line-height: 30px">
              <i class="el-icon-success" style="font-size: 14px"></i>
            </div>
            <div style="font-size: 14px; line-height: 25px; ">
              Shop của bạn đang sử dụng gói:
              <strong style="font-size: 14px">
                {{ m__check_atosa_agent_used_package().package_name }}
              </strong>
              <br>
              Thời hạn sử dụng tới:
              <strong style="font-size: 14px">{{ m__check_atosa_agent_used_package().license_to }}</strong>.
              &nbsp;
              <a style="font-size: 14px; font-weight: bold" href="javascript:void(0)"
                 @click="m__redirect_to_buy_atosa_agent()">
                👉 Gia hạn gói tại đây.
              </a>
              <br>
              Nếu bạn cần góp ý hay có bất kỳ câu hỏi nào, vui lòng liên hệ với chúng tôi qua hotline CSKH
              <a href="tel:0878 354 999" target="_blank" style="font-size: 14px; font-weight: bold">0878 354 999</a>.
            </div>
          </div>
          <div
            style="background-color: rgba(51,127,248,.15); padding: 10px; display: flex; align-items: center; border-radius: 4px">
            <div style="width: 25px; line-height: 30px">
              <i class="el-icon-warning" style="font-size: 14px"></i>
            </div>
            <div style="font-size: 14px;">
              Lưu ý: Hệ thống hiện chỉ hỗ trợ quảng cáo Tìm kiếm thủ công, chúng tôi sẽ sớm hoàn thiện các tính năng còn
              lại.
            </div>
          </div>
          <div v-if="m__check_is_unpaid_operating_cost()"
               style="background-color: #feece1; padding: 10px; display: flex; align-items: start; border-radius: 4px">
            <div style="width: 25px; line-height: 25px">
              <i class="el-icon-warning" style="font-size: 14px"></i>
            </div>
            <div style="font-size: 14px; line-height: 25px;">
              Tính năng đã bị tạm dừng do chưa thanh toán phí vận hành.
              <a href="javascript:void(0)" style="font-size: 14px; font-weight: bold"
                 @click="m__confirm_charge_unpaid_operating_cost()">
                👉 Thanh toán ngay
              </a>
            </div>
          </div>
        </div>
        <div v-else style="margin-top: 50px; display: flex; flex-direction: column; gap: 15px">
          <div style="background-color: #feece1; padding: 10px; display: flex; align-items: start; border-radius: 4px">
            <div style="width: 25px; line-height: 25px">
              <i class="el-icon-warning" style="font-size: 14px"></i>
            </div>
            <div style="font-size: 14px; line-height: 25px; ">
              Shop của bạn chưa được kích hoạt gói sản phẩm. Điều này khiến bạn không thể truy cập các tính năng
              chính.
              <br>
              - Một số tính năng sẽ bị khóa cho đến khi bạn hoàn tất đăng ký.
              <br>
              - Các cấu hình tự động đã cài sẽ bị tạm dừng.
              <br>
              - Đừng để gián đoạn quá trình sử dụng – hãy nâng cấp ngay!
              <br>
              <a style="font-size: 14px; font-weight: bold" href="javascript:void(0)"
                 @click="m__redirect_to_buy_atosa_agent()">
                👉 Mua gói ngay tại đây
              </a>
            </div>
          </div>
        </div>

        <div style="margin-top: 30px">
          <div v-if="auto_by_ai_state.selected_config">
            <div>
              <span style="font-size: 13px; font-weight: bold">
                {{ auto_by_ai_state.selected_campaign_id }}
                -
                {{ auto_by_ai_state.selected_campaign_name }}
              </span>
            </div>
            <div style="margin-top: 10px">
              <span style="font-size: 13px">Thời gian chạy:</span>
              <span style="font-size: 13px; font-weight: bold">
                {{ auto_by_ai_state.selected_config.last_phase.unix * 1000 | moment('DD/MM/YYYY HH:mm') }}
              </span>
              <el-tooltip placement="bottom" effect="light">
                <div slot="content" style="width: 280px">
                  <el-table :data="auto_by_ai_state.selected_config.update_history">
                    <el-table-column label="Thời gian">
                      <template slot-scope="scope">
                        {{ scope.row.unix * 1000 | moment('DD/MM/YYYY HH:mm') }}
                      </template>
                    </el-table-column>
                    <el-table-column label="Trạng thái">
                      <template slot-scope="scope">
                        {{ scope.row.label }}
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <i class="el-icon-info" style="font-size: 13px; font-weight: bold">
                </i>
              </el-tooltip>
            </div>
          </div>
          <div style="margin-top: 30px">
            <i class="el-icon-s-operation" style="font-size: 13px; font-weight: bold"></i>
            &nbsp;
            <strong style="font-size: 13px">Danh sách cấu hình tự động tối ưu Quảng cáo bằng AI</strong>
          </div>
          <div style="margin-top: 20px">
            <el-table :data="selected_auto_by_ai_config_list"
                      empty-text="Không có dữ liệu. Vui lòng ấn nút thêm cấu hình để tạo cấu hình tự động">
              <el-table-column label="Tên cấu hình">
                <template slot-scope="scope">
                  {{ scope.row.name }}
                </template>
              </el-table-column>
              <el-table-column label="Thời gian hoạt động">
                <template slot-scope="scope">
                  <div>
                    <strong>{{ spike_day_map(scope.row, false) }}</strong>
                    <strong v-if="spike_day_to_text(spike_days, scope.row)">- {{
                        spike_day_to_text(spike_days, scope.row)
                      }}</strong>
                  </div>
                  <div v-if="scope.row.radio === '1'">
                    {{ $t('base.continuously') }}
                  </div>
                  <div v-if="scope.row.radio === '2'">
                    {{ $t('base.optional') }}
                    <div>
                      Đã chọn {{ scope.row.datetimes.length }} khung giờ
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column v-if="false" label="Tiêu chí" width="220px">
                <template slot-scope="scope">
                  <div style="display: flex; flex-direction: column; gap: 10px; padding-right: 40px">
                    <el-tag v-if="scope.row.feature.max_revenue" type="success">
                      Tối đa doanh thu
                    </el-tag>
                    <el-tag v-if="scope.row.feature.optimize_cost" type="success">
                      Tối ưu chi phí
                    </el-tag>
                    <el-tag v-if="scope.row.feature.increase_traffic" type="success">
                      Tăng traffic, tăng đơn
                    </el-tag>
                    <el-tag v-if="scope.row.feature.optimize_roas_cir" type="success">
                      Tối ưu Roas + Cir
                    </el-tag>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="Chế độ" width="220px">
                <template slot-scope="scope">
                  <strong v-if="scope.row.mode === 'eco'"
                          style="font-size: 12px; color: #28a745; padding: 2px 10px; border: 1px solid #28a745; border-radius: 4px">
                    ECO
                  </strong>
                  <strong v-if="scope.row.mode === 'boost'"
                          style="font-size: 12px; color: #6f42c1; padding: 2px 10px; border: 1px solid #6f42c1; border-radius: 4px">
                    BOOST
                  </strong>
                  <strong v-if="scope.row.mode === 'ultra'"
                          style="font-size: 12px; color: #e74c3d; padding: 2px 10px; border: 1px solid #e74c3d; border-radius: 4px">
                    ULTRA
                  </strong>
                </template>
              </el-table-column>
              <el-table-column label="Trạng thái" width="100px">
                <template slot-scope="scope">
                  <el-switch
                    v-model="scope.row.config_status"
                    active-color="#13ce66"
                    inactive-color="#b7b7b7"
                    :active-value="1"
                    :inactive-value="0">
                  </el-switch>
                </template>
              </el-table-column>
              <el-table-column label="Tùy chọn" fixed="right" width="100px">
                <template slot-scope="scope">
                  <el-button type="text" size="mini" @click="m__edit_auto_by_ai_config(scope.row)">
                    <strong class="text-primary">
                      Chỉnh sửa
                    </strong>
                  </el-button>
                  <br>
                  <el-button v-if="false" type="text" size="mini"
                             @click="selected_auto_by_ai_config_list.splice(scope.$index, 1)">
                    <strong class="text-danger">
                      Xóa
                    </strong>
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <div style="margin-top: 50px">
            <i class="el-icon-s-operation" style="font-size: 13px; font-weight: bold"></i>
            &nbsp;
            <strong style="font-size: 13px">Cấp quyền cho Atosa Agent</strong>
          </div>
          <div style="margin-top: 20px">
            <div style="display: flex; flex-direction: column">
              <div style="background-color: rgb(245, 245, 245); border-radius: 4px; padding: 15px;">
                <div
                  style="display: flex; gap: 10px; align-items: center;">
                  <div style="flex: 1; font-size: 13px">
                    Cho phép Atosa Agent quản lý từ khóa của chiến dịch (thêm và xóa từ khóa mới)
                    <el-tooltip placement="top" effect="light">
                      <div slot="content" style="line-height: 20px; font-size: 13px">
                        Atosa Agent sẽ tự động cập nhật từ khóa cho chiến dịch của bạn — thêm mới các từ khóa tiềm năng
                        và
                        loại bỏ những từ khóa không mang lại hiệu quả.
                        <br>
                        Nguồn từ khóa được chọn lọc từ Công cụ Từ khóa, các tệp từ khóa bạn đã lưu, hoặc được đề xuất
                        thông minh bởi AI nhằm đảm bảo hiệu suất tối ưu cho quảng cáo.
                      </div>
                      <i class="el-icon-question" style="font-size: 13px"></i>
                    </el-tooltip>
                  </div>
                  <div style="width: 60px;">
                    <el-switch
                      v-model="auto_by_ai_state.rules.keyword.allow"
                      active-color="#13ce66"
                      inactive-color="#b7b7b7"
                      :active-value="true"
                      :inactive-value="false">
                    </el-switch>
                  </div>
                  <div style="width: 150px;">
                    <el-button type="primary" size="mini" :loading="loading.recommend_keywords"
                               @click="m__get_atosa_agent_suggest_keywords()">
                      Xem từ khóa gợi ý
                    </el-button>
                  </div>
                </div>
                <div v-if="auto_by_ai_state.rules.keyword.allow">
                  <el-checkbox-group v-model="auto_by_ai_state.rules.keyword.sources"
                                     style="margin-top: 20px; display: flex; flex-direction: column; gap: 10px">
                    <el-checkbox label="atosa">Cho phép thêm từ khóa gợi ý bởi Atosa Agent</el-checkbox>
                    <div style="display: flex; gap: 30px; align-items: center">
                      <el-checkbox label="file" style="margin-bottom: 0 !important;">
                        Cho phép thêm từ khóa trong file đã lưu
                      </el-checkbox>
                      <el-select v-if="auto_by_ai_state.rules.keyword.sources.includes('file')"
                                 v-model="auto_by_ai_state.rules.keyword.files" class="fix-collapse-tags"
                                 value="" size="mini" multiple collapse-tags>
                        <el-option v-for="file in keyword_file_list" :key="file._id"
                                   :value="file._id" :label="file.filename"></el-option>
                      </el-select>
                    </div>
                  </el-checkbox-group>
                </div>
              </div>
            </div>
          </div>

          <div style="margin-top: 80px; display: flex">
            <div>
              <el-button size="mini" @click="open_link('/marketing/log/atosa_ai?shop_id=' + shop.shop_id)">
                {{ 'Xem lịch sử thu phí' }}
              </el-button>
            </div>
            <div style="flex: 1; text-align: right">
              <el-button v-if="auto_by_ai_state.selected_campaign_id && selected_auto_by_ai_config_list.length"
                         type="danger" size="mini" @click="m__show_confirm_delete_auto_by_ai_config()">
                {{ $t('base.delete_config') }}
              </el-button>

              <el-tooltip :disabled="m__check_atosa_agent_used_package().result === true"
                          content="Bạn cần kích hoạt gói để sử dụng tính năng này" placement="top">
                <el-button type="primary" size="mini" icon="el-icon-plus"
                           :disabled="m__check_atosa_agent_used_package().result === false"
                           @click="m__show_add_auto_by_ai_config_dialog()">
                  {{ $t('base.add_config') }}
                </el-button>
              </el-tooltip>

              <el-tooltip :disabled="m__check_atosa_agent_used_package().result === true"
                          content="Bạn cần kích hoạt gói để sử dụng tính năng này" placement="top">
                <el-button type="primary" size="mini" icon="el-icon-check"
                           :disabled="m__check_atosa_agent_used_package().result === false"
                           :loading="loading.auto_by_ai" @click="m__confirm_update_auto_by_ai_config()">
                  {{ $t('base.save_config') }}
                </el-button>
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.welcome_atosa_agent" :close-on-click-modal="false"
               custom-class="no-body" width="750px" class="el-dialog__header-transparent">
      <div slot="title">
        <div class="ai-welcome-dialog">
          <div class="welcome-section">
            <div class="welcome-content">
              <h3>🎉 Chào mừng bạn đến với tính năng Tự Động Quản Lý & Tối Ưu Quảng Cáo bằng AI!</h3>
              <p>Chúng tôi sẽ giúp bạn tối ưu hóa chi phí, tăng trưởng hiệu quả chiến dịch một cách thông minh nhất.</p>
            </div>
          </div>

          <template v-if="welcome_atosa_agent_component === 'create'">
            <div class="campaign-section">
              <p style="font-size: 15px"> 🚀 Chúng tôi nhận thấy bạn vừa bắt đầu chạy quảng cáo, vì vậy chúng tôi đã chọn
                lọc sẵn các sản phẩm tiềm năng phù hợp để bạn dễ dàng khởi động chiến dịch. Hãy chọn những sản phẩm bạn
                muốn quảng bá, hệ thống sẽ tự động tạo chiến dịch và đề xuất từ khóa phù hợp nhằm tối ưu hiệu quả quảng
                cáo ngay từ đầu.</p>

              <div style="margin: 0; text-align: right">
                <el-button type="text"
                           @click="() => {welcome_atosa_agent_product_list.forEach(i => i.checked = true)}">
                  <strong class="text-primary" style="font-size: 13px">Chọn tất cả sản phẩm</strong>
                </el-button>
              </div>

              <div class="campaign-list">
                <div v-for="product in welcome_atosa_agent_product_list" :key="product.id" class="campaign-item">
                  <img :src="SHOPEE_IMAGE(product.images.split(',')[0])" alt="product_logo"/>
                  <span class="campaign-name" @click="product.checked = !product.checked">
                    {{ product.id }} - {{ product.name }}
                  </span>
                  <div style="width: 40px; text-align: right">
                    <el-checkbox v-model="product.checked"></el-checkbox>
                  </div>
                </div>
              </div>
            </div>
            <div style="text-align: center; padding: 20px">
              <button class="start-button" @click="m__confirm_create_welcome_atosa_agent_product()">
                Bắt đầu tạo quảng cáo
              </button>
            </div>
          </template>

          <template v-if="welcome_atosa_agent_component === 'setup'">
            <div class="campaign-section">
              <p style="font-size: 15px"> 🚀 Chúng tôi đã lựa chọn những chiến dịch tiềm năng nhất. Hãy chọn các chiến
                dịch bạn muốn để bắt đầu cài đặt cấu hình tự động. Hiện tại hệ thống sẽ chỉ hoạt động trên quảng cáo tìm
                kiếm thủ công.</p>

              <div style="margin: 0; text-align: right">
                <el-button type="text"
                           @click="() => {welcome_atosa_agent_campaign_list.forEach(i => i.checked = true)}">
                  <strong class="text-primary" style="font-size: 13px">Chọn tất cả sản phẩm</strong>
                </el-button>
              </div>

              <div class="campaign-list">
                <div v-for="campaign in welcome_atosa_agent_campaign_list" :key="campaign.campaign.campaignid"
                     class="campaign-item">
                  <img v-if="campaign.product.images" :src="m__map_campaign_image(campaign)" alt="product_logo"/>
                  <span class="campaign-name" @click="campaign.checked = !campaign.checked">
                    {{ campaign.campaign.campaignid }} - {{ campaign.product.name }}
                  </span>
                  <div style="width: 40px; text-align: right">
                    <el-checkbox v-model="campaign.checked"></el-checkbox>
                  </div>
                </div>
              </div>
            </div>
            <div style="text-align: center; padding: 20px">
              <button class="start-button" @click="m__submit_welcome_atosa_agent_campaign_list()">
                Bắt đầu cài đặt ngay
              </button>
            </div>
          </template>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.confirm_delete_auto_by_ai" :close-on-click-modal="false"
               custom-class="no-body" width="650px" class="el-dialog__header-transparent">
      <div slot="title">
        <div style="padding: 20px; background: white; border-radius: 10px; max-width: 650px; margin: auto;">
          <div style="text-align: center;">
            <h2 style="font-size: 20px; margin-bottom: 10px;">
              Bạn có chắc chắn muốn xóa cấu hình tự động không?
            </h2>
            <p v-if="auto_by_ai_state.report_since_setup" style="color: #555; font-size: 14px; font-weight: 600">
              Bạn đã chạy cấu hình từ ngày
              <strong
                style="font-size: 14px;">{{
                  auto_by_ai_state.selected_config ? auto_by_ai_state.selected_config.created_at : '' |
                    moment('DD/MM/YYYY')
                }}</strong>.
              Hãy xem những kết quả tuyệt vời bạn đã đạt được nhờ cấu hình này!
            </p>
          </div>

          <div style="margin: 30px 0;">
            <div v-if="auto_by_ai_state.report_since_setup"
                 style="display: flex; justify-content: space-around; margin-bottom: 20px; gap: 20px">
              <div style="text-align: center;">
                <div style="font-size: 20px; font-weight: bold; color: #4CAF50;">
                  {{ m__short_value(auto_by_ai_state.report_since_setup.click) || '-' }}
                </div>
                <div style="font-size: 14px; color: #666;">Traffic nhận được</div>
              </div>
              <div style="text-align: center;">
                <div style="font-size: 20px; font-weight: bold; color: #4CAF50;">
                  {{ m__short_value(auto_by_ai_state.report_since_setup.broad_gmv) || '-' }}
                </div>
                <div style="font-size: 14px; color: #666;">Doanh thu đem lại</div>
              </div>
              <div style="text-align: center;">
                <div style="font-size: 20px; font-weight: bold; color: #4CAF50;">
                  {{ m__short_value(auto_by_ai_state.report_since_setup.cost) || '-' }}
                </div>
                <div style="font-size: 14px; color: #666;">Chi phí tiết kiệm</div>
              </div>
              <div style="text-align: center;">
                <div style="font-size: 20px; font-weight: bold; color: #4CAF50;">
                  {{ auto_by_ai_state.report_since_setup.last_broad_roi.toFixed(1) || '-' }}
                  ->
                  {{ auto_by_ai_state.report_since_setup.broad_roi.toFixed(1) || '-' }}
                </div>
                <div style="font-size: 14px; color: #666;">Tăng trưởng ROAS</div>
              </div>
            </div>

            <div style="background: #fff8e1; padding: 10px; padding-left: 20px; border-radius: 5px; color: #e65100;">
              <strong>
                Khi bạn xóa cấu hình quảng cáo bằng AI thì bạn sẽ:
                <br>
                - Mất thời gian care quảng cáo. Các quảng cáo sẽ không được tự động hóa nữa.
                <br>
                - Bỏ lỡ cơ hội tăng trưởng tốt hơn vì đang chuẩn bị vào mùa vụ.
                <br>
                Bạn có chắc chắn?
              </strong>
            </div>
          </div>

          <div style="display: flex; justify-content: space-between; gap: 10px;">
            <button
              style="flex: 1; background-color: #4CAF50; color: white; padding: 10px; border: none; border-radius: 5px; cursor: pointer;"
              @click="show_dialog.confirm_delete_auto_by_ai = false; show_dialog.thanks_for_not_delete = true">
              Giữ lại cấu hình
            </button>
            <button
              style="flex: 1; background-color: #f44336; color: white; padding: 10px; border: none; border-radius: 5px; cursor: pointer;"
              @click="show_dialog.survey_form = true">Vẫn muốn xóa
            </button>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.thanks_for_not_delete" :close-on-click-modal="false"
               custom-class="no-body" width="650px" class="el-dialog__header-transparent">
      <div slot="title">
        <div style="padding: 20px; background: white; border-radius: 10px; max-width: 650px; margin: auto;">
          <div style="text-align: center;">
            <h2 style="font-size: 20px; margin-bottom: 10px;">
              Cảm ơn bạn vì đã rất hào phóng và cho chúng mình cơ hội tiếp tục hợp tác.
            </h2>
          </div>
          <div style="margin-top: 20px">
            <p style="color: #555; font-size: 14px; font-weight: 600">
              Chúng mình sẽ tiếp tục nỗ lực để phục vụ bạn tốt hơn.
              <br>
              Hãy liên hệ với Hotline hoặc fanpage nếu có điều gì đó bạn cần đóng góp để Atosa có thể đảm bảo phục vụ
              bạn tốt nhất nhé.
              Trong trường hợp bạn cần thì đây là hotline:
              <a style="font-size: 14px" href="https://chat.zalo.me/?phone=0878354999" target="_blank">0878354999</a>.
              <br>
              Và đây là fanpage chính thức của bên mình:
              <a style="font-size: 14px" href="https://m.me/atosa.asia" target="_blank">
                https://m.me/atosa.asia
              </a>.
            </p>
          </div>

          <div style="margin-top: 20px; text-align: center">
            <el-button size="mini" @click="show_dialog.thanks_for_not_delete = false">
              {{ $t('base.close') }}
            </el-button>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.survey_form" :close-on-click-modal="false"
               custom-class="no-body" width="650px" class="el-dialog__header-transparent">
      <div slot="title">
        <div style="padding: 20px; background: white; border-radius: 10px; max-width: 650px; margin: auto;">
          <div style="text-align: center;">
          </div>
          <div style="margin-top: 20px">
            <strong style="color: #555; font-size: 14px; font-weight: 600">
              Thật tiếc là chúng mình không cùng đồng hành với nhau nữa, và Atosa đang liên tục cải tiến để sản phẩm tốt
              hơn. Chúng mình rất hi vọng lần tới sẽ được phục vụ tốt hơn cho bạn.
            </strong>
          </div>
          <div style="margin-top: 20px">
            <p style="color: #555; font-size: 14px; font-weight: 600">
              Trước khi bạn rời đi, hãy chia sẻ về điều mà bạn cảm thấy chưa hài lòng nhé.
              Cấu hình sẽ được xóa sau khi bạn điền xong form khảo sát này.
            </p>
          </div>
          <el-checkbox-group v-model="survey_form_checkbox_group"
                             style="display: flex; flex-direction: column; gap: 10px;">
            <el-checkbox label="Kết quả không cải thiện">
            </el-checkbox>
            <el-checkbox label="Tôi có tuyển được nhân viên rồi">
            </el-checkbox>
            <el-checkbox label="Tôi thấy làm việc với nhân viên yên tâm hơn">
            </el-checkbox>
            <el-checkbox label="Không như kỳ vọng">
            </el-checkbox>
            <el-checkbox label="Phí quá cao">
            </el-checkbox>
            <el-checkbox label="Khác">
            </el-checkbox>
          </el-checkbox-group>
          <div style="margin-top: 20px; text-align: center">
            <el-button type="primary" size="mini" :disabled="!survey_form_checkbox_group.length" icon="el-icon-position"
                       @click="m__confirm_delete_auto_by_ai_send_survey()">
              Gửi phản hồi
            </el-button>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.recommend_keywords" :close-on-click-modal="false"
               custom-class="no-body" width="650px">
      <div slot="title" style="padding: 20px">
        <div style="font-size: 14px; line-height: 25px">
          ✨ Dựa trên phân tích hiệu suất và xu hướng tìm kiếm, chúng tôi đã tổng hợp danh sách những từ khóa tiềm năng,
          có liên quan chặt chẽ đến sản phẩm và nhu cầu của khách hàng mục tiêu. Việc thêm các từ khóa này vào chiến
          dịch không chỉ giúp quảng cáo tiếp cận đúng đối tượng hơn mà còn góp phần tăng tỷ lệ nhấp (CTR), tỷ lệ chuyển
          đổi và tối ưu chi phí quảng cáo.
          <br>
          <br>
          🚀 Hãy chủ động cập nhật và mở rộng danh sách từ khóa để nâng cao hiệu quả chiến dịch, gia tăng doanh thu và
          duy trì lợi thế cạnh tranh trên thị trường.
        </div>

        <div v-loading="loading.recommend_keywords"
             style="margin-top: 40px; display: flex; flex-direction: column; gap: 10px; max-height: calc(100vh - 400px); overflow-y: scroll; margin-bottom: 5px">
          <div style="display: flex; gap: 10px;">
            <div style="flex: 1; font-weight: bold; font-size: 13px">
              Từ khóa
            </div>
            <div style="width: 250px; font-weight: bold; font-size: 13px">
              Lượt tìm kiếm
            </div>
            <div style="width: 50px">
              <el-checkbox size="mini" :value="atosa_agent_suggest_keywords.every(i => i.checked)"
                           @change="(e) => atosa_agent_suggest_keywords.forEach(i => i.checked = e)"></el-checkbox>
            </div>
          </div>

          <template v-for="keyword of atosa_agent_suggest_keywords">
            <div style="display: flex; gap: 10px;">
              <div style="flex: 1; font-size: 13px; overflow: hidden">
                {{ keyword.keyword }}
              </div>
              <div style="width: 250px; font-size: 13px">
                {{ keyword.volume | currency }}
              </div>
              <div style="width: 50px">
                <el-checkbox size="mini" v-model="keyword.checked"></el-checkbox>
              </div>
            </div>
          </template>
        </div>

        <div style="margin-top: 30px; display: flex; justify-content: space-between">
          <div>
            <el-checkbox v-if="false">Không hiển thị lại</el-checkbox>
          </div>
          <div>
            <el-button size="mini" icon="el-icon-close" @click="show_dialog.recommend_keywords = false">
              Đóng
            </el-button>
            <el-button type="primary" size="mini" icon="el-icon-check" :loading="loading.add_recommend_keywords"
                       @click="m__confirm_add_recommended_keywords()">
              Xác nhận và thêm từ khóa
            </el-button>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.atosa_agent_create_campaign" :close-on-click-modal="false"
               custom-class="no-body" width="690px">
      <div slot="title" style="padding: 20px">
        <div style="line-height: 25px">
          <strong style="font-size: 16px;">Tạo quảng cáo tự động bằng Atosa Agent</strong>
          <br>
          <span v-if="loading.atosa_agent_create_campaign" style="font-size: 13px; color: #666">
            Hệ thống đang trong quá trình tạo chiến dịch, vui lòng đợi trong ít phút.
          </span>
        </div>

        <div style="margin-top: 30px">
          <el-table :data="welcome_atosa_agent_product_list.filter(i => i.checked)">
            <el-table-column :label="$t('base.image')" width="50px">
              <template slot-scope="scope">
                <template v-if="scope.row.images.length > 0">
                  <img :src="SHOPEE_IMAGE(scope.row.images.split(',')[0])" alt="product_logo"
                       style="width:32px; height:32px; border-radius: 4px;"/>
                </template>
              </template>
            </el-table-column>
            <el-table-column :label="$t('base.product')" prop="name" show-tooltip-when-overflow>
              <template slot-scope="scope">
                {{ scope.row.name }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('base.status')" width="150px">
              <template slot-scope="scope">
                <strong v-if="scope.row.state === 'pending'" class="text-warning">Đang chờ</strong>
                <strong v-if="scope.row.state === 'creating'" class="text-primary">Đang tạo...</strong>
                <strong v-if="scope.row.state === 'success'" class="text-success">Hoàn thành</strong>
                <strong v-if="scope.row.state === 'error'" class="text-danger">Đã có lỗi</strong>
                <strong v-if="scope.row.state === 'keywords_not_found'" class="text-danger">
                  Không tìm thấy từ khóa
                </strong>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <template v-if="!loading.atosa_agent_create_campaign">
          <div style="margin-top: 40px; line-height: 25px; font-size: 14px">
            🎉 Chiến dịch của bạn đã được tạo! Hãy bật cấu hình tự động với Atosa Agent để quảng cáo được tối ưu
            liên tục và hiệu quả hơn mỗi ngày.
          </div>

          <div style="margin-top: 20px; text-align: center">
            <el-button type="primary" size="mini"
                       @click="() => {m__get_ads_data(); show_dialog.atosa_agent_create_campaign = false}">
              Đi tới danh sách chiến dịch
            </el-button>
          </div>
        </template>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.auto_fill_keywords" :close-on-click-modal="false"
               custom-class="no-body" width="690px">
      <div slot="title" style="padding: 20px">
        <div style="line-height: 25px">
          <strong style="font-size: 16px;">Tạo quảng cáo tự động bằng Atosa Agent</strong>
        </div>
      </div>
    </el-dialog>

    <input accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" type="file"
           @change="m__import_excel_file" id="input_check" style="display: none;">

    <input accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" type="file"
           @change="m__import_excel_file" id="input_control_detail" style="display: none;">
  </div>
</template>

<script>
import component__keyword_file_manager from '../keyword/component__keyword_file_manager'
import Component__fffComVn from '../keyword/component__fff'
import ComponentMetric from './component/component_metric.vue'
import {
  atosa_flag,
  base_flag,
  default_report,
  campaign_filter,
  pas_base_flag,
  picker_options,
} from '../../addon/options'
import { action_template, get_shopee_campaign_type, make_uuid } from '../../addon/ads_function'
import {
  drop as _drop,
  omit as _omit,
  orderBy as _orderBy,
  snakeCase as _snakeCase,
  take as _take,
  uniq as _uniq,
  uniqBy as _uniqBy,
  shuffle as _shuffle,
} from 'lodash'
import ComponentSearchCampaign from './detail/search.vue'
import ComponentTargetingCampaign from './detail/targeting.vue'
import ComponentShopCampaign from './detail/shop.vue'
import readXlsxFile from 'read-excel-file'
import {
  advanced_auto_condition_action_fixed_list,
  advanced_fixed_list, always_ongoing_fixed_list,
  atosa_advanced_fixed_list,
  atosa_ai_fixed_list,
  auto_condition_action_fixed_list,
  connect_platform_fixed_list,
  filter_by_categories_fixed_list,
  group_campaign_advanced_list,
  new_buttons_fixed_list,
  restricted_keyword_fixed_list,
} from '../../addon/fixed_list'
import { convert_auto_config } from './script/convert_config'
import { template_auto_position_x_auto_cir, template_auto_quota } from './script/template_config'
import ComponentAntiClickGuide from './component/component_anti_click_guide.vue'
import ComponentAutoPositionGuide from './component/component_anti_click_guide.vue'
import ComponentAutoPriceGuide from './component/component_anti_click_guide.vue'
import ComponentAutoCirGuide from './component/component_auto_cir_guide.vue'
import ComponentAutoByAI from './component/component_auto_by_ai.vue'
import ComponentCustomTimePicker from './component/component_custom_time_picker.vue'
import ComponentAutoFillKeywords from './component/component_auto_fill_keywords.vue'
import { fix_ads_mixins } from '../../mixins/fix_ads'
import { function_mixins } from '../../mixins/function'
import { package_mixins } from '../../mixins/package'
import { validate_mixins } from '../../mixins/validate'
import { campaign_form_mixins } from '../../mixins/campaign_form'

export default {
  name: 'page__campaigns',

  mixins: [fix_ads_mixins, function_mixins, package_mixins, validate_mixins, campaign_form_mixins],

  props: {
    campaign_type: null,
    shop: null,
    shopee_shop: {},
    date_range: null,
    sp_user: null,
    start_date: null,
    end_date: null,
    campaign_component: null,
    select_hour: false,
    hour_mode: false,
    is_group: false,
    agency_files: null,
    agency_file_id_selected: null,
    parent_is_compare_campaign: false,
    parent_compare_date_range: null,
    ads_config: {},
    ads_data: {},
    non_ads_data: {},
    product_list: null,
    is_full: true,
    cascader_options: null,
    fff: null,
    active_campaign_list: null,
    filter_clone: null,
    getting_campaigns: false,
    welcome_atosa_agent_showed_dialog: false,
  },

  components: {
    component__keyword_file_manager,
    Component__fffComVn,
    ComponentMetric,
    ComponentSearchCampaign,
    ComponentTargetingCampaign,
    ComponentShopCampaign,
    ComponentAntiClickGuide,
    ComponentAutoPositionGuide,
    ComponentAutoPriceGuide,
    ComponentAutoCirGuide,
    ComponentAutoByAI,
    ComponentCustomTimePicker,
    ComponentAutoFillKeywords
  },

  data() {
    return {
      picker_options,

      metrics: {},
      reports: [],

      is_compare_campaign: false,
      compare_date_range: [new Date().getTime() - 3600 * 1000 * 24 * 6, new Date().getTime() - 3600 * 1000 * 24],
      compare_metrics: {},
      compare_reports: [],
      compare_list: [],

      filter_flag: true,
      filter: campaign_filter,

      flag_list: this.clone(pas_base_flag),
      atosa_flag_list: atosa_flag,

      campaign_filter: {
        page_size: 15,
        current_page: 0,
        total_record: 0,
      },

      campaign_optimizer_selected: '',

      selected_campaign_type: '',

      campaign_type_checkbox: [
        {
          label: this.$t('ads.all_ads'),
          checked: false,
          key: 'all',
          type: 'product_homepage',
          placement: 'all',
        },
        {
          label: this.$t('ads.search_ads'),
          checked: false,
          key: 'keyword',
          type: 'product_homepage',
          placement: 'search_product',
        },
        {
          label: this.$t('ads.targeting_ads'),
          checked: false,
          key: 'targeting',
          type: 'product_homepage',
          placement: 'targeting',
        },
        {
          label: this.$t('ads.shop_ads'),
          checked: false,
          key: 'shop',
          type: 'shop',
          placement: 'shop',
        },
      ],
      campaign_placement_checkbox: [
        {
          label: this.$t('base.manual_bidding'),
          checked: false,
          key: 'manual',
          type: '',
        },
        // {
        //   label: this.$t('ads.auto_bidding_standard'),
        //   checked: false,
        //   key: 'auto',
        //   type: '',
        // },
        // {
        //   label: this.$t('ads.gmv_max'),
        //   checked: false,
        //   key: 'roi_two',
        //   type: '',
        // },
        {
          label: 'Tối đa doanh thu - Tự động',
          checked: false,
          key: 'roi_two_auto',
          type: '',
        },
        {
          label: 'Tối đa doanh thu - Tùy chỉnh',
          checked: false,
          key: 'roi_two_manual',
          type: '',
        },
      ],

      selected_state: 'ongoing',

      group_list: [],

      expected_cir: null,

      search_keywords: '',
      search_keywords_mask: '',

      sort_option: {
        order: null,
        prop: null,
      },

      campaign_list: [],
      ongoing_campaign_list: [],

      selected_campaign: null,
      campaign_detail: null,

      selected_time_type: '',
      campaign_time: {
        start_time: null,
        end_time: null,
      },

      selected_quota_type: '',
      campaign_quota: {
        quota: null,
        type: 'daily',
      },

      loading: {
        get_campaigns: false,
        update_campaign_date: false,
        update_campaign_quota: false,
        add_new_campaign: false,
        confirm_and_add_new_campaign: false,
        config_anti_click: false,
        config_auto_pause: false,
        get_products: false,
        export_excel: false,
        add_campaign_type: false,
        marketing_report_file: false,
        update_multiple_quota: false,
        auto_position: false,
        config_auto_campaign: false,
        update_multiple_max_price: false,
        compare_campaign: false,
        auto_position_advanced_multiple: false,
        update_multiple_keyword_price: false,
        config_auto_position_by_suggest: false,
        config_anti_click_by_suggest: false,
        add_new_campaign_advanced: false,
        auto_quota: false,
        add_keywords: false,
        config_auto_cir: false,
        select_hour: false,
        update_multiple_keyword_price_by_cir: false,
        config_auto_optimize: false,
        config_boost_ads: false,
        update_keyword_by_condition: false,
        action_condition_save_file: false,
        update_campaign_state: false,
        config_auto_optimize_targeting: false,
        update_multiple_premium: false,
        resume_multiple_config: false,
        pause_multiple_config: false,
        delete_multiple_config: false,
        convert_to_auto_condition_action: false,
        create_tag: false,
        add_tag_to_campaigns: false,
        save_filter: false,
        save_auto_condition_action_file: false,
        update_auto_condition_action_config_file: false,
        update_auto_condition_action_filename: false,
        update_target_broad_roi: false,
        auto_by_ai: false,
        recommend_keywords: false,
        add_recommend_keywords: false,
        recommend_target: false,
        atosa_agent_create_campaign: false,
        auto_fill_keywords: false
      },
      show_dialog: {
        update_campaign_date: false,
        update_campaign_quota: false,
        select_product: false,
        add_new_campaign: false,
        add_new_campaign_advanced: false,
        config_auto_pause: false,
        config_anti_click: false,
        shop_not_selected: false,
        anti_click_list: false,
        select_index: false,
        filter: false,
        add_campaign_type: false,
        update_multiple_quota: false,
        config_auto_campaign: false,
        auto_position_advanced: false,
        update_multiple_max_price: false,
        compare_campaign: false,
        auto_position_advanced_multiple: false,
        update_multiple_keyword_price: false,
        config_auto_position_by_suggest: false,
        config_anti_click_by_suggest: false,
        set_ads_position_type: false,
        config_auto_quota: false,
        add_keywords: false,
        update_added_keyword_price: false,
        config_auto_cir: false,
        auto_cir_advanced: false,
        select_hour: false,
        update_multiple_keyword_price_by_cir: false,
        config_auto_optimize: false,
        config_boost_ads: false,
        update_keyword_by_condition: false,
        action_condition_save_file: false,
        action_condition_select_file: false,
        update_campaign_state: false,
        config_auto_optimize_targeting: false,
        update_multiple_premium: false,
        resume_multiple_config: false,
        pause_multiple_config: false,
        delete_multiple_config: false,
        auto_by_condition: false,
        auto_by_condition_list: false,
        convert_to_auto_condition_action: false,
        create_tag: false,
        add_tag_to_campaigns: false,
        save_filter: false,
        filter_list: false,
        save_auto_condition_action_file: false,
        update_auto_condition_action_filename: false,
        create_link: false,
        get_link: false,
        paste_auto_condition_action_item: false,
        clone_campaign_result: false,
        config_schedule: false,
        update_target_broad_roi: false,
        convert_json_to_automatic_condition: false,
        convert_json_to_automatic_budget: false,
        auto_by_ai: false,
        auto_by_ai_key: false,
        auto_by_ai_config_list: false,
        welcome_atosa_agent: false,
        confirm_delete_auto_by_ai: false,
        thanks_for_not_delete: false,
        survey_form: false,
        recommend_keywords: false,
        atosa_agent_create_campaign: false,
        auto_fill_keywords: false,
        update_multiple_target_roas: false
      },

      setup_auto_config_dropdown_item_list: [
        {
          label: this.$t('base.setup_x', { x: this.$t('ads.automatic_budget_configuration') }),
          value: 'auto_quota',
          type: '',
          divided: false,
          is_bold: true,
          require_vit_ads: true,
        },

        // todo: product_homepage
        {
          label: `${this.$t('base.setup_x', { x: this.$t('ads.optimize_based_on_cir_advanced') })} (${this.$t(
            'base.keyword')})`,
          value: 'auto_optimize',
          type: '',
          divided: true,
          is_bold: true,
          require_vit_ads: true,
        },
        {
          label: `${this.$t('base.setup_x', { x: this.$t('ads.optimize_based_on_cir_advanced') })} (${this.$t(
            'base.discovery')})`,
          value: 'targeting_auto_optimize',
          type: 'product_homepage',
          divided: true,
          is_bold: true,
          require_vit_ads: true,
        },
        {
          label: this.$t('ads.mass_setup_anti_click_configuration'),
          value: 'anti_click',
          type: '',
          divided: true,
        },
        {
          label: this.$t('ads.mass_setup_auto_configuration'),
          value: 'auto_campaign',
          type: 'product_homepage',
        },
        {
          label: this.$t('ads.mass_setup_advanced_configuration'),
          value: 'auto_position_advanced',
          type: 'product_homepage',
        },
        {
          label: this.$t('ads.mass_setup_optimize_based_on_cir_configuration'),
          value: 'auto_cir',
          type: 'product_homepage',
        },
        {
          label: this.$t('ads.max_edit_max_bid_price_of_auto_position'),
          value: 'auto_position_max',
          type: 'product_homepage',
        },
        {
          label: this.$t('base.mass_resume_configuration'),
          value: 'resume_multiple_config',
          type: 'product_homepage',
          divided: true,
        },
        {
          label: this.$t('base.mass_pause_configuration'),
          value: 'pause_multiple_config',
          type: 'product_homepage',
        },
        {
          label: this.$t('base.mass_delete_configuration'),
          value: 'delete_multiple_config',
          type: 'product_homepage',
        },
        {
          label: this.$t('base.convert_automatic_config_to_automatic_condition'),
          value: 'convert_to_auto_condition_action',
          type: 'product_homepage',
        },
        {
          label: this.$t('base.convert_json_to_automatic_condition'),
          value: 'convert_json_to_automatic_condition',
          type: 'product_homepage',
          hide: !this.array_to_set(['vuducminhdev07']).has(this.$store.state.userInfo.username),
        },
        {
          label: this.$t('base.convert_json_to_automatic_budget'),
          value: 'convert_json_to_automatic_budget',
          type: 'product_homepage',
          hide: !this.array_to_set(['vuducminhdev07']).has(this.$store.state.userInfo.username),
        },
      ],
      mass_adjust_item_list: [
        {
          label: this.$t('ads.change_budget'),
          value: 'change_budget',
          type: '',
        },
        {
          label: this.$t('base.update_campaign_status'),
          value: 'campaign_state',
          type: '',
        },
        {
          label: this.$t('ads.mass_add_keywords'),
          value: 'add_keyword',
          type: '',
        },
        {
          label: this.$t('base.mass_edit_x', { x: this.$t('base.bid_price') }),
          value: 'update_keyword_price',
          type: '',
        },
        {
          label: this.$t('base.mass_edit_x', { x: this.$t('base.target_roas') }),
          value: 'update_target_roas',
          type: '',
        },
        {
          label: this.$t('ads.mass_edit_keywords_by_condition'),
          value: 'action_condition',
          type: '',
        },
        {
          label: `Bật Đẩy nhanh hàng loạt`,
          value: 'rapid_boost_on',
          type: '',
        },
        {
          label: `Tắt Đẩy nhanh hàng loạt`,
          value: 'rapid_boost_off',
          type: '',
        },
        // {
        //   label: this.$t('ads.convert_from_all_to_search'),
        //   value: 'convert_from_all_to_search',
        //   type: 'product_homepage',
        //   divided: true
        // },
        // {
        //   label: this.$t('ads.convert_from_all_to_discovery'),
        //   value: 'convert_from_all_to_discovery',
        //   type: 'product_homepage',
        // },
        {
          label: this.$t('base.create_new_campaign'),
          value: 'create_product_ads',
          type: 'product_homepage',
          divided: true,
        },
        {
          label: this.$t('ads.create_shop_flash_sale'),
          value: 'create_shop_flash_sale',
          type: 'product_homepage',
        },
        {
          label: this.$t('ads.create_shop_vouchers'),
          value: 'create_shop_voucher',
          type: 'product_homepage',
        },
      ],

      // todo: old search data
      selected_tab: '2',
      current_component: 'list',
      balance: 0,
      product_filter: {
        page_size: 10,
        current_page: 0,
        keyword: '',
        total_record: 0,
        show: true,
      },
      add_keyword_filter: {
        page_size: 10,
        current_page: 0,
      },
      fff_tool: false,
      current_tab: 1,
      web_chat_id: '',
      selected_keyword: [],
      change_price: {
        show: false,
        apply_field: 'sp_price',
        type: 'PERCENT',
        func: 'SUB',
        percent: 20,
        value: 1000,
      },
      fff_tab: 1,
      add_keyword: {
        checked: false,
        keyword: '',
        show: false,
        loading: false,
        data: [],
        product_id: 0,
      },
      save_keyword_file: {
        show: false,
        loading: false,
        filename: 'Tệp keyword',
      },
      keyword_manager: {
        show: false,
      },
      delay_search: '',
      show_detail: false,
      product_not_campaign_list: [],
      product_not_campaign_list_clone: [],
      anti_click_list: [],
      type_product: 'all',
      category_list: [],
      selected_category: null,
      shop_category_list: [],
      selected_shop_category: null,
      flag_12: this.clone(base_flag),

      add_campaign_type: 'keyword',
      enable_shop_ads: false,
      interval: null,

      indeterminate: false,

      config_tab: 2,

      is_advanced_ads: true,

      spike_days: [],

      MATCH_TYPE_0_MIN: null, // TODO: exact
      MATCH_TYPE_1_MIN: null, // TODO: broad
      SHOP_ADS_MATCH_TYPE_0_MIN: null, // TODO: exact
      SHOP_ADS_MATCH_TYPE_1_MIN: null, // TODO: broad
      TARGETING_MIN: null,
      DAILY_BUDGET_MIN: null,

      ads_position_type: 'exact',

      show_available_product: true,

      radio: '1',
      keyword: '',
      base_keyword: '',
      selected_keyword_file: '',
      keyword_file_list: [],
      shopee_suggest_keywords: [],
      mipee_suggest_keywords: [],
      added_keywords: [],
      added_keywords_type: 0,
      excel_keyword: [],
      fff_loading: false,
      fff_result: [],
      fff_clone: [],
      added_keyword_filter: {
        page_size: 10,
        current_page: 0,
        sort_option: {
          order: null,
          prop: null,
        },
      },
      mipee_suggest_keywords_filter: {
        page_size: 10,
        current_page: 0,
        sort_option: {
          order: null,
          prop: null,
        },
      },
      excel_keyword_filter: {
        page_size: 10,
        current_page: 0,
      },
      omit_duplicated_keyword: false,
      fff_sort_option: {
        order: null,
        prop: null,
      },

      selected_hour: 1,
      hour_list: [
        {
          start: 0,
          end: 1,
          value: 1,
          label: this.$t('base.from') + ' 0 ' + this.$t('base.hours') + ' ' + this.$t('base.to') + ' 1 ' +
            this.$t('base.hours') + ' 59 ' + this.$t('base.minutes'),
        },
        {
          start: 2,
          end: 3,
          value: 2,
          label: this.$t('base.from') + ' 2 ' + this.$t('base.hours') + ' ' + this.$t('base.to') + ' 3 ' +
            this.$t('base.hours') + ' 59 ' + this.$t('base.minutes'),
        },
        {
          start: 4,
          end: 5,
          value: 3,
          label: this.$t('base.from') + ' 4 ' + this.$t('base.hours') + ' ' + this.$t('base.to') + ' 5 ' +
            this.$t('base.hours') + ' 59 ' + this.$t('base.minutes'),
        },
        {
          start: 6,
          end: 7,
          value: 4,
          label: this.$t('base.from') + ' 6 ' + this.$t('base.hours') + ' ' + this.$t('base.to') + ' 7 ' +
            this.$t('base.hours') + ' 59 ' + this.$t('base.minutes'),
        },
        {
          start: 8,
          end: 9,
          value: 5,
          label: this.$t('base.from') + ' 8 ' + this.$t('base.hours') + ' ' + this.$t('base.to') + ' 9 ' +
            this.$t('base.hours') + ' 59 ' + this.$t('base.minutes'),
        },
        {
          start: 10,
          end: 11,
          value: 6,
          label: this.$t('base.from') + ' 10 ' + this.$t('base.hours') + ' ' + this.$t('base.to') + ' 11 ' +
            this.$t('base.hours') + ' 59 ' + this.$t('base.minutes'),
        },
        {
          start: 12,
          end: 13,
          value: 7,
          label: this.$t('base.from') + ' 12 ' + this.$t('base.hours') + ' ' + this.$t('base.to') + ' 13 ' +
            this.$t('base.hours') + ' 59 ' + this.$t('base.minutes'),
        },
        {
          start: 14,
          end: 15,
          value: 8,
          label: this.$t('base.from') + ' 14 ' + this.$t('base.hours') + ' ' + this.$t('base.to') + ' 15 ' +
            this.$t('base.hours') + ' 59 ' + this.$t('base.minutes'),
        },
        {
          start: 16,
          end: 17,
          value: 9,
          label: this.$t('base.from') + ' 16 ' + this.$t('base.hours') + ' ' + this.$t('base.to') + ' 17 ' +
            this.$t('base.hours') + ' 59 ' + this.$t('base.minutes'),
        },
        {
          start: 18,
          end: 19,
          value: 10,
          label: this.$t('base.from') + ' 18 ' + this.$t('base.hours') + ' ' + this.$t('base.to') + ' 19 ' +
            this.$t('base.hours') + ' 59 ' + this.$t('base.minutes'),
        },
        {
          start: 20,
          end: 21,
          value: 11,
          label: this.$t('base.from') + ' 20 ' + this.$t('base.hours') + ' ' + this.$t('base.to') + ' 21 ' +
            this.$t('base.hours') + ' 59 ' + this.$t('base.minutes'),
        },
        {
          start: 22,
          end: 23,
          value: 12,
          label: this.$t('base.from') + ' 22 ' + this.$t('base.hours') + ' ' + this.$t('base.to') + ' 23 ' +
            this.$t('base.hours') + ' 59 ' + this.$t('base.minutes'),
        },
      ],
      hour_report: [],

      boost_ads_tab: 'config',

      condition_template: {
        label: '',
        expression: '',
        value: '',
        value_p: '',
        value_t: [],
        value_s: '',
        match_type: 'all',
        post_expression: '&&',

        level: '',
        time: '',
        time_range: null,
      },
      condition_action_template: {
        condition_group: [],
        condition_list: [],
        action: '',
        value: '',
        update_price_type: 'value',
        update_price_value: '',
        default_cpc: '',
        cpc_range: null,
        error_msg: '',
        success_msg: '',
        max_bid_price: null,
        min_bid_price: null,
        tag_id: null,

        actions: [],
        use_actions: true,

        // ...action_template,
      },
      condition_action_list: [],
      condition_action_tab: 'main',
      condition_action_file_list: [],
      condition_action_radio: '1',
      condition_action_filename: '',
      condition_action_file_selected: null,
      condition_action_file_filter: '',
      default_report: default_report,

      campaign_state_radio: 'ongoing',

      resume_multiple_config_checkbox_list: [
        {
          name: this.$t('ads.auto_position_configuration'),
          key: 'auto_position',
          type: 'product_homepage',
          value: false,
        },
        {
          name: this.$t('ads.optimize_based_on_cir_configuration'),
          key: 'auto_cir',
          type: 'product_homepage',
          value: false,
        },
        {
          name: this.$t('ads.anti_click_configuration'),
          key: 'anti_click',
          type: 'product_homepage',
          value: false,
        },
      ],
      pause_multiple_config_checkbox_list: [
        {
          name: this.$t('ads.auto_position_configuration'),
          key: 'auto_position',
          type: 'product_homepage',
          value: false,
        },
        {
          name: this.$t('ads.optimize_based_on_cir_configuration'),
          key: 'auto_cir',
          type: 'product_homepage',
          value: false,
        },
        {
          name: this.$t('ads.anti_click_configuration'),
          key: 'anti_click',
          type: 'product_homepage',
          value: false,
        },
        {
          name: this.$t('ads.conditional_automatic_configuration'),
          key: 'auto_condition_action',
          type: 'product_homepage',
          value: false,
        },
      ],
      delete_multiple_config_checkbox_list: [
        {
          name: this.$t('ads.auto_position_configuration'),
          key: 'auto_position',
          type: 'product_homepage',
          value: false,
        },
        {
          name: this.$t('ads.optimize_based_on_cir_configuration'),
          key: 'auto_cir',
          type: 'product_homepage',
          value: false,
        },
        {
          name: this.$t('ads.anti_click_configuration'),
          key: 'anti_click',
          type: 'product_homepage',
          value: false,
        },
        {
          name: this.$t('ads.change_budget_configuration'),
          key: 'auto_quota',
          type: 'product_homepage',
          value: false,
        },
        {
          name: this.$t('ads.optimize_based_on_cir_advanced_configuration'),
          key: 'auto_optimize',
          type: 'product_homepage',
          value: false,
        },
        {
          name: this.$t('ads.conditional_automatic_configuration'),
          key: 'auto_condition_action',
          type: 'product_homepage',
          value: false,
        },
      ],
      auto_condition_action_checkbox_list: [
        {
          name: this.$t('ads.auto_position_configuration'),
          key: 'auto_position',
          type: 'product_homepage',
          value: false,
        },
        {
          name: this.$t('ads.optimize_based_on_cir_configuration'),
          key: 'auto_cir',
          type: 'product_homepage',
          value: false,
        },
        {
          name: this.$t('ads.anti_click_configuration'),
          key: 'anti_click',
          type: 'product_homepage',
          value: false,
        },
        {
          name: this.$t('ads.optimize_based_on_cir_advanced_configuration'),
          key: 'auto_optimize',
          type: 'product_homepage',
          value: false,
        },
      ],

      auto_condition_action_only_show_me: false,
      auto_condition_action_list: [],
      auto_condition_action_config_list: [],
      auto_condition_action_detail_config_list: [],
      auto_condition_action_state: {
        type: 'add',
        updated_advanced_day: null,
        updated_advanced_day_number: null,
        updated_config_list_index: null,
        selected_item_id: null,
        selected_campaign_id: null,
      },
      auto_condition_action_detail: {
        campaign_detail_id: null,
        keyword_list: null,
      },

      agency_file_selected: null,

      keyword_tag_list: [],
      campaign_tag_list: [],
      campaign_tag_match: [],
      campaign_tag_name: '',
      campaign_tag_id_selected: null,
      tag_ids_selected: [],

      selected_template: 'manual',

      component_key: '',

      filter_name: '',
      filter_list: [],

      auto_condition_action_tab: 'configs',
      auto_condition_action_search_keyword: '',

      selected_auto_condition_action_config: null,
      selected_auto_condition_action_file: null,
      auto_condition_action_file_list: [],
      auto_condition_action_filename: '',
      auto_condition_action_file_search_keyword: '',
      auto_condition_action_file_code: '',

      quota_filter: 'all',

      paste_auto_condition_action_item_text: '',

      clone_campaign_status: null,
      clone_campaign_error: null,
      clone_campaign_results: [],

      cascader_value: 'all',
      cascader_type: null,
      cascader_id: null,
      cascader_result: [],

      last_scroll_position: 0,

      product_placement_list: ['all__search_product', 'all__targeting', 'search_product', 'targeting'],
      product_placement_list_previous: ['all__search_product', 'all__targeting', 'search_product', 'targeting'],

      auto_condition_action_json: '',
      auto_quota_json: '',

      selected_campaign_ids: [],
      auto_by_ai_config_list: [],
      selected_auto_by_ai_config_list: [],
      selected_auto_by_ai_config: null,
      auto_by_ai_state: {
        type: 'add',
        updated_advanced_day: null,
        updated_advanced_day_number: null,
        updated_config_list_index: null,
        selected_item_id: null,
        selected_campaign_id: null,
        selected_campaign_name: null,
        selected_config: null,
        report_since_setup: null,
        rules: {
          keyword: {
            allow: false,
            sources: [],
            files: [],
          },
        },
      },

      selected_gmv_max_type: '',

      sync_to_applied_config: false,

      is_applying_atosa_agent: false,
      atosa_agent_filter: 'all',
      welcome_atosa_agent_component: 'create',
      welcome_atosa_agent_product_list: [],
      welcome_atosa_agent_campaign_list: [],
      survey_form_checkbox_group: [],
      atosa_agent_package: null,
      atosa_agent_unpaid: null,
      atosa_agent_unpaid_max_hour: 12,
      atosa_agent_recommended_target_list: {},
      atosa_agent_recommend_roas: null,
      atosa_agent_recommend_gmv: null,
      atosa_agent_suggest_keywords: [],
      atosa_agent_campaign_result: {},

      target_roas_includes: new Set([
        'roi_two',
        'auto',
        'live_stream_homepage__max_gmv__target',
        'live_stream_homepage__max_gmv_roi_two__target',
      ]),

      group_campaign_advanced_list,
      new_buttons_fixed_list,
      advanced_fixed_list,
      atosa_advanced_fixed_list,
      restricted_keyword_fixed_list,
      filter_by_categories_fixed_list,
      auto_condition_action_fixed_list,
      advanced_auto_condition_action_fixed_list,
      atosa_ai_fixed_list,
      always_ongoing_fixed_list,
      connect_platform_fixed_list
    }
  },

  async beforeMount() {
    this.is_compare_campaign = this.parent_is_compare_campaign
    this.compare_date_range = this.clone(this.parent_compare_date_range)

    await Promise.all([
      this.m__get_keyword_file(),
      this.m__get_spike_days(),
      this.m__get_condition_action_list(),
      this.m__get_auto_condition_action_files(),
    ])

    if (this.$route.query.search) {
      this.search_keywords = this.$route.query.search
      this.search_keywords_mask = this.$route.query.search
    }

    await this.m__get_campaign_tag()
    await this.m__get_campaign_tag_match()
    await this.m__get_keyword_tag()
    await this.m__get_filter()
    await this.m__get_current_atosa_agent_package()
    await this.m__get_unpaid_operating_cost()
    await this.m__get_all_recommended_target()

    this.EB.$on('open_auto_condition_action_dialog', (data) => {
      this.m__show_auto_condition_action_detail_dialog(data)
    })

    if (this.connect_platform_fixed_list.includes(this.$store.state.userInfo.username)) {
      // this.setup_auto_config_dropdown_item_list.push({
      //   label: 'Đẩy dữ liệu chi tiết chiến dịch vào Google Sheet',
      //   value: 'auto_fill_keywords',
      //   type: '',
      //   divided: true,
      //   is_bold: true,
      // })
    }
  },

  watch: {
    'campaign_type': function () {
      this.m__get_ads_data()
    },

    'sp_user': function () {
      this.m__get_ads_data()
    },

    'add_keyword.keyword': function () {
      this.m__search_sp_keyword()
    },

    'select_hour': function () {
      this.show_dialog.select_hour = true
    },

    'agency_file_id_selected': function () {
      this.m__change_agency_file_id()
    },

    'ads_config': function () {
      // todo: set ads config
      if (this.ads_config && this.ads_config.bid_price) {
        this.MATCH_TYPE_0_MIN = this.m__calculate(this.ads_config.bid_price.search_product.exact_match.min / 100000)
        this.MATCH_TYPE_1_MIN = this.m__calculate(this.ads_config.bid_price.search_product.broad_match.min / 100000)
        this.SHOP_ADS_MATCH_TYPE_0_MIN = this.m__calculate(
          this.ads_config.bid_price.search_shop.exact_match.min / 100000)
        this.SHOP_ADS_MATCH_TYPE_1_MIN = this.m__calculate(
          this.ads_config.bid_price.search_shop.broad_match.min / 100000)
        this.TARGETING_MIN = this.m__calculate(this.ads_config.bid_price.targeting.min / 100000)
        this.DAILY_BUDGET_MIN = this.m__calculate(
          this.ads_config.ads_config.product_ads.manual.search_product.min_daily_budget / 100000)
      }
    },

    'condition_action_list': {
      async handler() {
        // todo: fix missing placeholder
        await this.$nextTick()
        const auto_by_condition = this.$refs.auto_by_condition
        if (auto_by_condition && auto_by_condition.$el) {
          const inputs = auto_by_condition.$el.querySelectorAll('input')
          inputs.forEach(input => {
            if (!input.hasAttribute('placeholder')) {
              input.setAttribute('placeholder', this.$t('input.value'));
            }
          })
        }
        // end fix missing placeholder
      },
      deep: true,
      immediate: true
    }
  },

  beforeDestroy() {
    this.EB.$off('open_auto_condition_action_dialog')
    clearInterval(this.interval)
    const dashboard_wrapper = document.getElementById('dashboard-wrapper')
    if (dashboard_wrapper) {
      dashboard_wrapper.onscroll = () => {
      }
    }
  },

  computed: {
    c__has_advanced_ads() {
      return this.$store.state.advanced_ads_list.some(i => this.$store.state.userInfo.username.includes(i))
    },

    c__has_vit_ads() {
      return this.$store.state.vit_ads_list.some(i => this.$store.state.userInfo.username.includes(i))
    },

    c__metrics() {
      if (this.c__show_filter_campaign_list.length !== this.campaign_list.length) {
        const metrics = {}
        for (const key of Object.keys(this.metrics)) {
          metrics[key] = 0
        }
        for (const campaign of this.c__show_filter_campaign_list) {
          for (const key of Object.keys(metrics)) {
            if (campaign.report && campaign.report[key]) {
              metrics[key] += +campaign.report[key].value
            }
          }
        }
        metrics.ctr = +(metrics.click / metrics.impression * 100).toFixed(2)
        metrics.broad_cir = +metrics.broad_gmv ? +(+metrics.cost * 100 / +metrics.broad_gmv).toFixed(2) : 0
        metrics.direct_cir = +metrics.direct_gmv ? +(+metrics.cost * 100 / +metrics.direct_gmv).toFixed(2) : 0
        metrics.broad_roi = +metrics.cost ? +(+metrics.broad_gmv / +metrics.cost).toFixed(2) : 0
        metrics.direct_roi = +metrics.cost ? +(+metrics.direct_gmv / +metrics.cost).toFixed(2) : 0
        metrics.atosa_cpc = +metrics.click ? this.m__calculate(+metrics.cost / +metrics.click) : 0
        metrics.cr = +metrics.click ? (+metrics.broad_order / +metrics.click * 100).toFixed(2) : 0
        metrics.cpm = +metrics.impression ? this.m__calculate(+metrics.cost / +metrics.impression * 1000) : 0
        metrics.aov = metrics.broad_order !== 0 ? this.m__calculate(metrics.broad_gmv / metrics.broad_order) : 0
        metrics.cancelled_roi = +metrics.cost ? +(+metrics.cancelled_gmv / +metrics.cost).toFixed(2) : 0
        metrics.exclude_cancelled_roi = +metrics.cost ? +(+metrics.exclude_cancelled_gmv / +metrics.cost).toFixed(2) : 0
        return metrics
      }

      this.metrics.cancelled_gmv = this.campaign_list.reduce((t, i) => t + (i.report.cancelled_gmv ? i.report.cancelled_gmv.value : 0), 0)
      this.metrics.cancelled_roi = +this.metrics.cost ? +(+this.metrics.cancelled_gmv / +this.metrics.cost).toFixed(2) : 0
      this.metrics.exclude_cancelled_gmv = this.metrics.broad_gmv >= this.metrics.cancelled_gmv ? this.metrics.broad_gmv - this.metrics.cancelled_gmv : 0
      this.metrics.exclude_cancelled_roi = +this.metrics.cost ? +(+this.metrics.exclude_cancelled_gmv / +this.metrics.cost).toFixed(2) : 0
      return this.clone(this.metrics)
    },

    c__show_filter_and_group_campaign_list() {
      let result = this.campaign_list

      if (this.selected_state) {
        if (new Set(['all', 'ongoing', 'paused', 'ended', 'deleted']).has(this.selected_state)) {
        } else {
          result = result.filter(item => item.group_id === this.selected_state)
        }
      }

      if (this.campaign_type_checkbox.filter(i => i.checked).length) {
        if (this.campaign_type_checkbox.filter(
            i => this.campaign_type === 'new_cpc_homepage' || i.type === this.campaign_type).length !==
          this.campaign_type_checkbox.filter(
            i => (this.campaign_type === 'new_cpc_homepage' || i.type === this.campaign_type) && i.checked).length) {
          result = result.filter(item =>
            this.campaign_type_checkbox.some(
              i => (this.campaign_type === 'new_cpc_homepage' || i.type === this.campaign_type) && i.checked &&
                i.key === item.campaign.type),
          )
        }
      }
      if (this.campaign_placement_checkbox.filter(i => i.checked).length) {
        result = result.filter(item =>
            item.campaign && this.campaign_placement_checkbox.some(i => {
              if (i.checked && i.key === 'roi_two_auto' && item.campaign.bidding_type === 'roi_two' && item.campaign.subtype === 'product_homepage__roi_two__simple') return true
              if (i.checked && i.key === 'roi_two_manual' && item.campaign.bidding_type === 'roi_two' && item.campaign.subtype === 'product_homepage__roi_two__target') return true
              return i.checked && i.key === item.campaign.bidding_type
            }),
        )
      }

      if (this.filter_clone) {
        for (const item of this.filter_clone) {
          if (item.value || (item.expression === '< <' && item.value && item.value2)) {
            result = result.filter(i => {
              const value = item.is_percent === true
                ? i.report[item.camel_key].value * 100
                : i.report[item.camel_key].value

              return item.expression === '< <'
                ? i.report && eval(`${item.value2} < ${value} && ${value} < ${item.value}`)
                : i.report && eval(`${value}${item.expression}${item.value}`)
            })
          }
        }
      }

      if (this.campaign_optimizer_selected) {
        if (this.campaign_optimizer_selected === 'lowest') {
          const min_cost = this.DAILY_BUDGET_MIN * 5
          result = result.filter(i => i.report &&
            (i.report.cost.value >= min_cost && (i.report.broad_cir.value > 0.2 || i.report.broad_cir.value === 0)))
        }
        if (this.campaign_optimizer_selected === 'low') {
          result = result.filter(i => i.report && (i.report.broad_cir.value > 0.15 && i.report.broad_cir.value <= 0.2))
        }
        if (this.campaign_optimizer_selected === 'medium') {
          result = result.filter(i => i.report && (i.report.broad_cir.value > 0.08 && i.report.broad_cir.value <= 0.15))
        }
        if (this.campaign_optimizer_selected === 'high') {
          result = result.filter(i => i.report && (i.report.broad_cir.value > 0 && i.report.broad_cir.value <= 0.08))
        }
        if (this.campaign_optimizer_selected === 'duplicated_campaigns') {
          const seen = new Set()
          const duplicates = new Set()

          for (const campaign of result) {
            if (campaign.campaign.type === 'shop' || !campaign.product) continue

            const key = `${campaign.product.itemid}-${campaign.campaign.type}-${campaign.campaign.bidding_type}`
            if (seen.has(key)) {
              duplicates.add(key)
            } else {
              seen.add(key)
            }
          }

          result = result.filter(
            i => duplicates.has(`${i.product.itemid}-${i.campaign.type}-${i.campaign.bidding_type}`))
        }

        if (this.campaign_optimizer_selected === 'sort') {
          result = _orderBy(result,
            ['md5', 'campaign.report.gmv.value', 'campaign.report.click.value', 'campaign.report.impression.value'],
            ['desc', 'desc', 'desc'])
        }

        if (this.campaign_optimizer_selected === 'auto_condition_action') {
          result = result.filter(i => {
            if (!i.auto_condition_action || !i.auto_condition_action.config_list &&
              !i.auto_condition_action.config_list.length) {
              return false
            }

            const config_list = typeof i.auto_condition_action.config_list === 'string'
              ? JSON.parse(i.auto_condition_action.config_list)
              : this.clone(i.auto_condition_action.config_list)
            const condition_length = config_list.reduce((total, item) => total + item.config_list.length, 0)

            return condition_length > 0
          })
        }
        if (this.campaign_optimizer_selected === 'not_auto_condition_action') {
          result = result.filter(i => {
            if (!i.auto_condition_action || !i.auto_condition_action.config_list &&
              !i.auto_condition_action.config_list.length) {
              return true
            }

            const config_list = typeof i.auto_condition_action.config_list === 'string'
              ? JSON.parse(i.auto_condition_action.config_list)
              : this.clone(i.auto_condition_action.config_list)
            const condition_length = config_list.reduce((total, item) => total + item.config_list.length, 0)

            return condition_length <= 0
          })
        }
        if (this.campaign_optimizer_selected === 'auto_optimize') {
          result = result.filter(i => i.auto_optimize_search || i.auto_optimize_targeting)
        }
        if (this.campaign_optimizer_selected === 'not_auto_optimize') {
          result = result.filter(i => !i.auto_optimize_search && !i.auto_optimize_targeting)
        }
        if (this.campaign_optimizer_selected === 'auto_quota') {
          result = result.filter(i => i.auto_quota)
        }
        if (this.campaign_optimizer_selected === 'not_auto_quota') {
          result = result.filter(i => !i.auto_quota)
        }
        if (this.campaign_optimizer_selected === 'atosa_agent') {
          result = result.filter(i => this.m__can_setup_auto_by_ai(i) && this.m__has_auto_by_ai_config(i))
        }
        if (this.campaign_optimizer_selected === 'not_atosa_agent') {
          result = result.filter(i => !this.m__has_auto_by_ai_config(i))
        }
      }

      if (this.quota_filter === 'low_quota') {
        result = result.filter(i => this.m__is_low_quota(i))
      }
      if (this.quota_filter === 'sort_desc') {
        result = _orderBy(result, ['campaign.daily_quota'], ['desc'])
      }
      if (this.quota_filter === 'sort_asc') {
        result = _orderBy(result, ['campaign.daily_quota'], ['asc'])
      }

      if (this.atosa_agent_filter === 'applying') {
        result = result.filter(i => this.m__can_setup_auto_by_ai(i) && this.m__has_auto_by_ai_config(i))
      }
      if (this.atosa_agent_filter === 'not_applying') {
        result = result.filter(i => this.m__can_setup_auto_by_ai(i) && !this.m__has_auto_by_ai_config(i))
      }
      if (this.atosa_agent_filter === 'replanning') {
        result = result.filter(i => this.m__can_setup_auto_by_ai(i) && this.m__has_auto_by_ai_config(i) &&
          this.m__check_atosa_agent_config_target(i))
      }

      if (this.tag_ids_selected.length) {
        if (this.array_to_set(this.tag_ids_selected).has('added')) {
          result = result.filter(i => this.m__check_campaign_has_tag(i.campaign.campaignid))
        } else if (this.array_to_set(this.tag_ids_selected).has('not_added')) {
          result = result.filter(i => !this.m__check_campaign_has_tag(i.campaign.campaignid))
        } else {
          result = this.tag_ids_selected.reduce((r, i) => {
            r.push(...result.filter(c => this.m__check_campaign_match(c.campaign.campaignid, i)))
            return r
          }, [])
        }
      }

      if (this.cascader_value && this.cascader_value !== 'all' && this.cascader_type) {
        if (this.cascader_type === 'shopee') {
          const products = this.product_list.filter(
            i => i.global_cat && this.array_to_set(i.global_cat.catid).has(this.cascader_id))
          const product_ids_set = this.array_to_set(products.map(i => i.itemid))
          result = result.filter(i => i.product && i.product.itemid && product_ids_set.has(i.product.itemid))
        }

        if (this.cascader_type === 'my_shop') {
          const products = this.product_list.filter(i => this.array_to_set(this.cascader_result).has(i.itemid))
          const product_ids_set = this.array_to_set(products.map(i => i.itemid))
          result = result.filter(i => i.product && i.product.itemid && product_ids_set.has(i.product.itemid))
        }
      }

      if (this.selected_gmv_max_type) {
        if (this.selected_gmv_max_type === 'sort_desc') {
          result = _orderBy(result, ['campaign.roi_two_target'], ['desc'])
        } else if (this.selected_gmv_max_type === 'sort_asc') {
          result = _orderBy(result, ['campaign.roi_two_target'], ['asc'])
        } else {
          result = result.filter(i => i.campaign && i.campaign.subtype === this.selected_gmv_max_type)
        }
      }

      const words = this.remove_unicode(this.search_keywords)
      result = result.filter(item => this.remove_unicode(JSON.stringify({
        campaign: item.campaign,
        product: item.product,
        title: item.title,
      }).normalize()).includes(words))

      if (this.is_group) {
        const group_data = {}
        for (const campaign of result) {
          const id = campaign.product.itemid || campaign.type

          if (!(id in group_data)) {
            group_data[id] = {
              ...this.clone(campaign),
              // id: campaign.product.itemid || 'shop',
              id: id,
              product: campaign.product,
              campaign: {
                name: campaign.product.name,
                roi_two_target: campaign.campaign.roi_two_target || 0,
              },
              report: {},
              advertisements: [],
              children: [],
              is_parent: true,
              tags: new Set(),
              auto_condition_action: this.auto_condition_action_config_list.find(
                i => !i.keyword && !i.campaign_id && i.item_id === campaign.product.itemid
              ),
            }
          }

          group_data[id].product = campaign.product
          group_data[id].campaign.name = campaign.product.name
          group_data[id].children.push({
            ...campaign,
            id: campaign.campaign.campaignid,
          })
        }
        result = Object.values(group_data)

        for (const item of result) {
          for (const key of Object.keys(this.default_report)) {
            item.report[key] = {
              value: item.children.reduce((t, i) => {
                if (i.report && i.report[key] && +i.report[key].value) t += +i.report[key].value
                return t
              }, 0),
            }
            item.c_report[key] = {
              value: item.children.reduce((t, i) => {
                if (i.c_report && i.c_report[key] && +i.c_report[key].value) t += +i.c_report[key].value
                return t
              }, 0),
            }
          }

          for (const key of ['report', 'c_report']) {
            if (/*item.children.length && */item[key].atosa_cpc) {
              item[key].atosa_cpc.value = item[key].click && item[key].click.value
                ? this.m__calculate(item[key].cost.value / item[key].click.value)
                : 0
              item[key].atosa_cpc.ratio = 0
            }
            if (/*item.children.length && */item[key].cpm) {
              item[key].cpm.value = item[key].impression && item[key].impression.value
                ? this.m__calculate(item[key].cost.value / item[key].impression.value * 1000)
                : 0
              item[key].cpm.ratio = 0
            }
            if (/*item.children.length && */item[key].aov) {
              item[key].aov.value = item[key].broad_order && item[key].broad_order.value
                ? this.m__calculate(item[key].broad_gmv.value / item[key].broad_order.value)
                : 0
              item[key].aov.ratio = 0
            }
            if (/*item.children.length && */item[key].ctr) {
              item[key].ctr.value = item[key].impression && item[key].impression.value
                ? item[key].click.value / item[key].impression.value
                : 0
              item[key].impression.ratio = 0
            }
            if (/*item.children.length && */item[key].broad_cir) {
              item[key].broad_cir.value = item[key].broad_gmv && item[key].broad_gmv.value
                ? item[key].cost.value / item[key].broad_gmv.value
                : 0
              item[key].broad_cir.ratio = 0
            }
            if (/*item.children.length && */item[key].direct_cir) {
              item[key].direct_cir.value = item[key].direct_gmv && item[key].direct_gmv.value
                ? item[key].cost.value / item[key].direct_gmv.value
                : 0
              item[key].direct_cir.ratio = 0
            }
            if (/*item.children.length && */item[key].broad_roi) {
              item[key].broad_roi.value = item[key].cost && item[key].cost.value
                ? item[key].broad_gmv.value / item[key].cost.value
                : 0
              item[key].broad_roi.ratio = 0
            }
            if (/*item.children.length && */item[key].direct_roi) {
              item[key].direct_roi.value = item[key].cost && item[key].cost.value
                ? item[key].direct_gmv.value / item[key].cost.value
                : 0
              item[key].direct_roi.ratio = 0
            }
            if (/*item.children.length && */item[key].cr) {
              item[key].cr.value = item[key].click && item[key].click.value
                ? item[key].broad_order.value / item[key].click.value
                : 0
              item[key].cr.ratio = 0
            }
            if (/*item.children.length && */item[key].direct_cr) {
              item[key].direct_cr.value = item[key].click && item[key].click.value
                ? item[key].direct_order.value / item[key].click.value
                : 0
              item[key].direct_cr.ratio = 0
            }
            if (/*item.children.length && */item[key].cpc) {
              item[key].cpc.value = item[key].broad_order && item[key].broad_order.value
                ? this.m__calculate(item[key].cost.value / item[key].broad_order.value)
                : 0
              item[key].cpc.ratio = 0
            }
            if (/*item.children.length && */item[key].cpdc) {
              item[key].cpdc.value = item[key].broad_order && item[key].direct_order.value
                ? this.m__calculate(item[key].cost.value / item[key].direct_order.value)
                : 0
              item[key].cpdc.ratio = 0
            }
            if (/*item.children.length && */item[key].cpm) {
              item[key].cpm.value = item[key].impression && item[key].impression.value
                ? this.m__calculate(item[key].cost.value / item[key].impression.value * 1000)
                : 0
              item[key].cpm.ratio = 0
            }
            if (/*item.children.length && */item[key].cpa) {
              const impression = item[key].impression ? item[key].impression.value : 0
              const ctr = item[key].ctr ? item[key].ctr.value : 0
              const cr = item[key].cr ? item[key].cr.value : 0
              const action = impression * ctr * cr
              item[key].cpa.value = action ? this.m__calculate(item[key].cost.value / action) : 0
              item[key].cpa.ratio = 0
            }
            if (/*item.children.length && */item[key].avg_rank) {
              item[key].avg_rank.value = item[key].avg_rank.value
                ? Math.round(item[key].avg_rank.value / item.children.length)
                : 0
              item[key].avg_rank.ratio = 0
            }
            if (/*item.children.length && */item[key].cancelled_roi) {
              item[key].cancelled_roi.value = item[key].cost && item[key].cost.value
                ? item[key].cancelled_gmv && item[key].cancelled_gmv.value / item[key].cost.value
                : 0
              item[key].cancelled_roi.ratio = 0
            }
          }

          // todo: set tags
          if (this.m__has_agent() && this.m__is_best_selling_product(item)) item.tags.add('best_selling')
          if (this.m__has_agent() && this.m__is_able_to_x2(item)) item.tags.add('able_to_x2')
        }
      }

      result = _orderBy(result, ['broad_gmv', 'click', 'impression'], ['desc', 'desc', 'desc'])

      if (this.sort_option.order) {
        this.sort_option.order === 'ascending' && (result = _orderBy(result, [this.sort_option.prop], ['asc']))
        this.sort_option.order === 'descending' && (result = _orderBy(result, [this.sort_option.prop], ['desc']))
      }

      return result
    },

    c__show_filter_campaign_list() {
      if (this.is_group) {
        return this.c__show_filter_and_group_campaign_list.reduce((result, campaign) => {
          if (campaign.children && campaign.children.length) {
            result.push(...campaign.children)
          }
          return result
        }, [])
      } else {
        return this.c__show_filter_and_group_campaign_list
      }
    },

    c__show_display_campaign_list() {
      const limit = this.campaign_filter.page_size
      const skip = limit * (this.campaign_filter.current_page - 1)

      return _take(_drop(this.c__show_filter_and_group_campaign_list, skip), limit)
    },

    c__filter_show_list() {
      if (this.filter_flag) {
        const result = []

        for (const item of this.filter) {
          const flag_found = this.flag_list.find(i => i.value === item.key)
          if (flag_found) {
            if (flag_found.checked) result.push(item)
          } else {
            result.push(item)
          }
        }

        return result
      } else {
        return this.filter
      }
    },

    c__add_keyword__data_checked() {
      return this.add_keyword.data.filter(e => e.checked)
    },

    c__product_not_campaign_filter_list() {
      let result = this.product_not_campaign_list

      if (this.type_product === 'category') {
        result = result.filter(i => i.category_path && i.category_path.includes(this.selected_category))
      }

      if (this.show_available_product) {
        result = result.filter(i => i.stock)
      }

      const keyword = this.remove_unicode(this.product_filter.keyword)
      return result.filter(i => this.remove_unicode(i.name.normalize()).includes(this.remove_unicode(keyword)))
    },

    c__product_not_campaign_display_list() {
      const limit = this.product_filter.page_size
      const skip = limit * (this.product_filter.current_page - 1)

      return _take(_drop(this.c__product_not_campaign_filter_list, skip), limit)
    },

    c__add_keyword_display_list() {
      const limit = this.add_keyword_filter.page_size
      const skip = limit * (this.add_keyword_filter.current_page - 1)

      return _take(_drop(this.add_keyword.data, skip), limit)
    },

    c__mipee_suggest_keywords_display() {
      let result = this.mipee_suggest_keywords

      if (this.mipee_suggest_keywords_filter.sort_option.order) {
        this.mipee_suggest_keywords_filter.sort_option.order === 'ascending' &&
        (result = _orderBy(result, [this.mipee_suggest_keywords_filter.sort_option.prop], ['asc']))
        this.mipee_suggest_keywords_filter.sort_option.order === 'descending' &&
        (result = _orderBy(result, [this.mipee_suggest_keywords_filter.sort_option.prop], ['desc']))
      }

      const limit = this.mipee_suggest_keywords_filter.page_size
      const skip = limit * (this.mipee_suggest_keywords_filter.current_page - 1)

      return _take(_drop(result, skip), limit)
    },

    c__fff_result_display_list() {
      const limit = this.add_keyword_filter.page_size
      const skip = limit * (this.add_keyword_filter.current_page - 1)

      let result = this.fff_result

      if (this.fff_sort_option.order) {
        this.fff_sort_option.order === 'ascending' && (result = _orderBy(result, [this.fff_sort_option.prop], ['asc']))
        this.fff_sort_option.order === 'descending' &&
        (result = _orderBy(result, [this.fff_sort_option.prop], ['desc']))
      }

      return _take(_drop(result, skip), limit)
    },

    c__excel_keyword_display_list() {
      const limit = this.excel_keyword_filter.page_size
      const skip = limit * (this.excel_keyword_filter.current_page - 1)

      return _take(_drop(this.excel_keyword, skip), limit)
    },

    c__added_keyword_display_list() {
      let result = this.added_keywords

      if (this.added_keyword_filter.sort_option.order) {
        this.added_keyword_filter.sort_option.order === 'ascending' &&
        (result = _orderBy(result, [this.added_keyword_filter.sort_option.prop], ['asc']))
        this.added_keyword_filter.sort_option.order === 'descending' &&
        (result = _orderBy(result, [this.added_keyword_filter.sort_option.prop], ['desc']))
      }

      const limit = this.added_keyword_filter.page_size
      const skip = limit * (this.added_keyword_filter.current_page - 1)

      return _take(_drop(result, skip), limit)
    },

    c__condition_action_file_filter_list() {
      const keyword = this.remove_unicode(this.condition_action_file_filter)
      return this.condition_action_file_list.filter(
        i => this.remove_unicode(i.filename.normalize()).includes(this.remove_unicode(keyword)))
    },

    c__all_auto_condition_action_config_list() {
      let result = []

      for (const config of this.auto_condition_action_config_list) {
        if (config.item_id) {
          const row = {
            type: 'product',
            product_id: null,
            product_name: null,
            config_list: [],
          }

          const product_found = this.product_list.find(i => i.id === config.itemid)
          if (product_found) {
            row.product_id = product_found.id
            row.product_name = product_found.name

            const config_list = typeof config.config_list === 'string'
              ? JSON.parse(config.config_list)
              : this.clone(config.config_list)
            for (const item of config_list) {
              row.config_list.push(
                ...item.config_list.map(i => {
                  i.checked = false
                  i.advanced_day = i.type = item.advanced_day
                  i.advanced_day_number = i.day = item.advanced_day_number
                  return i
                }),
              )
            }

            result.push(row)
          }
        }

        if (config.campaign_id) {
          const row = {
            type: 'campaign',
            campaign_product: null,
            campaign_detail: null,
            config_list: [],
          }

          const campaign_found = this.campaign_list.find(i => i.campaign.campaignid === config.campaign_id)
          if (campaign_found) {
            row.campaign_product = campaign_found.product
            row.campaign_detail = campaign_found.campaign

            const config_list = typeof config.config_list === 'string'
              ? JSON.parse(config.config_list)
              : this.clone(config.config_list)
            for (const item of config_list) {
              row.config_list.push(
                ...item.config_list.map(i => {
                  i.checked = false
                  i.advanced_day = i.type = item.advanced_day
                  i.advanced_day_number = i.day = item.advanced_day_number
                  return i
                }),
              )
            }

            result.push(row)
          }
        }
      }

      const keyword = this.remove_unicode(this.auto_condition_action_search_keyword)
      return result.filter(i => this.remove_unicode(JSON.stringify(i)).includes(this.remove_unicode(keyword)))
    },

    c__auto_condition_action_config_file_list() {
      let result = this.auto_condition_action_file_list

      const keyword = this.remove_unicode(this.auto_condition_action_file_search_keyword)
      return result.filter(i => this.remove_unicode(JSON.stringify({
        a: i.filename,
        b: i.config.name,
      })).includes(this.remove_unicode(keyword)))
    },
  },

  methods: {
    async m__on_off_rapid_boost(value) {
      try {
        await this.$confirm(`Bạn có chắc chắn muốn ${value ? 'Bật' : 'Tắt'} Đẩy nhanh cho các chiến dịch đã chọn không`, {
          type: 'warning',
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
        })
      } catch (e) {
        return
      }

      for (const campaign of this.c__show_filter_campaign_list.filter(i => i.checked)) {
        const form = {
          campaign_id: campaign.campaign.campaignid,
          header: {},
          type: `rapid_boost_toggle_${value ? 'on' : 'off'}`,
          reference_id: make_uuid()
        }

        await this.sp_user.marketing_pas_update_campaign(form, campaign.campaign.shopee_type)
      }

      this.ntf_s('Cập nhật thành công')
    },

    m__get_expected_placeholder(type) {
      if (type === 'cir') return 'Nhập tỉ lệ CIR (ACOS) mong muốn'
      if (type === 'roi') return 'Nhập tỉ lệ ROI (ROAS) mong muốn'
      if (type === 'exclude_cancelled_roi') return 'Nhập tỉ lệ ROI (ROAS) đã trừ huỷ mong muốn'
    },

    m__open_auto_condition_log_page() {
      let link = `/marketing/log/auto_condition?shop_id=${this.shop.shop_id}`
      if (this.auto_condition_action_state.selected_campaign_id) {
        link += `&campaign_id=${this.auto_condition_action_state.selected_campaign_id}`
      }
      this.open_link(link)
    },

    m__fix_condition_action_list() {
      for (const item of this.condition_action_list) {
        if (item.use_actions === true) continue
        if (item.actions && item.actions.length) continue

        if (!item.actions) item.actions = []

        const clone_action_template = {}
        for (const key of Object.keys(action_template)) {
          clone_action_template[key] = item[key]
        }

        const type_list = ['campaign', 'match_type_0', 'match_type_1', 'placement_2', 'placement_5']
        for (const type of type_list) {
          if (item[`action_${type}`]) {
            const new_action = {
              type: type,
              ...clone_action_template
            }
            item.actions.push(new_action)
          }
        }

        for (const key of Object.keys(action_template)) {
          delete item[key]
        }

        item.use_actions = true
      }

      this.condition_action_list = this.clone(this.condition_action_list)
    },

    m__check_atosa_agent_config_target(campaign) {
      // const config = this.auto_by_ai_config_list.find(i => i.campaign_id === campaign.campaign.campaignid && i.config_list !== '[]')
      // if (!config) return false
      //
      // const config_list = typeof config.config_list === 'string'
      //   ? JSON.parse(config.config_list)
      //   : this.clone(config.config_list)
      // const [config_found] = config_list.filter(i => i.config_status === 1)
      // if (!config_found) return false
      //
      // if (+config_found.selected_target_roas && +config_found.selected_target_gmv && this.atosa_agent_recommended_target_list[campaign.campaign.campaignid]) {
      //   const {
      //     roas_list,
      //     gmv_list
      //   } = this.atosa_agent_recommended_target_list[campaign.campaign.campaignid]
      //   if (roas_list.every(i => i > 0) && +config_found.selected_target_roas > roas_list[roas_list.length - 1] * 2) return true
      //   if (gmv_list.every(i => i > 0) && +config_found.selected_target_gmv > gmv_list[gmv_list.length - 1] * 1.3) return true
      // }

      return false
    },

    async m__confirm_charge_unpaid_operating_cost() {
      if (!this.atosa_agent_unpaid || !this.atosa_agent_unpaid.total_unpaid_cost) return

      if (this.$store.state.userInfo.store_current_money >= this.atosa_agent_unpaid.total_unpaid_cost) {
        try {
          await this.$confirm(`Bạn có chắc chắn muốn thực hiện thanh toán số tiền: ${this.format_currency(
            this.m__calculate(this.atosa_agent_unpaid.total_unpaid_cost))} không?`, this.$t('base.attention'), {
            type: 'warning',
            confirmButtonText: this.$t('base.confirm'),
            cancelButtonText: this.$t('base.cancel'),
          })
        } catch (e) {
          return
        }

        await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/atosa_agent/charge_unpaid_cost', {
          shop_id: this.shop._id,
        }, this.cf())
        await this.m__get_unpaid_operating_cost()
        this.ntf_s('Thanh toán thành công')
      } else {
        try {
          await this.$confirm(`Số dư tài khoản của bạn không đủ để thực hiện thanh toán số tiền: ${this.format_currency(
              this.m__calculate(this.atosa_agent_unpaid.total_unpaid_cost))}! Bạn có muốn nạp thêm tiền không?`,
            this.$t('base.attention'), {
              type: 'warning',
              confirmButtonText: 'Nạp tiền ngay',
              cancelButtonText: this.$t('base.cancel'),
            })
        } catch (e) {
          return
        }

        this.open_link('https://banhang.atosa.asia/payment/transfer')
      }
    },

    async m__create_welcome_atosa_agent_product() {
      this.loading.atosa_agent_create_campaign = true

      for (const product of this.welcome_atosa_agent_product_list.filter(i => i.checked)) {
        product.state = 'creating'

        try {
          const suggest_keyword_response = await this.$http.post(
            this.API.URL_API_SRV_2 + '/mipee/atosa_agent/get_suggest_keywords', {
              shop_id: this.shop._id,
              product_id: product.id,
              product_name: product.name,
            }, this.cf())

          if (suggest_keyword_response && suggest_keyword_response.body && suggest_keyword_response.body.data &&
            suggest_keyword_response.body.data.length > 0) {
            const suggest_keywords = suggest_keyword_response.body.data

            const form = {
              reference_id: make_uuid(),
              campaign: {
                daily_budget: Math.trunc(100000 * 100000),
                product_placement: 'search_product',
                ecpc: false,
                bidding_strategy: 'manual',
                product_selection: 'manual',
                start_time: this.dayjs().startOf('day').unix(),
                end_time: 0,
              },
              ads_list: [
                {
                  item_id: product.id,
                },
              ],
              header: {},
            }
            form.campaign.keyword_list = suggest_keywords.map(i => ({
              keyword: i.keyword,
              bid_price: Math.trunc(this.MATCH_TYPE_0_MIN * 100000),
              match_type: 'exact',
            }))

            const create_response = await this.sp_user.marketing_pas_publish_campaign(form)
            console.log(form)
            console.log(create_response)
            if (create_response.code === 0) {
              product.state = 'success'
            } else {
              product.state = 'error'
            }
          } else {
            product.state = 'keywords_not_found'
          }
        } catch (e) {
          console.error(e)
          product.state = 'error'
        }

        await this.sleep(2000)
      }

      this.loading.atosa_agent_create_campaign = false
    },

    async m__confirm_create_welcome_atosa_agent_product() {
      if (!this.welcome_atosa_agent_product_list.filter(i => i.checked).length) {
        this.show_dialog.welcome_atosa_agent = false
        return
      }

      try {
        await this.$confirm(`Bạn có chắc chắn muốn tạo các sản phẩm đã chọn không?`, this.$t('base.attention'), {
          type: 'warning',
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
        })
      } catch (e) {
        return
      }

      this.show_dialog.welcome_atosa_agent = false
      this.show_dialog.atosa_agent_create_campaign = true
      this.loading.atosa_agent_create_campaign = true
      await this.m__create_welcome_atosa_agent_product()
    },

    async m__get_all_recommended_target() {
      if (!this.shop || !this.shop._id) return

      // this.atosa_agent_recommended_target_list = {}

      const recommend_response = await this.$http.post(
        this.API.URL_API_SRV_2 + '/mipee/atosa_agent/get_all_recommend_target', {
          shop_id: this.shop._id,
        }, this.cf())

      for (const item of recommend_response.body.data) {
        this.atosa_agent_recommended_target_list[item.campaign_id] = {
          roas_list: item.roas_list,
          gmv_list: item.gmv_list,
        }
      }
      this.atosa_agent_recommended_target_list = this.clone(this.atosa_agent_recommended_target_list)
    },

    async m__atosa_agent_get_campaign_result() {
      this.atosa_agent_campaign_result = {}

      const campaign_list = []

      const start_time = this.dayjs().startOf('month')
      const end_time = this.dayjs().endOf('day')
      const now = this.dayjs()
      // const key = `campaign_result_${this.shop.shop_id}_${now.format('YYYYMMDD')}_${now.format('A')}`
      const key = `campaign_result_${this.shop.shop_id}_${now.format('YYYYMMDDHH')}`

      // todo: load from cache
      const cache_data = {
        data_id: key,
        type: 'campaign_result',
        shop_id: this.shop.shop_id,
      }
      const cache_response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/cache/get', cache_data, this.cf())
      if (cache_response && cache_response.body && cache_response.body.data) {
        // console.log('load campaign result from cache')
        // console.log(cache_response.body.data)
        campaign_list.push(...JSON.parse(cache_response.body.data))
      } else {
        // todo: load from api
        let limit = 50, offset = 0, has_more = true
        while (has_more) {
          let response = await this.sp_user.marketing_pas_get_campaigns(start_time.unix(), end_time.unix(), offset,
            limit, {
              campaign_type: this.campaign_type,
              search_term: '',
              state: 'ongoing',
            })
          response = this.m__map_campaign_data(response, true)

          if (response && response.data && response.data.campaign_ads_list && response.data.campaign_ads_list.length >
            0) {
            campaign_list.push(...response.data.campaign_ads_list)
            offset += limit
          } else {
            has_more = false
          }
        }

        if (campaign_list.length) {
          const cache_data = {
            data_id: key,
            data: JSON.stringify(campaign_list),
            type: 'campaign_result',
            shop_id: this.shop.shop_id,
          }
          this.$http.post(this.API.URL_API_SRV_2 + '/mipee/cache/update', cache_data, this.cf()).catch(console.error)
        }
      }

      for (const campaign of campaign_list) {
        this.atosa_agent_campaign_result[campaign.campaign.campaign_id] = {
          roas: +campaign.report.broad_roi.value,
          gmv: +campaign.report.broad_gmv.value,
        }
      }

      this.atosa_agent_campaign_result = this.clone(this.atosa_agent_campaign_result)
    },

    async m__confirm_add_recommended_keywords() {
      if (!this.atosa_agent_suggest_keywords.filter(i => i.checked).length) {
        this.ntf_w('Vui lòng chọn từ khóa để thêm vào chiến dịch')
        return
      }

      try {
        await this.$confirm(`Bạn có chắc chắn muốn thêm các từ khóa đã chọn không?`, this.$t('base.attention'), {
          type: 'warning',
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
        })
      } catch (e) {
        return
      }

      this.loading.add_recommend_keywords = true
      try {
        await this.m__fix_missing_keywords(this.selected_campaign)
        const placement = this.selected_campaign.advertisements.find(i => [0, 3].includes(i.placement))
        if (placement) {
          const added_keywords = new Set(placement.extinfo.keywords.map(i => i.keyword))
          const not_added_keywords = this.atosa_agent_suggest_keywords.filter(
            i => i.checked && !added_keywords.has(i.keyword))
          const add_new_keywords = not_added_keywords.map(i => {
            return {
              keyword: i.keyword,
              match_type: 0,
              price: this.MATCH_TYPE_0_MIN,
            }
          })
          await this.sp_user.marketing_pas_add_keyword(this.selected_campaign.campaign.campaignid, add_new_keywords)
        }

        this.show_dialog.recommend_keywords = false
        this.ntf_s('Thêm từ khóa thành công')
      } catch (e) {
        console.error(e)
        this.ntf_w('Đã có lỗi xảy ra')
      } finally {
        this.loading.add_recommend_keywords = false
      }
    },

    async m__get_atosa_agent_suggest_keywords() {
      if (!this.selected_campaign || !this.selected_campaign.product || !this.selected_campaign.product.itemid) return

      this.loading.recommend_keywords = true
      try {
        const suggest_keyword_response = await this.$http.post(
          this.API.URL_API_SRV_2 + '/mipee/atosa_agent/get_suggest_keywords', {
            shop_id: this.shop._id,
            product_id: this.selected_campaign.product.itemid,
            product_name: this.selected_campaign.product.name,
          }, this.cf())

        if (suggest_keyword_response && suggest_keyword_response.body && suggest_keyword_response.body.data &&
          suggest_keyword_response.body.data.length > 0) {
          const suggest_keywords = suggest_keyword_response.body.data

          if (suggest_keywords.length < 20) {
            const shopee_response = await this.sp_user.marketing_suggest_keyword(this.selected_campaign.product.itemid)
            const avg_search_volume = shopee_response.data.reduce((total, i) => total + i.search_volume, 0) /
              shopee_response.data.length / 2
            const shuffle = _shuffle(shopee_response.data.filter(i => i.search_volume > avg_search_volume)).slice(0, 20).map(i => {
              return {
                keyword: i.keyword,
                volume: i.search_volume,
              }
            })
            suggest_keywords.push(...shuffle)
          }

          const ordered = _orderBy(suggest_keywords, ['volume'], ['desc'])
          this.atosa_agent_suggest_keywords = ordered.map(i => ({
            ...i,
            checked: false,
          }))
          this.show_dialog.recommend_keywords = true
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.loading.recommend_keywords = false
      }
    },

    async m__redirect_to_buy_atosa_agent() {
      try {
        await this.$confirm(
          `Gói sản phẩm sẽ chỉ kích hoạt riêng cho từng shop, bạn có chắc chắn muốn mua gói cho shop "${this.shop.username}" không?`,
          this.$t('base.attention'), {
            type: 'warning',
            confirmButtonText: this.$t('base.confirm'),
            cancelButtonText: this.$t('base.cancel'),
          })
      } catch (e) {
        return
      }

      this.open_link(`https://banhang.atosa.asia/authenticate/handle?redirect=${encodeURIComponent(
        `/payment/transfer?channel=atosa_agent&extra=${JSON.stringify(
          { shop_id: this.shop._id })}`)}&token=${this.$store.state.userInfo.token}`)
    },

    m__check_atosa_agent_used_package() {
      const agent_found = this.atosa_agent_package
      if (agent_found) {
        return this.dayjs().isBefore(new Date(agent_found.expired_at), 'second')
          ? {
            result: true,
            package_name: agent_found.package_name,
            license_to: this.dayjs(new Date(agent_found.expired_at)).format('HH:mm DD/MM/YYYY'),
          }
          : { result: false }
      }
      return { result: false }
    },

    async m__get_current_atosa_agent_package() {
      if (!this.shop || !this.shop._id) return

      this.atosa_agent_package = null
      const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/atosa_agent/current_package',
        { shop_id: this.shop._id }, this.cf())
      this.atosa_agent_package = response.body.data

      if (this.m__check_atosa_agent_used_package().result === true) {
        await this.m__atosa_agent_get_campaign_result()
      }
    },

    m__check_is_unpaid_operating_cost() {
      return this.atosa_agent_unpaid && this.atosa_agent_unpaid.last_diff_hour &&
        this.atosa_agent_unpaid.last_diff_hour > this.atosa_agent_unpaid_max_hour
    },

    async m__get_unpaid_operating_cost() {
      if (!this.shop || !this.shop._id) return

      const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/atosa_agent/get_unpaid_cost', {
        shop_id: this.shop._id,
        current_time: this.dayjs().unix(),
      }, this.cf())
      this.atosa_agent_unpaid = response.body.data
    },

    m__has_agent() {
      return false && this.array_to_set(atosa_ai_fixed_list).has(this.$store.state.userInfo.username) || !!this.atosa_agent_package
    },

    m__get_auto_by_ai_result(campaign, key) {
      if (!this.atosa_agent_campaign_result[campaign.campaign.campaign_id]) return 0
      return +this.atosa_agent_campaign_result[campaign.campaign.campaign_id][key] || 0
    },

    m__get_auto_by_ai_target(campaign, key) {
      const config = this.auto_by_ai_config_list.find(
        i => i.campaign_id === campaign.campaign.campaignid && i.config_list !== '[]')
      if (!config) return 0

      const config_list = typeof config.config_list === 'string'
        ? JSON.parse(config.config_list)
        : this.clone(config.config_list)
      const [config_found] = config_list.filter(i => i.config_status === 1)
      if (!config_found) return 0

      if (+config_found.selected_target_roas && +config_found.selected_target_gmv) {
        if (key === 'roas') {
          return parseFloat(+config_found.selected_target_roas.toFixed(1))
        }
        if (key === 'gmv') {
          return this.m__calculate(+config_found.selected_target_gmv)
        }
      } else {
        const recommended_target_found = this.atosa_agent_recommended_target_list[campaign.campaign.campaignid]
        if (!recommended_target_found) return 0

        const {
          roas_list,
          gmv_list,
        } = recommended_target_found

        if (key === 'gmv') {
          if (config_found.target_gmv === 'gmv_1') return this.m__calculate(gmv_list[0])
          if (config_found.target_gmv === 'gmv_2') return this.m__calculate(gmv_list[1])
          if (config_found.target_gmv === 'gmv_3') return this.m__calculate(gmv_list[2])
          if (config_found.target_gmv === 'custom') return config_found.target_gmv_custom || 0
        }

        if (key === 'roas') {
          if (config_found.target_roas === 'roas_1') return parseFloat(roas_list[0].toFixed(1))
          if (config_found.target_roas === 'roas_2') return parseFloat(roas_list[1].toFixed(1))
          if (config_found.target_roas === 'roas_3') return parseFloat(roas_list[2].toFixed(1))
          if (config_found.target_roas === 'custom') return config_found.target_roas_custom || 0
        }
        return 0
      }
    },

    m__calculate_auto_by_ai_target(part, total) {
      if (!total) return 0
      if (!part) return 0
      if (part < 0) return 0

      const result = (part / total) * 100
      return result > 100 ? Math.round(result) : parseFloat(result.toFixed(1))
    },

    m__get_css_percent_auto_by_ai(campaign, key) {
      if (!campaign || !campaign.report) return ''

      const percent = this.m__calculate_auto_by_ai_target(this.m__get_auto_by_ai_result(campaign, key),
        this.m__get_auto_by_ai_target(campaign, key))
      const result = { background: `linear-gradient(to right, #4d9cd9 ${percent}%, #fff ${percent}%)` }
      if (percent >= 90) result['color'] = '#fff'

      return result
    },

    m__submit_welcome_atosa_agent_campaign_list() {
      const checked_list = this.welcome_atosa_agent_campaign_list.filter(i => i.checked)
      if (checked_list.length) {
        for (const campaign of checked_list) {
          const found = this.c__show_filter_campaign_list.find(
            i => i.campaign.campaignid === campaign.campaign.campaignid)
          if (found) found.checked = true
        }
        this.m__show_auto_by_ai_config_list_dialog()
      }

      this.show_dialog.welcome_atosa_agent = false
    },

    m__is_best_selling_product(campaign) {
      if (!this.m__has_agent()) {
        return false
      }

      const key_fields = ['impression', 'click', 'broad_gmv', 'cr', 'roi']
      if (campaign.children) {
        for (const child of campaign.children) {
          if (!child.report) continue
          for (const key of key_fields) {
            if (!child.report[key]) continue
            if (child.report[key].ratio > 0) return true
          }
        }
      }

      return false
    },

    m__is_able_to_x2(campaign) {
      return !!(this.m__is_best_selling_product(campaign) && campaign.is_parent &&
        campaign.children.some(i => this.m__can_setup_auto_by_ai(i)))
    },

    async m__convert_from_all_to_search() {
      try {
        await this.$confirm(this.$t('base.do_action_confirm'), this.$t('base.attention'), {
          type: 'warning',
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
        })
      } catch (e) {
        return
      }

      this.loading.get_campaigns = true

      this.ntf_w('ads.processing_convert_ads_message')

      for (const campaign of this.c__show_filter_campaign_list.filter(i => i.checked)) {
        if (campaign.campaign.shopee_type === 'product' && campaign.campaign.bidding_type === 'manual' &&
          campaign.campaign.type === 'all') {
          await this.m__fix_missing_keywords(campaign)

          const form = {
            campaign_id: campaign.campaign.campaignid,
            change_product_placement: {
              product_placement: 'search_product',
            },
            header: {},
            type: 'change_product_placement',
          }

          const placement0 = campaign.advertisements.find(i => i.placement === 0)
          if (!placement0) continue

          form['keyword_list'] = placement0.extinfo.keywords.filter(i => i.status === 1).map(i => ({
            keyword: i.keyword,
            bid_price: Math.trunc(i.price * 100000),
            match_type: i.match_type === 0 ? 'exact' : 'broad',
          }))

          const update_response = await this.sp_user.marketing_pas_update_campaign(form)
          console.log('campaign: ', campaign.campaign.campaignid, 'update_response: ', update_response)
        }
      }

      await this.m__get_ads_data()

      this.ntf_s(this.$t('base.update_success'))
    },

    async m__convert_from_all_to_discovery() {
      try {
        await this.$confirm(this.$t('base.do_action_confirm'), this.$t('base.attention'), {
          type: 'warning',
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
        })
      } catch (e) {
        return
      }

      this.loading.get_campaigns = true

      this.ntf_w('ads.processing_convert_ads_message')

      for (const campaign of this.c__show_filter_campaign_list.filter(i => i.checked)) {
        if (campaign.campaign.shopee_type === 'product' && campaign.campaign.bidding_type === 'manual' &&
          campaign.campaign.type === 'all') {
          await this.m__fix_missing_placement(campaign)

          const form = {
            campaign_id: campaign.campaign.campaignid,
            change_product_placement: {
              product_placement: 'targeting',
            },
            header: {},
            type: 'change_product_placement',
          }

          const display_location = {
            daily_discover: {},
            you_may_also_like: {},
          }
          const placement2 = this.campaign.advertisements.find(i => i.placement === 2)
          const placement5 = this.campaign.advertisements.find(i => i.placement === 5)
          if (!placement2 && !placement5) continue

          if (placement2) {
            display_location.daily_discover = {
              bid_price: Math.trunc(+placement2.extinfo.target.price * 100000),
              state: 'active',
            }
          } else {
            display_location.daily_discover = {
              bid_price: Math.trunc(this.TARGETING_MIN * 100000),
              state: 'active',
            }
          }
          if (placement5) {
            display_location.you_may_also_like = {
              bid_price: Math.trunc(+placement5.extinfo.target.price * 100000),
              state: 'active',
            }
          } else {
            display_location.you_may_also_like = {
              bid_price: Math.trunc(this.TARGETING_MIN * 100000),
              state: 'active',
            }
          }
          form.change_product_placement['display_location'] = display_location

          const update_response = await this.sp_user.marketing_pas_update_campaign(form)
          console.log('campaign: ', campaign.campaign.campaignid, 'update_response: ', update_response)
        }
      }

      await this.m__get_ads_data()

      this.ntf_s(this.$t('base.update_success'))
    },

    m__get_auto_condition_action_filename(file_id) {
      const found = this.auto_condition_action_file_list.find(i => i._id === file_id)
      return found ? found.filename : file_id
    },

    m__has_auto_by_ai_config(campaign) {
      return this.m__has_agent() && this.auto_by_ai_config_list.some(i => {
        const config_list = typeof i.config_list === 'string'
          ? JSON.parse(i.config_list)
          : i.config_list
        return i.campaign_id === campaign.campaign.campaignid && config_list.some(ii => ii.config_status === 1)
      })
    },

    async m__get_auto_by_ai_config() {
      const form = {
        campaign_ids: this.campaign_list.reduce((r, i) => {
          if (i.campaign && i.campaign.campaignid) r.push(i.campaign.campaignid)
          return r
        }, []),
      }
      const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/atosa_agent/get', form, this.cf())
      this.auto_by_ai_config_list = response.body.data.map(i => {
        if (!i.rules) {
          i.rules = {
            keyword: {
              allow: false,
              sources: [],
              files: [],
            },
          }
        }

        return i
      })
    },

    async m__show_confirm_delete_auto_by_ai_config() {
      const { created_at } = this.auto_by_ai_state.selected_config
      const start_time = this.dayjs(new Date(created_at)).startOf('day').unix()
      const end_time = this.dayjs().subtract(1, 'day').endOf('day').unix()
      const report_response = await this.sp_user.marketing_get_time_graph('product', start_time, end_time, { campaign_id: this.selected_campaign.campaign.campaignid })

      const last_month_start_time = this.dayjs().subtract(1, 'month').startOf('month').unix()
      const last_month_end_time = this.dayjs().subtract(1, 'month').date(this.dayjs().date()).endOf('day').unix()
      const last_month_report_response = await this.sp_user.marketing_get_time_graph('product', last_month_start_time,
        last_month_end_time, { campaign_id: this.selected_campaign.campaign.campaignid })

      if (report_response && report_response.data && last_month_report_response && last_month_report_response.data) {
        const result = {
          ...this.m__map_graph_response(report_response.data.report_aggregate),
          last_broad_roi: last_month_report_response.data.report_aggregate.broad_roi,
        }
        if (result.broad_roi > 0 && result.broad_roi < result.last_broad_roi) {
          const diff = result.last_broad_roi - result.broad_roi
          result.last_broad_roi -= (diff * 1.5)
        }
        this.auto_by_ai_state.report_since_setup = result
      } else {
        this.auto_by_ai_state.report_since_setup = null
      }

      this.show_dialog.confirm_delete_auto_by_ai = true
    },

    async m__confirm_delete_auto_by_ai_send_survey() {
      await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/form/delete_auto_by_ai', {
        survey_form: this.survey_form_checkbox_group,
      }, this.cf())
      await this.m__confirm_delete_auto_by_ai_config()

      this.show_dialog.survey_form = false
    },

    async m__confirm_delete_auto_by_ai_config() {
      await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/atosa_agent/delete',
        { campaign_ids: [this.auto_by_ai_state.selected_campaign_id] }, this.cf())
      await this.m__get_auto_by_ai_config()
      this.show_dialog.auto_by_ai = false
      this.show_dialog.auto_by_ai_config_list = false
      this.show_dialog.confirm_delete_auto_by_ai = false
      this.ntf_s(this.$t('base.delete_success'))

      this.survey_form_checkbox_group = []
    },

    async m__confirm_update_auto_by_ai_config(short = false) {
      if (!short) {
        try {
          await this.$confirm(
            `${this.$t('base.save_config_confirm')} Lưu ý, các cấu hình tự động bên trong chiến dịch sẽ bị tạm dừng!`,
            this.$t('base.attention'), {
              type: 'warning',
              confirmButtonText: this.$t('base.confirm'),
              cancelButtonText: this.$t('base.cancel'),
            })
        } catch (e) {
          return
        }
      }

      this.loading.auto_by_ai = true
      try {
        const form = {
          campaign_ids: this.auto_by_ai_state.selected_campaign_id
            ? [this.auto_by_ai_state.selected_campaign_id]
            : this.c__show_filter_campaign_list.filter(i => i.checked).map(i => i.campaign.campaignid),
          config_list: this.selected_auto_by_ai_config_list,
          rules: this.auto_by_ai_state.rules,
          shop_id: this.shop._id,
        }

        await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/atosa_agent/update', form, this.cf())

        if (!this.m__has_auto_by_ai_config(this.selected_campaign)) {
          await this.m__get_atosa_agent_suggest_keywords()
        }
        if (this.auto_by_ai_state.selected_campaign_id) {
          this.$http.post(this.API.URL_API_SRV_1 + '/auto_position/v2/status', {
            campaignId: this.auto_by_ai_state.selected_campaign_id,
            status: 0,
            mipeeUserId: this.$store.state.userInfo.username,
          }, this.cf()).catch(console.error)
          this.$http.post(this.API.URL_API_SRV_1 + '/auto_cir/status', {
            campaignId: this.auto_by_ai_state.selected_campaign_id,
            status: 0,
            mipeeUserId: this.$store.state.userInfo.username,
          }, this.cf()).catch(console.error)
          this.$http.post(this.API.URL_API_SRV_1 + '/anti_click/v2/status', {
            campaignId: this.auto_by_ai_state.selected_campaign_id,
            status: 0,
            mipeeUserId: this.$store.state.userInfo.username,
          }, this.cf()).catch(console.error)
        }
        await this.m__get_auto_by_ai_config()
        if (!short) this.show_dialog.auto_by_ai_config_list = false
        this.ntf_s(this.$t('base.update_success'))
      } catch (e) {
        console.error(e)
      } finally {
        this.loading.auto_by_ai = false
      }
    },

    m__edit_auto_by_ai_config(config) {
      this.show_dialog.auto_by_ai_key = make_uuid()
      this.selected_auto_by_ai_config = config
      this.show_dialog.auto_by_ai = true
    },

    m__add_auto_by_ai_config(data) {
      if (data.state === 'create') {
        this.selected_auto_by_ai_config_list.push(data.config)
      }
      if (data.state === 'edit') {
        let index_found = this.selected_auto_by_ai_config_list.findIndex(i => i.config_id === data.config.config_id)
        if (index_found !== -1) this.selected_auto_by_ai_config_list[index_found] = this.clone(data.config)
      }

      this.selected_auto_by_ai_config_list = this.clone(this.selected_auto_by_ai_config_list)
      this.show_dialog.auto_by_ai = false

      this.m__confirm_update_auto_by_ai_config(true).catch(console.error)
    },

    m__show_add_auto_by_ai_config_dialog() {
      this.selected_auto_by_ai_config = null
      this.show_dialog.auto_by_ai_key = make_uuid()
      this.show_dialog.auto_by_ai = true
    },

    m__can_setup_auto_by_ai(campaign) {
      return campaign && campaign.campaign.bidding_type === 'manual' &&
        ['all', 'keyword'].includes(campaign.campaign.type)
    },

    m__show_auto_by_ai_config_list_dialog_by_campaign_id(campaign_id) {
      const campaign_found = this.campaign_list.find(i => i.campaign.campaignid === campaign_id)
      if (!campaign_found) return

      this.m__show_auto_by_ai_config_list_dialog(campaign_found)
    },

    async m__show_auto_by_ai_config_list_dialog(campaign) {
      this.auto_by_ai_state.selected_campaign_id = null
      this.auto_by_ai_state.selected_campaign_name = null
      this.auto_by_ai_state.selected_config = null
      this.auto_by_ai_state.rules = {
        keyword: {
          allow: false,
          sources: [],
          files: [],
        },
      }

      if (campaign) {
        this.auto_by_ai_state.selected_campaign_id = campaign.campaign.campaignid
        this.auto_by_ai_state.selected_campaign_name = campaign.campaign.name
        this.selected_campaign = campaign

        const found = this.auto_by_ai_config_list.find(i => i.campaign_id === campaign.campaign.campaignid)
        if (found) {
          this.auto_by_ai_state.selected_config = found

          this.auto_by_ai_state.rules = typeof found.rules === 'string'
            ? JSON.parse(found.rules)
            : this.clone(found.rules)

          const config_list = typeof found.config_list === 'string'
            ? JSON.parse(found.config_list)
            : this.clone(found.config_list)

          // todo: set default value
          for (const item of config_list) {
            if (!item.mode) item.mode = ''
            if (!item.target) item.target = 'both'
            if (!item.target_period) item.target_period = 'month'
            if (!item.target_roas) item.target_roas = null
            if (!item.target_gmv) item.target_gmv = null
            if (!item.target_roas_custom) item.target_roas_custom = null
            if (!item.target_gmv_custom) item.target_gmv_custom = null
            if (!item.datetimes) item.datetimes = []
            if (!item.datetimes_daterange_type) item.datetimes_daterange_type = 'group'
            if (!item.allow_risk_control) item.allow_risk_control = false
            if (!item.max_cir) item.max_cir = null
            if (!item.max_cpc) item.max_cpc = null
            if (!item.min_cpc_math_type_0) item.min_cpc_math_type_0 = null
            if (!item.max_cpc_math_type_0) item.max_cpc_math_type_0 = item.max_cpc || null
            if (!item.max_cpc_month_math_type_0) item.max_cpc_month_math_type_0 = null
            if (!item.max_cpc_math_type_0_spd) item.max_cpc_math_type_0_spd = null
            if (!item.min_cpc_math_type_1) item.min_cpc_math_type_1 = null
            if (!item.max_cpc_math_type_1) item.max_cpc_math_type_1 = item.max_cpc || null
            if (!item.max_cpc_month_math_type_1) item.max_cpc_month_math_type_1 = null
            if (!item.max_cpc_math_type_1_spd) item.max_cpc_math_type_1_spd = null
            if (!item.allow_cpc_control) item.allow_cpc_control = true
            if (!item.min_gmv) item.min_gmv = null
            if (!item.min_roas) {
              if (+item.max_cir) {
                item.min_roas = 100 / +item.max_cir
              } else {
                item.min_roas = null
              }
            }
            if (!item.max_price) item.max_price = null
            if (!item.send_alert_to) {
              item.send_alert_to = 'email'
              item.alert_config = {
                email: '',
                zalo: '',
                telegram_bot_token: '',
                telegram_chat_id: '',
              }
            }
            if (!item.selected_target_roas) {
              item.selected_target_roas = null
            }
            if (!item.selected_target_gmv) {
              item.selected_target_gmv = null
            }
          }

          this.selected_auto_by_ai_config_list = config_list
        } else {
          this.selected_auto_by_ai_config_list = []
        }
      }

      this.show_dialog.auto_by_ai_config_list = true

      // todo: load recommend data
      if (campaign) {
        try {
          this.loading.recommend_target = true
          const recommend_response = await this.$http.post(
            this.API.URL_API_SRV_2 + '/mipee/atosa_agent/recommend_target', {
              shop_id: this.shop._id,
              campaign_id: campaign.campaign.campaignid,
              override: true,
            }, this.cf())
          this.atosa_agent_recommend_roas = recommend_response.body.data.roas_list
          this.atosa_agent_recommend_gmv = recommend_response.body.data.gmv_list
          await this.m__get_all_recommended_target()
        } catch (e) {
          console.error(e)
        }
        this.loading.recommend_target = false
      }
    },

    m__convert_json_to_automatic_condition() {
      try {
        const json = JSON.parse(this.auto_condition_action_json)
        if (Array.isArray(json)) {
          this.auto_condition_action_list = typeof json[0].config_list === 'string'
            ? JSON.parse(json[0].config_list)
            : this.clone(json[0].config_list)
        } else {
          this.auto_condition_action_list = typeof json.config_list === 'string'
            ? JSON.parse(json.config_list)
            : this.clone(json.config_list)
        }
      } catch (e) {
        console.error(e)
      }

      this.show_dialog.convert_json_to_automatic_condition = false
      this.show_dialog.auto_by_condition_list = true
      this.auto_condition_action_tab = 'configs'
    },

    m__convert_json_to_automatic_budget() {
      try {
        const json = JSON.parse(this.auto_quota_json)
        const fake_campaign = {
          campaign: {},
          auto_quota: json[0],
        }

        this.show_dialog.convert_json_to_automatic_budget = false
        this.m__show_config_auto_quota_dialog(fake_campaign)
      } catch (e) {
        console.error(e)
      }
    },

    m__on_change_search_keywords_mask() {
      if (this.search_keywords_mask === '') {
        this.search_keywords = ''
      }
    },

    async m__show_update_target_broad_roi_dialog(campaign) {
      if (!this.target_roas_includes.has(campaign.campaign.bidding_type)) return

      // this.sp_user.marketing_pas_get_recommended_roi_two_target(campaign.product.itemid || null, make_uuid(), campaign.campaign.shopee_type)
      this.sp_user.marketing_pas_get_recommended_roi_two_target_by_campaign_id(make_uuid(), campaign.campaign.campaignid, campaign.campaign.type)
        .then(response => {
          if (response && response.data) {
            this.form_update_target_broad_roi.custom_type_list = []
            this.form_update_target_broad_roi.custom_type_list.push(response.data.lower_bound.value)
            this.form_update_target_broad_roi.custom_type_list.push(response.data.exact.value)
            this.form_update_target_broad_roi.custom_type_list.push(response.data.upper_bound.value)
            this.form_update_target_broad_roi.last_log_key = response.data.log_key
          }

          const target = Math.trunc(campaign.campaign.roi_two_target * 100000)
          this.form_update_target_broad_roi.type = target ? 'custom' : 'auto'
          if (this.form_update_target_broad_roi.custom_type_list.includes(target)) {
            this.form_update_target_broad_roi.custom_type = target
          } else {
            this.form_update_target_broad_roi.custom_type = 'custom'
            this.form_update_target_broad_roi.custom_value = target / 100000
          }
        })

      this.selected_campaign = campaign
      this.show_dialog.update_target_broad_roi = true
    },

    async m__confirm_update_target_broad_roi() {
      this.loading.update_target_broad_roi = true

      // todo: edit roi two
      if (this.target_roas_includes.has(this.selected_campaign.campaign.bidding_type)) {
        let target_roi_two = this.form_update_target_broad_roi.type === 'custom'
          ? this.form_update_target_broad_roi.custom_type
          : 0

        if (this.form_update_target_broad_roi.type === 'custom' && this.form_update_target_broad_roi.custom_type ===
          'custom') {
          target_roi_two = Math.trunc(+this.form_update_target_broad_roi.custom_value * 100000)
          if (!target_roi_two) target_roi_two = 0

          if (!target_roi_two || Number.isNaN(target_roi_two)) {
            this.ntf_w(this.$t('required.target_broad_roi'))
            this.loading.update_target_broad_roi = false
            return
          }
        }

        const form = {
          campaign_id: this.selected_campaign.campaign.campaignid,
          header: {},
          reference_id: make_uuid(),
          type: 'change_roi_two_target',
          change_roi_two_target: {
            log_key: null,
            target_value: Math.round(target_roi_two),
          },
        }

        if (this.selected_campaign.campaign.shopee_type === 'live_stream') {
          delete form.reference_id
          form.change_roi_two_target.log_key = this.form_update_target_broad_roi.last_log_key
          form.change_roi_two_target.min_daily_budget = Math.round(this.selected_campaign.campaign.daily_quota * 100000)
        }

        const response = await this.sp_user.marketing_pas_update_campaign(form, this.selected_campaign.campaign.shopee_type)

        if (response && response.code === 0) {
          this.selected_campaign.campaign.roi_two_target = parseFloat((target_roi_two / 100000).toFixed(1))
        }
      }
      // todo: end edit roi two

      this.show_dialog.update_target_broad_roi = false
      this.loading.update_target_broad_roi = false
    },

    async m__on_cascader_change(value) {
      this.loading.get_campaigns = true

      this.cascader_type = value[0]
      this.cascader_id = value[value.length - 1]
      if (this.cascader_type === 'my_shop') {
        let offset = 0, limit = 100, product_ids = []
        let response = await this.sp_user.marketing_pas_get_products_with_category(offset, limit, 'my_shop',
          this.cascader_id)
        while (response && response.data && response.data.item_list && response.data.item_list.length) {
          product_ids.push(...response.data.item_list.map(i => i.itemid))
          offset += limit
          response = this.sp_user.marketing_pas_get_products_with_category(offset, limit, 'my_shop', this.cascader_id)
        }
        this.cascader_result = []
        this.cascader_result = product_ids
      }

      this.loading.get_campaigns = false
    },

    async m__get_auto_condition_action_link() {
      if (!this.auto_condition_action_file_code) return

      try {
        const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/auto_condition_action/file/get_link', {
          code: this.auto_condition_action_file_code,
        }, this.cf())

        if (response.body.data && response.body.data.file) {
          const file = response.body.data.file
          // console.log(file)

          await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/auto_condition_action/file/create', {
            filename: file.filename,
            config: JSON.parse(file.config),
            config_list: JSON.parse(file.config_list),
          }, this.cf())
          await this.m__get_auto_condition_action_files()
          this.ntf_s(this.$t('base.import_config_success'))
          this.show_dialog.get_link = false
        } else {
          this.ntf_w(this.$t('base.config_not_found'))
        }
      } catch (e) {
        console.error(e)
        this.ntf_w(e)
      }
    },

    async m__show_create_auto_condition_action_link_dialog(file) {
      try {
        const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/auto_condition_action/file/create_link',
          {
            file_id: file._id,
          }, this.cf())
        this.auto_condition_action_file_code = response.body.data.code
        this.show_dialog.create_link = true
      } catch (e) {
        console.error(e)
        this.ntf_w(e)
      }
    },

    async m__confirm_copy_auto_condition_action_config(file) {
      try {
        await this.$confirm('Bạn có chắc chắn muốn copy file cấu hình này không?', this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning',
        })
      } catch (e) {
        return
      }

      this.loading.save_auto_condition_action_file = true
      try {
        await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/auto_condition_action/file/create', {
          filename: file.filename + ' - copy',
          config: file.config,
          config_list: file.config_list,
        }, this.cf())
        await this.m__get_auto_condition_action_files()
        this.ntf_s(this.$t('base.save_success'))
        this.show_dialog.save_auto_condition_action_file = false
      } catch (e) {
        console.error(e)
        this.ntf_w(this.$t('base.has_an_occurred'))
      } finally {
        this.loading.save_auto_condition_action_file = false
      }
    },

    m__show_update_auto_condition_action_config_filename_dialog(file) {
      this.selected_auto_condition_action_file = file
      this.auto_condition_action_filename = file.filename
      this.show_dialog.update_auto_condition_action_filename = true
    },

    async m__update_auto_condition_action_config_filename() {
      try {
        await this.$confirm(this.$t('base.update_file_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning',
        })
      } catch (e) {
        return
      }

      this.loading.update_auto_condition_action_filename = true
      try {
        await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/auto_condition_action/file/update', {
          file_id: this.selected_auto_condition_action_file._id,
          filename: this.auto_condition_action_filename,
          config: this.selected_auto_condition_action_file.config,
          config_list: this.selected_auto_condition_action_file.config_list,
        }, this.cf())
        await this.m__get_auto_condition_action_files()
        this.ntf_s(this.$t('base.update_success'))
        this.show_dialog.update_auto_condition_action_filename = false
      } catch (e) {
        console.error(e)
        this.ntf_w(this.$t('base.has_an_occurred'))
      } finally {
        this.loading.update_auto_condition_action_filename = false
      }
    },

    async m__delete_auto_condition_action_config_file(file, show_ntf = true) {
      if (show_ntf) {
        try {
          await this.$confirm(this.$t('base.delete_file_confirm') + ' Các cấu hình đang áp dụng file này cũng sẽ bị gỡ bỏ.', this.$t('base.attention'), {
            confirmButtonText: this.$t('base.confirm'),
            cancelButtonText: this.$t('base.cancel'),
            type: 'warning',
          })
        } catch (e) {
          return
        }
      }

      try {
        await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/auto_condition_action/file/delete', {
          file_id: file._id,
        }, this.cf())

        if (show_ntf) {
          await this.m__get_auto_condition_action_files()
          this.ntf_s(this.$t('base.update_success'))
        }
      } catch (e) {
        console.error(e)
        this.ntf_w(this.$t('base.has_an_occurred'))
      }
    },

    async m__batch_delete_auto_condition_action_config_file() {
      try {
        await this.$confirm(this.$t('base.update_data_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning',
        })
      } catch (e) {
        return
      }

      try {
        for (const file of this.c__auto_condition_action_config_file_list.filter(i => i.selected)) {
          await this.m__delete_auto_condition_action_config_file(file, false)
        }

        await this.m__get_auto_condition_action()
        await this.m__get_auto_condition_action_files()
        this.ntf_s(this.$t('base.update_success'))
        this.show_dialog.auto_by_condition_list = false
      } catch (e) {
        console.error(e)
        this.ntf_w(this.$t('base.has_an_occurred'))
      }
    },

    async m__delete_auto_condition_action_config_file_link(file, show_ntf = true) {
      if (show_ntf) {
        try {
          await this.$confirm(this.$t('base.update_data_confirm'), this.$t('base.attention'), {
            confirmButtonText: this.$t('base.confirm'),
            cancelButtonText: this.$t('base.cancel'),
            type: 'warning',
          })
        } catch (e) {
          return
        }
      }

      try {
        await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/auto_condition_action/file/delete_link', {
          file_id: file._id,
        }, this.cf())

        if (show_ntf) {
          await this.m__get_auto_condition_action()
          await this.m__get_auto_condition_action_files()
          this.ntf_s(this.$t('base.update_success'))
          this.show_dialog.auto_by_condition_list = false
        }
      } catch (e) {
        console.error(e)
        this.ntf_w(this.$t('base.has_an_occurred'))
      }
    },

    async m__update_auto_condition_action_config_file() {
      try {
        await this.$confirm(this.$t('base.update_file_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning',
        })
      } catch (e) {
        return
      }

      this.loading.update_auto_condition_action_config_file = true
      try {
        const new_config = {
          ...this.clone(this.form_auto_condition_action),
          condition_action_list: this.clone(this.condition_action_list),
        }
        await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/auto_condition_action/file/update', {
          file_id: this.selected_auto_condition_action_file._id,
          filename: this.selected_auto_condition_action_file.filename,
          config: new_config,
          config_list: [new_config],
          sync_to_applied_config: this.sync_to_applied_config,
        }, this.cf())
        await this.m__get_auto_condition_action_files()
        await this.m__get_auto_condition_action()
        this.ntf_s(this.$t('base.update_success'))
        this.show_dialog.auto_by_condition = false
        this.show_dialog.auto_by_condition_list = false // todo: testable

        if (this.sync_to_applied_config) {

        }
      } catch (e) {
        console.error(e)
        this.ntf_w(this.$t('base.has_an_occurred'))
      } finally {
        this.loading.update_auto_condition_action_config_file = false
      }
    },

    async m__show_update_auto_condition_action_config_file_dialog(config, file) {
      this.selected_auto_condition_action_file = file
      this.selected_auto_condition_action_config = config

      this.form_auto_condition_action.advanced_day = config.advanced_day
      this.form_auto_condition_action.advanced_day_number = config.advanced_day_number
      this.form_auto_condition_action.time = config.time
      this.form_auto_condition_action.times = config.times
      this.form_auto_condition_action.name = config.name
      this.form_auto_condition_action.radio = config.radio
      this.form_auto_condition_action.not_in = config.not_in

      this.condition_action_list = this.clone(config.condition_action_list)

      this.auto_condition_action_state = {
        ...this.auto_condition_action_state,
        type: 'update_file',
        updated_advanced_day: config.advanced_day,
        updated_advanced_day_number: config.advanced_day_number,
        updated_config_list_index: null,
      }

      this.m__fix_condition_action_list()
      this.show_dialog.auto_by_condition = true
    },

    async m__get_auto_condition_action_files() {
      const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/auto_condition_action/file/get', {},
        this.cf())
      for (const item of response.body.data) {
        item.selected = false
        if (typeof item.config === 'string') {
          item.config = JSON.parse(item.config)
        }
        if (typeof item.config_list === 'string') {
          item.config_list = JSON.parse(item.config_list)
        }
      }
      this.auto_condition_action_file_list = response.body.data
    },

    m__show_save_auto_condition_action_file_dialog(config) {
      this.selected_auto_condition_action_config = config
      this.auto_condition_action_filename = config.name || ''
      this.show_dialog.save_auto_condition_action_file = true
    },

    async m__save_auto_condition_action_file() {
      if (!this.auto_condition_action_filename || !this.selected_auto_condition_action_config) {
        return
      }

      this.loading.save_auto_condition_action_file = true
      try {
        await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/auto_condition_action/file/create', {
          filename: this.auto_condition_action_filename,
          config: this.selected_auto_condition_action_config,
          config_list: [this.selected_auto_condition_action_config],
        }, this.cf())
        await this.m__get_auto_condition_action_files()
        this.ntf_s(this.$t('base.save_success'))
        this.show_dialog.save_auto_condition_action_file = false
      } catch (e) {
        console.error(e)
        this.ntf_w(this.$t('base.has_an_occurred'))
      } finally {
        this.loading.save_auto_condition_action_file = false
      }
    },

    m__can_clone_campaign(campaign) {
      return campaign.campaign.shopee_type === 'product' ||
        (campaign.campaign.type === 'shop' && campaign.campaign.bidding_type !== 'auto')
    },

    async m__clone_campaign(campaign) {

      try {
        await this.$confirm(this.$t('base.clone_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning',
        })
      } catch (e) {
        return
      }

      console.log('clone campaign:', campaign)
      this.clone_campaign_results = []

      if (campaign.campaign.type === 'all') {
        await this.m__fix_missing_keywords(campaign)
      }
      if (campaign.campaign.type === 'keyword') {
        await this.m__fix_missing_keywords(campaign)
      }
      if (campaign.campaign.type === 'shop') {
        await this.m__fix_missing_keywords(campaign)
      }
      if (campaign.campaign.type === 'targeting') {
        await this.m__fix_missing_placement(campaign)
      }

      if (campaign.campaign.type === 'shop') {
        const form = {
          reference_id: make_uuid(),
          campaign: {
            campaign_id: 0,
            target_broad_roi: 0,
            daily_budget: Math.trunc(campaign.campaign.daily_quota * 100000),
            creative: {
              is_use_default: !campaign.advertisements[0].extinfo.shop_customisation.display_title,
              landing_page: 'shop_homepage',
              image_url: campaign.advertisements[0].extinfo.shop_customisation.image_url,
              tagline: campaign.advertisements[0].extinfo.shop_customisation.display_title,
            },
            bidding_strategy: campaign.campaign.bidding_type,
            start_time: this.dayjs().startOf('day').unix(),
            end_time: 0,
            name: campaign.campaign.name + ' ' + this.random_range(1000, 9999),
          },
          header: {},
        }

        if (campaign.campaign.bidding_type === 'manual') {
          const placement3 = campaign.advertisements.find(i => i.placement === 3)

          form.campaign.bidding_strategy = 'manual'
          form.campaign.keyword_list = placement3.extinfo.keywords.filter(i => i.status === 1).map(keyword => {
            return {
              keyword: keyword.keyword.trim().normalize().toLowerCase(),
              bid_price: Math.trunc(keyword.price * 100000),
              match_type: keyword.match_type === 0 ? 'exact' : 'broad',
            }
          })
          form.campaign.keyword_list = _uniqBy(form.campaign.keyword_list, 'keyword').slice(0, 200)
        }

        console.log('clone form:', form)
        const create_response = await this.sp_user.marketing_pas_publish_campaign(form, 'shop')
        console.log('clone create_response:', create_response)

        if (create_response) {
          const keyword_black_list = []
          if (create_response.code !== 0 && create_response.validation_error_list) {
          }

          this.clone_campaign_results.push({
            name: campaign.product.name,
            code: create_response.code,
            validation_error_list: [
              this.$t('base.error_code') + ': ' + (create_response.msg || create_response.message) + ', code:' +
              create_response.code],
          })
        }

        this.show_dialog.clone_campaign_result = true
      } else {
        const form = {
          reference_id: make_uuid(),
          campaign: {
            daily_budget: Math.trunc(campaign.campaign.daily_quota * 100000),
            product_placement: campaign.campaign.type,
            ecpc: false,
            bidding_strategy: campaign.campaign.bidding_type,
            product_selection: 'manual',
            start_time: this.dayjs().startOf('day').unix(),
            end_time: 0,
          },
          ads_list: [
            {
              item_id: campaign.product.itemid,
            },
          ],
          header: {},
        }

        if (form.campaign.product_placement === 'keyword') form.campaign.product_placement = 'search_product'
        if (campaign.campaign.bidding_type === 'auto') {
          delete form.campaign.ecpc
          delete form.campaign.keyword_list
          delete form.campaign.display_location
          delete form.campaign.target_audience
          form.campaign.target_broad_roi = 0
          // form.campaign.target_broad_roi = campaign.advertisements[0].extinfo.target_broad_roi
        }
        if (campaign.campaign.bidding_type === 'roi_two') {
          delete form.campaign.ecpc
          delete form.campaign.keyword_list
          delete form.campaign.display_location
          delete form.campaign.target_audience

          form.campaign.roi_two_target = campaign.advertisements[0].extinfo.roi_two.target
        }
        if (['all', 'keyword'].includes(campaign.campaign.type) && campaign.campaign.bidding_type === 'manual') {
          const placement0 = campaign.advertisements.find(i => i.placement === 0)
          form.campaign.keyword_list = placement0.extinfo.keywords.filter(i => i.status === 1).map(keyword => {
            return {
              keyword: keyword.keyword.trim().normalize().toLowerCase(),
              bid_price: Math.trunc(keyword.price * 100000),
              match_type: keyword.match_type === 0 ? 'exact' : 'broad',
            }
          })
          form.campaign.keyword_list = _uniqBy(form.campaign.keyword_list, 'keyword').slice(0, 200)
        }
        if (['all', 'targeting'].includes(campaign.campaign.type) && campaign.campaign.bidding_type === 'manual') {
          const placement2 = campaign.advertisements.find(i => i.placement === 2)
          const placement5 = campaign.advertisements.find(i => i.placement === 5)
          form.campaign.display_location = {
            daily_discover: {
              state: 'active',
              bid_price: Math.trunc(placement2.extinfo.target.price * 100000),
            },
            you_may_also_like: {
              state: 'active',
              bid_price: Math.trunc(placement5.extinfo.target.price * 100000),
            },
          }
        }

        if (form.campaign.bidding_strategy === 'roi_two') {
          delete form.campaign.ecpc
        }

        console.log('clone campaign:', campaign)
        console.log('clone form:', form)
        const create_response = await this.sp_user.marketing_pas_publish_campaign(form)
        console.log('clone create_response:', create_response)

        if (create_response) {
          this.clone_campaign_results.push({
            ...campaign.product,
            code: create_response.code,
            validation_error_list: create_response.validation_error_list ||
              (create_response.data.result_list && create_response.data.result_list &&
                create_response.data.result_list.length && create_response.data.result_list[0].validation_error_list),
          })
        }

        this.show_dialog.clone_campaign_result = true
      }
    },

    async m__delete_atosa_filter(data) {
      try {
        await this.$confirm(this.$t('base.delete_filter_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning',
        })
      } catch (e) {
        return
      }

      await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/filter/delete', {
        filter_id: data._id,
      }, this.cf())
      await this.m__get_filter()

      this.ntf_s(this.$t('base.delete_success'))
    },

    m__use_filter(data) {
      for (const item of data.data) {
        const found = this.filter.find(i => i.camel_key === item.camel_key)
        if (found) {
          found.expression = item.expression
          found.value = item.value
          found.value2 = item.value2
        }
      }
      this.show_dialog.filter_list = false
    },

    async m__get_filter() {
      const response = await this.$http.get(this.API.URL_API_SRV_2 + '/mipee/filter/get', this.cf())
      this.filter_list = response.body.data
    },

    async m__save_filter() {
      if (!this.filter_name) return

      this.loading.save_filter = true
      await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/filter/create', {
        name: this.filter_name,
        data: this.filter,
      }, this.cf())
      await this.m__get_filter()

      this.loading.save_filter = false
      this.show_dialog.save_filter = false
      this.ntf_s(this.$t('base.save_success'))
    },

    m__duplicate_auto_condition_action_from_object(data, file) {
      const found = data.advanced_day === 'day'
        ? this.auto_condition_action_list.find(
          i => i.advanced_day === data.advanced_day && i.advanced_day_number === data.advanced_day_number)
        : this.auto_condition_action_list.find(i => i.advanced_day === data.advanced_day)
      if (found) {
        found.config_list.push({
          ...this.clone(data),
          condition_action_list: this.clone(data.condition_action_list),
          link_to: file ? file._id : null,
          enable: true
        })
      } else {
        this.auto_condition_action_list.push({
          type: data.advanced_day,
          advanced_day: data.advanced_day,
          day_number: data.advanced_day_number,
          advanced_day_number: data.advanced_day_number,
          time: data.time,
          times: data.times,
          config_list: [
            {
              ...this.clone(data),
              condition_action_list: this.clone(data.condition_action_list),
              link_to: file ? file._id : null,
              enable: true
            }],
        })
      }

      this.auto_condition_action_tab = 'configs'
    },

    m__is_show_auto_condition_action_config(campaign) {
      if (!campaign.auto_condition_action || !campaign.auto_condition_action.config_list || !campaign.auto_condition_action.config_list.length) {
        return false
      }

      const config_list = typeof campaign.auto_condition_action.config_list === 'string'
        ? JSON.parse(campaign.auto_condition_action.config_list)
        : this.clone(campaign.auto_condition_action.config_list)
      const condition_length = config_list.reduce((total, item) => total + item.config_list.length, 0)

      return condition_length > 0
    },

    m__is_auto_condition_action_config_running(campaign) {
      if (!campaign.auto_condition_action || !campaign.auto_condition_action.config_list || !campaign.auto_condition_action.config_list.length) {
        return false
      }

      const config_list = typeof campaign.auto_condition_action.config_list === 'string'
        ? JSON.parse(campaign.auto_condition_action.config_list)
        : this.clone(campaign.auto_condition_action.config_list)

      return config_list.some(i => i.config_list.some(j => j.enable))
    },

    m__get_campaign_in_new_tab_url(campaign) {
      let url = `/marketing/pas?type=${this.campaign_type}&shop_id=${this.shop.shop_id}&campaign_id=${campaign.campaign.campaignid}&from=${this.start_date.getTime()}&to=${this.end_date.getTime()}`
      if (this.is_compare_campaign && this.compare_date_range[0] && this.compare_date_range[1]) {
        url += `&is_compare=true&compare_from=${this.dayjs(this.compare_date_range[0]).unix() *
        1000}&compare_to=${this.dayjs(this.compare_date_range[1]).unix() * 1000}`
      }

      return url
    },

    m__map_campaign_image(campaign) {
      if (this.sp_user.is_buff) {
        if (campaign.campaign.type === 'shop') {
          return this.SHOPEE_IMAGE('sg-11134201-7rbk0-louxtq64h8mw49')
        } else {
          const product_found = this.product_list.find(i => i.id === campaign.product.itemid)
          if (product_found) {
            return this.SHOPEE_IMAGE(product_found.images.split(',')[0])
          } else {
            return this.SHOPEE_IMAGE('sg-11134201-7rbk0-louxtq64h8mw49')
          }
        }
      } else {
        if (campaign.campaign.type === 'all') {
          return this.SHOPEE_IMAGE(campaign.product.images.split(',')[0])
        }
        if (campaign.campaign.type === 'keyword') {
          return this.SHOPEE_IMAGE(campaign.product.images.split(',')[0])
        }
        if (campaign.campaign.type === 'targeting') {
          return this.SHOPEE_IMAGE(campaign.product.images.split(',')[0])
        }
        if (campaign.campaign.type === 'shop') {
          return this.SHOPEE_IMAGE(
            campaign.campaign.image_url || campaign.advertisements[0].extinfo.shop_customisation.image_url)
        }

        return campaign.product.images
          ? this.SHOPEE_IMAGE(campaign.product.images.split(',')[0])
          : this.SHOPEE_IMAGE('sg-11134201-7rbk0-louxtq64h8mw49')
      }
    },

    m__is_show_atosa_index(value) {
      const flag = this.atosa_flag_list.find(i => i.value === value)
      return flag ? flag.checked : false
    },

    async m__set_atosa_flag_list() {
      const flags = this.atosa_flag_list.filter(i => i.checked).map(i => i.value)
      await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/atosa_flags/set', {
        shop_id: this.shop._id,
        flags,
      }, this.cf())
    },

    async m__get_atosa_flag_list() {
      try {
        const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/atosa_flags/get',
          { shop_id: this.shop._id }, this.cf())

        if (response.body.data && response.body.data.flags && response.body.data.flags.length) {
          for (const flag of response.body.data.flags) {
            const flag_found = this.atosa_flag_list.find(i => i.value === flag)
            if (flag_found) flag_found.checked = true
          }
        }
      } catch (e) {
        console.error(e)
      }
    },

    async m__delete_campaign_tag(tag) {
      try {
        await this.$confirm(this.$t('base.delete_tags_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning',
        })
      } catch (e) {
        return
      }

      try {
        await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/campaign_tags/delete', {
          _id: tag._id,
        }, this.cf())
        await this.m__get_campaign_tag()
        this.ntf_s(this.$t('base.delete_success'))
      } catch (e) {
        console.error(e)
        this.ntf_w(this.$t('base.has_an_occurred'))
      }
    },

    async m__create_campaign_tag() {
      if (!this.campaign_tag_name) {
        return
      }

      this.loading.create_tag = true
      try {
        await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/campaign_tags/create', {
          name: this.campaign_tag_name,
          color: '',
        }, this.cf())
        await this.m__get_campaign_tag()

        this.loading.create_tag = false
        this.campaign_tag_name = ''
      } catch (e) {
        console.error(e)
        this.ntf_w(this.$t('base.has_an_occurred'))
      } finally {
        this.loading.create_tag = false
      }
    },

    m__toggle_update_campaign_tag(tag, value) {
      tag.temp_name = tag.name
      tag.editable = value
    },

    async m__update_campaign_tag(tag) {
      if (!tag.name || !tag.temp_name) {
        return
      }

      try {
        await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/campaign_tags/update', {
          _id: tag._id,
          name: tag.temp_name,
        }, this.cf())

        tag.name = tag.temp_name
        tag.editable = false
      } catch (e) {
        console.error(e)
        this.ntf_w(this.$t('base.has_an_occurred'))
      }
    },

    m__check_campaign_has_tag(campaign_id) {
      const match_found = this.campaign_tag_match.find(i => i.campaign_id === campaign_id)
      return !!match_found
    },

    m__check_campaign_match(campaign_id, tag_id) {
      const match_found = this.campaign_tag_match.find(i => i.campaign_id === campaign_id)
      return match_found && match_found.tag_id === tag_id
    },

    m__map_campaign_tag(campaign) {
      const match_found = this.campaign_tag_match.find(i => i.campaign_id === campaign.campaign.campaignid)
      if (match_found) {
        const tag = this.campaign_tag_list.find(i => i._id === match_found.tag_id)
        return tag ? tag.name : null
      }

      return null
    },

    m__handle_campaign_tag_command(command) {
      const {
        campaign_id,
        tag_id,
      } = JSON.parse(command)
      if (tag_id === 'remove_tag') {
        this.m__remove_tag_to_campaign(campaign_id)
      } else {
        this.m__add_tag_to_campaign(campaign_id, tag_id)
      }
    },

    async m__get_campaign_tag_match() {
      const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/campaign_tags/get_match', {}, this.cf())
      this.campaign_tag_match = response.body.data
    },

    async m__add_tag_to_campaign(campaign_id, tag_id) {
      if (!tag_id) {
        return
      }

      try {
        await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/campaign_tags/add_to_campaigns', {
          tag_id: tag_id,
          campaign_ids: [campaign_id],
        }, this.cf())
        await this.m__get_campaign_tag_match()
        this.show_dialog.add_tag_to_campaigns = false
        this.ntf_s(this.$t('base.update_success'))
      } catch (e) {
        console.error(e)
        this.ntf_w(e)
      }
    },

    async m__remove_tag_to_campaign(campaign_id) {
      try {
        await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/campaign_tags/remove_from_campaigns', {
          campaign_ids: [campaign_id],
        }, this.cf())
        await this.m__get_campaign_tag_match()
      } catch (e) {
        console.error(e)
        this.ntf_w(e)
      }
    },

    async m__get_campaign_tag() {
      const response = await this.$http.get(this.API.URL_API_SRV_2 + '/mipee/campaign_tags/get', this.cf())
      for (const item of response.body.data) {
        item.temp_name = ''
        item.editable = false
      }
      this.campaign_tag_list = response.body.data
    },

    m__show_create_tag_dialog() {
      this.show_dialog.create_tag = true
    },

    m__handle_tag_command(command) {
      if (command === 'create_tag') {
        this.m__show_create_tag_dialog()
      } else if (command === 'add_to_keyword') {
        this.show_dialog.add_tag_to_campaigns = true
      } else if (command === 'remove_from_keyword') {
        this.m__remove_tag_to_campaigns()
      } else if (command === 'added') {
        this.tag_ids_selected.includes('added') ? this.tag_ids_selected = [] : this.tag_ids_selected = ['added']
      } else if (command === 'not_added') {
        this.tag_ids_selected.includes('not_added') ? this.tag_ids_selected = [] : this.tag_ids_selected = ['not_added']
      } else {
        this.tag_ids_selected = this.tag_ids_selected.filter(i => !['added', 'not_added'].includes(i))
        if (this.m__check_tag_ids_selected(command)) {
          this.tag_ids_selected = this.tag_ids_selected.filter(i => i !== command)
        } else {
          this.tag_ids_selected.push(command)
        }
      }
    },

    async m__add_tag_to_campaigns() {
      if (!this.campaign_tag_id_selected) {
        return
      }

      this.loading.add_tag_to_campaigns = true
      try {
        const campaign_ids = this.c__show_filter_campaign_list.filter(i => i.checked).map(i => i.campaign.campaignid)
        await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/campaign_tags/add_to_campaigns', {
          tag_id: this.campaign_tag_id_selected,
          campaign_ids: campaign_ids,
        }, this.cf())
        await this.m__get_campaign_tag_match()
        this.show_dialog.add_tag_to_campaigns = false
        this.ntf_s(this.$t('base.update_success'))
      } catch (e) {
        console.error(e)
        this.ntf_w(e)
      } finally {
        this.loading.add_tag_to_campaigns = false
      }
    },

    async m__remove_tag_to_campaigns() {
      try {
        const campaigns_ids = this.c__show_filter_campaign_list.filter(i => i.checked).map(i => i.campaign.campaignid)
        await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/campaign_tags/remove_from_campaigns', {
          campaign_ids: campaigns_ids,
        }, this.cf())
        await this.m__get_campaign_tag_match()
        this.ntf_s(this.$t('base.update_success'))
      } catch (e) {
        console.error(e)
        this.ntf_w(e)
      }
    },

    m__check_tag_ids_selected(tag_id) {
      return this.tag_ids_selected.includes(tag_id)
    },

    m__on_change_product_placement(data) {
      const campaign_found = this.campaign_list.find(i => i.campaign.campaignid === data.campaign_id)
      console.log(campaign_found)
      if (!campaign_found) return

      this.$emit('update:campaign_component', 'list')
      if (data.new_type === 'all') {
        campaign_found.campaign.type = 'all'
      }
      if (data.new_type === 'search_product') {
        campaign_found.campaign.type = 'keyword'
      }
      if (data.new_type === 'targeting') {
        campaign_found.campaign.type = 'targeting'
      }
      this.m__show_campaign_detail(campaign_found)
    },

    async m__use_template(key) {
      if (this.selected_template === key) {
        return
      }

      try {
        await this.$confirm(this.$t('base.use_condition_template_message'), this.$t('base.attention'), {
          type: 'warning',
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
        })
      } catch (e) {
        return
      }

      if (key === 'manual') {
        const template = this.clone(this.condition_action_template)
        template.condition_group.push({
          condition_list: [this.clone(this.condition_template)],
        })

        this.form_auto_condition_action = {
          name: '',
          level: 'campaign',
          advanced_day: null,
          advanced_day_number: null,
          radio: '1',
          time: '',
          start_time: '',
          end_time: '',
          times: [],
          condition_action_list: [template],
          not_in: action_template,
        }
        this.condition_action_list = this.clone(this.form_auto_condition_action.condition_action_list)
        this.selected_template = 'manual'
      }

      if (key === 'auto_position') {
        this.form_auto_condition_action = this.clone(template_auto_position_x_auto_cir)
        this.condition_action_list = this.clone(this.form_auto_condition_action.condition_action_list)
        this.selected_template = 'auto_position'
      }

      if (key === 'auto_quota') {
        this.form_auto_condition_action = this.clone(template_auto_quota)
        this.condition_action_list = this.clone(this.form_auto_condition_action.condition_action_list)
        this.selected_template = 'auto_quota'
      }

      this.m__fix_condition_action_list()
    },

    async m__confirm_convert_to_auto_action_condition() {
      try {
        await this.$confirm(this.$t('base.convert_to_condition_message'), this.$t('base.attention'), {
          type: 'warning',
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
        })
      } catch (e) {
        return
      }

      this.loading.convert_to_auto_condition_action = true
      try {
        for (const campaign of this.c__show_filter_campaign_list.filter(i => i.checked)) {
          await convert_auto_config(campaign, action_template, this)
        }
        await this.m__get_auto_condition_action()
        this.show_dialog.convert_to_auto_condition_action = false
        this.ntf_s(this.$t('base.update_success'))
      } catch (e) {
        console.error(e)
        this.ntf_w(e)
      } finally {
        this.loading.convert_to_auto_condition_action = false
      }
    },

    m__show_auto_condition_action_detail_dialog(data) {
      this.auto_condition_action_detail.campaign_detail_id = data.campaign_detail_id
      this.auto_condition_action_detail.keyword_list = data.keyword_list

      const [auto_condition_action] = this.auto_condition_action_detail_config_list.filter(
        i => i.campaign_detail_id === data.campaign_detail_id && data.keyword_list.includes(i.keyword))
      if (auto_condition_action) {
        this.auto_condition_action_list = typeof auto_condition_action.config_list === 'string'
          ? JSON.parse(auto_condition_action.config_list)
          : this.clone(auto_condition_action.config_list)
      } else {
        this.auto_condition_action_list = []
      }

      this.show_dialog.auto_by_condition_list = true
      this.auto_condition_action_tab = 'configs'
    },

    m__show_auto_condition_action_dialog(campaign = null) {
      this.auto_condition_action_detail.campaign_detail_id = null
      this.auto_condition_action_detail.keyword_list = null

      if (!campaign) {
        const campaign_ids = this.array_to_set(this.c__show_filter_campaign_list.filter(i => i.checked).map(i => i.campaign.campaignid))
        if (campaign_ids) {
          const found = this.auto_condition_action_config_list.find(i => campaign_ids.has(i.campaign_id))
          if (found) {
            this.auto_condition_action_list = typeof found.config_list === 'string'
              ? JSON.parse(found.config_list)
              : this.clone(found.config_list)
            this.auto_condition_action_only_show_me = !!found.only_show_me
          } else {
            this.auto_condition_action_list = []
            this.auto_condition_action_only_show_me = false
          }
        }

        this.auto_condition_action_state.selected_item_id = null
        this.auto_condition_action_state.selected_campaign_id = null
        this.auto_condition_action_state.selected_campaign_name = null
      } else {
        if (campaign.is_parent) {
          if (campaign.auto_condition_action) {
            this.auto_condition_action_list = typeof campaign.auto_condition_action.config_list === 'string'
              ? JSON.parse(campaign.auto_condition_action.config_list)
              : this.clone(campaign.auto_condition_action.config_list)
            this.auto_condition_action_only_show_me = !!campaign.auto_condition_action.only_show_me
          }
          this.auto_condition_action_state.selected_item_id = campaign.product.itemid
          this.auto_condition_action_state.selected_campaign_id = null
          this.auto_condition_action_state.selected_campaign_name = null
        } else {
          if (campaign.auto_condition_action) {
            this.auto_condition_action_list = typeof campaign.auto_condition_action.config_list === 'string'
              ? JSON.parse(campaign.auto_condition_action.config_list)
              : this.clone(campaign.auto_condition_action.config_list)
            this.auto_condition_action_only_show_me = !!campaign.auto_condition_action.only_show_me
          }
          this.auto_condition_action_state.selected_item_id = null
          this.auto_condition_action_state.selected_campaign_id = campaign.campaign.campaignid
          this.auto_condition_action_state.selected_campaign_name = campaign.campaign.name
        }
      }

      this.show_dialog.auto_by_condition_list = true
      this.auto_condition_action_tab = 'configs'
    },

    m__show_duplicate_auto_condition_action_config_dialog(data, index, config) {
      this.form_auto_condition_action.advanced_day = data.advanced_day = config.advanced_day
      this.form_auto_condition_action.advanced_day_number = config.data = config.advanced_day_number
      this.form_auto_condition_action.time = data.time
      this.form_auto_condition_action.times = data.times
      this.form_auto_condition_action.name = data.name
      this.form_auto_condition_action.radio = data.radio
      this.form_auto_condition_action.not_in = data.not_in

      this.condition_action_list = this.clone(data.condition_action_list)

      this.auto_condition_action_state = {
        ...this.auto_condition_action_state,
        type: 'add',
        updated_advanced_day: null,
        updated_advanced_day_number: null,
        updated_config_list_index: null,
      }

      this.m__fix_condition_action_list()
      this.show_dialog.auto_by_condition = true
    },

    m__show_update_auto_condition_action_config_dialog(data, index, config) {
      // todo: fix radio 4
      if (data.radio === '4' && (!data.times || !data.times.length)) {
        data.times = [
          {
            start_time: data.start_time,
            end_time: data.end_time
          }
        ]

        data.start_time = null
        data.end_time = null
      }

      this.form_auto_condition_action.advanced_day = data.advanced_day = config.advanced_day
      this.form_auto_condition_action.advanced_day_number = config.data = config.advanced_day_number
      this.form_auto_condition_action.time = data.time
      this.form_auto_condition_action.times = data.times
      this.form_auto_condition_action.name = data.name
      this.form_auto_condition_action.radio = data.radio
      this.form_auto_condition_action.not_in = data.not_in
      this.form_auto_condition_action.start_time = data.start_time
      this.form_auto_condition_action.end_time = data.end_time
      this.form_auto_condition_action.config_id = data.config_id
      this.form_auto_condition_action.enable = data.enable
      this.form_auto_condition_action.link_to = data.link_to

      this.condition_action_list = this.clone(data.condition_action_list)

      this.auto_condition_action_state = {
        ...this.auto_condition_action_state,
        type: 'update',
        updated_advanced_day: config.advanced_day,
        updated_advanced_day_number: config.advanced_day_number,
        updated_config_list_index: index,
      }

      this.m__fix_condition_action_list()
      this.show_dialog.auto_by_condition = true
    },

    async m__get_keyword_tag() {
      const response = await this.$http.get(this.API.URL_API_SRV_2 + '/mipee/keyword_tags/get', this.cf())
      for (const item of response.body.data) {
        item.temp_name = ''
        item.editable = false
      }
      this.keyword_tag_list = response.body.data
    },

    async m__get_auto_condition_action() {
      this.auto_condition_action_config_list = []

      const form = {
        item_ids: this.campaign_list.reduce((r, i) => {
          if (i.product && i.product.itemid) r.push(i.product.itemid)
          return r
        }, []),
        campaign_ids: this.campaign_list.reduce((r, i) => {
          if (i.campaign && i.campaign.campaignid) r.push(i.campaign.campaignid)
          return r
        }, []),
      }
      const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/auto_condition_action/get', form,
        this.cf())
      this.auto_condition_action_config_list = response.body.data

      for (const campaign of this.campaign_list) {
        campaign.auto_condition_action = this.auto_condition_action_config_list.find(i => !i.keyword && !i.item_id && i.campaign_id === campaign.campaign.campaignid)

        if (this.selected_campaign && this.selected_campaign.campaign && this.selected_campaign.campaign.campaignid === campaign.campaign.campaignid) {
          this.selected_campaign = campaign
        }
      }
    },

    // todo: testable
    async m__get_auto_condition_action_for_campaign(campaign_id) {
      this.auto_condition_action_detail_config_list = []

      if (!campaign_id) return

      try {
        const form = { campaign_detail_ids: [campaign_id] }
        const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/auto_condition_action/get', form,
          this.cf())
        this.auto_condition_action_detail_config_list = response.body.data
      } catch (e) {
        console.error(e)
      }
    },

    async m__delete_auto_condition_action() {
      try {
        await this.$confirm(this.$t('base.delete_config_confirm'), this.$t('base.attention'), {
          type: 'warning',
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
        })
      } catch (e) {
        return
      }

      const form = {
        item_ids: [],
        campaign_ids: [],
        keywords: [],
        campaign_id: null,
        shop_id: this.shop._id.toString(),
      }

      for (const item of this.c__show_filter_campaign_list.filter(i => i.checked)) {
        if (item.is_parent) {
          form.item_ids.push(item.product.itemid)
        } else {
          form.campaign_ids.push(item.campaign.campaignid)
        }
      }

      if (this.auto_condition_action_state.selected_item_id) {
        form.item_ids = [this.auto_condition_action_state.selected_item_id]
        form.campaign_ids = []
      }
      if (this.auto_condition_action_state.selected_campaign_id) {
        form.item_ids = []
        form.campaign_ids = [this.auto_condition_action_state.selected_campaign_id]
      }

      await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/auto_condition_action/delete', form, this.cf())
      await this.m__get_auto_condition_action()
      this.ntf_s(this.$t('base.update_success'))
      this.show_dialog.auto_by_condition_list = false
    },

    async m__delete_multiple_auto_condition_action(require_confirm = true) {
      if (require_confirm) {
        try {
          await this.$confirm(this.$t('base.delete_multiple_config_confirm'), this.$t('base.attention'), {
            type: 'warning',
            confirmButtonText: this.$t('base.confirm'),
            cancelButtonText: this.$t('base.cancel'),
          })
        } catch (e) {
          return
        }
      }

      const form = {
        item_ids: [],
        campaign_ids: [],
        keywords: [],
        campaign_id: null,
        shop_id: this.shop._id.toString(),
      }

      for (const item of this.c__show_filter_campaign_list.filter(i => i.checked)) {
        if (item.is_parent) {
          form.item_ids.push(item.product.itemid)
        } else {
          form.campaign_ids.push(item.campaign.campaignid)
        }
      }

      await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/auto_condition_action/delete', form, this.cf())
      await this.m__get_auto_condition_action()
      this.ntf_s(this.$t('base.update_success'))
      this.show_dialog.auto_by_condition_list = false
    },

    async m__update_auto_condition_action(show_ntf = true) {
      const form = {
        item_ids: [],
        campaign_ids: [],
        campaign_detail_id: null,
        keyword_list: null,
        config_list: this.auto_condition_action_list,
        shop_id: this.shop._id.toString(),
        only_show_me: this.auto_condition_action_only_show_me,
        link_to_files: [],
        campaign_type_mapping: {},
      }

      const file_ids_set = new Set()
      for (const config of form.config_list) {
        for (const sub_config of config.config_list) {
          if (sub_config.link_to) file_ids_set.add(sub_config.link_to)
        }
      }
      form.link_to_files = Array.from(file_ids_set)

      // todo: including get product
      for (const item of this.c__show_filter_campaign_list.filter(i => i.checked)) {
        if (item.is_parent) {
          form.item_ids.push(item.product.itemid)
        } else {
          form.campaign_ids.push(item.campaign.campaignid)
        }
      }

      if (this.auto_condition_action_state.selected_item_id) {
        form.item_ids = [this.auto_condition_action_state.selected_item_id]
        form.campaign_ids = []
      }
      if (this.auto_condition_action_state.selected_campaign_id) {
        form.item_ids = []
        form.campaign_ids = [this.auto_condition_action_state.selected_campaign_id]
      }

      if (this.auto_condition_action_detail.campaign_detail_id) {
        form.campaign_detail_id = this.auto_condition_action_detail.campaign_detail_id
        form.keyword_list = this.auto_condition_action_detail.keyword_list
        form.item_ids = []
        form.campaign_ids = []
      }

      if (!form.item_ids.length && !form.campaign_ids.length && !form.campaign_detail_id) {
        this.ntf_w(this.$t('required.products_or_campaigns'))
        return
      }

      // todo: map campaign type
      for (const campaign_id of form.campaign_ids) {
        const campaign_found = this.campaign_list.find(c => c.campaign.campaignid === campaign_id)
        if (campaign_found) form.campaign_type_mapping[campaign_id] = campaign_found.campaign.shopee_type
      }
      if (form.campaign_detail_id) {
        const campaign_found = this.campaign_list.find(c => c.campaign.campaignid === form.campaign_detail_id)
        if (campaign_found) form.campaign_type_mapping[form.campaign_detail_id] = campaign_found.campaign.shopee_type
      }

      if (show_ntf) {
        try {
          await this.$confirm(this.$t('base.save_config_confirm'), this.$t('base.attention'), {
            type: 'warning',
            confirmButtonText: this.$t('base.confirm'),
            cancelButtonText: this.$t('base.cancel'),
          })
        } catch (e) {
          return
        }
      }

      this.loading.config_auto_optimize = true

      form.item_ids = form.item_ids.filter(i => !!i)
      form.campaign_ids = form.campaign_ids.filter(i => !!i)

      await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/auto_condition_action/update', form, this.cf())
      await this.m__get_auto_condition_action()
      await this.m__get_auto_condition_action_for_campaign(this.auto_condition_action_detail.campaign_detail_id)
      if (show_ntf) this.ntf_s(this.$t('base.save_config_success'))
      this.show_dialog.auto_by_condition_list = false

      this.loading.config_auto_optimize = false
    },

    m__delete_auto_condition_action_config(config, index) {
      config.config_list.splice(index, 1)
    },

    m__update_auto_condition_action_config() {
      if (!this.form_auto_condition_action.advanced_day) {
        this.ntf_w(this.$t('select.active_day'))
        return
      }

      if (this.form_auto_condition_action.radio === '2' && !this.m__check_times(this.form_auto_condition_action.times)) {
        this.ntf_w(this.$t('required.select_runtime'))
        return
      }

      if (this.form_auto_condition_action.radio === '3' && !this.form_auto_condition_action.time) {
        this.ntf_w(this.$t('required.select_runtime'))
        return
      }

      if (this.form_auto_condition_action.radio === '4' && !this.m__check_times(this.form_auto_condition_action.times)) {
        this.ntf_w(this.$t('required.select_runtime'))
        return
      }

      // const found = this.auto_condition_action_state.updated_advanced_day === 'day'
      //   ? this.auto_condition_action_list.find(i => i.advanced_day === this.auto_condition_action_state.updated_advanced_day && i.advanced_day_number === this.auto_condition_action_state.updated_advanced_day_number)
      //   : this.auto_condition_action_list.find(i => i.advanced_day === this.auto_condition_action_state.updated_advanced_day)
      // if (found) {
      //   found.config_list[this.auto_condition_action_state.updated_config_list_index] = {
      //     ...this.clone(this.form_auto_condition_action),
      //     condition_action_list: this.clone(this.condition_action_list),
      //   }
      // }

      const found = this.array_to_set(['day', 'before_flash_sale', 'after_flash_sale']).has(this.auto_condition_action_state.updated_advanced_day)
        ? this.auto_condition_action_list.find(i => i.advanced_day === this.auto_condition_action_state.updated_advanced_day && i.advanced_day_number === this.auto_condition_action_state.updated_advanced_day_number)
        : this.auto_condition_action_list.find(i => i.advanced_day === this.auto_condition_action_state.updated_advanced_day)
      if (found) {
        found.config_list.splice(this.auto_condition_action_state.updated_config_list_index, 1)
        this.m__add_auto_condition_action_config(true)
      }

      this.auto_condition_action_list = this.clone(this.auto_condition_action_list)

      this.show_dialog.auto_by_condition = false
    },

    m__add_auto_condition_action_config(is_update = false) {
      if (!this.form_auto_condition_action.advanced_day) {
        this.ntf_w(this.$t('select.active_day'))
        return
      }

      if (this.form_auto_condition_action.radio === '2' && !this.m__check_times(this.form_auto_condition_action.times)) {
        this.ntf_w(this.$t('required.select_runtime'))
        return
      }

      if (this.form_auto_condition_action.radio === '3' && !this.form_auto_condition_action.time) {
        this.ntf_w(this.$t('required.select_runtime'))
        return
      }

      if (this.form_auto_condition_action.radio === '4' && !this.m__check_times(this.form_auto_condition_action.times)) {
        this.ntf_w(this.$t('required.select_runtime'))
        return
      }

      const new_auto_condition_action_config = {
        ...this.clone(this.form_auto_condition_action),
        ...(!is_update && { config_id: make_uuid() }),
        ...(!is_update && { enable: true }),
        ...(!is_update && { link_to: null }),
      }

      const found = this.array_to_set(['day', 'before_flash_sale', 'after_flash_sale']).has(this.form_auto_condition_action.advanced_day)
        ? this.auto_condition_action_list.find(i => i.advanced_day === this.form_auto_condition_action.advanced_day && i.advanced_day_number === this.form_auto_condition_action.advanced_day_number)
        : this.auto_condition_action_list.find(i => i.advanced_day === this.form_auto_condition_action.advanced_day)
      if (found) {
        found.config_list.push({
          ...new_auto_condition_action_config,
          condition_action_list: this.clone(this.condition_action_list),
        })
      } else {
        this.auto_condition_action_list.push({
          type: this.form_auto_condition_action.advanced_day,
          advanced_day: this.form_auto_condition_action.advanced_day,
          day_number: this.form_auto_condition_action.advanced_day_number,
          advanced_day_number: this.form_auto_condition_action.advanced_day_number,
          time: this.form_auto_condition_action.time,
          times: this.form_auto_condition_action.times,
          config_list: [
            {
              ...new_auto_condition_action_config,
              condition_action_list: this.clone(this.condition_action_list),
            }],
        })
      }

      this.show_dialog.auto_by_condition = false
    },

    m__paste_auto_condition_action_item() {
      const old_condition_action_list = this.clone(this.condition_action_list)
      try {
        this.condition_action_list.push(this.clone(JSON.parse(this.paste_auto_condition_action_item_text)))
        this.show_dialog.paste_auto_condition_action_item = false
      } catch (e) {
        this.condition_action_list = this.clone(old_condition_action_list)
        this.ntf_w(this.$t('base.invalid_data'))
      }
    },

    m__copy_condition_action_item(item, index) {
      this.condition_action_list.splice(index + 1, 0, this.clone(item))
    },

    m__show_auto_by_condition_dialog() {
      this.condition_action_list = []
      const template = this.clone(this.condition_action_template)
      template.condition_group.push({
        condition_list: [this.clone(this.condition_template)],
      })
      this.condition_action_list.push(template)

      this.auto_condition_action_state = {
        ...this.auto_condition_action_state,
        type: 'add',
        updated_advanced_day: null,
        updated_advanced_day_number: null,
        updated_config_list_index: null,
      }

      this.m__fix_condition_action_list()
      this.show_dialog.auto_by_condition = true
    },

    m__map_campaign_name(campaign) {
      if (campaign.campaign.type === 'all') {
        if (campaign.campaign.bidding_type === 'auto') return this.$t('ads.auto_all_ads_standard')
        if (campaign.campaign.bidding_type === 'manual') return this.$t('ads.manual_all_ads')
        if (campaign.campaign.bidding_type === 'roi_two') {
          if (campaign.campaign.subtype === 'product_homepage__roi_two__simple') return this.$t('ads.all_gmv_max_auto')
          if (campaign.campaign.subtype === 'product_homepage__roi_two__target') return this.$t(
            'ads.all_gmv_max_custom')
          return this.$t('ads.auto_all_ads')
        }
      }
      if (campaign.campaign.type === 'keyword') {
        if (campaign.campaign.bidding_type === 'auto') return this.$t('ads.auto_search_ads_standard')
        if (campaign.campaign.bidding_type === 'manual') return this.$t('ads.manual_search_ads')
        if (campaign.campaign.bidding_type === 'roi_two') {
          if (campaign.campaign.subtype === 'product_homepage__roi_two__simple') return this.$t(
            'ads.search_gmv_max_auto')
          if (campaign.campaign.subtype === 'product_homepage__roi_two__target') return this.$t(
            'ads.search_gmv_max_custom')
          return this.$t('ads.auto_all_ads')
        }
      }
      if (campaign.campaign.type === 'targeting') {
        if (campaign.campaign.bidding_type === 'auto') return this.$t('ads.auto_targeting_ads_standard')
        if (campaign.campaign.bidding_type === 'manual') return this.$t('ads.manual_targeting_ads')
        if (campaign.campaign.bidding_type === 'roi_two') {
          if (campaign.campaign.subtype === 'product_homepage__roi_two__simple') return this.$t(
            'ads.targeting_gmv_max_auto')
          if (campaign.campaign.subtype === 'product_homepage__roi_two__target') return this.$t(
            'ads.targeting_gmv_max_custom')
          return this.$t('ads.auto_all_ads')
        }
      }

      // return campaign.campaign.bidding_type
    },

    async m__confirm_delete_multiple_config() {
      try {
        await this.$confirm(this.$t('base.delete_multiple_config_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning',
        })
      } catch (e) {
        return
      }

      this.loading.delete_multiple_config = true
      for (const selected of this.delete_multiple_config_checkbox_list.filter(i => i.value)) {
        try {
          if (selected.key === 'auto_position') {
            for (const campaign of this.c__show_filter_campaign_list.filter(i => i.checked)) {
              await this.$http.post(this.API.URL_API_SRV_1 + '/auto_position/v2/delete/all', {
                campaignId: campaign.campaign.campaignid,
                mipeeUserId: this.$store.state.userInfo.username,
              }, this.cf())

              await this.$http.post(this.API.URL_API_SRV_1 + '/shop_ads_position/v2/delete/all', {
                campaignId: campaign.campaign.campaignid,
                mipeeUserId: this.$store.state.userInfo.username,
              }, this.cf())

              await this.$http.delete(this.API.URL_API_SRV_1 + '/targeting_auto_position/all', {
                ...this.cf(),
                params: {
                  campaignId: campaign.campaign.campaignid,
                  mipeeUserId: this.$store.state.userInfo.username,
                },
              })
            }
          }

          if (selected.key === 'auto_position') {
            for (const campaign of this.c__show_filter_campaign_list.filter(i => i.checked)) {
              await this.$http.post(this.API.URL_API_SRV_1 + '/auto_campaigns/v2/delete/all', {
                campaignId: campaign.campaign.campaignid,
                mipeeUserId: this.$store.state.userInfo.username,
              }, this.cf())
            }
          }

          if (selected.key === 'auto_cir') {
            for (const campaign of this.c__show_filter_campaign_list.filter(i => i.checked)) {
              await this.$http.post(this.API.URL_API_SRV_1 + '/auto_cir/delete/all', {
                campaignId: campaign.campaign.campaignid,
                mipeeUserId: this.$store.state.userInfo.username,
              }, this.cf())
            }
          }

          if (selected.key === 'anti_click') {
            for (const campaign of this.c__show_filter_campaign_list.filter(i => i.checked)) {
              await this.$http.post(this.API.URL_API_SRV_1 + '/anti_click/v2/delete/all', {
                campaignId: campaign.campaign.campaignid,
                mipeeUserId: this.$store.state.userInfo.username,
              }, this.cf())

              await this.$http.delete(this.API.URL_API_SRV_1 + '/targeting_anti_click/all', {
                ...this.cf(),
                params: {
                  campaignId: campaign.campaign.campaignid,
                  mipeeUserId: this.$store.state.userInfo.username,
                },
              })
            }
          }

          if (selected.key === 'auto_quota') {
            await this.m__delete_multiple_config_auto_quota(false)
          }

          if (selected.key === 'auto_optimize') {
            await this.m__delete_multiple_config_auto_optimize(false)
          }

          if (selected.key === 'auto_condition_action') {
            await this.m__delete_multiple_auto_condition_action(false)
          }

          // this.ntf_s(this.$t('base.update_success'))
        } catch (e) {
          console.error(e)
          // this.ntf_w(this.$t('base.has_an_occurred'))
        }
      }
      this.ntf_s(this.$t('base.update_success'))
      this.loading.delete_multiple_config = false
      this.show_dialog.delete_multiple_config = false
    },

    async m__confirm_pause_multiple_config() {
      try {
        await this.$confirm(this.$t('base.update_config_status_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning',
        })
      } catch (e) {
        return
      }

      this.loading.pause_multiple_config = true
      for (const selected of this.pause_multiple_config_checkbox_list.filter(i => i.value)) {
        await this.m__update_config_status(selected.key, 0)
      }
      this.ntf_s(this.$t('base.update_success'))
      this.loading.pause_multiple_config = false
      this.show_dialog.pause_multiple_config = false
    },

    async m__confirm_resume_multiple_config() {
      try {
        await this.$confirm(this.$t('base.update_config_status_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning',
        })
      } catch (e) {
        return
      }

      this.loading.resume_multiple_config = true
      for (const selected of this.resume_multiple_config_checkbox_list.filter(i => i.value)) {
        await this.m__update_config_status(selected.key, 1)
      }
      this.ntf_s(this.$t('base.update_success'))
      this.loading.resume_multiple_config = false
      this.show_dialog.resume_multiple_config = false
    },

    async m__confirm_update_multiple_premium() {
      if (this.form_update_multiple_premium.update_type === 1 &&
        !this.form_update_multiple_premium.update_by_cost_value) {
        this.ntf_w(this.$t('input.amount'))
        return
      }

      if (this.form_update_multiple_premium.update_type === 1 &&
        +this.form_update_multiple_premium.update_by_cost_value <= 0) {
        this.ntf_w(this.$t('base.y_gt_x', {
          y: this.$t('base.amount'),
          x: '0',
        }))
        return
      }

      if (this.form_update_multiple_premium.update_type === 2 &&
        !this.form_update_multiple_premium.update_by_percent_value) {
        this.ntf_w(this.$t('input.percent'))
        return
      }

      if (this.form_update_multiple_premium.update_type === 2 &&
        +this.form_update_multiple_premium.update_by_percent_value <= 0) {
        this.ntf_w(this.$t('base.y_gt_x', {
          y: this.$t('base.percent'),
          x: '0',
        }))
        return
      }

      if (this.form_update_multiple_premium.update_type === 5 && this.form_update_multiple_premium.cost_value ===
        null) {
        this.ntf_w(this.$t('input.bid_price'))
        return
      }

      if (!this.form_update_multiple_premium.placement2 && !this.form_update_multiple_premium.placement5) {
        this.ntf_w(this.$t('select.ad_type'))
        return
      }

      try {
        await this.$confirm(this.$t('base.update_data_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning',
        })
      } catch (e) {
        return
      }

      this.loading.update_multiple_premium = true
      try {
        for (const campaign of this.c__show_filter_campaign_list.filter(i => i.checked)) {
          await this.m__fix_missing_placement(campaign)

          for (const ads of campaign.advertisements) {
            if (this.form_update_multiple_premium[`placement${ads.placement}`]) {
              let price = +ads.extinfo.target.price

              if (this.form_update_multiple_premium.update_type === 1 &&
                this.form_update_multiple_premium.update_by_cost === 'increase') {
                price += +this.form_update_multiple_premium.update_by_cost_value

                const max = +this.form_update_multiple_premium.update_by_cost_value_max
                if (max && max < price) price = max
              }
              if (this.form_update_multiple_premium.update_type === 1 &&
                this.form_update_multiple_premium.update_by_cost === 'reduce') {
                price -= +this.form_update_multiple_premium.update_by_cost_value

                const min = +this.form_update_multiple_premium.update_by_cost_value_min
                if (min && min > price) price = min
              }

              if (this.form_update_multiple_premium.update_type === 2 &&
                this.form_update_multiple_premium.update_by_percent === 'increase') {
                const value = this.m__calculate(
                  this.percent_of(this.form_update_multiple_premium.update_by_percent_value, price))
                price += value

                const max = +this.form_update_multiple_premium.update_by_percent_value_max
                if (max && max < price) price = max
              }
              if (this.form_update_multiple_premium.update_type === 2 &&
                this.form_update_multiple_premium.update_by_percent === 'reduce') {
                const value = this.m__calculate(
                  this.percent_of(this.form_update_multiple_premium.update_by_percent_value, price))
                price -= value

                const min = +this.form_update_multiple_premium.update_by_percent_value_min
                if (min && min > price) price = min
              }

              if (this.form_update_multiple_premium.update_type === 5) {
                price = this.form_update_multiple_premium.cost_value
              }

              if (+price < this.TARGETING_MIN) price = this.TARGETING_MIN

              ads.extinfo.target.price = price

              let placement = ''
              if (ads.placement === 2) placement = 'daily_discover'
              if (ads.placement === 5) placement = 'you_may_also_like'
              const body = {
                campaign_id: campaign.campaign.campaignid,
                type: 'change_display_location',
                header: {},
                change_display_location: {
                  bid_price: Math.trunc(price * 100000),
                  place: placement,
                  state: ads.status === 1 ? 'active' : 'inactive',
                },
              }
              await this.sp_user.marketing_pas_update_campaign(body)
            }
          }
        }

        this.show_dialog.update_multiple_premium = false
        this.ntf_s(this.$t('base.update_data_success'))
      } catch (e) {
        console.log(e)
        this.ntf_w(this.$t('base.has_an_occurred'))
      } finally {
        this.loading.update_multiple_premium = false
      }
    },

    async m__on_expand_change(row, expanded) {
      const found = expanded.find(i => i.campaign.campaignid === row.campaign.campaignid)
      if (found) {
        found.is_expanded = true
      }
    },

    m__get_fixed_column(check_mobile = false) {
      if (check_mobile && this.is_mobile_device()) {
        return false
      }

      if (['new_cpc_homepage', 'product_homepage'].includes(this.campaign_type)) {
        const checked_list = this.campaign_type_checkbox.filter(
          i => this.campaign_type === 'new_cpc_homepage' || i.type === this.campaign_type).filter(i => i.checked)
        return !(checked_list.length === 1 && checked_list[0].key === 'targeting')
      }

      return true
    },

    m__back_to_last_scroll_position() {
      this.$nextTick(() => {
        const wrapper = document.querySelector('#dashboard-wrapper')
        if (wrapper && this.last_scroll_position) {
          wrapper.scrollTop = this.last_scroll_position
        }
      })
    },

    m__on_back_to_list() {
      this.$emit('update:campaign_component', 'list')
      this.m__generate_scrollbar()

      // todo: set scroll top
      this.m__back_to_last_scroll_position()
    },

    m__is_allow_check_position() {
      const pack = this.$store.state.package && this.$store.state.package.extend_package &&
        this.$store.state.package.extend_package.find(i => i.channel === 'shopee_marketing')
      return pack && pack.package && pack.package.extra_data && pack.package.extra_data.marketing &&
        pack.package.extra_data.marketing.check_ads_position
    },

    m__show_compare_campaign() {
      if (!this.m__is_allow_check_position()) {
        this.$confirm(this.$t('base.need_up_to_pro_package'), this.$t('base.attention'), {
          showConfirmButton: false,
          showCancelButton: false,
          type: 'warning',
        })
        return
      }

      this.show_dialog.compare_campaign = true
    },

    async m__confirm_compare_campaign() {
      if (!this.compare_date_range || !this.compare_date_range[0] || !this.compare_date_range[1]) {
        return
      }

      this.loading.compare_campaign = true
      this.compare_list = []

      let limit = 50, offset = 0, state = this.selected_state,
        start_time = this.dayjs(new Date(this.compare_date_range[0])).startOf('day'),
        end_time = this.dayjs(new Date(this.compare_date_range[1])).endOf('day'),
        filter = {
          campaign_type: this.campaign_type,
          search_term: '',
          state: state,
        }

      if (this.campaign_fixed_list[this.$store.state.userInfo.username]) {
        limit = this.campaign_fixed_list[this.$store.state.userInfo.username].campaign_limit
      }

      let response = await this.sp_user.marketing_pas_get_campaigns(start_time.unix(), end_time.unix(), offset, limit, filter)
      response = this.m__map_campaign_data(response, true)

      while (response && response.data && response.data.campaign_ads_list && response.data.campaign_ads_list.length >
      0) {
        for (const item of response.data.campaign_ads_list) {
          for (const key of Object.keys(item.report)) {
            item.report[key].ratio = Number(item.report[key].ratio)
            item.report[key].value = Number(item.report[key].value)
          }
          item.report = this.m__map_campaign_report(item.report)

          const campaign_found = this.campaign_list.find(i => i.campaign.campaignid === item.campaign.campaignid)
          if (campaign_found) campaign_found.c_report = item.report
        }
        this.compare_list.push(...response.data.campaign_ads_list)

        offset += limit
        response = await this.sp_user.marketing_pas_get_campaigns(start_time.unix(), end_time.unix(), offset, limit,
          filter)
        response = this.m__map_campaign_data(response, true)
      }

      // todo: compare canceled gmv + roi
      const item_ids_set = new Set()
      for (const campaign of this.compare_list) {
        if (campaign.product && campaign.product.itemid) item_ids_set.add(campaign.product.itemid)
      }
      const get_canceled_orders_by_itemid_response = await this.$http.post(this.API.URL_API_SRV_2 + '/shopee/get_canceled_orders_by_itemid', {
        shop_id: this.shop.shop_id,
        item_ids: Array.from(item_ids_set),
        start_time: start_time.unix(),
        end_time: end_time.unix()
      }, this.cf())
      if (get_canceled_orders_by_itemid_response.body.data.length) {
        for (const source of ['campaign_list']) {
          for (const item of get_canceled_orders_by_itemid_response.body.data) {
            const campaign_found = this[source].find(i => i.product && i.product.itemid === +item.item_id)
            if (campaign_found) {
              campaign_found.c_report.cancelled_gmv = { value: 0 }
              campaign_found.c_report.cancelled_gmv.value = item.price
              campaign_found.c_report.cancelled_roi = { value: 0 }
              campaign_found.c_report.cancelled_roi.value = campaign_found.c_report.cost && campaign_found.c_report.cost.value
                ? parseFloat((campaign_found.c_report.cancelled_gmv.value / campaign_found.c_report.cost.value).toFixed(2))
                : 0
              campaign_found.c_report.exclude_cancelled_gmv = { value: 0 }
              campaign_found.c_report.exclude_cancelled_gmv.value = campaign_found.c_report.broad_gmv >= campaign_found.c_report.cancelled_gmv
                ? campaign_found.c_report.broad_gmv - campaign_found.c_report.cancelled_gmv
                : 0
              campaign_found.c_report.exclude_cancelled_roi = { value: 0 }
              campaign_found.c_report.exclude_cancelled_roi.value = campaign_found.c_report.cost && campaign_found.c_report.cost.value
                ? parseFloat((campaign_found.c_report.exclude_cancelled_gmv.value / campaign_found.c_report.cost.value).toFixed(2))
                : 0
            }
          }
          this[source] = this.clone(this[source])
        }
      }
      // end compare cancelled gmv + roi

      // todo: compare metrics
      const report_response = await this.sp_user.marketing_get_time_graph(this.campaign_type, start_time.unix(), end_time.unix(), {})
      if (report_response.data) {
        this.compare_metrics = this.m__map_graph_response(report_response.data.report_aggregate)
        this.compare_metrics.cancelled_gmv = this.campaign_list.reduce((t, i) => t + (i.c_report.cancelled_gmv ? i.c_report.cancelled_gmv.value : 0), 0)
        this.compare_metrics.cancelled_roi = +this.compare_metrics.cost ? +(+this.compare_metrics.cancelled_gmv / +this.compare_metrics.cost).toFixed(2) : 0
        this.compare_metrics.exclude_cancelled_gmv = this.compare_metrics.broad_gmv >= this.compare_metrics.cancelled_gmv ? this.compare_metrics.broad_gmv - this.compare_metrics.cancelled_gmv : 0
        this.compare_metrics.exclude_cancelled_roi = +this.compare_metrics.cost ? +(+this.compare_metrics.exclude_cancelled_gmv / +this.compare_metrics.cost).toFixed(2) : 0
        this.compare_reports = this.m__map_graph_by_time_response(report_response.data.report_by_time)
      }

      this.is_compare_campaign = true
      this.$emit('update:parent_is_compare_campaign', true)
      this.show_dialog.compare_campaign = false
      this.loading.compare_campaign = false
    },

    m__show_filter_dialog() {
      if (!this.m__is_allow_check_position()) {
        this.$confirm(this.$t('base.need_up_to_pro_package'), this.$t('base.attention'), {
          showConfirmButton: false,
          showCancelButton: false,
          type: 'warning',
        })
        return
      }

      this.show_dialog.filter = true
    },

    m__start_filter() {
      let any_change = false
      for (const item of this.filter) {
        if (item.value) {
          any_change = true
          break
        }
      }
      if (!any_change) {
        // this.filter_clone = null
        this.$emit('update:filter_clone', null)
      } else {
        // this.filter_clone = JSON.parse(JSON.stringify(this.filter))
        this.$emit('update:filter_clone', this.clone(this.filter))
      }
      this.show_dialog.filter = false
    },

    m__delete_filter() {
      this.filter.forEach(i => {
        i.value = null
        i.expression = '>'
      })
      // this.filter_clone = null
      this.$emit('update:filter_clone', null)
      this.show_dialog.filter = false
    },

    m__show_update_multiple_quota_dialog() {
      if (!this.check_role(this.shop, 'keyword_ads', 'update_campaign')) {
        return
      }

      this.show_dialog.update_multiple_quota = true
    },

    async m__confirm_update_multiple_quota() {
      if (this.form_update_multiple_quota.update_type === 1 && !this.form_update_multiple_quota.update_by_cost_value) {
        this.ntf_w(this.$t('input.amount'))
        return
      }

      if (this.form_update_multiple_quota.update_type === 1 && +this.form_update_multiple_quota.update_by_cost_value <= 0) {
        this.ntf_w(this.$t('base.y_gt_x', {
          y: this.$t('base.amount'),
          x: '0',
        }))
        return
      }

      if (this.form_update_multiple_quota.update_type === 2 && !this.form_update_multiple_quota.update_by_percent_value) {
        this.ntf_w(this.$t('input.percent'))
        return
      }

      if (this.form_update_multiple_quota.update_type === 2 && +this.form_update_multiple_quota.update_by_percent_value <= 0) {
        this.ntf_w(this.$t('base.y_gt_x', {
          y: this.$t('base.percent'),
          x: '0',
        }))
        return
      }

      if (this.form_update_multiple_quota.update_type === 5 && !+this.form_update_multiple_quota.cost_value) {
        this.ntf_w(this.$t('input.budget'))
        return
      }

      if (this.form_update_multiple_quota.update_type === 7 && !+this.form_update_multiple_quota.update_by_cost_percent_value) {
        this.ntf_w(this.$t('input.percent'))
        return
      }

      if (this.form_update_multiple_quota.update_type === 8 && !+this.form_update_multiple_quota.cost_percent) {
        this.ntf_w(this.$t('required.value'))
        return
      }

      try {
        this.loading.update_multiple_quota = true

        await this.$confirm(this.$t('ads.update_budget_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning',
        })

        try {
          for (const campaign of this.c__show_filter_campaign_list.filter(i => i.checked)) {
            const temp = this.clone(campaign)

            const body = {
              action: 4,
              campaignid_list: [campaign.campaign.campaignid],
              daily_quota: 0,
              total_quota: 0,
              need_campaign: true,
            }

            const log = {
              campaignId: campaign.campaignid,
              mipeeUserId: this.$store.state.userInfo.username,
              shopId: this.shop._id + '_multiple',
              oldDailyQuota: +campaign.daily_quota,
              oldCampaign: JSON.stringify(campaign),
              newDailyQuota: null,
              newCampaign: null,
            }

            // console.log(campaign.campaign)

            let allow_update = false

            if (this.form_update_multiple_quota.update_type === 6) {
              temp.campaign.daily_quota = body.daily_quota = 0
              temp.campaign.total_quota = body.daily_quota = 0
              allow_update = true
            } else {
              if (!+temp.campaign.daily_quota) temp.campaign.daily_quota = body.daily_quota = this.DAILY_BUDGET_MIN
              if (!+temp.campaign.total_quota) temp.campaign.total_quota = body.total_quota = this.DAILY_BUDGET_MIN * 10

              if (this.form_update_multiple_quota.update_type === 1 &&
                this.form_update_multiple_quota.update_by_cost === 'increase') {
                if (this.form_update_multiple_quota.quota_type === 'daily') {
                  temp.campaign.daily_quota = body.daily_quota = this.m__calculate(+temp.campaign.daily_quota + +this.form_update_multiple_quota.update_by_cost_value)
                  temp.campaign.total_quota = body.total_quota = 0
                  allow_update = true
                }
                if (this.form_update_multiple_quota.quota_type === 'total') {
                  temp.campaign.daily_quota = body.daily_quota = 0
                  temp.campaign.total_quota = body.total_quota = this.m__calculate(+temp.campaign.total_quota + +this.form_update_multiple_quota.update_by_cost_value)
                }
              }
              if (this.form_update_multiple_quota.update_type === 1 &&
                this.form_update_multiple_quota.update_by_cost === 'reduce') {
                if (this.form_update_multiple_quota.quota_type === 'daily') {
                  temp.campaign.daily_quota = body.daily_quota = this.m__calculate(+temp.campaign.daily_quota - +this.form_update_multiple_quota.update_by_cost_value)
                  temp.campaign.total_quota = body.total_quota = 0
                  allow_update = true
                }
                if (this.form_update_multiple_quota.quota_type === 'total') {
                  temp.campaign.daily_quota = body.daily_quota = 0
                  temp.campaign.total_quota = body.total_quota = this.m__calculate(+temp.campaign.total_quota - +this.form_update_multiple_quota.update_by_cost_value)
                }
              }

              if (this.form_update_multiple_quota.update_type === 2 &&
                this.form_update_multiple_quota.update_by_percent === 'increase') {
                if (this.form_update_multiple_quota.quota_type === 'daily') {
                  const value = this.m__calculate(temp.campaign.daily_quota * this.form_update_multiple_quota.update_by_percent_value / 100)
                  temp.campaign.daily_quota = body.daily_quota = this.m__calculate(+temp.campaign.daily_quota + value)
                  temp.campaign.total_quota = body.total_quota = 0
                  allow_update = true
                }
                if (this.form_update_multiple_quota.quota_type === 'total') {
                  const value = this.m__calculate(temp.campaign.total_quota * this.form_update_multiple_quota.update_by_percent_value / 100)
                  temp.campaign.daily_quota = body.daily_quota = 0
                  temp.campaign.total_quota = body.total_quota = this.m__calculate(+temp.campaign.total_quota + value)
                }
              }
              if (this.form_update_multiple_quota.update_type === 2 &&
                this.form_update_multiple_quota.update_by_percent === 'reduce') {
                if (this.form_update_multiple_quota.quota_type === 'daily') {
                  const value = this.m__calculate(temp.campaign.daily_quota * this.form_update_multiple_quota.update_by_percent_value / 100)
                  temp.campaign.daily_quota = body.daily_quota = this.m__calculate(+temp.campaign.daily_quota - value)
                  temp.campaign.total_quota = body.total_quota = 0
                  allow_update = true
                }
                if (this.form_update_multiple_quota.quota_type === 'total') {
                  const value = this.m__calculate(temp.campaign.total_quota * this.form_update_multiple_quota.update_by_percent_value / 100)
                  temp.campaign.daily_quota = body.daily_quota = 0
                  temp.campaign.total_quota = body.total_quota = this.m__calculate(+temp.campaign.total_quota - value)
                }
              }

              if (this.form_update_multiple_quota.update_type === 7 && this.form_update_multiple_quota.update_by_cost_percent === 'increase') {
                if (this.form_update_multiple_quota.quota_type === 'daily') {
                  const value = this.m__calculate(temp.report.cost.value * this.form_update_multiple_quota.update_by_cost_percent_value / 100)
                  temp.campaign.daily_quota = body.daily_quota = this.m__calculate(+temp.campaign.daily_quota + value)
                  temp.campaign.total_quota = body.total_quota = 0
                  allow_update = true
                }
              }
              if (this.form_update_multiple_quota.update_type === 7 && this.form_update_multiple_quota.update_by_cost_percent === 'reduce') {
                if (this.form_update_multiple_quota.quota_type === 'daily') {
                  const value = this.m__calculate(temp.report.cost.value * this.form_update_multiple_quota.update_by_cost_percent_value / 100)
                  temp.campaign.daily_quota = body.daily_quota = this.m__calculate(+temp.campaign.daily_quota - value)
                  temp.campaign.total_quota = body.total_quota = 0
                  allow_update = true
                }
              }

              if (this.form_update_multiple_quota.update_type === 5) {
                if (this.form_update_multiple_quota.quota_type === 'daily') {
                  temp.campaign.daily_quota = body.daily_quota = this.m__calculate(this.form_update_multiple_quota.cost_value)
                  temp.campaign.total_quota = body.total_quota = 0
                  allow_update = true
                }
                if (this.form_update_multiple_quota.quota_type === 'total') {
                  temp.campaign.daily_quota = body.daily_quota = 0
                  temp.campaign.total_quota = body.total_quota = this.m__calculate(this.form_update_multiple_quota.cost_value)
                }
              }

              if (this.form_update_multiple_quota.update_type === 8) {
                if (this.form_update_multiple_quota.quota_type === 'daily' && temp.report && temp.report.cost && temp.report.cost.value > 0) {
                  const value = temp.report.cost.value * this.form_update_multiple_quota.cost_percent / 100
                  temp.campaign.daily_quota = body.daily_quota = this.m__calculate(value)
                  temp.campaign.total_quota = body.total_quota = 0
                  allow_update = true
                }
              }
            }

            if (allow_update) {
              const new_body = {
                campaign_id_list: [campaign.campaign.campaignid],
                type: 'change_budget',
                change_budget: {
                  daily_budget: Math.trunc(body.daily_quota * 100000),
                  page: 'page_homepage',
                },
                budget_log_key: 'budget_log_' + make_uuid(),
              }
              const resp = await this.sp_user.marketing_pas_mass_update(new_body)
              if (resp.code === 0) {
                campaign.campaign.daily_quota = temp.campaign.daily_quota
                campaign.campaign.total_quota = temp.campaign.total_quota
              }

              log.newDailyQuota = +campaign.daily_quota
              log.newCampaign = JSON.stringify(campaign)
              this.$http.post(this.API.URL_API_SRV_1 + '/lg/5.1', log, this.cf()).catch(console.error)
            }
          }
          this.ntf_s(this.$t('base.update_success'))
          this.show_dialog.update_multiple_quota = false
        } catch (e) {
          console.error(e)
          this.ntf_w(this.$t('base.has_an_occurred'))
        }
      } catch (e) {
      } finally {
        this.loading.update_multiple_quota = false
      }
    },

    m__handle_multiple_command(command) {
      // {command === 1 ? m__show_config_auto_campaign_multiple() : (command === 2 ? m__show_update_multiple_max_price_dialog() : m__show_config_multiple_advanced())}
      this.selected_campaign = null

      if (command === 'auto_campaign') this.m__show_config_auto_campaign_multiple()
      if (command === 'auto_position_max') this.m__show_update_multiple_max_price_dialog()
      if (command === 'auto_position_advanced') this.m__show_config_multiple_advanced()
      if (command === 'anti_click') this.m__show_config_anti_click()
      if (command === 'auto_cir') this.m__show_config_auto_cir()
      if (command === 'update_keyword_price') this.m__show_update_multiple_keyword_price()
      if (command === 'update_target_roas') this.m__show_update_multiple_target_roas()

      if (command === 5) this.m__show_config_auto_position_by_suggest()
      if (command === 6) this.m__show_config_anti_click_by_suggest()

      if (command === 'auto_quota') this.m__show_config_multiple_auto_quota_dialog()
      if (command === 'delete_auto_quota') this.m__delete_multiple_config_auto_quota()

      if (command === 'add_keyword') this.m__show_add_keywords_dialog()

      if (command === 'auto_optimize') this.m__show_config_auto_optimize(null, 'search')
      if (command === 'delete_auto_optimize') this.m__delete_multiple_config_auto_optimize()

      if (command === 'targeting_auto_optimize') this.m__show_config_auto_optimize(null, 'targeting')
      if (command === 'delete_auto_optimize') this.m__delete_multiple_config_auto_optimize()

      if (command === 'action_condition') this.m__show_update_keyword_by_condition_dialog()
      if (command === 'campaign_state') this.m__show_update_campaign_state_dialog()

      if (command === 'update_targeting_price') this.show_dialog.update_multiple_premium = true

      if (command === 'create_shop_flash_sale') {
        const product_ids = _uniq(this.c__show_filter_campaign_list.reduce((r, i) => {
          if (i.checked && i.product && i.product.itemid) r.push(i.product.itemid)
          return r
        }, [])).join(',')

        this.open_link(`/flash-sale?shop_id=${this.shop.shop_id}&product_ids=${product_ids}`)
      }

      if (command === 'create_shop_voucher') {
        const product_ids = _uniq(this.c__show_filter_campaign_list.reduce((r, i) => {
          if (i.checked && i.product && i.product.itemid) r.push(i.product.itemid)
          return r
        }, [])).join(',')

        this.open_link(`/voucher?shop_id=${this.shop.shop_id}&product_ids=${product_ids}`)
      }

      if (command === 'create_product_ads') {
        const product_ids = _uniq(this.c__show_filter_campaign_list.reduce((r, i) => {
          if (i.checked && i.product && i.product.itemid) r.push(i.product.itemid)
          return r
        }, [])).join(',')

        this.open_link(
          `/marketing/pas?shop_id=${this.shop.shop_id}&state=create_new_campaign&product_ids=${product_ids}`)
      }

      if (command === 'resume_multiple_config') {
        this.resume_multiple_config_checkbox_list.forEach(i => i.value = false)
        this.show_dialog.resume_multiple_config = true
      }
      if (command === 'pause_multiple_config') {
        this.pause_multiple_config_checkbox_list.forEach(i => i.value = false)
        this.show_dialog.pause_multiple_config = true
      }
      if (command === 'delete_multiple_config') {
        this.show_dialog.delete_multiple_config = true
      }
      if (command === 'convert_to_auto_condition_action') {
        this.show_dialog.convert_to_auto_condition_action = true
      }
      if (command === 'convert_json_to_automatic_condition') {
        this.show_dialog.convert_json_to_automatic_condition = true
      }
      if (command === 'convert_json_to_automatic_budget') {
        this.show_dialog.convert_json_to_automatic_budget = true
      }
      if (command === 'change_budget') {
        this.m__show_update_multiple_quota_dialog()
      }
      if (command === 'auto_by_ai') {
        this.m__show_auto_by_ai_config_list_dialog()
      }

      if (command === 'convert_from_all_to_search') {
        this.m__convert_from_all_to_search()
      }

      if (command === 'convert_from_all_to_discovery') {
        this.m__convert_from_all_to_discovery()
      }

      if (command === 'rapid_boost_on') {
        this.m__on_off_rapid_boost(true)
      }
      if (command === 'rapid_boost_off') {
        this.m__on_off_rapid_boost(false)
      }
    },

    async m__export_shopee() {
      this.loading.marketing_report_file = true

      try {
        const start_time = this.dayjs(this.start_date).startOf('d').unix()
        const end_time = this.dayjs(this.end_date).endOf('d').unix()

        const trigger_response = await this.sp_user.marketing_pas_report_trigger({
          start_time: start_time,
          end_time: end_time,
          report_type: 'new_cpc_homepage__overall',
        })

        if (trigger_response && trigger_response.data && trigger_response.data.export_id) {
          const { export_id } = trigger_response.data

          let report_result = await this.sp_user.marketing_pas_report_get_single_result(export_id)
          while (report_result && report_result.data && ['waiting', 'processing'].includes(report_result.data.status)) {
            await this.sleep(5000)
            report_result = await this.sp_user.marketing_pas_report_get_single_result(export_id)
          }

          if (report_result && report_result.data && report_result.data.status === 'success') {
            const download_response = await this.sp_user.marketing_pas_report_download(export_id)
            const anchor = document.createElement('a')
            anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(download_response.data.content)
            anchor.target = '_blank'
            anchor.download = `${this.shop.username}.-${download_response.data.file_name}`
            anchor.click()
          } else {
            this.ntf_w(this.$t('base.cannot_export_report'))
          }
        } else {
          this.ntf_w(this.$t('base.cannot_export_report'))
        }
      } catch (e) {
        console.error(e)
        this.ntf_w(this.$t('ads.error_with_exporting'))
      } finally {
        this.loading.marketing_report_file = false
      }
    },

    m__toggle_select_index() {
      if (!this.check_role(this.shop, 'keyword_ads', 'update_campaign')) {
        return
      }

      this.show_dialog.select_index = !this.show_dialog.select_index
    },

    async m__update_flag_list() {
      if (this.flag_list.filter(i => i.checked === true).length <= 0) {
        return
      }
      const data = {
        metric_list: this.flag_list.reduce((r, i) => {
          if (i.checked) r.push(_snakeCase(i.value))
          return r
        }, []),
        page: this.campaign_type,
      }
      await this.sp_user.marketing_pas_update_metric_config(data)
    },

    m__generate_scrollbar() {
      this.$nextTick(() => {
        try {
          const dashboard_wrapper = document.getElementById('dashboard-wrapper')
          const main_pagination = document.getElementById('main-pagination')

          const main_table = document.querySelector('div#main-table')
          const main_table_fixed = document.querySelector('div#main-table-fixed-header')
          const main_table_wrapper = document.querySelector('div#main-table div.el-table__body-wrapper')
          const main_table_wrapper_fixed = document.querySelector('div#main-table-fixed-header div.el-table__header-wrapper')
          const scrollbar = document.getElementById('double-scroll-bar')

          const scrollbar_wrapper = document.getElementById('double-scroll-wrapper')
          scrollbar_wrapper.style.width = main_table.scrollWidth + 'px'
          main_table_fixed.style.width = main_table.scrollWidth + 'px'

          scrollbar.appendChild(document.createElement('div'))
          scrollbar.style.overflowX = 'auto'
          scrollbar.style.overflowY = 'hidden'
          scrollbar.firstChild.style.width = main_table_wrapper.scrollWidth + 'px'
          this.interval = setInterval(() => {
            scrollbar_wrapper.style.width = main_table.scrollWidth + 'px'
            main_table_fixed.style.width = main_table.scrollWidth + 'px'
            scrollbar.firstChild.style.width = main_table_wrapper.scrollWidth + 'px'
          }, 1000)
          scrollbar.firstChild.style.paddingTop = '1px'
          scrollbar.firstChild.appendChild(document.createTextNode('\xA0'))
          scrollbar.onscroll = () => {
            main_table_wrapper.scrollLeft = scrollbar.scrollLeft
            main_table_wrapper_fixed.scrollLeft = main_table_wrapper.scrollLeft
          }
          main_table_wrapper.onscroll = () => {
            scrollbar.scrollLeft = main_table_wrapper.scrollLeft
            main_table_wrapper_fixed.scrollLeft = main_table_wrapper.scrollLeft
          }

          const bounding_main_pagination = () => {
            const rect = main_pagination.getBoundingClientRect()
            const elem_top = rect.top
            const is_visible = elem_top <= window.innerHeight
            if (is_visible) {
              scrollbar_wrapper.style.zIndex = '-1'
            } else {
              scrollbar_wrapper.style.zIndex = '2000'
            }

            const rect2 = main_table_wrapper.getBoundingClientRect()
            const elem_top2 = rect2.top
            const elem_bot2 = rect2.bottom
            if (elem_top2 > 0 || elem_bot2 <= 100) {
              main_table_fixed.style.zIndex = '-1'
            } else {
              main_table_fixed.style.zIndex = '2000'
            }
          }
          bounding_main_pagination()

          dashboard_wrapper.onscroll = () => {
            bounding_main_pagination()
          }
        } catch (e) {
        }
      })
    },

    m__is_checked_all() {
      return this.c__show_filter_campaign_list.length && this.c__show_filter_campaign_list.length ===
        this.c__show_filter_campaign_list.filter(i => i.checked).length
    },

    m__is_indeterminate() {
      return this.c__show_filter_campaign_list.some(i => i.checked) && !this.m__is_checked_all()
    },

    m__check_all(e) {
      for (const campaign of this.c__show_filter_campaign_list) {
        campaign.checked = e
      }
    },

    m__checked_by_page() {
      this.indeterminate = true
      const start_index = (this.campaign_filter.current_page - 1) * this.campaign_filter.page_size
      const end_index = start_index + this.campaign_filter.page_size - 1

      for (const [index, campaign] of this.c__show_filter_campaign_list.entries()) {
        campaign.checked = index >= start_index && index <= end_index
      }
    },

    m__sort_change({
                     prop,
                     order,
                   }) {
      this.sort_option.order = order
      this.sort_option.prop = prop

      // todo: set scroll top
      this.m__back_to_last_scroll_position()
    },

    m__is_show_index(value) {
      const flag = this.flag_list.find(i => i.value === value)
      return flag ? flag.checked : false
    },

    m__get_report_property(campaign, key) {
      if (!campaign || !campaign.report) return '0'
      if (!campaign.report[key] || !campaign.report[key].value) return '0'
      return campaign.report[key].value > 0 ? campaign.report[key].value : '0'
    },

    m__get_compare_report_property(campaign, key) {
      if (!campaign || !campaign.c_report) return '0'
      if (!campaign.c_report[key] || !campaign.c_report[key].value) return '0'
      return campaign.c_report[key].value > 0 ? campaign.c_report[key].value : '0'
    },

    m__check_report_ratio(campaign, key) {
      if (!campaign || !campaign.report) return 0
      if (!campaign.report[key] || !campaign.report[key].ratio) return 0
      return +campaign.report[key].ratio
    },

    m__get_report_ratio(campaign, key) {
      if (!campaign || !campaign.report) return '-'

      if (!campaign.report[key] || !campaign.report[key].ratio) return '-'

      return +campaign.report[key].ratio !== 0 ? `${(+campaign.report[key].ratio * 100).toFixed(1)}%` : '-'
    },

    m__show_update_campaign_quota(campaign) {
      if (!this.check_role(this.shop, 'keyword_ads', 'update_campaign')) {
        return
      }

      if (campaign.campaign.state === 'ended' || campaign.campaign.state === 'closed') {
        return
      }

      if (this.m__calculate(campaign.campaign.daily_quota) === 0 && this.m__calculate(campaign.campaign.total_quota) ===
        0) {
        this.selected_quota_type = '1'
      } else {
        this.selected_quota_type = '2'
        if (this.m__calculate(campaign.campaign.daily_quota) > 0) {
          this.campaign_quota.quota = this.m__calculate(campaign.campaign.daily_quota)
          this.campaign_quota.type = 'daily'
        } else {
          this.campaign_quota.quota = this.m__calculate(campaign.campaign.total_quota)
          this.campaign_quota.type = 'total'
        }
      }

      this.selected_campaign = campaign
      this.show_dialog.update_campaign_quota = true
    },

    async m__update_campaign_quota() {
      this.loading.update_campaign_quota = true

      const campaign = this.selected_campaign.campaign
      const body = {
        campaign_id_list: [campaign.campaignid],
        type: 'change_budget',
        change_budget: {
          daily_budget: 0,
          page: 'page_homepage',
          // total_budget: 0,
          // budget_log_key: 'budget_log_' + make_uuid()
        },
        budget_log_key: 'budget_log_' + make_uuid(),
      }

      const log = {
        campaignId: campaign.campaignid,
        mipeeUserId: this.$store.state.userInfo.username,
        shopId: this.shop._id + '_single',
        oldDailyQuota: +campaign.daily_quota,
        oldCampaign: JSON.stringify(campaign),
        newDailyQuota: null,
        newCampaign: null,
      }

      if (this.selected_quota_type === '1') {
        campaign.daily_quota = body.change_budget.daily_budget = 0
        campaign.total_quota = body.change_budget.daily_budget = 0
      } else {
        console.log('this.DAILY_BUDGET_MIN', this.DAILY_BUDGET_MIN)
        if (this.campaign_quota.type === 'daily') {
          if (this.campaign_quota.quota < this.DAILY_BUDGET_MIN) {
            this.ntf_w(this.$t('base.y_gte_than_x', {
              y: this.$t('base.budget'),
              x: this.DAILY_BUDGET_MIN,
            }))
            this.loading.update_campaign_quota = false
            return
          } else {
            campaign.daily_quota = body.change_budget.daily_budget = this.campaign_quota.quota
            campaign.total_quota = 0
          }
        }

        if (this.campaign_quota.type === 'total') {
          if (this.campaign_quota.quota < this.DAILY_BUDGET_MIN * 10) {
            this.ntf_w(this.$t('base.y_gte_than_x', {
              y: this.$t('base.budget'),
              x: this.DAILY_BUDGET_MIN * 10,
            }))
            this.loading.update_campaign_quota = false
            return
          } else {
            campaign.total_quota = 0
            campaign.daily_quota = body.change_budget.daily_budget = 0
          }
        }
      }

      body.change_budget.daily_budget *= 100000
      await this.sp_user.marketing_pas_mass_update(body)

      log.newDailyQuota = +campaign.daily_quota
      log.newCampaign = JSON.stringify(campaign)
      this.$http.post(this.API.URL_API_SRV_1 + '/lg/5.1', log, this.cf()).catch(console.error)

      this.ntf_s(this.$t('base.update_success'))

      this.loading.update_campaign_quota = false
      this.show_dialog.update_campaign_quota = false
    },

    async m__redirect_detail(e, campaign) {
      if (e) e.preventDefault()

      if (!this.is_full) return

      // todo: save last scroll top
      const wrapper = document.querySelector('#dashboard-wrapper')
      if (wrapper) {
        this.last_scroll_position = wrapper.scrollTop
      }

      await this.m__show_campaign_detail(campaign)
    },

    async m__show_campaign_detail(campaign) {
      campaign.loading = true
      this.selected_campaign = campaign
      this.component_key = make_uuid()
      this.$emit('update:campaign_component', campaign.campaign.type)
      await this.m__get_auto_condition_action_for_campaign(campaign.campaign.campaignid)
    },

    m__show_update_campaign_date(campaign) {
      if (!this.check_role(this.shop, 'keyword_ads', 'update_campaign')) {
        return
      }

      if (campaign.campaign.state === 'ended' || campaign.campaign.state === 'closed') {
        return
      }

      if (campaign.campaign.end_time === 0) {
        this.campaign_time.start_time = new Date(campaign.campaign.start_time * 1000)
        this.selected_time_type = 'unlimited'
      } else {
        this.selected_time_type = 'from_to'
        this.campaign_time.start_time = new Date()
        this.campaign_time.end_time = new Date(campaign.campaign.end_time * 1000)
      }
      this.selected_campaign = campaign
      this.show_dialog.update_campaign_date = true
    },

    async m__update_campaign_date() {
      this.loading.update_campaign_date = true

      const campaign = this.selected_campaign.campaign
      if (this.selected_time_type === 'unlimited') {
        this.selected_campaign.campaign.end_time = 0
        await this.sp_user.marketing_pas_mass_update({
          campaign_id_list: [campaign.campaignid],
          type: 'change_schedule',
          change_schedule: {
            start_time: campaign.start_time,
            end_time: 0,
          },
        })
      } else {
        if (!this.campaign_time.start_time) {
          this.ntf_w(this.$t('required.start_time'))
          return
        }
        if (!this.campaign_time.end_time) {
          this.$t('required.end_time')
          return
        }
        if (this.campaign_time.end_time.getTime() <= this.campaign_time.start_time.getTime()) {
          this.ntf_w(this.$t('base.y_gt_than_x', {
            y: this.$t('base.start_time'),
            x: this.$t('base.end_time'),
          }))
          return
        }

        campaign.start_time = this.dayjs(this.campaign_time.start_time).startOf('d').unix()
        campaign.end_time = this.dayjs(this.campaign_time.end_time).endOf('d').unix()
        await this.sp_user.marketing_pas_mass_update({
          campaign_id_list: [campaign.campaignid],
          type: 'change_schedule',
          change_schedule: {
            start_time: campaign.start_time,
            end_time: campaign.end_time,
          },
        })
      }

      this.ntf_s(this.$t('base.update_success'))

      this.loading.update_campaign_date = false
      this.show_dialog.update_campaign_date = false
    },

    async m__get_ads_data() {
      await this.m__get_atosa_flag_list()

      await Promise.all([
        this.m__get_shop_campaigns(),
        this.m__get_campaign_reports(),
        this.m__get_report_config(),
      ])
    },

    async m__get_shop_campaigns() {
      this.loading.get_campaigns = true
      this.$emit('update:getting_campaigns', true)
      this.campaign_list = []

      try {
        let limit = 50, offset = 0, state = this.selected_state
        if (this.campaign_fixed_list[this.$store.state.userInfo.username]) {
          limit = this.campaign_fixed_list[this.$store.state.userInfo.username].campaign_limit
        }
        let start_time = this.dayjs(this.start_date).startOf('day'), end_time = this.dayjs(this.end_date).endOf('day')
        let filter = {
          campaign_type: this.campaign_type,
          search_term: '',
          state: state,
        }
        if (this.campaign_type === 'product_homepage' && this.product_placement_list.length) {
          filter['product_placement_list'] = this.product_placement_list
        }

        let response = await this.sp_user.marketing_pas_get_campaigns(start_time.unix(), end_time.unix(), offset, limit,
          filter)
        response = this.m__map_campaign_data(response, true)

        while (response && response.data && response.data.campaign_ads_list && response.data.campaign_ads_list.length > 0) {
          for (const item of response.data.campaign_ads_list) {
            for (const key of Object.keys(item.report)) {
              item.report[key].ratio = Number(item.report[key].ratio)
              item.report[key].value = Number(item.report[key].value)
            }
            item.report = this.m__map_campaign_report(item.report)

            const campaign_found = this.compare_list.find(i => i.campaign.campaignid === item.campaign.campaignid)
            item.c_report = campaign_found ? campaign_found.report : this.clone(item.report)

            item.plan = null
            item.auto_pause = null
            item.auto_quota = null
            item.group_id = null
            item.group_name = null
            item.loading = false
            item.checked = false
            item.is_expanded = false
            item.auto_condition_action = null
            item.tags = new Set()

            // todo: calculate target roi
            if (item.campaign.bidding_type === 'roi_two' && item.campaign.roi_two_target > 0) {
              item.campaign.roi_two_target = parseFloat((item.campaign.roi_two_target / 100000).toFixed(1))
            }
            if (item.campaign.bidding_type === 'auto' && item.campaign.roi_two_target > 0) {
              item.campaign.roi_two_target = parseFloat((item.campaign.roi_two_target / 100000).toFixed(1))
            }
            if (item.live_stream_ads && item.campaign.bidding_type === 'live_stream_homepage__max_gmv__target') {
              item.campaign.roi_two_target = parseFloat((item.live_stream_ads.target_broad_roi / 100000).toFixed(1))
            }
            if (item.live_stream_ads && item.campaign.bidding_type === 'live_stream_homepage__max_gmv_roi_two__target') {
              item.campaign.roi_two_target = parseFloat((item.live_stream_ads.roi_two.target / 100000).toFixed(1))
            }
          }
          this.campaign_list.push(...response.data.campaign_ads_list)

          if (this.campaign_component === 'list' && this.$route.query.campaign_id) {
            const campaign = this.campaign_list.find(i => i.campaign.campaignid === +this.$route.query.campaign_id)
            if (campaign) {
              await this.m__redirect_detail(null, campaign)
              const new_query = this.clone(this.$route.query)
              delete new_query.campaign_id
              this.$router.replace({ 'query': new_query }).catch(console.error)
            }
          }

          offset += limit
          response = await this.sp_user.marketing_pas_get_campaigns(start_time.unix(), end_time.unix(), offset, limit,
            filter)
          response = this.m__map_campaign_data(response, true)
        }

        // todo: load auto config
        const campaign_list_ids = this.campaign_list.map(i => i.campaign.campaignid)
        try {
          const [auto_quota_resp, auto_optimize_resp] = await Promise.all([
            this.$http.post(this.API.URL_API_SRV_1 + '/auto_quota/get', {
              mipeeUserId: this.$store.state.userInfo.username,
              campaignIds: campaign_list_ids,
            }),
            this.$http.post(this.API.URL_API_SRV_1 + '/targeting_auto_optimize/m?campaignId=1', {
              mipeeUserId: this.$store.state.userInfo.username,
              campaignIds: campaign_list_ids,
            }, this.cf()),
          ])

          for (const item of this.campaign_list) {
            item.auto_quota = auto_quota_resp.body.find(i => i.campaignId === item.campaign.campaignid)
            item.auto_optimize = null
            item.auto_optimize_search = null
            item.auto_optimize_targeting = null
            const auto_optimize_list = auto_optimize_resp.body.filter(i => i.campaignId === item.campaign.campaignid)
            for (const auto_optimize of auto_optimize_list) {
              item[`auto_optimize_${auto_optimize.campaignType}`] = auto_optimize
            }
          }

          await Promise.all([
            this.m__sync_config(),
            this.m__get_auto_condition_action(),
            this.m__get_auto_by_ai_config(),
          ])
        } catch (e) {
          console.error(e)
        }

        if (this.is_compare_campaign) {
          this.m__confirm_compare_campaign().catch(console.error)
        }

        if (this.array_to_set(['all', 'ongoing']).has(this.selected_state)) {
          console.log('update:active_campaign_list')
          this.$emit('update:active_campaign_list', this.campaign_list.filter(i => i.campaign.state === 'ongoing').map(i => ({ ...i.campaign, ...i.product })))
        }

        // todo: get update count
        const get_update_count_response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/log/get_update_count', {
          shop_id: this.shop.shop_id,
          campaign_ids: campaign_list_ids,
          start_time: this.dayjs().startOf('day').unix(),
          end_time: this.dayjs().endOf('day').unix()
        }, this.cf())
        for (const key of Object.keys(get_update_count_response.body.data)) {
          const campaign_found = this.campaign_list.find(i => i.campaign && i.campaign.campaignid === +key)
          if (campaign_found) {
            campaign_found.report.update_count = get_update_count_response.body.data[key]
            console.log(campaign_found.campaign.campaignid, campaign_found.report.update_count)
          }
        }
        // end get update count

        // todo: get cancelled gmv + roi
        const item_ids_set = new Set()
        for (const campaign of this.campaign_list) {
          if (campaign.product && campaign.product.itemid) item_ids_set.add(campaign.product.itemid)
        }

        const get_canceled_orders_by_itemid_response = await this.$http.post(this.API.URL_API_SRV_2 + '/shopee/get_canceled_orders_by_itemid', {
          shop_id: this.shop.shop_id,
          item_ids: Array.from(item_ids_set),
          start_time: start_time.unix(),
          end_time: end_time.unix()
        }, this.cf())
        for (const item of get_canceled_orders_by_itemid_response.body.data) {
          const campaign_found = this.campaign_list.find(i => i.product && i.product.itemid === +item.item_id)
          if (campaign_found) {
            campaign_found.report.cancelled_gmv = { value: 0 }
            campaign_found.report.cancelled_gmv.value = item.price
            campaign_found.report.cancelled_roi = { value: 0 }
            campaign_found.report.cancelled_roi.value = campaign_found.report.cost && campaign_found.report.cost.value
              ? parseFloat((campaign_found.report.cancelled_gmv.value / campaign_found.report.cost.value).toFixed(2))
              : 0
          }
        }
        for (const campaign_found of this.campaign_list) {
          if (!campaign_found.report.cancelled_gmv) continue

          campaign_found.report.exclude_cancelled_gmv = { value: 0 }
          campaign_found.report.exclude_cancelled_gmv.value = campaign_found.report.broad_gmv.value >= campaign_found.report.cancelled_gmv.value
            ? campaign_found.report.broad_gmv.value - campaign_found.report.cancelled_gmv.value
            : 0
          campaign_found.report.exclude_cancelled_roi = { value: 0 }
          campaign_found.report.exclude_cancelled_roi.value = campaign_found.report.cost && campaign_found.report.cost.value
            ? parseFloat((campaign_found.report.exclude_cancelled_gmv.value / campaign_found.report.cost.value).toFixed(2))
            : 0
        }
        // end cancelled gmv + roi

        this.campaign_list = this.clone(this.campaign_list)
      } catch (e) {
        console.error(e)
        this.ntf_w(this.$t('ads.error_with_getting_campaigns'))
      } finally {
        this.loading.get_campaigns = false
        this.$emit('update:getting_campaigns', false)
        this.m__generate_scrollbar()
      }

      // todo: welcome to atosa agent ai
      // if (this.m__check_atosa_agent_used_package().result === true) {
      //   if (!this.welcome_atosa_agent_showed_dialog && !this.m__check_is_unpaid_operating_cost() &&
      //     !this.auto_by_ai_config_list.length) {
      //     await this.sleep(2000)
      //
      //     if (this.campaign_list.length < 5) {
      //       const product_ids = new Set()
      //       for (const campaign of this.campaign_list) {
      //         if (!this.m__can_setup_auto_by_ai(campaign)) continue
      //         if (campaign.product && campaign.product.itemid) product_ids.add(campaign.product.itemid)
      //       }
      //       const products_not_in = this.product_list.filter(i => !product_ids.has(i.id))
      //       const products_filtered = products_not_in.filter(i => i.extra_data && i.extra_data.add_to_cart_units > 0)
      //       const products_sorted = _orderBy(products_filtered, ['sold'], ['desc'])
      //       this.welcome_atosa_agent_product_list = products_sorted.slice(0, 5).map(i => ({
      //         id: i.id,
      //         name: i.name,
      //         images: i.images,
      //         checked: false,
      //         state: 'pending',
      //       }))
      //       if (this.welcome_atosa_agent_product_list.length) {
      //         this.welcome_atosa_agent_component = 'create'
      //         this.show_dialog.welcome_atosa_agent = true
      //         this.$emit('update:welcome_atosa_agent_showed_dialog', true)
      //       }
      //     } else {
      //       const filtered = this.campaign_list.filter(
      //         i => this.m__can_setup_auto_by_ai(i) && !this.m__has_auto_by_ai_config(i))
      //       const sorted = _orderBy(filtered,
      //         ['campaign.report.gmv.value', 'campaign.report.click.value', 'campaign.report.impression.value'],
      //         ['desc', 'desc', 'desc'])
      //       this.welcome_atosa_agent_campaign_list = this.clone(sorted.slice(0, 5))
      //       if (this.welcome_atosa_agent_campaign_list.length) {
      //         this.welcome_atosa_agent_component = 'setup'
      //         this.show_dialog.welcome_atosa_agent = true
      //         this.$emit('update:welcome_atosa_agent_showed_dialog', true)
      //       }
      //     }
      //   }
      // }
    },

    async m__change_campaign_state(state) {
      this.selected_state = state
      await this.m__get_shop_campaigns()
    },

    async m__get_campaign_reports() {
      const start_time = this.dayjs(this.start_date).startOf('day').unix()
      const end_time = this.dayjs(this.end_date).endOf('day').unix()

      const filter_params = {}
      if (this.campaign_type === 'product_homepage' && this.product_placement_list.length) {
        filter_params['product_placement_list'] = this.product_placement_list
      }

      const response = await this.sp_user.marketing_get_time_graph(this.campaign_type, start_time, end_time, filter_params)
      if (response.data) {
        this.metrics = this.m__map_graph_response(response.data.report_aggregate)
        this.reports = this.m__map_graph_by_time_response(response.data.report_by_time)
      }
    },

    async m__get_report_config() {
      const report_config_response = await this.sp_user.marketing_pas_get_report_config()
      if (report_config_response.data && report_config_response.data.selected_metric) {
        for (const flag of this.flag_list) {
          flag.checked = report_config_response.data.selected_metric[this.campaign_type].metric_list.includes(
            flag.value)
        }
      }
    },

    async m__pause_campaign(campaign) {
      if (!this.check_role(this.shop, 'keyword_ads', 'update_campaign')) {
        return
      }

      await this.sp_user.marketing_pas_update_campaign({
        campaign_id: campaign.campaign.campaignid,
        header: {},
        type: 'pause',
      }, campaign.campaign.shopee_type)
      campaign.campaign.state = 'paused'
    },

    async m__stop_campaign(campaign) {
      if (!this.check_role(this.shop, 'keyword_ads', 'update_campaign')) {
        return
      }

      await this.sp_user.marketing_pas_update_campaign({
        campaign_id: campaign.campaign.campaignid,
        header: {},
        type: 'stop',
      }, campaign.campaign.shopee_type)
      campaign.campaign.state = 'stop'
    },

    async m__ongoing_campaign(campaign) {
      if (!this.check_role(this.shop, 'keyword_ads', 'update_campaign')) {
        return
      }

      await this.sp_user.marketing_pas_update_campaign({
        campaign_id: campaign.campaign.campaignid,
        header: {},
        type: 'resume',
      }, campaign.campaign.shopee_type)
      campaign.campaign.state = 'ongoing'
    },

    async m__restart_campaign(campaign) {
      if (!this.check_role(this.shop, 'keyword_ads', 'update_campaign')) {
        return
      }

      if (campaign.campaign.type === 'all') {
        await this.m__fix_missing_keywords(campaign)
      }
      if (campaign.campaign.type === 'keyword') {
        await this.m__fix_missing_keywords(campaign)
      }
      if (campaign.campaign.type === 'shop') {
        await this.m__fix_missing_keywords(campaign)
      }
      if (campaign.campaign.type === 'targeting') {
        await this.m__fix_missing_placement(campaign)
      }

      if (campaign.campaign.type === 'shop') {
        const form = {
          reference_id: make_uuid(),
          campaign: {
            campaign_id: campaign.campaign.campaignid,
            target_broad_roi: 0,
            daily_budget: Math.trunc(campaign.campaign.daily_quota * 100000),
            creative: {
              is_use_default: !campaign.advertisements[0].extinfo.shop_customisation.display_title,
              landing_page: 'shop_homepage',
              image_url: campaign.advertisements[0].extinfo.shop_customisation.image_url,
              tagline: campaign.advertisements[0].extinfo.shop_customisation.display_title,
            },
            bidding_strategy: campaign.campaign.bidding_type,
            start_time: this.dayjs().startOf('day').unix(),
            end_time: 0,
            name: campaign.campaign.name + ' ' + this.random_range(1000, 9999),
          },
          header: {},
        }

        if (campaign.campaign.bidding_type === 'auto') {
          form.target_broad_roi = 0
          form.creative = {
            is_use_default: true
          }
        }

        if (campaign.campaign.bidding_type === 'manual') {
          const placement3 = campaign.advertisements.find(i => i.placement === 3)

          form.campaign.bidding_strategy = 'manual'
          form.campaign.keyword_list = placement3.extinfo.keywords.filter(i => i.status === 1).map(keyword => {
            return {
              keyword: keyword.keyword.trim().normalize().toLowerCase(),
              bid_price: Math.trunc(keyword.price * 100000),
              match_type: keyword.match_type === 0 ? 'exact' : 'broad',
            }
          })
          form.campaign.keyword_list = _uniqBy(form.campaign.keyword_list, 'keyword').slice(0, 200)
        }

        console.log('restart form:', form)
        const create_response = await this.sp_user.marketing_pas_publish_campaign(form, 'shop')
        console.log('restart create_response:', create_response)
        if (create_response.code === 0) campaign.campaign.state = 'ongoing'
      } else {
        const form = {
          reference_id: make_uuid(),
          campaign: {
            campaign_id: campaign.campaign.campaignid,
            daily_budget: Math.trunc(campaign.campaign.daily_quota * 100000),
            product_placement: campaign.campaign.type,
            ecpc: false,
            bidding_strategy: campaign.campaign.bidding_type,
            product_selection: 'manual',
            start_time: this.dayjs().startOf('day').unix(),
            end_time: 0,
          },
          ads_list: [
            {
              item_id: campaign.product.itemid,
            },
          ],
          header: {},
        }

        if (form.campaign.product_placement === 'keyword') form.campaign.product_placement = 'search_product'
        if (campaign.campaign.bidding_type === 'auto') {
          delete form.campaign.ecpc
          delete form.campaign.keyword_list
          delete form.campaign.display_location
          delete form.campaign.target_audience
          form.campaign.target_broad_roi = 0
        }
        if (campaign.campaign.bidding_type === 'roi_two') {
          delete form.campaign.ecpc
          delete form.campaign.keyword_list
          delete form.campaign.display_location
          delete form.campaign.target_audience
          form.campaign.roi_two_target = campaign.advertisements[0].extinfo.roi_two.target
        }
        if (['all', 'keyword'].includes(campaign.campaign.type) && campaign.campaign.bidding_type === 'manual') {
          const placement0 = campaign.advertisements.find(i => i.placement === 0)
          form.campaign.keyword_list = placement0.extinfo.keywords.filter(i => i.status === 1).map(keyword => {
            return {
              keyword: keyword.keyword.trim().normalize().toLowerCase(),
              bid_price: Math.trunc(keyword.price * 100000),
              match_type: keyword.match_type === 0 ? 'exact' : 'broad',
            }
          })
          form.campaign.keyword_list = _uniqBy(form.campaign.keyword_list, 'keyword').slice(0, 200)
        }
        if (['all', 'targeting'].includes(campaign.campaign.type) && campaign.campaign.bidding_type === 'manual') {
          const placement2 = campaign.advertisements.find(i => i.placement === 2)
          const placement5 = campaign.advertisements.find(i => i.placement === 5)
          form.campaign.display_location = {
            daily_discover: {
              state: 'active',
              bid_price: Math.trunc(placement2.extinfo.target.price * 100000),
            },
            you_may_also_like: {
              state: 'active',
              bid_price: Math.trunc(placement5.extinfo.target.price * 100000),
            },
          }
        }

        if (form.campaign.bidding_strategy === 'roi_two') {
          delete form.campaign.ecpc
        }

        console.log('restart form:', form)
        const create_response = await this.sp_user.marketing_pas_publish_campaign(form)
        console.log('restart create_response:', create_response)
        if (create_response.code === 0) campaign.campaign.state = 'ongoing'
      }
    },

    // todo: old function
    async m__confirm_update_campaign_state() {
      this.loading.update_campaign_state = true

      try {
        for (const campaign of this.c__show_filter_campaign_list.filter(i => i.checked)) {
          if (this.campaign_state_radio === 'ongoing' && campaign.campaign.state !== 'ongoing' &&
            campaign.campaign.state !== 'ended') {
            await this.m__ongoing_campaign(campaign)
          }
          if (this.campaign_state_radio === 'pause' && campaign.campaign.state !== 'paused' &&
            campaign.campaign.state !== 'ended') {
            await this.m__pause_campaign(campaign)
          }
          if (this.campaign_state_radio === 'stop' && campaign.campaign.state !== 'ended') {
            await this.m__stop_campaign(campaign)
          }
          if (this.campaign_state_radio === 'restart' && campaign.campaign.state === 'ended') {
            await this.m__restart_campaign(campaign)
          }
        }

        this.ntf_s(this.$t('base.update_success'))
        this.show_dialog.update_campaign_state = false
      } catch (e) {
        console.error(e)
        this.ntf_w(this.$t('base.has_an_occurred'))
      } finally {
        this.loading.update_campaign_state = false
      }
    },

    m__show_update_campaign_state_dialog() {
      this.show_dialog.update_campaign_state = true
    },

    async m__get_condition_action_list() {
      const response = await this.$http.get(this.API.URL_API_SRV_2 + '/mipee/condition_action/get', this.cf())
      this.condition_action_file_list = response.body.data
    },

    async m__delete_condition_action_file(file) {
      try {
        await this.$confirm(this.$t('base.delete_file_confirm'), this.$t('base.attention'), {
          type: 'warning',
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
        })
      } catch (e) {
        return
      }

      await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/condition_action/delete', {
        id: file._id,
      }, this.cf())

      await this.m__get_condition_action_list()
      this.ntf_s(this.$t('base.update_success'))
    },

    m__confirm_action_select_file(file) {
      const found = file || this.condition_action_file_list.find(i => i._id === this.condition_action_file_selected)
      if (!found) return

      this.condition_action_list = this.clone(found.data)
      this.show_dialog.action_condition_select_file = false

      if (file) this.condition_action_tab = 'main'
    },

    m__show__action_select_file_dialog() {
      this.show_dialog.action_condition_select_file = true
    },

    async m__confirm_action_save_file() {
      this.loading.action_condition_save_file = true
      try {
        if (this.condition_action_radio === '1') {
          if (!this.condition_action_filename) {
            this.ntf_w(this.$t('required.filename'))
            return
          }

          await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/condition_action/save', {
            filename: this.condition_action_filename,
            data: this.condition_action_list,
          }, this.cf())
        }

        if (this.condition_action_radio === '2') {
          if (!this.condition_action_file_selected) {
            this.ntf_w(this.$t('required.select_file'))
            return
          }

          const found = this.condition_action_file_list.find(i => i._id === this.condition_action_file_selected)
          await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/condition_action/update', {
            id: found._id,
            filename: found.filename,
            data: this.condition_action_list,
          }, this.cf())
        }

        await this.m__get_condition_action_list()
        this.ntf_s(this.$t('base.update_success'))
        this.show_dialog.action_condition_save_file = false
      } catch (e) {
        console.error(e)
      } finally {
        this.loading.action_condition_save_file = false
      }
    },

    m__show_condition_action_save_file_dialog() {
      this.show_dialog.action_condition_save_file = true
    },

    async m__confirm_condition_action() {
      this.loading.update_keyword_by_condition = true
      let has_error = false

      for (const item of this.condition_action_list) {
        if (!item.action) {
          item.error_msg = this.$t('required.action_to_handle')
          has_error = true
          continue
        }

        if (['increase', 'reduce'].includes(item.action) && !item.update_price_type) {
          item.error_msg = this.$t('required.i_or_d_type')
          has_error = true
          continue
        }

        if (['increase', 'reduce'].includes(item.action) && !item.update_price_value) {
          item.error_msg = this.$t('required.i_or_d_value')
          has_error = true
          continue
        }

        if (item.action === 'cpc' && !item.cpc_range) {
          item.error_msg = this.$t('required.cpc_duration')
          has_error = true
          continue
        }

        item.error_msg = ''

        for (const condition of item.condition_list) {
          if (!condition.expression) condition.expression = '==='

          const {
            label,
            expression,
            value,
            value_s,
          } = condition

          if (!label || !expression || (Number.isNaN(+value) && !value_s)) {
            item.error_msg = this.$t('required.full_filter_data')
            has_error = true
            break
          }

          item.error_msg = ''
        }
      }

      try {
        if (!has_error) {
          for (const campaign of this.c__show_filter_campaign_list.filter(i => i.checked)) {
            campaign.advertisements = []
            await this.m__fix_missing_keywords(campaign, true)
            const placement = campaign.advertisements.find(i => [0, 3].includes(i.placement))

            if (!placement || !placement.extinfo) continue

            const placement_found = placement.placement
            const campaign_type = get_shopee_campaign_type(placement_found)

            for (const item of this.condition_action_list) {
              let report_response
              if (item.action === 'cpc') {
                const start_time = this.dayjs(item.cpc_range[0]).startOf('day')
                const end_time = this.dayjs(item.cpc_range[1]).endOf('day')
                const new_response = await this.sp_user.marketing_get_report('keyword', campaign_type,
                  start_time.unix(), end_time.unix(), { campaign_id: campaign.campaign.campaignid })
                report_response = this.m__map_search_report_by_key(new_response)
              }

              item.error_msg = ''
              item.success_msg = ''

              let keywords = placement.extinfo.keywords
              for (const condition of item.condition_list) {
                keywords = keywords.filter(i => {
                  if (condition.match_type === 'match_type_0' && i.match_type === 1) return false
                  if (condition.match_type === 'match_type_1' && i.match_type === 0) return false

                  if (condition.label === 'include_keywords' && condition.value_s && condition.value_s.trim()) {
                    const split_keywords = condition.value_s.trim().toLowerCase().split('\n')
                    return split_keywords.some(ii => ii.trim() === i.keyword)
                  } else {
                    if (!i.report) i.report = this.default_report

                    i.report.price = i.price

                    const found = this.filter.find(i => i.camel_key === condition.label)
                    const base_value = i.report[condition.label]
                    const value = found && found.is_percent === true ? base_value * 100 : base_value

                    return eval(`${value}${condition.expression}${condition.value}`)
                  }
                })
              }

              const update_status_list = []
              for (const keyword of keywords) {

                if (item.action === 'value') {
                  keyword.price = +item.value
                }
                if (item.action === 'increase') {
                  const value = item.update_price_type === 'value'
                    ? this.m__calculate(item.update_price_value)
                    : this.m__calculate(this.percent_of(+item.update_price_value, keyword.price))
                  keyword.price += value

                  if (+item.max_bid_price && keyword.price > +item.max_bid_price) {
                    keyword.price = +item.max_bid_price
                  }
                }
                if (item.action === 'reduce') {
                  const value = item.update_price_type === 'value'
                    ? this.m__calculate(item.update_price_value)
                    : this.m__calculate(this.percent_of(+item.update_price_value, keyword.price))
                  keyword.price -= value

                  if (+item.min_bid_price && keyword.price < +item.min_bid_price) {
                    keyword.price = +item.min_bid_price
                  }
                }
                if (item.action === 'cpc') {
                  for (const item of report_response.data) {
                    const atosa_cpc = +item.click ? this.m__calculate(+item.cost / +item.click) : 0
                    const keyword_found = keywords.find(i => i.keyword === item.keyword)
                    if (keyword_found) keyword_found.price = atosa_cpc
                  }
                }
                if (item.action === 'match_type_0') {
                  keyword.match_type = 0
                }
                if (item.action === 'match_type_1') {
                  keyword.match_type = 1
                }
                if (item.action === 'ongoing') {
                  if (keyword.status !== 1) {
                    keyword.status = 1
                    update_status_list.push(keyword)
                  }
                }
                if (item.action === 'pause') {
                  if (keyword.status !== 0) {
                    keyword.status = 0
                    update_status_list.push(keyword)
                  }
                }
                if (item.action === 'ongoing_both') {
                  if (keyword.status !== 1) {
                    keyword.status = 1
                    update_status_list.push(keyword)
                  }

                  await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/update_config_status', {
                    shop_id: this.shop._id,
                    campaign_id: campaign.campaign.campaignid,
                    keyword: keyword.keyword,
                    status: 1,
                  }, this.cf())
                }
                if (item.action === 'pause_both') {
                  if (keyword.status !== 0) {
                    keyword.status = 0
                    update_status_list.push(keyword)
                  }

                  await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/update_config_status', {
                    shop_id: this.shop._id,
                    campaign_id: campaign.campaign.campaignid,
                    keyword: keyword.keyword,
                    status: 0,
                  }, this.cf())
                }
                if (item.action === 'add_tags' && item.tag_id) {
                  await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/keyword_tags/add_to_keywords', {
                    tag_id: item.tag_id,
                    campaign_id: campaign.campaign.campaignid,
                    keywords: [keyword.keyword],
                  }, this.cf())
                }

                this.m__prefix_keyword_price(keyword, placement.placement)
              }

              if (['ongoing', 'pause', 'ongoing_both', 'pause_both'].includes(item.action)) {
                await this.sp_user.marketing_pas_update_keyword_status(campaign.campaign.campaignid, update_status_list,
                  campaign_type)
              } else {
                await this.sp_user.marketing_pas_update_keyword_type(campaign.campaign.campaignid, keywords,
                  campaign_type)
                await this.sp_user.marketing_pas_update_keyword_price(campaign.campaign.campaignid, keywords,
                  campaign_type)
              }
              // todo: write log
              this.$http.post(this.API.URL_API_SRV_2 + '/mipee/condition_action/log', {
                condition_list: this.condition_action_list,
                campaign_id: campaign.campaign.campaignid,
                keywords: keywords,
              }, this.cf()).catch(console.error)

              item.success_msg = this.$t('base.update_keywords_success')
            }
          }

          this.show_dialog.update_keyword_by_condition = false
          this.ntf_s(this.$t('base.update_success'))
        }
      } catch (e) {
        console.error(e)
        this.ntf_w(this.$t('base.has_an_occurred'))
      }

      this.loading.update_keyword_by_condition = false
    },

    m__remove_action(action_list, index) {
      action_list.splice(index, 1)
    },

    m__add_action(item, type) {
      if (!item.actions) item.actions = []

      item.actions.push({
        type: type,
        ...this.clone(action_template)
      })

      this.condition_action_list = this.clone(this.condition_action_list)
    },

    m__remove_condition(condition_list, index, parent = null) {
      condition_list.splice(index, 1)

      if (parent) {
        parent.condition_group = parent.condition_group.filter(i => i.condition_list.length)
      }
    },

    m__swap_condition(condition_list, index, type) {
      if (type === 'up' && index === 0) return
      if (type === 'down' && index === condition_list.length - 1) return

      if (type === 'up') {
        const temp = condition_list[index]
        condition_list[index] = condition_list[index - 1]
        condition_list[index - 1] = temp
      }
      if (type === 'down') {
        const temp = condition_list[index]
        condition_list[index] = condition_list[index + 1]
        condition_list[index + 1] = temp
      }

      this.condition_action_list = this.clone(this.condition_action_list)
    },

    m__copy_condition(condition_list, index, data) {
      condition_list.splice(index + 1, 0, this.clone(data))
    },

    m__add_condition(condition_list) {
      condition_list.push(this.clone(this.condition_template))
    },

    m__swap_condition_group(condition_group, index, type) {
      if (type === 'up' && index === 0) return
      if (type === 'down' && index === condition_group.length - 1) return

      if (type === 'up') {
        const temp = condition_group[index]
        condition_group[index] = condition_group[index - 1]
        condition_group[index - 1] = temp
      }
      if (type === 'down') {
        const temp = condition_group[index]
        condition_group[index] = condition_group[index + 1]
        condition_group[index + 1] = temp
      }

      this.condition_action_list = this.clone(this.condition_action_list)
    },

    m__copy_condition_group(condition_group, index, condition_action_list) {
      condition_action_list.condition_group.splice(index + 1, 0, this.clone(condition_group))
    },

    m__add_condition_group(condition_group) {
      condition_group.push({ condition_list: [this.clone(this.condition_template)] })
    },

    m__remove_condition_action(index) {
      this.condition_action_list.splice(index, 1)
    },

    m__add_condition_action(add_to_group = true) {
      const template = this.clone(this.condition_action_template)
      template.condition_group.push({
        condition_list: [this.clone(this.condition_template)],
      })
      if (!add_to_group) {
        template.condition_list.push(this.clone(this.condition_template))
      }
      this.condition_action_list.push(template)
    },

    m__show_update_keyword_by_condition_dialog() {
      if (!this.condition_action_list.length) {
        const template = this.clone(this.condition_action_template)
        template.condition_list.push(this.clone(this.condition_template))
        this.condition_action_list.push(template)
      }

      this.show_dialog.update_keyword_by_condition = true
    },

    async m__renew_campaign(campaign) {
      const campaign_type = campaign.campaign.type === 'shop' ? 'shop' : 'product'
      const response = await this.sp_user.marketing_get_campaign_detail(campaign.campaign.campaignid, campaign_type)
      const campaign_detail = response.data
      campaign.advertisements = campaign_detail.advertisements

      if (campaign_detail.campaign.bidding_strategy === 'roi_two') {
        campaign_detail.campaign.roi_two_target = parseFloat((campaign_detail.campaign.roi_two.target * 100).toFixed(1))
      }
    },

    async m__fix_missing_keywords(campaign, get_report = false, renew = false) {
      const campaign_type = campaign.campaign.type === 'shop' ? 'shop' : 'product'

      if (renew || (!campaign.advertisements.length && ['all', 'keyword'].includes(campaign.campaign.type))) {
        const response = await this.sp_user.marketing_get_campaign_detail(campaign.campaign.campaignid, campaign_type)
        if (response && response.data && response.data.advertisements) {
          campaign.advertisements = response.data.advertisements
        }
      }
      if (renew || (!campaign.advertisements.length && ['shop'].includes(campaign.campaign.type))) {
        const response = await this.sp_user.marketing_get_campaign_detail(campaign.campaign.campaignid, campaign_type)
        if (response && response.data && response.data.advertisements) {
          campaign.advertisements = response.data.advertisements
        }
      }

      const placement_found = campaign.advertisements.find(i => [0, 3].includes(i.placement))
      if (placement_found && placement_found.extinfo && placement_found.extinfo.keywords &&
        !placement_found.extinfo.keywords.length) {
        const response = await this.sp_user.marketing_get_campaign_detail(campaign.campaign.campaignid, campaign_type)
        const campaign_detail = response.data
        placement_found.extinfo.keywords = campaign_detail.advertisements.find(
          item => item.placement === placement_found.placement).extinfo.keywords.map(i => {
          i.report = this.default_report
          return i
        })
      }
      if (placement_found && get_report) {
        const start_time = this.dayjs(this.start_date).startOf('day')
        const end_time = this.dayjs(this.end_date).endOf('day')
        const campaign_type = get_shopee_campaign_type(placement_found)
        const new_response = await this.sp_user.marketing_get_report('keyword', campaign_type, start_time.unix(),
          end_time.unix(), { campaign_id: campaign.campaign.campaignid })
        const report_response = this.m__map_search_report_by_key(new_response)
        for (const item of report_response.data) {
          const keyword_found = placement_found.extinfo.keywords.find(i => i.keyword === item.keyword)
          if (keyword_found) keyword_found.report = this.m__map_detail_campaign_report(item)
        }
      }
    },

    async m__fix_missing_placement(campaign, get_report = false, renew = false) {
      const campaign_type = campaign.campaign.type === 'shop' ? 'shop' : 'product'

      if (renew || (!campaign.advertisements.length || !campaign.advertisements[0].extinfo)) {
        const response = await this.sp_user.marketing_get_campaign_detail(campaign.campaign.campaignid, campaign_type)
        if (response && response.data && response.data.advertisements) {
          campaign.advertisements = response.data.advertisements
        }
      }

      if (get_report) {
        const agg_type = campaign.campaign.advertisements.some(i => [1, 2, 5].includes(i.placement))
          ? 'display_location'
          : 'product_placement_auto_strategy'
        const start_time = this.dayjs(this.start_date).startOf('day')
        const end_time = this.dayjs(this.end_date).endOf('day')
        const new_response = await this.sp_user.marketing_get_report(agg_type, 'product', start_time.unix(),
          end_time.unix(), { campaign_id: campaign.campaign.campaignid })
        const report_response = this.m__map_search_report_by_key(new_response)
        for (const ads of campaign.advertisements) {
          const report = report_response.find(i => i.placement === ads.placement.toString())
          if (report) {
            ads.report = this.m__map_detail_campaign_report(report)
          }
        }
      }
    },

    m__is_low_quota(campaign) {
      const start_time = this.dayjs(this.date_range[0])
      const end_time = this.dayjs(this.date_range[1])

      if (start_time.isSame(this.dayjs(), 'day') && end_time.isSame(this.dayjs(), 'day') && campaign.report &&
        +campaign.report.cost.value) {
        const value = +campaign.campaign.daily_quota
          ? +campaign.campaign.daily_quota * 15 / 100
          : +campaign.campaign.total_quota * 15 / 100

        if (+campaign.campaign.daily_quota && +campaign.campaign.daily_quota <= +campaign.report.cost.value +
          value) return true
        if (+campaign.campaign.total_quota && +campaign.campaign.total_quota <= +campaign.report.cost.value +
          value) return true
      }

      return false
    },

    async m__sync_config() {
      await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/sync_config', {
        shop_id: this.shop._id,
        campaign_ids: this.campaign_list.map(i => +i.campaign.campaignid),
      }, this.cf())
    },

    async m__delete_multiple_config_auto_optimize(require_confirm = true) {
      if (require_confirm) {
        try {
          await this.$confirm(this.$t('base.delete_config_confirm'), this.$t('base.attention'), {
            type: 'warning',
            confirmButtonText: this.$t('base.confirm'),
            cancelButtonText: this.$t('base.cancel'),
          })
        } catch (e) {
          return
        }
      }

      try {
        for (const campaign of this.c__show_filter_campaign_list.filter(i => i.checked)) {
          await this.$http.delete(this.API.URL_API_SRV_1 + '/targeting_auto_optimize', {
            ...this.cf(),
            params: {
              mipeeUserId: this.$store.state.userInfo.username,
              campaignId: campaign.campaign.campaignid,
              placement: 1,
            },
          })

          campaign.auto_optimize = null
          campaign.auto_optimize_search = null
          campaign.auto_optimize_targeting = null
        }
        this.show_dialog.config_auto_optimize = false
        this.ntf_s(this.$t('base.delete_config_success'))
      } catch (e) {
        console.error(e)
      }
    },

    async m__delete_config_auto_optimize(type) {
      try {
        await this.$confirm(this.$t('base.delete_config_confirm'), this.$t('base.attention'), {
          type: 'warning',
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
        })
      } catch (e) {
        return
      }

      try {
        await this.$http.delete(this.API.URL_API_SRV_1 + '/targeting_auto_optimize', {
          ...this.cf(),
          params: {
            mipeeUserId: this.$store.state.userInfo.username,
            campaignId: this.selected_campaign.campaign.campaignid,
            campaignType: type,
          },
        })

        if (type === 'search') this.selected_campaign.auto_optimize_search = null
        if (type === 'targeting') this.selected_campaign.auto_optimize_targeting = null
        this.selected_campaign.auto_optimize = null
        this.show_dialog.config_auto_optimize = false
        this.show_dialog.config_auto_optimize_targeting = false
        this.ntf_s(this.$t('base.delete_config_success'))
      } catch (e) {
        console.error(e)
      }
    },

    async m__update_config_auto_optimize() {
      if (!this.form_config_auto_optimize.advanced_days || !this.form_config_auto_optimize.advanced_days.length) {
        return this.ntf_w(this.$t('required.add_config'))
      }

      try {
        await this.$confirm(this.$t('base.save_config_confirm'), this.$t('base.attention'), {
          type: 'warning',
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
        })
      } catch (e) {
        return
      }

      const source = this.selected_campaign
        ? [this.selected_campaign]
        : this.c__show_filter_campaign_list.filter(i => i.checked)

      this.loading.config_auto_optimize = true
      try {
        for (const campaign of source) {
          await this.m__fix_missing_keywords(campaign)

          const placement = campaign.advertisements.find(i => [0, 3].includes(i.placement))

          await this.$http.post(this.API.URL_API_SRV_1 + '/targeting_auto_optimize', {
            shopId: this.shop._id,
            mipeeUserId: this.$store.state.userInfo.username,
            campaignId: campaign.campaign.campaignid,
            campaignType: 'search',
            maxCir: this.form_config_auto_optimize.max_cir,
            cirType: this.form_config_auto_optimize.cir_type,
            maxCost: this.form_config_auto_optimize.max_cost,
            maxBasePrice: this.form_config_auto_optimize.max_base_price,
            advancedDays: this.form_config_auto_optimize.advanced_days.map(i => JSON.stringify(i)),
            keywords: placement ? JSON.stringify(placement.extinfo.keywords) : '',
          }, this.cf())

          campaign.auto_optimize = campaign.auto_optimize_search = {
            maxCir: this.form_config_auto_optimize.max_cir,
            cirType: this.form_config_auto_optimize.cir_type,
            maxCost: this.form_config_auto_optimize.max_cost,
            maxBasePrice: this.form_config_auto_optimize.max_base_price,
            advancedDays: this.form_config_auto_optimize.advanced_days.map(i => JSON.stringify(i)),
            campaignType: 'search',
          }
        }

        this.show_dialog.config_auto_optimize = false
        this.ntf_s(this.$t('base.save_config_success'))
      } catch (e) {
        console.error(e)
        this.ntf_w(e)
      } finally {
        this.loading.config_auto_optimize = false
      }
    },

    m__show_config_auto_optimize(campaign, type = 'search') {
      this.selected_campaign = campaign

      if (campaign) {
        if (campaign.auto_optimize_search && type === 'search') {
          Object.assign(this.form_config_auto_optimize, {
            max_cir: campaign.auto_optimize_search.maxCir,
            cir_type: campaign.auto_optimize_search.cirType,
            max_cost: campaign.auto_optimize_search.maxCost,
            max_base_price: campaign.auto_optimize_search.maxBasePrice,
          })
          this.form_config_auto_optimize.advanced_days = campaign.auto_optimize_search.advancedDays
            ? campaign.auto_optimize_search.advancedDays.map(i => JSON.parse(i))
            : []

          this.show_dialog.config_auto_optimize = true
          return
        }

        if (campaign.auto_optimize_targeting && type === 'targeting') {
          Object.assign(this.form_config_auto_optimize_targeting, {
            max_cir: campaign.auto_optimize_targeting.maxCir,
            cir_type: campaign.auto_optimize_targeting.cirType,
            max_cost: campaign.auto_optimize_targeting.maxCost,
            max_base_price: campaign.auto_optimize_targeting.maxBasePrice,
          })
          this.form_config_auto_optimize_targeting.advanced_days = campaign.auto_optimize_targeting.advancedDays
            ? campaign.auto_optimize_targeting.advancedDays.map(i => JSON.parse(i))
            : []

          this.show_dialog.config_auto_optimize_targeting = true
          return
        }

        if (type === 'search') {
          this.show_dialog.config_auto_optimize = true
          return
        }
        if (type === 'targeting') {
          this.show_dialog.config_auto_optimize_targeting = true
          return
        }
      }

      // todo: load default config
      if (type === 'search') {
        const default_config = this.c__show_filter_campaign_list.find(i => i.checked && i.auto_optimize_search)
        if (default_config) {
          Object.assign(this.form_config_auto_optimize, {
            max_cir: default_config.auto_optimize_search.maxCir,
            cir_type: default_config.auto_optimize_search.cirType,
            max_cost: default_config.auto_optimize_search.maxCost,
            max_base_price: default_config.auto_optimize_search.maxBasePrice,
          })
          this.form_config_auto_optimize.advanced_days = default_config.auto_optimize_search.advancedDays
            ? default_config.auto_optimize_search.advancedDays.map(i => JSON.parse(i))
            : []
        }
        this.show_dialog.config_auto_optimize = true
      }
      if (type === 'targeting') {
        const default_config = this.c__show_filter_campaign_list.find(i => i.checked && i.auto_optimize_targeting)
        if (default_config) {
          Object.assign(this.form_config_auto_optimize_targeting, {
            max_cir: default_config.auto_optimize_targeting.maxCir,
            cir_type: default_config.auto_optimize_targeting.cirType,
            max_cost: default_config.auto_optimize_targeting.maxCost,
            max_base_price: default_config.auto_optimize_targeting.maxBasePrice,
          })
          this.form_config_auto_optimize_targeting.advanced_days = default_config.auto_optimize_targeting.advancedDays
            ? default_config.auto_optimize_targeting.advancedDays.map(i => JSON.parse(i))
            : []
        }
        this.show_dialog.config_auto_optimize_targeting = true
      }
    },

    m__add_optimize_advanced_day() {
      if (!this.form_config_auto_optimize.advanced_day) {
        this.ntf_w(this.$t('select.active_day'))
        return
      }
      if (!this.form_config_auto_optimize.cir) {
        this.ntf_w(this.$t('required.expected_cir'))
        return
      }
      if (!this.form_config_auto_optimize.include_exact && !this.form_config_auto_optimize.include_broad) {
        this.ntf_w(this.$t('required.applied_keyword_type'))
      }
      if (this.form_config_auto_optimize.include_exact && !this.form_config_auto_optimize.max_price_0) {
        this.ntf_w(this.$t('required.max_bid_price_for_exact'))
        return
      }
      if (this.form_config_auto_optimize.include_broad && !this.form_config_auto_optimize.max_price_1) {
        this.ntf_w(this.$t('required.max_bid_price_for_broad'))
        return
      }
      if (!this.form_config_auto_optimize.min_price) {
        this.ntf_w(this.$t('required.min_bid_price'))
        return
      }

      if (!this.m__check_advanced_times(this.form_config_auto_optimize.advanced_times)) {
        this.ntf_w(this.$t('required.select_runtime'))
        return
      }

      if (['mini_spike_day', 'flash_sale', 'remain'].includes(this.form_config_auto_optimize.advanced_day)) {
        if (this.form_config_auto_optimize.advanced_days.some(
          i => i.type === this.form_config_auto_optimize.advanced_day)) {
          this.ntf_w(this.$t('base.runtime_is_used'))
          return
        }

        this.form_config_auto_optimize.advanced_days.push({
          ...this.clone(_omit(this.form_config_auto_optimize, ['advanced_days', 'advanced_times'])),
          type: this.form_config_auto_optimize.advanced_day,
          day_number: null,
          times: this.form_config_auto_optimize.advanced_times.map(
            i => `${i.advanced_start_time}-${i.advanced_end_time}`),
        })

        this.form_config_auto_optimize.advanced_day = ''
        this.form_config_auto_optimize.advanced_day_number = null
        this.form_config_auto_optimize.advanced_cir = null
        this.form_config_auto_optimize.cir = null
        this.form_config_auto_optimize.advanced_times = [
          {
            advanced_start_time: '00:00',
            advanced_end_time: '02:00',
          }]
      } else {
        if (!this.form_config_auto_optimize.advanced_day_number) {
          this.ntf_w(this.$t('required.configuration_active_day'))
          return
        }
        if (this.form_config_auto_optimize.advanced_days.some(
          i => i.type === this.form_config_auto_optimize.advanced_day && i.day_number ===
            this.form_config_auto_optimize.advanced_day_number)) {
          this.ntf_w(this.$t('base.runtime_is_used'))
          return
        }

        this.form_config_auto_optimize.advanced_days.push({
          ...this.clone(_omit(this.form_config_auto_optimize, ['advanced_days', 'advanced_times'])),
          type: this.form_config_auto_optimize.advanced_day,
          day_number: this.form_config_auto_optimize.advanced_day_number,
          times: this.form_config_auto_optimize.advanced_times.map(
            i => `${i.advanced_start_time}-${i.advanced_end_time}`),
        })

        this.form_config_auto_optimize.advanced_day = ''
        this.form_config_auto_optimize.advanced_day_number = null
        this.form_config_auto_optimize.advanced_cir = null
        this.form_config_auto_optimize.cir = null
        this.form_config_auto_optimize.advanced_times = [
          {
            advanced_start_time: '00:00',
            advanced_end_time: '02:00',
          }]
      }
    },

    m__remove_optimize_advanced_day(index) {
      this.form_config_auto_optimize.advanced_days.splice(index, 1)
    },

    m__edit_optimize_advanced_day(index) {
      const [data] = this.form_config_auto_optimize.advanced_days.splice(index, 1)

      Object.assign(this.form_config_auto_optimize, _omit(data, 'advanced_days'))
      this.form_config_auto_optimize.advanced_day = data.type
      this.form_config_auto_optimize.day_number = data.day_number
      this.form_config_auto_optimize.advanced_times = data.times.map(i => {
        return {
          advanced_start_time: i.split('-')[0],
          advanced_end_time: i.split('-')[1],
        }
      })

      this.scroll_to_top_element('#search-auto-optimize > .el-dialog')
    },

    async m__additional_search_for_product() {
      if (!this.product_filter.keyword) {
        return
      }

      try {
        const offset = 0, limit = 50
        const product_resp = await this.sp_user.marketing_product_selector(offset, limit, 'search', 0,
          this.product_filter.keyword)
        if (product_resp && product_resp.data && product_resp.data.item_list && product_resp.data.item_list.length) {
          for (const item of product_resp.data.item_list) {
            if (this.product_not_campaign_list.some(i => i.itemid === item.itemid)) {
              continue
            }

            item.id = item.itemid
            item.checked = false
            item.revenue = item.monthly_sales * item.price
            item.extra_data = {
              add_to_cart_units: 0,
              placed_units: 0,
              placed_sales: 0,
            }

            this.product_not_campaign_list.push(item)
          }
        }
      } catch (e) {
        console.error(e)
      }
    },

    async m__select_data_by_hour() {
      if (!this.selected_hour) return

      const hour_found = this.hour_list.find(i => i.value === this.selected_hour)
      if (!hour_found) return

      this.loading.select_hour = true
      try {
        if (!this.hour_report.length) {
          const start_time = this.dayjs(this.start_date).startOf('day').unix()
          const end_time = this.dayjs(this.start_date).endOf('day').unix()
          for (const campaign of this.campaign_list.filter(i => i.campaign.state === 'ongoing')) {
            if (campaign.campaign.type === 'keyword') {
              const new_response = await this.sp_user.marketing_get_time_graph('product', start_time, end_time,
                { campaign_id: campaign.campaign.campaignid })

              this.hour_report.push({
                campaign_id: campaign.campaign.campaignid,
                report: this.m__map_graph_by_time_response(new_response.data.report_by_time),
              })
            }
            if (campaign.campaign.type === 'shop') {
              const placement3 = campaign.advertisements.find(i => i.placement === 3)
              const new_response = await this.sp_user.marketing_get_time_graph('shop', start_time, end_time,
                { campaign_id: campaign.campaign.campaignid })
              this.hour_report.push({
                campaign_id: campaign.campaign.campaignid,
                report: this.m__map_graph_by_time_response(new_response.data.report_by_time),
              })
            }
          }
        }

        const start_time = this.dayjs(this.start_date).hour(hour_found.start).startOf('hour').unix()
        const end_time = this.dayjs(this.end_date).hour(hour_found.end).endOf('hour').unix()

        const metrics = {}
        for (const campaign of this.campaign_list) {
          const hour_report_found = this.hour_report.find(i => i.campaign_id === campaign.campaign.campaignid)
          if (hour_report_found) {
            const report_filter = hour_report_found.report.filter(
              i => i.timestamp >= start_time && i.timestamp < end_time)
            const report_reduce = report_filter.reduce((result, item) => {
              for (const key of Object.keys(item)) {
                if (result[key]) {
                  result[key] += +item[key]
                } else {
                  result[key] = +item[key]
                }
              }

              return result
            }, {})

            report_reduce.ctr = report_reduce.impression ? +(report_reduce.click / report_reduce.impression *
              100).toFixed(2) : 0
            report_reduce.broad_cir = +report_reduce.broad_gmv ? +(+report_reduce.cost /
              +report_reduce.broad_gmv).toFixed(1) : 0
            report_reduce.atosa_cpc = +report_reduce.click ? this.m__calculate(
              +report_reduce.cost / +report_reduce.click) : 0

            campaign.report = {}
            for (const key of Object.keys(report_reduce)) {
              campaign.report[key] = {
                value: report_reduce[key],
                ratio: 0,
              }

              if (metrics[key]) {
                metrics[key] += +report_reduce[key]
              } else {
                metrics[key] = +report_reduce[key]
              }
            }

          } else {
            for (const key of Object.keys(campaign.report)) {
              campaign.report[key].value = 0
              campaign.report[key].ratio = 0
            }
          }
        }

        metrics.ctr = metrics.impression ? +(metrics.click / +metrics.impression * 100).toFixed(2) : 0
        metrics.broad_cir = +metrics.broad_gmv ? +(+metrics.cost * 100 / +metrics.broad_gmv).toFixed(1) : 0
        metrics.atosa_cpc = +metrics.click ? this.m__calculate(+metrics.cost / +metrics.click) : 0
        this.metrics = metrics
        this.show_dialog.select_hour = false
        this.$emit('update:hour_mode', true)
      } catch (e) {
        console.error(e)
      } finally {
        this.loading.select_hour = false
      }
    },

    m__suggest_cir_advanced() {
      this.form_config_auto_cir.advanced_max_price = this.form_config_auto_position.price
      if (this.form_config_auto_cir.maxPrice) {
        const random = Math.round(Math.random() * (26 - 13 + 1)) + 13
        const add_random = parseFloat(`1.${random}`)
        this.form_config_auto_cir.advanced_max_price = this.m__calculate(
          this.form_config_auto_cir.maxPrice * add_random)
      }
    },

    m__confirm_cir_advanced() {
      if (!this.form_config_auto_cir.advanced_times /*|| !this.form_config_auto_cir.advanced_times.length*/) {
        this.ntf_w(this.$t('required.select_advanced_runtime'))
        return
      }

      this.show_dialog.auto_cir_advanced = false
    },

    m__add_cir_advanced_day() {
      if (!this.form_config_auto_cir.advanced_day) {
        this.ntf_w(this.$t('select.active_day'))
        return
      }
      if (!this.form_config_auto_cir.advanced_cir) {
        this.ntf_w(this.$t('required.expected_cir'))
        return
      }
      if (!this.form_config_auto_cir.advanced_price) {
        this.ntf_w(this.$t('required.bonus_amount'))
        return
      }
      if (!this.form_config_auto_cir.advanced_max_price) {
        this.ntf_w(this.$t('required.max_bid_price'))
        return
      }

      if (!this.m__check_advanced_times(this.form_config_auto_cir.advanced_times)) {
        this.ntf_w(this.$t('required.select_runtime'))
        return
      }

      if (['flash_sale', 'remain'].includes(this.form_config_auto_cir.advanced_day)) {
        if (this.form_config_auto_optimize.advanced_days.some(
          i => i.type === this.form_config_auto_optimize.advanced_day)) {
          this.ntf_w(this.$t('base.runtime_is_used'))
          return
        }

        this.form_config_auto_cir.advanced_days.push({
          type: this.form_config_auto_cir.advanced_day,
          day_number: null,
          cir: this.form_config_auto_cir.advanced_cir,
          cir_type: this.form_config_auto_cir.advanced_cir_type,
          cir_type2: this.form_config_auto_cir.advanced_cir_type2,
          price: this.form_config_auto_cir.advanced_price,
          price_type: this.form_config_auto_cir.advanced_price_type,
          max_price: this.form_config_auto_cir.advanced_max_price,
          start_price: this.form_config_auto_cir.advanced_start_price,
          max_type: this.form_config_auto_cir.advanced_max_type,
          max_cost: this.form_config_auto_cir.advanced_max_cost,
          max_cost_type: this.form_config_auto_cir.advanced_max_cost_type,
          max_cost_value: this.form_config_auto_cir.advanced_max_cost_value,
          times: this.form_config_auto_cir.advanced_times.map(i => `${i.advanced_start_time}-${i.advanced_end_time}`),
        })

        this.form_config_auto_cir.advanced_day = ''
        this.form_config_auto_cir.advanced_day_number = null
        this.form_config_auto_cir.advanced_cir = null
        this.form_config_auto_cir.advanced_price = null
        this.form_config_auto_cir.advanced_max_price = null
        this.form_config_auto_cir.advanced_start_price = null
        this.form_config_auto_cir.advanced_max_cost = null
        this.form_config_auto_cir.advanced_times = []
      } else if (this.form_config_auto_cir.advanced_day === 'mini_spike_day') {
        if (this.form_config_auto_cir.advanced_days.some(i => i.type === 'mini_spike_day')) {
          this.ntf_w(this.$t('base.runtime_is_used'))
          return
        }

        this.form_config_auto_cir.advanced_days.push({
          type: 'mini_spike_day',
          day_number: null,
          cir: this.form_config_auto_cir.advanced_cir,
          cir_type: this.form_config_auto_cir.advanced_cir_type,
          cir_type2: this.form_config_auto_cir.advanced_cir_type2,
          price: this.form_config_auto_cir.advanced_price,
          price_type: this.form_config_auto_cir.advanced_price_type,
          max_price: this.form_config_auto_cir.advanced_max_price,
          start_price: this.form_config_auto_cir.advanced_start_price,
          max_type: this.form_config_auto_cir.advanced_max_type,
          max_cost: this.form_config_auto_cir.advanced_max_cost,
          max_cost_type: this.form_config_auto_cir.advanced_max_cost_type,
          max_cost_value: this.form_config_auto_cir.advanced_max_cost_value,
          times: this.form_config_auto_cir.advanced_times.map(i => `${i.advanced_start_time}-${i.advanced_end_time}`),
        })

        this.form_config_auto_cir.advanced_day = ''
        this.form_config_auto_cir.advanced_day_number = null
        this.form_config_auto_cir.advanced_cir = null
        this.form_config_auto_cir.advanced_price = null
        this.form_config_auto_cir.advanced_max_price = null
        this.form_config_auto_cir.advanced_start_price = null
        this.form_config_auto_cir.advanced_max_cost = null
        this.form_config_auto_cir.advanced_times = []
      } else {
        if (!this.form_config_auto_cir.advanced_day_number) {
          this.ntf_w(this.$t('required.specific_day'))
          return
        }
        if (this.form_config_auto_cir.advanced_days.some(
          i => i.type === this.form_config_auto_cir.advanced_day && i.day_number ===
            this.form_config_auto_cir.advanced_day_number)) {
          return
        }

        this.form_config_auto_cir.advanced_days.push({
          type: this.form_config_auto_cir.advanced_day,
          day_number: this.form_config_auto_cir.advanced_day_number,
          cir: this.form_config_auto_cir.advanced_cir,
          cir_type: this.form_config_auto_cir.advanced_cir_type,
          cir_type2: this.form_config_auto_cir.advanced_cir_type2,
          price: this.form_config_auto_cir.advanced_price,
          price_type: this.form_config_auto_cir.advanced_price_type,
          max_price: this.form_config_auto_cir.advanced_max_price,
          start_price: this.form_config_auto_cir.advanced_start_price,
          max_type: this.form_config_auto_cir.advanced_max_type,
          max_cost: this.form_config_auto_cir.advanced_max_cost,
          max_cost_type: this.form_config_auto_cir.advanced_max_cost_type,
          max_cost_value: this.form_config_auto_cir.advanced_max_cost_value,
          times: this.form_config_auto_cir.advanced_times.map(i => `${i.advanced_start_time}-${i.advanced_end_time}`),
        })

        this.form_config_auto_cir.advanced_day = ''
        this.form_config_auto_cir.advanced_day_number = null
        this.form_config_auto_cir.advanced_cir = null
        this.form_config_auto_cir.advanced_price = null
        this.form_config_auto_cir.advanced_max_price = null
        this.form_config_auto_cir.advanced_start_price = null
        this.form_config_auto_cir.advanced_max_cost = null
        this.form_config_auto_cir.advanced_times = []
      }
    },

    m__remove_cir_advanced_day(index) {
      this.form_config_auto_cir.advanced_days.splice(index, 1)
    },

    m__show_cir_advanced_dialog() {
      this.show_dialog.auto_cir_advanced = true
    },

    async m__confirm_update_auto_cir() {
      if (!this.form_config_auto_cir.fromCir) {
        this.ntf_w(this.$t('required.expected_cir'))
        return
      }

      if (!this.form_config_auto_cir.toCir) {
        this.ntf_w(this.$t('required.expected_cir'))
        return
      }

      if (!this.form_config_auto_cir.cirType) {
        this.ntf_w(this.$t('required.cir_type'))
        return
      }

      if (!this.form_config_auto_cir.timeType) {
        this.ntf_w(this.$t('required.check_duration'))
        return
      }

      if (this.form_config_auto_cir.allowBidPrice) {
        if (!this.form_config_auto_cir.price) {
          this.ntf_w(this.$t('required.bonus_amount'))
          return
        }
        if (!this.form_config_auto_cir.maxPrice) {
          this.ntf_w(this.$t('required.max_bid_price'))
          return
        }
      }

      if (this.form_config_auto_cir.allowAtCase1) {
        if (this.form_config_auto_cir.case1Type === 'value' && !this.form_config_auto_cir.case1Value) {
          this.ntf_w(this.$t('input.amount'))
          return
        }
        if (this.form_config_auto_cir.case1Type === 'reduce' && !this.form_config_auto_cir.case1Reduce) {
          this.ntf_w(this.$t('input.amount'))
          return
        }
        if (this.form_config_auto_cir.case1Type === 'reduce' && !this.form_config_auto_cir.case1ReduceMin) {
          this.ntf_w(this.$t('required.min_bid_price'))
          return
        }
        if (this.form_config_auto_cir.case1Type === 'percent' && !this.form_config_auto_cir.case1Percent) {
          this.ntf_w(this.$t('required.percent'))
          return
        }
      }

      if (this.form_config_auto_cir.allowAtCase2) {
        if (this.form_config_auto_cir.case2Type === 'value' && !this.form_config_auto_cir.case2Value) {
          this.ntf_w(this.$t('input.amount'))
          return
        }
        if (this.form_config_auto_cir.case2Type === 'percent' && !this.form_config_auto_cir.case2Percent) {
          this.ntf_w(this.$t('required.percent'))
          return
        }
        if (this.form_config_auto_cir.case2Type === 'reduce' && !this.form_config_auto_cir.case2ReduceMin) {
          this.ntf_w(this.$t('required.min_bid_price'))
          return
        }
        if (this.form_config_auto_cir.case2Type === 'percent' && !this.form_config_auto_cir.case2Percent) {
          this.ntf_w(this.$t('required.percent'))
          return
        }
      }

      if (!this.form_config_auto_cir.allowBidPrice && !this.form_config_auto_cir.allowAtCase1 &&
        !this.form_config_auto_cir.allowAtCase2) {
        this.ntf_w(this.$t('required.must_select_at_least'))
        return
      }

      try {
        await this.$confirm(this.$t('ads.just_select_only_one_1'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning',
        })
      } catch (e) {
        return
      }

      this.loading.config_auto_cir = true

      for (const campaign of this.c__show_filter_campaign_list.filter(i => i.checked)) {
        await this.m__fix_missing_keywords(campaign)

        const placement0 = campaign.advertisements.find(i => i.placement === 0)
        if (placement0 && placement0.extinfo.keywords.length) {
          const keyword_list = placement0.extinfo.keywords.map(i => i.keyword)

          await this.$http.post(this.API.URL_API_SRV_1 + '/auto_cir', {
            ...this.form_config_auto_cir,
            advancedDays: this.form_config_auto_cir.advanced_days.map(i => JSON.stringify(i)),
            keywords: keyword_list,
            mipeeUserId: this.$store.state.userInfo.username,
            campaignId: campaign.campaign.campaignid,
            shopId: this.shop._id,
            configStatus: 1,
          }, this.cf())

          await this.$http.post(this.API.URL_API_SRV_1 + '/auto_position/v2/status', {
            mipeeUserId: this.$store.state.userInfo.username,
            campaignId: campaign.campaign.campaignid,
            keywords: keyword_list,
            status: 0,
          }, this.cf())

          await this.$http.post(this.API.URL_API_SRV_1 + '/auto_campaigns/v2/status', {
            mipeeUserId: this.$store.state.userInfo.username,
            campaignId: campaign.campaign.campaignid,
            keywords: keyword_list,
            status: 0,
          }, this.cf())
        }
      }

      this.ntf_s(this.$t('base.save_config_success'))
      this.loading.config_auto_cir = false
      this.show_dialog.config_auto_cir = false
      this.show_dialog.config_auto_campaign = false
    },

    m__show_config_auto_cir() {
      this.show_dialog.config_auto_cir = true
      this.config_tab = 6
    },

    async m__add_keyword_campaign_multiple() {
      try {
        await this.$confirm(this.$t('base.add_keywords_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning',
        })
      } catch (e) {
        return
      }

      this.loading.add_keywords = true
      for (const campaign of this.c__show_filter_campaign_list.filter(i => i.checked)) {
        await this.m__fix_missing_keywords(campaign, false, true)

        try {
          const placement0 = campaign.advertisements.find(item => item.placement === 0)
          if (!placement0) continue

          const active_keywords = placement0.extinfo.keywords.filter(item => item.status === 1).length
          if (active_keywords >= 200) continue

          let temp_keywords = []
          this.added_keywords.forEach(i => {
            const temp = {
              'status': 1,
              'price': !i.recommend_price || Number.isNaN(i.recommend_price) || +i.recommend_price,
              'match_type': this.added_keywords_type,
              'keyword': i.keyword.trim().normalize().toLowerCase(),
              'algorithm': i.algorithm || 'kwrcmdv2',
            }

            this.m__prefix_keyword_price(temp)
            if (new Blob([temp.keyword]).size <= 128) {
              temp_keywords.push(temp)
            }
          })

          if (active_keywords < 200) {
            temp_keywords = temp_keywords.slice(0, 200 - active_keywords)
          }

          // todo: check duplicated keywords
          const keywords_set = new Set(placement0.extinfo.keywords.filter(i => i.status === 1).map(i => i.keyword))
          const add_new_keywords = temp_keywords.filter(i => !keywords_set.has(i.keyword))
          await this.sp_user.marketing_pas_add_keyword(campaign.campaign.campaignid, add_new_keywords)

          this.ntf_s(this.$t('base.update_keywords_success'))
          this.show_dialog.add_keywords = false
        } catch (e) {
          console.error(e)
        }
      }
      this.loading.add_keywords = false
    },

    m__update_added_keyword_price() {
      if (this.form_update_multiple_added_keyword_price.update_type === 1 &&
        this.form_update_multiple_added_keyword_price.update_by_cost_value) {
        this.added_keywords.forEach(i => {
          if (this.form_update_multiple_added_keyword_price.update_by_cost === 'increase') {
            i.recommend_price += this.m__calculate(this.form_update_multiple_added_keyword_price.update_by_cost_value)
          }

          if (this.form_update_multiple_added_keyword_price.update_by_cost === 'reduce') {
            i.recommend_price -= this.m__calculate(this.form_update_multiple_added_keyword_price.update_by_cost_value)
          }
        })
      }

      if (this.form_update_multiple_added_keyword_price.update_type === 2 &&
        this.form_update_multiple_added_keyword_price.update_by_percent_value) {
        this.added_keywords.forEach(i => {
          if (this.form_update_multiple_added_keyword_price.update_by_percent === 'increase') {
            i.recommend_price += (i.recommend_price *
              this.m__calculate(this.form_update_multiple_added_keyword_price.update_by_percent_value) / 100)
          }

          if (this.form_update_multiple_added_keyword_price.update_by_percent === 'reduce') {
            i.recommend_price -= (i.recommend_price *
              this.m__calculate(this.form_update_multiple_added_keyword_price.update_by_percent_value) / 100)
          }
        })
      }

      if (this.form_update_multiple_added_keyword_price.update_type === 3) {
        this.added_keywords.forEach(i => {
          i.recommend_price = this.m__calculate(this.form_update_multiple_added_keyword_price.price)
        })
      }

      this.show_dialog.update_added_keyword_price = false
    },

    async m__import_excel_file(e) {
      try {
        const file_store = e.target.files || e.dataTransfer.files
        if (file_store.length === 0) {
          return
        }

        const raw = await readXlsxFile(file_store[0])
        for (const row of raw) {
          if (row && row[0] && typeof row[0] === 'string' &&
            !this.excel_keyword.some(i => i.keyword === row[0].toLowerCase())) {
            this.excel_keyword.push({
              keyword: row[0].toLowerCase(),
              recommend_price: row[1] && !Number.isNaN(+row[1]) ? +row[1] : null,
              search_volume: 0,
              algorithm: 'kwrcmdv2',
            })
          }
        }

        if (this.excel_keyword.length) {
          try {
            const resp = await this.$http.post(this.API.URL_API_SRV_2 + '/keyword/save_and_result', {
              mipeeUserId: this.$store.state.userInfo.username,
              keyword: this.excel_keyword[0].keyword,
              data: this.excel_keyword.map(i => i.keyword),
              country: this.sp_user.country,
            }, this.cf())
            this.save_and_result_list = resp.body
          } catch (e) {
            console.error(e)
          }

          const temp_product = this.c__show_filter_campaign_list.find(i => i.checked && i.product && i.product.itemid)

          for (const keyword of this.excel_keyword) {
            if (keyword.recommend_price) continue

            const found = this.save_and_result_list.find(i => i.keyword === keyword.keyword)
            if (found) {
              keyword.search_volume = found.volume
              if (keyword.recommend_price === 0) keyword.recommend_price = this.m__calculate(found.recommendPrice)
            } else {
              const info = temp_product
                ? await this.sp_user.marketing_get_keyword_volume(keyword.keyword, temp_product.product.itemid)
                : await this.sp_user.marketing_get_keyword_volume(keyword.keyword, null, '3')
              keyword.search_volume = this.m__calculate(info.search_volume)
              keyword.algorithm = info.algorithm
              if (keyword.recommend_price === 0) keyword.recommend_price = this.m__calculate(info.recommend_price)
            }
          }
        }
      } catch (e) {
        console.log(e)
        this.ntf_w(this.$t('base.error_reading_file'))
      } finally {
        event.target.value = null
      }
    },

    m__show_update_added_keyword_dialog() {
      this.show_dialog.update_added_keyword_price = true
    },

    m__fff_sort_change({
                         prop,
                         order,
                       }) {
      this.fff_sort_option.order = order
      this.fff_sort_option.prop = prop
    },

    m__can_add(keyword) {
      return !this.added_keywords.find(i => i.keyword.toLowerCase() === keyword.keyword.toLowerCase())
    },

    m__add_all() {
      let source = []

      if (this.radio === '1') {
        source = this.shopee_suggest_keywords
      }
      if (this.radio === '2') {
        const data = JSON.parse(JSON.stringify(this.mipee_suggest_keywords))
        source = data.map(i => {
          i.recommend_price = this.form_add_new_campaign && this.form_add_new_campaign.price_type === 'mipee'
            ? i.price
            : i.recommend_price
          return i
        })
      }
      if (this.radio === '3') {
        source = this.add_keyword
      }
      if (this.radio === '4') {
        source = this.fff_result.slice(0, 100)
      }
      if (this.radio === '5') {
        source = this.excel_keyword
      }

      if (source) {
        for (let i = 0; i < source.length; i++) {
          const keyword = source[i]

          if (this.omit_duplicated_keyword) {
            if (
              !this.added_keywords.find(e => e.keyword.normalize() === keyword.keyword.normalize()) &&
              !this.added_keywords.find(e => e.keyword.normalize() === keyword.keyword.normalize())
            ) {
              this.added_keywords.push({
                ...keyword,
                recommend_price: keyword.input_price || 500,
                volume: keyword.volume,
              })
            }
          } else {
            if (
              !this.added_keywords.find(e => e.keyword === source[i].keyword) &&
              !this.added_keywords.find(e => e.keyword === source[i].keyword)
            ) {
              this.added_keywords.push({
                ...keyword,
                recommend_price: keyword.input_price || 500,
                volume: keyword.volume,
              })
            }
          }
        }
      }
    },

    m__add_keyword(keyword) {
      this.added_keywords.push({
        ...keyword,
        recommend_price: keyword.input_price || 500,
        volume: keyword.volume,
      })
    },

    m__remove_keyword(keyword) {
      this.added_keywords = this.added_keywords.filter(i => i.keyword !== keyword.keyword)
    },

    m__show_import_excel_file() {
      this.$el.querySelector(`#input_control_detail`).click()
    },

    async m__enter_input() {
      if (!this.fff_loading) {
        await this.m__try_get_keyword_result()
      }
    },

    async m__try_get_keyword_result() {
      this.fff_loading = true
      let keyword_list = await this.m__get_suggestion_keyword(this.base_keyword)
      let result = await this.fff.get_keyword_result(keyword_list, 5000, this.base_keyword)
      if (result === null) {
        await this.$nextTick(() => {
          this.ntf_w(this.$t('keyword.error_while_get_data'))
        })
      } else if (!result.data || !result.data.keywords || !result.data.keywords.length || result.data.keywords.length <
        30) {
        this.ntf_w(this.$t('keyword.result_not_found_message', { x: this.base_keyword }))
        await this.m__handle_missing_keyword(this.base_keyword)

        this.ntf_s(this.$t('keyword.start_getting_shopee_data'))
        await this.m__start_get_sp_keyword()
      } else {
        let temp = result.data.keywords.map(e => {
          return {
            ...e,
            results: this.m__calculate(e.results) || 0,
            checked: false,
            sp_volume: 0,
            loading: false,
            sp_price: 0,
          }
        })
        if (!temp.some(i => i.keyword === this.base_keyword)) {
          const base_item = {
            keyword: this.base_keyword,
            results: 0,
            sp_volume: 0,
            sp_price: 0,
            relevance: 0,
            checked: false,
            loading: false,
          }
          temp.unshift(base_item)
        }

        if (temp[0].keyword !== this.base_keyword) {
          const index = temp.findIndex(i => i.keyword === this.base_keyword)
          const temp_item = temp[index]
          temp.splice(index, 1)
          temp.unshift(temp_item)
        }

        const first = temp.shift()
        this.fff_result = _take(_orderBy(temp, ['results'], ['desc']), 500)
        this.fff_result.unshift(first)

        const keyword = this.base_keyword

        const temp_product = this.c__show_filter_campaign_list.find(i => i.checked && i.product && i.product.itemid)
        const extend_resp = temp_product
          ? await this.sp_user.marketing_suggest_keywords(keyword, temp_product.product.itemid)
          : await this.sp_user.marketing_suggest_keywords(keyword, null, '3')

        if (extend_resp && extend_resp.data) {
          let index_splice = 1
          for (const item of extend_resp.data) {
            if (this.contain_at_least(keyword, item.keyword)) {
              const keyword = {
                keyword: item.keyword,
                results: 0,
                sp_volume: item.search_volume,
                sp_price: item.recommend_price,
                relevance: item.relevance,
                checked: false,
                loading: false,
              }
              this.fff_result.splice(index_splice++, 0, keyword)
            }
          }
        }

        try {
          const resp = await this.$http.post(this.API.URL_API_SRV_2 + '/keyword/save_and_result', {
            mipeeUserId: this.$store.state.userInfo.username,
            keyword: this.base_keyword,
            data: this.fff_result.map(i => i.keyword),
            country: this.sp_user.country,
          }, this.cf())
          this.save_and_result_list = resp.body
        } catch (e) {
          console.error(e)
        }

        this.result = _uniqBy(this.fff_result, 'keyword')

        this.fetch_index = 0
        this.fetch_keyword = this.base_keyword
        await this.m__start_get_sp_keyword()
      }

      this.fff_loading = false
    },

    async m__handle_missing_keyword(base_keyword) {
      const temp_product = this.c__show_filter_campaign_list.find(i => i.checked && i.product && i.product.itemid)

      const hint_keywords = temp_product
        ? await this.sp_user.marketing_list_keyword_hint(base_keyword, temp_product.product.itemid, 0)
        : await this.sp_user.marketing_list_keyword_hint(base_keyword, null, 3)

      if (hint_keywords && hint_keywords.data) {
        let index_splice = 2
        for (const hint of hint_keywords.data) {
          const extend_resp = temp_product
            ? await this.sp_user.marketing_suggest_keywords(hint.keyword, temp_product.product.itemid)
            : await this.sp_user.marketing_suggest_keywords(hint.keyword, null, '3')

          if (extend_resp && extend_resp.data) {
            for (const item of extend_resp.data) {
              if (!this.contain_at_least(base_keyword, item.keyword)) continue

              const keyword = {
                keyword: item.keyword,
                results: 0,
                sp_volume: +item.search_volume,
                sp_price: +item.recommend_price,
              }
              if (!this.fff_result.some(i => i.keyword === item.keyword)) {
                this.fff_result.splice(index_splice++, 0, keyword)
              }
            }
          }
        }
      } else {
        const extend_resp = temp_product
          ? await this.sp_user.marketing_suggest_keywords(base_keyword, temp_product.product.itemid)
          : await this.sp_user.marketing_suggest_keywords(base_keyword, null, '3')

        if (extend_resp && extend_resp.data) {
          let index_splice = 2
          for (const item of extend_resp.data) {
            if (!this.contain_at_least(base_keyword, item.keyword)) continue

            const keyword = {
              keyword: item.keyword,
              sp_volume: +item.search_volume,
              sp_price: +item.recommend_price,
            }
            if (!this.fff_result.some(i => i.keyword === item.keyword)) {
              this.fff_result.splice(index_splice++, 0, keyword)
            }
          }
        }
      }

      if (this.fff_result.some(i => i.keyword === base_keyword) && this.fff_result[0].keyword !== base_keyword) {
        const index = this.fff_result.findIndex(i => i.keyword === base_keyword)
        const temp = this.fff_result[index]
        this.fff_result.splice(index, 1)
        this.fff_result.unshift(temp)
      }
      if (!this.fff_result.some(i => i.keyword === base_keyword)) {
        const response = temp_product
          ? await this.sp_user.marketing_suggest_keywords(base_keyword, temp_product.product.itemid)
          : await this.sp_user.marketing_suggest_keywords(base_keyword, null, 3)

        if (response && response.data) {
          for (const item of response.data.reverse()) {
            if (!this.contain_at_least(base_keyword, item.keyword, false)) continue
            if (this.fff_result.some(i => i.keyword === item.keyword)) continue

            const keyword = {
              keyword: item.keyword,
              results: 0,
              sp_volume: item.search_volume,
              sp_price: item.recommend_price,
              relevance: item.relevance,
              checked: false,
              loading: false,
            }
            this.fff_result.unshift(keyword)
          }
        }
      }
    },

    async m__start_get_sp_keyword() {
      this.fetch_loading = true

      for (const item of this.fff_result) {
        if (this.fetch_keyword !== this.base_keyword) {
          break
        }

        if (item.sp_volume && item.sp_price) continue

        const found = this.save_and_result_list.find(i => i.keyword === item.keyword)
        if (found) {
          item.relevance = found.relevance
          item.sp_volume = found.volume
          item.sp_price = item.recommend_price = this.m__calculate(found.recommendPrice)
        } else {
          await this.m__get_sp_keyword_info(item)
        }
      }

      this.fff_clone = JSON.parse(JSON.stringify(this.fff_result))
      this.fetch_loading = false
    },

    async m__suggest_keyword(queryString, cb) {
      if (!queryString) {
        cb([])
        return
      }
      let hint_keywords = await this.sp_user.marketing_get_hint_keyword(queryString)
      cb(hint_keywords.map(e => ({ value: e.keyword })))
    },

    async m__show_add_keywords_dialog() {
      if (!this.check_role(this.shop, 'keyword_ads', 'add_keyword')) {
        return
      }

      this.show_dialog.add_keywords = true

      for (const campaign of this.c__show_filter_campaign_list.filter(i => i.checked)) {
        if (campaign.product && campaign.product.itemid) {
          const response = await this.sp_user.marketing_suggest_keyword(campaign.product.itemid)
          this.shopee_suggest_keywords = response.data
          break
        }
      }

      if (!this.shopee_suggest_keywords.length) {
        const response = await this.sp_user.shop_ads_get_suggest_keyword_price(null)
        this.shopee_suggest_keywords = response.data
      }
    },

    async m__update_config_status(type, status) {
      try {
        if (type === 'auto_position') {
          for (const campaign of this.c__show_filter_campaign_list.filter(i => i.checked)) {
            await this.$http.post(this.API.URL_API_SRV_1 + '/auto_position/v2/status', {
              campaignId: campaign.campaign.campaignid,
              status: status,
              mipeeUserId: this.$store.state.userInfo.username,
            }, this.cf())

            await this.$http.post(this.API.URL_API_SRV_1 + '/shop_ads_position/v2/status', {
              campaignId: campaign.campaign.campaignid,
              status: status,
              mipeeUserId: this.$store.state.userInfo.username,
            }, this.cf())

            await this.$http.post(this.API.URL_API_SRV_1 + '/targeting_auto_position/status', {
              campaignId: campaign.campaign.campaignid,
              status: status,
              mipeeUserId: this.$store.state.userInfo.username,
            }, this.cf())
          }
        }

        if (type === 'auto_position') {
          for (const campaign of this.c__show_filter_campaign_list.filter(i => i.checked)) {
            await this.$http.post(this.API.URL_API_SRV_1 + '/auto_campaigns/v2/status', {
              campaignId: campaign.campaign.campaignid,
              status: status,
              mipeeUserId: this.$store.state.userInfo.username,
            }, this.cf())
          }
        }

        if (type === 'auto_cir') {
          for (const campaign of this.c__show_filter_campaign_list.filter(i => i.checked)) {
            await this.$http.post(this.API.URL_API_SRV_1 + '/auto_cir/status', {
              campaignId: campaign.campaign.campaignid,
              status: status,
              mipeeUserId: this.$store.state.userInfo.username,
            }, this.cf())
          }
        }

        if (type === 'anti_click') {
          for (const campaign of this.c__show_filter_campaign_list.filter(i => i.checked)) {
            await this.$http.post(this.API.URL_API_SRV_1 + '/anti_click/v2/status', {
              campaignId: campaign.campaign.campaignid,
              status: status,
              mipeeUserId: this.$store.state.userInfo.username,
            }, this.cf())

            await this.$http.post(this.API.URL_API_SRV_1 + '/targeting_anti_click/status', {
              campaignId: campaign.campaign.campaignid,
              status: status,
              mipeeUserId: this.$store.state.userInfo.username,
            }, this.cf())
          }
        }

        if (type === 'auto_condition_action') {
          for (const campaign of this.c__show_filter_campaign_list.filter(i => i.checked)) {
            const found = this.auto_condition_action_config_list.find(i => i.campaign_id === campaign.campaign.campaignid)
            if (found) {
              this.auto_condition_action_list = typeof found.config_list === 'string'
                ? JSON.parse(found.config_list)
                : this.clone(found.config_list)
              this.auto_condition_action_only_show_me = !!found.only_show_me

              for (const item of this.auto_condition_action_list) {
                for (const config of item.config_list) {
                  config.enable = false
                }
              }
            }

            await this.m__update_auto_condition_action(false)
          }
        }
      } catch (e) {
        console.error(e)
      }
    },

    async m__delete_multiple_config_auto_quota(require_confirm = true) {
      if (require_confirm) {
        try {
          await this.$confirm(this.$t('base.delete_config_confirm'), this.$t('base.attention'), {
            confirmButtonText: this.$t('base.confirm'),
            cancelButtonText: this.$t('base.cancel'),
            type: 'warning',
          })
        } catch (e) {
          return
        }
      }

      try {
        for (const campaign of this.c__show_filter_campaign_list.filter(i => i.checked)) {
          await this.$http.delete(this.API.URL_API_SRV_1 + '/auto_quota/delete', {
            ...this.cf(),
            params: {
              mipeeUserId: this.$store.state.userInfo.username,
              campaignId: campaign.campaign.campaignid,
            },
          })

          campaign.auto_quota = null

          if (this.selected_campaign && this.selected_campaign.campaign && this.selected_campaign.campaign.campaignid === campaign.campaign.campaignid) {
            this.selected_campaign = campaign
          }
        }
        this.ntf_s(this.$t('base.delete_success'))
        this.show_dialog.config_auto_quota = false
      } catch (e) {
        console.error(e)
        this.ntf_w(this.$t('base.has_an_occurred'))
      }
    },

    async m__delete_config_auto_quota() {
      try {
        await this.$confirm(this.$t('base.delete_config_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning',
        })

        await this.$http.delete(this.API.URL_API_SRV_1 + '/auto_quota/delete', {
          ...this.cf(),
          params: {
            mipeeUserId: this.$store.state.userInfo.username,
            campaignId: this.selected_campaign.campaign.campaignid,
          },
        })
        this.ntf_s(this.$t('base.delete_success'))
        this.selected_campaign.auto_quota = null
        this.show_dialog.config_auto_quota = false
      } catch (e) {
        // console.error(e)
        // this.ntf_w(this.$t('base.has_an_occurred'))
      }
    },

    async m__save_config_auto_quota() {
      if (this.form_config_auto_quota.mode === 'auto' && !this.form_config_auto_quota.cir) {
        this.ntf_w(this.$t('required.expected_cir'))
        return
      }
      if (this.form_config_auto_quota.mode === 'auto' && !this.form_config_auto_quota.start) {
        this.ntf_w(this.$t('required.starting_budget'))
        return
      }
      if (this.form_config_auto_quota.mode === 'manual' &&
        (!this.form_config_auto_quota.data || !this.form_config_auto_quota.data.length)) {
        this.ntf_w(this.$t('required.add_config'))
        return
      }

      this.loading.auto_quota = true
      try {
        for (const campaign_id of this.form_config_auto_quota.campaign_ids) {
          const campaign_found = this.campaign_list.find(i => i.campaign.campaignid === campaign_id)

          await this.$http.post(this.API.URL_API_SRV_1 + '/auto_quota/update', {
            mipeeUserId: this.$store.state.userInfo.username,
            shopId: this.shop._id,
            campaignId: campaign_id,
            data: JSON.stringify(this.form_config_auto_quota.data),
            action2: this.form_config_auto_quota.action2,
            mode: this.form_config_auto_quota.mode,
            cir: this.form_config_auto_quota.cir,
            start: this.form_config_auto_quota.start,
            max: this.form_config_auto_quota.max,
            alwaysOngoing: this.form_config_auto_quota.alwaysOngoing,
            campaignType: campaign_found ? campaign_found.campaign.shopee_type : null,
            spikeCir: this.form_config_auto_quota.spike_cir,
            spikeStart: this.form_config_auto_quota.spike_start,
            spikeMax: this.form_config_auto_quota.spike_max,
            autoType: this.form_config_auto_quota.auto_type,
            autoValue: this.form_config_auto_quota.auto_value,
            spikeAutoType: this.form_config_auto_quota.spike_auto_type,
            spikeAutoValue: this.form_config_auto_quota.spike_auto_value,
            checkType: this.form_config_auto_quota.check_type,
            spikeCheckType: this.form_config_auto_quota.spike_check_type,
          }, this.cf())

          if (campaign_found) {
            campaign_found.auto_quota = {
              data: JSON.stringify(this.form_config_auto_quota.data),
              action2: this.form_config_auto_quota.action2,
              mode: this.form_config_auto_quota.mode,
              cir: this.form_config_auto_quota.cir,
              start: this.form_config_auto_quota.start,
              max: this.form_config_auto_quota.max,
              alwaysOngoing: this.form_config_auto_quota.alwaysOngoing,
              campaignType: campaign_found ? campaign_found.campaign.shopee_type : null,
              spikeCir: this.form_config_auto_quota.spike_cir,
              spikeStart: this.form_config_auto_quota.spike_start,
              spikeMax: this.form_config_auto_quota.spike_max,
              autoType: this.form_config_auto_quota.auto_type,
              autoValue: this.form_config_auto_quota.auto_value,
              spikeAutoType: this.form_config_auto_quota.spike_auto_type,
              spikeAutoValue: this.form_config_auto_quota.spike_auto_value,
              checkType: this.form_config_auto_quota.check_type,
              spikeCheckType: this.form_config_auto_quota.spike_check_type,
            }

            if (this.selected_campaign && this.selected_campaign.campaign && this.selected_campaign.campaign.campaignid === campaign_found.campaign.campaignid) {
              this.selected_campaign = campaign_found
            }
          }
        }

        this.ntf_s(this.$t('base.save_config_success'))
        this.show_dialog.config_auto_quota = false
      } catch (e) {
        console.error(e)
        this.ntf_w(this.$t('base.has_an_occurred'))
      } finally {
        this.loading.auto_quota = false
      }
    },

    m__remove_item_auto_quota(index) {
      this.form_config_auto_quota.data.splice(index, 1)
    },

    m__remove_item_auto_quota_by_id(config_id) {
      const index = this.form_config_auto_quota.data.findIndex(i => i.config_id === config_id)
      if (index !== -1) this.form_config_auto_quota.data.splice(index, 1)
    },

    m__update_item_auto_quota(config_id) {
      const config_found = this.form_config_auto_quota.data.find(i => i.config_id === config_id)
      if (config_found) {
        this.form_config_auto_quota.config_id = config_found.config_id
        this.form_config_auto_quota.start_time = config_found.start_time
        this.form_config_auto_quota.end_time = config_found.end_time
        this.form_config_auto_quota.daily_quota = config_found.daily_quota
        this.form_config_auto_quota.total_quota = config_found.total_quota
        this.form_config_auto_quota.cir_quota = config_found.cir_quota
        this.form_config_auto_quota.active_day = config_found.active_day
        this.form_config_auto_quota.start = config_found.start
        this.form_config_auto_quota.max = config_found.max
        this.form_config_auto_quota.auto_type = config_found.auto_type
        this.form_config_auto_quota.auto_value = config_found.auto_value
        this.form_config_auto_quota.check_type = config_found.check_type || 'cir'
        if (config_found.action.startsWith('auto_quota')) {
          if (config_found.check_type) {
            this.form_config_auto_quota.action = `${config_found.action}_${config_found.check_type}`
          } else {
            this.form_config_auto_quota.action = 'auto_quota_cir'
          }
        } else {
          this.form_config_auto_quota.action = config_found.action
        }

        this.form_config_auto_quota.data = this.form_config_auto_quota.data.filter(i => i.config_id !== config_id)
      }
    },

    m__add_item_auto_quota() {
      if (!this.form_config_auto_quota.start_time) {
        this.ntf_w(this.$t('required.start_time'))
        return
      }
      if (!this.form_config_auto_quota.end_time) {
        this.ntf_w(this.$t('required.end_time'))
        return
      }
      if (!this.form_config_auto_quota.action) {
        this.ntf_w(this.$t('required.budget_type'))
        return
      }
      if (this.form_config_auto_quota.action === 'daily_quota' &&
        (!+this.form_config_auto_quota.daily_quota || +this.form_config_auto_quota.daily_quota < 1)) {
        this.ntf_w(this.$t('required.budget'))
        return
      }
      if (this.form_config_auto_quota.action === 'total_quota' &&
        (!+this.form_config_auto_quota.total_quota || +this.form_config_auto_quota.total_quota < 1)) {
        this.ntf_w(this.$t('required.budget'))
        return
      }
      if (this.form_config_auto_quota.action === 'auto_quota' &&
        (!+this.form_config_auto_quota.cir_quota || !+this.form_config_auto_quota.cir_quota < 0)) {
        this.ntf_w(this.$t('required.expected_cir'))
        return
      }
      if (['value', 'percent'].includes(this.form_config_auto_quota.auto_type) && !+this.form_config_auto_quota.auto_value) {
        this.ntf_w(this.$t('required.value'))
        return
      }

      let action = this.form_config_auto_quota.action
      let check_type = 'cir'
      if (this.form_config_auto_quota.action === 'auto_quota_cir') {
        action = 'auto_quota'
        check_type = 'cir'
      }
      if (this.form_config_auto_quota.action === 'auto_quota_roi') {
        action = 'auto_quota'
        check_type = 'roi'
      }
      if (this.form_config_auto_quota.action === 'auto_quota_exclude_cancelled_roi') {
        action = 'auto_quota'
        check_type = 'exclude_cancelled_roi'
      }

      this.form_config_auto_quota.data.push({
        config_id: make_uuid(),
        start_time: this.form_config_auto_quota.start_time,
        end_time: this.form_config_auto_quota.end_time,
        daily_quota: this.form_config_auto_quota.daily_quota,
        total_quota: this.form_config_auto_quota.total_quota,
        cir_quota: this.form_config_auto_quota.cir_quota,
        active_day: this.form_config_auto_quota.active_day,
        start: this.form_config_auto_quota.start,
        max: this.form_config_auto_quota.max,
        auto_type: this.form_config_auto_quota.auto_type,
        auto_value: this.form_config_auto_quota.auto_value,
        action: action,
        check_type: check_type
      })

      Object.assign(this.form_config_auto_quota, {
        config_id: null,
        start_time: '',
        end_time: '',
        // action: 'daily_quota',
        // action2: 'nothing',
        daily_quota: null,
        total_quota: null,
        cir_quota: null,
      })
    },

    m__show_config_multiple_auto_quota_dialog() {
      if (!this.check_role(this.shop, 'keyword_ads', 'auto_campaign')) {
        return
      }

      Object.assign(this.form_config_auto_quota, {
        start_time: '',
        end_time: '',
        action: 'daily_quota',
        daily_quota: null,
        total_quota: null,
        action2: 'nothing',
        alwaysOngoing: false,
      })

      this.form_config_auto_quota.campaign_ids = this.c__show_filter_campaign_list.filter(i => i.checked).map(i => i.campaign.campaignid)
      this.show_dialog.config_auto_quota = true
    },

    m__show_config_auto_quota_dialog(campaign) {
      this.selected_campaign = campaign

      if (!this.check_role(this.shop, 'keyword_ads', 'auto_campaign')) {
        return
      }

      Object.assign(this.form_config_auto_quota, {
        start_time: '',
        end_time: '',
        action: 'daily_quota',
        daily_quota: null,
        total_quota: null,
        action2: 'nothing',
        alwaysOngoing: false,
      })

      if (campaign.auto_quota) {
        this.form_config_auto_quota.data = JSON.parse(campaign.auto_quota.data)
        this.form_config_auto_quota.action2 = campaign.auto_quota.action2
        this.form_config_auto_quota.mode = campaign.auto_quota.mode
        this.form_config_auto_quota.cir = campaign.auto_quota.cir
        this.form_config_auto_quota.start = campaign.auto_quota.start
        this.form_config_auto_quota.max = campaign.auto_quota.max
        this.form_config_auto_quota.alwaysOngoing = campaign.auto_quota.alwaysOngoing
        this.form_config_auto_quota.spike_cir = campaign.auto_quota.spikeCir
        this.form_config_auto_quota.spike_start = campaign.auto_quota.spikeStart
        this.form_config_auto_quota.spike_max = campaign.auto_quota.spikeMax
        this.form_config_auto_quota.auto_type = campaign.auto_quota.autoType || 'auto'
        this.form_config_auto_quota.auto_value = campaign.auto_quota.autoValue
        this.form_config_auto_quota.spike_auto_type = campaign.auto_quota.spikeAutoType || 'auto'
        this.form_config_auto_quota.spike_auto_value = campaign.auto_quota.spikeAutoValue
        this.form_config_auto_quota.check_type = campaign.auto_quota.checkType || 'cir'
        this.form_config_auto_quota.spike_check_type = campaign.auto_quota.spikeCheckType || 'cir'
        if (!campaign.auto_quota.mode) {
          this.form_config_auto_quota.mode = 'manual'
        }
      }

      this.form_config_auto_quota.campaign_ids = [campaign.campaign.campaignid]
      this.show_dialog.config_auto_quota = true
    },

    m__show_set_ads_position_type_dialog() {
      if (!this.shopee_shop.selected) {
        return
      }

      if (!this.shop.extra_data.ads_position_type) {
        this.ads_position_type = 'exact'
      } else {
        this.ads_position_type = this.shop.extra_data.ads_position_type
      }

      this.show_dialog.set_ads_position_type = true
    },

    async m__set_ads_position_type() {
      this.shop.extra_data.ads_position_type = this.ads_position_type
      this.shop.extra_data = _omit(this.shop.extra_data,
        ['wrong_pwd', 'is_needed_otp', 'is_error_api', 'is_banned', 'is_need_ivs', 'too_frequent'])
      await this.$http.post(this.API.shopee_manager__add_shop, {
        _id: this.shop._id,
        username: this.shop.username,
        password: this.shop.password,
        shop_id: this.shop.shop_id.toString(),
        cookie: this.shop.cookie,
        device_id: this.shop.device_id,
        pin_password: this.shop.pin_password,
        channel: this.shop.channel,
        name: this.shop.name,
        token: this.shop.token,
        extra_data: this.shop.extra_data,
      }, this.cf())

      this.ntf_s(this.$t('base.update_success'))
      this.show_dialog.set_ads_position_type = false
    },

    m__get_suggestion_keyword(keyword) {
      return new Promise(resolve => {
        this.$http.get(this.API.marketing_get_suggest.replace('_keyword', keyword), this.cf()).then(resp => {
          let data = resp.body.data
          resolve(data.toplevel.CompleteSuggestion.map(e => e.suggestion['@data']))
        }).catch(() => resolve([keyword]))
      })
    },

    m__show_config_anti_click_by_suggest() {
      this.show_dialog.config_anti_click_by_suggest = true
    },

    m__show_config_auto_position_by_suggest() {
      this.show_dialog.config_auto_position_by_suggest = true
    },

    async m__update_multiple_keyword_price() {

      if (this.form_update_multiple_keyword_price.update_type === 1) {
        if (!this.form_update_multiple_keyword_price.update_by_cost_value) {
          this.ntf_w(this.$t('base.y_gt_x', {
            y: this.$t('base.bid_price'),
            x: '0',
          }))
          return
        }
      }

      if (this.form_update_multiple_keyword_price.update_type === 2) {
        if (!this.form_update_multiple_keyword_price.update_by_percent_value) {
          this.ntf_w(this.$t('base.y_gt_x', {
            y: this.$t('base.bid_price'),
            x: '0',
          }))
          return
        }
      }

      if (this.form_update_multiple_keyword_price.update_type === 3) {
        if (!this.form_update_multiple_keyword_price.update_by_suggest_cost_value) {
          this.ntf_w(this.$t('base.y_gt_x', {
            y: this.$t('base.bid_price'),
            x: '0',
          }))
          return
        }
      }

      if (this.form_update_multiple_keyword_price.update_type === 4) {
        if (!this.form_update_multiple_keyword_price.update_by_suggest_percent_value) {
          this.ntf_w(this.$t('base.y_gt_x', {
            y: this.$t('base.bid_price'),
            x: '0',
          }))
          return
        }
      }

      if (this.form_update_multiple_keyword_price.update_type === 5) {
        if (!this.form_update_multiple_keyword_price.cost_value) {
          this.ntf_w(this.$t('base.y_gt_x', {
            y: this.$t('base.bid_price'),
            x: '0',
          }))
          return
        }
      }

      try {
        await this.$confirm(this.$t('base.update_bid_price_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning',
        })
      } catch (e) {
        return
      }

      this.loading.update_multiple_keyword_price = true

      try {
        for (const campaign of this.c__show_filter_campaign_list.filter(i => i.checked)) {
          await this.m__renew_campaign(campaign)

          // todo: keywords
          const keywords_placement = campaign.advertisements.find(i => [0, 3].includes(i.placement))
          if (keywords_placement && keywords_placement.extinfo && keywords_placement.extinfo.keywords) {
            const checked_list = []
            if (this.form_update_multiple_keyword_price.keyword_types.includes('exact')) {
              checked_list.push(...keywords_placement.extinfo.keywords.filter(i => i.match_type === 0))
            }
            if (this.form_update_multiple_keyword_price.keyword_types.includes('broad')) {
              checked_list.push(...keywords_placement.extinfo.keywords.filter(i => i.match_type === 1))
            }

            const old_keyword = this.clone(checked_list)

            if (this.form_update_multiple_keyword_price.update_type === 1) {
              checked_list.forEach(i => {
                if (this.form_update_multiple_keyword_price.update_by_cost === 'increase') {
                  i.price = this.m__calculate(i.price) +
                    this.m__calculate(this.form_update_multiple_keyword_price.update_by_cost_value)

                  const max = +this.form_update_multiple_keyword_price.update_by_cost_value_max
                  if (max && max < i.price) i.price = max
                }

                if (this.form_update_multiple_keyword_price.update_by_cost === 'reduce') {
                  i.price = this.m__calculate(i.price) -
                    this.m__calculate(this.form_update_multiple_keyword_price.update_by_cost_value)

                  const min = +this.form_update_multiple_keyword_price.update_by_cost_value_min
                  if (min && min > i.price) i.price = min
                }
              })
            }

            if (this.form_update_multiple_keyword_price.update_type === 2) {
              checked_list.forEach(i => {
                if (this.form_update_multiple_keyword_price.update_by_percent === 'increase') {
                  i.price = this.m__calculate(i.price) + (this.m__calculate(i.price) *
                    this.m__calculate(this.form_update_multiple_keyword_price.update_by_percent_value) / 100)

                  const max = +this.form_update_multiple_keyword_price.update_by_percent_value_max
                  if (max && max < i.price) i.price = max
                }

                if (this.form_update_multiple_keyword_price.update_by_percent === 'reduce') {
                  i.price = this.m__calculate(i.price) - (this.m__calculate(i.price) *
                    this.m__calculate(this.form_update_multiple_keyword_price.update_by_percent_value) / 100)

                  const min = +this.form_update_multiple_keyword_price.update_by_percent_value_min
                  if (min && min > i.price) i.price = min
                }
              })
            }

            if (this.form_update_multiple_keyword_price.update_type === 3) {
              checked_list.forEach(i => {
                const temp = this.form_update_multiple_keyword_price.type === 'suggest'
                  ? i.recommend_price
                  : (+i.report.atosa_cpc || 400)

                if (this.form_update_multiple_keyword_price.update_by_suggest_cost === 'increase') {
                  i.price = temp +
                    this.m__calculate(this.form_update_multiple_keyword_price.update_by_suggest_cost_value)
                }

                if (this.form_update_multiple_keyword_price.update_by_suggest_cost === 'reduce') {
                  i.price = temp -
                    this.m__calculate(this.form_update_multiple_keyword_price.update_by_suggest_cost_value)
                }
              })
            }

            if (this.form_update_multiple_keyword_price.update_type === 4) {
              checked_list.forEach(i => {
                const temp = this.form_update_multiple_keyword_price.type === 'suggest'
                  ? i.recommend_price
                  : (+i.report.atosa_cpc || 400)

                if (this.form_update_multiple_keyword_price.update_by_suggest_percent === 'increase') {
                  i.price = temp +
                    (temp * this.m__calculate(this.form_update_multiple_keyword_price.update_by_suggest_percent_value) /
                      100)
                } else {
                  i.price = temp -
                    (temp * this.m__calculate(this.form_update_multiple_keyword_price.update_by_suggest_percent_value) /
                      100)
                }
              })
            }

            if (this.form_update_multiple_keyword_price.update_type === 5) {
              checked_list.forEach(i => {
                i.price = this.m__calculate(this.form_update_multiple_keyword_price.cost_value)
              })
            }

            if (this.form_update_multiple_keyword_price.update_type === 6) {
              checked_list.forEach(i => {
                i.price = this.form_update_multiple_keyword_price.type === 'suggest'
                  ? i.recommend_price
                  : (+i.report.atosa_cpc || 400)
              })
            }

            checked_list.forEach(i => {
              this.m__prefix_keyword_price(i)
            })

            const campaign_type = get_shopee_campaign_type(keywords_placement)
            await this.sp_user.marketing_pas_update_keyword_price(campaign.campaign.campaignid, checked_list,
              campaign_type)

            const keyword_list = []
            for (const old of old_keyword) {
              const found = checked_list.find(i => i.keyword === old.keyword)
              if (found) {
                keyword_list.push({
                  keyword: old.keyword,
                  oldPrice: this.m__calculate(campaign),
                  newPrice: this.m__calculate(found.price),
                  recommendPrice: this.m__calculate(found.recommend_price),
                  report: found.report ? JSON.stringify(found.report) : '',
                })
              }
            }
            this.m__save_update_keyword_log(keyword_list, campaign, this.form_update_multiple_keyword_price).catch(console.error)
          }

          // todo: targeting
          const targeting_placements = campaign.advertisements.filter(i => [1, 2, 5].includes(i.placement))
          for (const ads of targeting_placements) {
            let placement
            if (ads.placement === 2) placement = 'daily_discover'
            if (ads.placement === 5) placement = 'you_may_also_like'

            if (placement && this.form_update_multiple_keyword_price.keyword_types.includes(placement)) {
              let price = +ads.extinfo.target.price

              if (this.form_update_multiple_keyword_price.update_type === 1 &&
                this.form_update_multiple_keyword_price.update_by_cost === 'increase') {
                price += +this.form_update_multiple_keyword_price.update_by_cost_value

                const max = +this.form_update_multiple_keyword_price.update_by_cost_value_max
                if (max && max < price) price = max
              }
              if (this.form_update_multiple_keyword_price.update_type === 1 &&
                this.form_update_multiple_keyword_price.update_by_cost === 'reduce') {
                price -= +this.form_update_multiple_keyword_price.update_by_cost_value

                const min = +this.form_update_multiple_keyword_price.update_by_cost_value_min
                if (min && min > price) price = min
              }

              if (this.form_update_multiple_keyword_price.update_type === 2 &&
                this.form_update_multiple_keyword_price.update_by_percent === 'increase') {
                const value = this.m__calculate(
                  this.percent_of(this.form_update_multiple_keyword_price.update_by_percent_value, price))
                price += value

                const max = +this.form_update_multiple_keyword_price.update_by_percent_value_max
                if (max && max < price) price = max
              }
              if (this.form_update_multiple_keyword_price.update_type === 2 &&
                this.form_update_multiple_keyword_price.update_by_percent === 'reduce') {
                const value = this.m__calculate(
                  this.percent_of(this.form_update_multiple_keyword_price.update_by_percent_value, price))
                price -= value

                const min = +this.form_update_multiple_keyword_price.update_by_percent_value_min
                if (min && min > price) price = min
              }

              if (this.form_update_multiple_keyword_price.update_type === 5) {
                price = this.form_update_multiple_keyword_price.cost_value
              }

              if (+price < this.TARGETING_MIN) price = this.TARGETING_MIN

              ads.extinfo.target.price = price

              const body = {
                campaign_id: campaign.campaign.campaignid,
                type: 'change_display_location',
                header: {},
                change_display_location: {
                  bid_price: Math.trunc(price * 100000),
                  place: placement,
                  state: ads.status === 1 ? 'active' : 'inactive',
                },
              }
              await this.sp_user.marketing_pas_update_campaign(body)
            }
          }

          // todo: target roas
          if (this.form_update_multiple_keyword_price.keyword_types.includes('target_roas') &&
            campaign.campaign.bidding_type === 'roi_two') {
            let price = campaign.campaign.roi_two_target
            console.log('price', price)

            if (this.form_update_multiple_keyword_price.update_type === 1 &&
              this.form_update_multiple_keyword_price.update_by_cost === 'increase') {
              price += +this.form_update_multiple_keyword_price.update_by_cost_value

              const max = +this.form_update_multiple_keyword_price.update_by_cost_value_max
              if (max && max < price) price = max
            }
            if (this.form_update_multiple_keyword_price.update_type === 1 &&
              this.form_update_multiple_keyword_price.update_by_cost === 'reduce') {
              price -= +this.form_update_multiple_keyword_price.update_by_cost_value

              const min = +this.form_update_multiple_keyword_price.update_by_cost_value_min
              if (min && min > price) price = min
            }

            if (this.form_update_multiple_keyword_price.update_type === 2 &&
              this.form_update_multiple_keyword_price.update_by_percent === 'increase') {
              const value = this.m__calculate(
                this.percent_of(this.form_update_multiple_keyword_price.update_by_percent_value, price))
              price += value

              const max = +this.form_update_multiple_keyword_price.update_by_percent_value_max
              if (max && max < price) price = max
            }
            if (this.form_update_multiple_keyword_price.update_type === 2 &&
              this.form_update_multiple_keyword_price.update_by_percent === 'reduce') {
              const value = this.m__calculate(
                this.percent_of(this.form_update_multiple_keyword_price.update_by_percent_value, price))
              price -= value

              const min = +this.form_update_multiple_keyword_price.update_by_percent_value_min
              if (min && min > price) price = min
            }

            if (this.form_update_multiple_keyword_price.update_type === 5) {
              price = this.form_update_multiple_keyword_price.cost_value
            }

            if (price > 0 && price < 1) price = 1
            if (price > 50) price = 50

            if (price === 0) campaign.campaign.subtype = 'product_homepage__roi_two__simple'
            if (price > 0) campaign.campaign.subtype = 'product_homepage__roi_two__target'

            const update_response = await this.sp_user.marketing_pas_update_campaign({
              campaign_id: campaign.campaign.campaignid,
              header: {},
              reference_id: make_uuid(),
              type: 'change_roi_two_target',
              change_roi_two_target: {
                log_key: null,
                target_value: Math.trunc(price * 100000),
              },
            }, campaign.campaign.shopee_type)
            if (update_response && update_response.code === 0) {
              campaign.campaign.roi_two_target = price
            }
          }
        }

        this.ntf_s(this.$t('base.update_success'))
        this.show_dialog.update_multiple_keyword_price = false
        this.show_dialog.update_multiple_target_roas = false
      } catch (e) {
        console.error(e)
      } finally {
        this.loading.update_multiple_keyword_price = false
      }
    },

    m__prefix_keyword_price(keyword, placement = 0) {
      if (!keyword.price) keyword.price = 400

      if (placement === 0) {
        if (keyword.match_type === 0 && keyword.price < this.MATCH_TYPE_0_MIN) {
          keyword.price = this.MATCH_TYPE_0_MIN
        }
        if (keyword.match_type === 1 && keyword.price < this.MATCH_TYPE_1_MIN) {
          keyword.price = this.MATCH_TYPE_1_MIN
        }
      } else {
        if (keyword.match_type === 0 && keyword.price < this.SHOP_ADS_MATCH_TYPE_0_MIN) {
          keyword.price = this.SHOP_ADS_MATCH_TYPE_0_MIN
        }
        if (keyword.match_type === 1 && keyword.price < this.SHOP_ADS_MATCH_TYPE_1_MIN) {
          keyword.price = this.SHOP_ADS_MATCH_TYPE_1_MIN
        }
      }
    },

    async m__save_update_keyword_log(keyword_list, campaign, config = null) {
      const start_time = this.dayjs().startOf('day')
      const end_time = this.dayjs().endOf('day')

      const placement_found = campaign.advertisements.find(i => [0, 3].includes(i.placement))
      const campaign_type = get_shopee_campaign_type(placement_found)

      const [campaign_report_resp, ads_report_resp, shop_report_resp, ads_report_resp_v2, campaign_report_resp_v2] = await Promise.all(
        [
          // this.sp_user.marketing_detail_report_by_time(start_time.toDate(), end_time.toDate(), '[0,4]', campaign.product.itemid, null),
          // this.sp_user.marketing_homepage_report_by_time(start_time.toDate(), end_time.toDate(), '[0,3,4]'),
          { data: null },
          { data: null },
          this.sp_user.dashboard__key_metrics(start_time.unix(), end_time.unix(), 'real_time'),
          this.sp_user.marketing_get_time_graph('search', start_time.unix(), end_time.unix(), {}),
          this.sp_user.marketing_get_time_graph(campaign_type, start_time.unix(), end_time.unix(),
            { campaign_id: campaign.campaign.campaignid }),
        ])

      const form = {
        keywords: keyword_list,
        mipeeUserId: this.$store.state.userInfo.username,
        campaignId: campaign.campaign.campaignid,
        shopMetrics: JSON.stringify(shop_report_resp.result),
        adsMetrics: ads_report_resp.data ? JSON.stringify(ads_report_resp.data.data) : '',
        campaignReport: campaign_report_resp.data ? JSON.stringify(campaign_report_resp.data.data) : '',
        config: config ? JSON.stringify(config) : null,
        adsMetricsV2: ads_report_resp_v2.data ? JSON.stringify(ads_report_resp_v2.data) : '',
        campaignReportV2: campaign_report_resp_v2.data ? JSON.stringify(campaign_report_resp_v2.data) : '',
      }
      this.$http.post(this.API.URL_API_SRV_1 + '/lg/2.1', form, this.cf()).catch(console.error)
    },

    m__show_update_multiple_keyword_price() {
      if (!this.check_role(this.shop, 'keyword_ads', 'update_keyword')) {
        return
      }

      if (this.form_update_multiple_keyword_price.keyword_types.includes('target_roas')) {
        this.form_update_multiple_keyword_price.keyword_types = ['exact', 'broad', 'daily_discover', 'you_may_also_like']
      }

      this.show_dialog.update_multiple_keyword_price = true
    },

    m__show_update_multiple_target_roas() {
      if (!this.check_role(this.shop, 'keyword_ads', 'update_keyword')) {
        return
      }

      if (!this.form_update_multiple_keyword_price.keyword_types.includes('target_roas')) {
        this.form_update_multiple_keyword_price.keyword_types = ['target_roas']
      }

      this.show_dialog.update_multiple_target_roas = true
    },

    async m__confirm_update_multiple_advanced() {
      if (!this.form_config_auto_position.advanced_days.length) {
        this.ntf_w(this.$t('required.add_advanced_config'))
        return
      }

      if (!this.m__check_advanced_times(this.form_config_auto_position.advanced_times)) {
        this.ntf_w(this.$t('required.select_runtime'))
        return
      }

      try {
        this.loading.update_multiple_max_price = true

        await this.$confirm(this.$t('base.save_config_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning',
        })
      } catch (e) {
        return
      }

      this.loading.auto_position_advanced_multiple = true
      try {
        for (const campaign of this.c__show_filter_campaign_list.filter(i => i.checked)) {
          const auto_position_response = await this.$http.get(this.API.URL_API_SRV_1 + '/auto_position/v2/detail', {
            ...this.cf(),
            params: {
              mipeeUserId: this.$store.state.userInfo.username,
              campaignId: campaign.campaign.campaignid,
            },
          })

          if (auto_position_response.body && auto_position_response.body.length) {
            const form = []
            for (const item of auto_position_response.body) {
              const max_price = +item.maxPrice

              const advanced_times = this.clone(this.form_config_auto_position.advanced_times)
              const advanced_days = this.clone(this.form_config_auto_position.advanced_days)

              for (const advanced_item of advanced_days) {
                if (advanced_item.max_type === 'price') {
                  advanced_item.max_price = max_price + +advanced_item.max_price
                }
                if (advanced_item.max_type === 'percent') {
                  const percent = this.m__calculate(+advanced_item.max_price * max_price / 100)
                  advanced_item.max_price = max_price + percent
                }
              }
              const advancedTimes = advanced_times.map(i => `${i.advanced_start_time}-${i.advanced_end_time}`)
              const advancedDays = advanced_days.map(i => JSON.stringify(i))

              form.push({
                id: item.id,
                advancedTimes,
                advancedDays,
              })
            }
            await this.$http.post(this.API.URL_API_SRV_1 + '/auto_position/v2/max_price', {
              data: form,
            }, this.cf())
          }
        }
        this.ntf_s(this.$t('base.update_success'))
        this.show_dialog.auto_position_advanced_multiple = false
      } catch (e) {
        console.error(e)
        this.ntf_w(this.$t('base.has_an_occurred'))
      } finally {
        this.loading.auto_position_advanced_multiple = false
      }
    },

    m__show_config_multiple_advanced() {
      this.show_dialog.auto_position_advanced_multiple = true
    },

    async m__get_spike_days() {
      const resp = await this.$http.get(this.API.URL_API_SRV_2 + '/shopee/spike_days', this.cf())
      this.spike_days = resp.body.data
    },

    async m__change_agency_file_id() {
      this.agency_file_selected = this.agency_files.find(i => i.id === this.agency_file_id_selected)

      if (this.agency_file_selected && this.agency_file_selected.dataProduct) {
        const data = JSON.parse(this.agency_file_selected.dataProduct)

        for (const item of data) {
          const found = this.c__show_filter_campaign_list.find(i => i.product.itemid === item.id)
          if (found) {
            const data_found = item.data.find(i => i.time === this.dayjs().format('DD/MM/YYYY'))
            if (data_found) {
              found.plan = data_found
              for (const child of found.children) {
                child.plan = data_found
              }
            }
          }
        }
      } else {
        for (const campaign of this.campaign_list) {
          campaign.plan = null

          if (campaign.children) {
            for (const child of campaign.children) {
              child.plan = null
            }
          }
        }
      }
    },

    async m__get_agency_file() {
      const send_request_list_resp = await this.$http.get(
        this.API.URL_API_SRV_2 + '/mipee/sub_account/send_request_list', this.cf())

      const mipeeUserIds = [
        this.$store.state.userInfo.username,
        ...send_request_list_resp.body.data.filter(i => i.status === 'accepted').map(i => i.request_user.username)].join(',')
      const resp = await this.$http.get(this.API.URL_API_SRV_1 + '/agency_file/list', {
        ...this.cf(),
        params: {
          mipeeUserId: this.$store.state.userInfo.username,
          mipeeUserIds,
        },
      })
      for (const item of resp.body) {
        item.loading = false
      }
      this.agency_files = resp.body.filter(
        i => this.$store.state.userInfo.username === 'vuducminhdev07' ? true : this.shopee_shop.list.some(
          ii => ii._id === i.shopId))
    },

    m__row_type_to_text(row) {
      return this.spike_day_to_text(this.spike_days, row)
    },

    m__show_update_multiple_max_price_dialog() {
      this.show_dialog.update_multiple_max_price = true
    },

    async m__confirm_update_multiple_max_price() {
      if (this.form_update_multiple_max_price.update_type === 1 &&
        !this.form_update_multiple_max_price.update_by_cost_value) {
        this.ntf_w(this.$t('input.amount'))
        return
      }

      if (this.form_update_multiple_max_price.update_type === 1 &&
        +this.form_update_multiple_max_price.update_by_cost_value <= 0) {
        this.ntf_w(this.$t('base.y_gt_x', {
          y: this.$t('base.amount'),
          x: '0',
        }))
        return
      }

      if (this.form_update_multiple_max_price.update_type === 2 &&
        !this.form_update_multiple_max_price.update_by_percent_value) {
        this.ntf_w(this.$t('input.percent'))
        return
      }

      if (this.form_update_multiple_max_price.update_type === 2 &&
        +this.form_update_multiple_max_price.update_by_percent_value <= 0) {
        this.ntf_w(this.$t('base.y_gt_x', {
          y: this.$t('base.percent'),
          x: '0',
        }))
        return
      }

      if (this.form_update_multiple_max_price.update_type === 5 && !this.form_update_multiple_max_price.cost_value) {
        this.ntf_w(this.$t('required.max_bid_price'))
        return
      }

      if (this.form_update_multiple_max_price.update_type === 6 && !this.form_update_multiple_max_price.date_range) {
        this.ntf_w(this.$t('required.configuration_active_day'))
        return
      }

      try {
        this.loading.update_multiple_max_price = true

        await this.$confirm(this.$t('base.save_config_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning',
        })

        try {
          for (const campaign of this.c__show_filter_campaign_list.filter(i => i.checked)) {
            const auto_position_response = await this.$http.get(this.API.URL_API_SRV_1 + '/auto_position/v2/detail', {
              ...this.cf(),
              params: {
                mipeeUserId: this.$store.state.userInfo.username,
                campaignId: campaign.campaign.campaignid,
              },
            })

            if (auto_position_response.body && auto_position_response.body.length) {
              const keyword_cpc = []
              if (this.form_update_multiple_max_price.update_type === 6) {
                const start_time = this.dayjs(this.form_update_multiple_max_price.date_range[0])
                const end_time = this.dayjs(this.form_update_multiple_max_price.date_range[1])
                const new_response = await this.sp_user.marketing_get_report('keyword', 'product', start_time.unix(),
                  end_time.unix(), { campaign_id: campaign.campaign.campaignid })
                const report_response = this.m__map_search_report_by_key(new_response)
                for (const item of report_response.data) {
                  if (+item.click) {
                    keyword_cpc.push({
                      keyword: item.keyword,
                      atosa_cpc: this.m__calculate(+item.cost / +item.click),
                    })
                  }
                }
              }

              const form = []
              for (const item of auto_position_response.body) {
                let max_price = +item.maxPrice

                if (this.form_update_multiple_max_price.update_type === 1 &&
                  this.form_update_multiple_max_price.update_by_cost === 'increase') {
                  max_price += +this.form_update_multiple_max_price.update_by_cost_value
                }
                if (this.form_update_multiple_max_price.update_type === 1 &&
                  this.form_update_multiple_max_price.update_by_cost === 'reduce') {
                  max_price -= +this.form_update_multiple_max_price.update_by_cost_value
                }

                if (this.form_update_multiple_max_price.update_type === 2 &&
                  this.form_update_multiple_max_price.update_by_percent === 'increase') {
                  const value = this.m__calculate(
                    max_price * +this.form_update_multiple_max_price.update_by_percent_value / 100)
                  max_price += value
                }
                if (this.form_update_multiple_max_price.update_type === 2 &&
                  this.form_update_multiple_max_price.update_by_percent === 'reduce') {
                  const value = this.m__calculate(
                    max_price * +this.form_update_multiple_max_price.update_by_percent_value / 100)
                  max_price -= value
                }

                if (this.form_update_multiple_max_price.update_type === 5) {
                  max_price = +this.form_update_multiple_max_price.cost_value
                }

                if (this.form_update_multiple_max_price.update_type === 6) {
                  const found = keyword_cpc.find(i => i.keyword === item.keyword)
                  if (found) max_price = found.atosa_cpc
                }

                form.push({
                  id: item.id,
                  maxPrice: max_price,
                })
              }

              await this.$http.post(this.API.URL_API_SRV_1 + '/auto_position/v2/max_price', {
                data: form,
              }, this.cf())
            }
          }
          this.ntf_s(this.$t('base.update_success'))
          this.show_dialog.update_multiple_max_price = false
        } catch (e) {
          console.error(e)
          this.ntf_w(this.$t('base.has_an_occurred'))
        }
      } catch (e) {
      } finally {
        this.loading.update_multiple_max_price = false
      }
    },

    m__suggest_advanced() {
      this.form_config_auto_position.advanced_max_value = this.form_config_auto_position.maxValue
      if (this.form_config_auto_position.maxPrice) {
        const random = Math.round(Math.random() * (26 - 13 + 1)) + 13
        const add_random = parseFloat(`1.${random}`)
        this.form_config_auto_position.advanced_max_price = this.m__calculate(
          this.form_config_auto_position.maxPrice * add_random)
      }
    },

    m__add_advanced_day() {
      if (!this.form_config_auto_position.advanced_day) {
        this.ntf_w(this.$t('select.active_day'))
        return
      }
      if (!this.form_config_auto_position.advanced_max_value) {
        this.ntf_w(this.$t('required.bonus_amount'))
        return
      }
      if (!this.form_config_auto_position.advanced_max_price) {
        this.ntf_w(this.$t('required.max_bid_price'))
        return
      }

      if (!this.m__check_advanced_times(this.form_config_auto_position.advanced_times)) {
        this.ntf_w(this.$t('required.select_runtime'))
        return
      }

      if (['flash_sale', 'remain'].includes(this.form_config_auto_position.advanced_day)) {
        if (this.form_config_auto_position.advanced_days.some(
          i => i.type === this.form_config_auto_position.advanced_day)) {
          this.ntf_w(this.$t('base.runtime_is_used'))
          return
        }

        this.form_config_auto_position.advanced_days.push({
          type: this.form_config_auto_position.advanced_day,
          day_number: null,
          max_value: this.form_config_auto_position.advanced_max_value,
          max_price: this.form_config_auto_position.advanced_max_price,
          start_price: this.form_config_auto_position.advanced_start_price,
          max_type: this.form_config_auto_position.advanced_max_type,
          times: this.form_config_auto_position.advanced_times.map(
            i => `${i.advanced_start_time}-${i.advanced_end_time}`),
        })

        this.form_config_auto_position.advanced_day = ''
        this.form_config_auto_position.advanced_day_number = null
        this.form_config_auto_position.advanced_max_value = null
        this.form_config_auto_position.advanced_max_price = null
        this.form_config_auto_position.advanced_start_price = null
      } else if (this.form_config_auto_position.advanced_day === 'mini_spike_day') {
        if (this.form_config_auto_position.advanced_days.some(i => i.type === 'mini_spike_day')) {
          this.ntf_w(this.$t('base.runtime_is_used'))
          return
        }

        this.form_config_auto_position.advanced_days.push({
          type: 'mini_spike_day',
          day_number: null,
          max_value: this.form_config_auto_position.advanced_max_value,
          max_price: this.form_config_auto_position.advanced_max_price,
          start_price: this.form_config_auto_position.advanced_start_price,
          max_type: this.form_config_auto_position.advanced_max_type,
          times: this.form_config_auto_position.advanced_times.map(
            i => `${i.advanced_start_time}-${i.advanced_end_time}`),
        })

        this.form_config_auto_position.advanced_day = ''
        this.form_config_auto_position.advanced_day_number = null
        this.form_config_auto_position.advanced_max_value = null
        this.form_config_auto_position.advanced_max_price = null
        this.form_config_auto_position.advanced_start_price = null
      } else {
        if (!this.form_config_auto_position.advanced_day_number) {
          this.ntf_w(this.$t('required.specific_day'))
          return
        }
        if (this.form_config_auto_position.advanced_days.some(
          i => i.type === this.form_config_auto_position.advanced_day && i.day_number ===
            this.form_config_auto_position.advanced_day_number)) {
          return
        }

        this.form_config_auto_position.advanced_days.push({
          type: this.form_config_auto_position.advanced_day,
          day_number: this.form_config_auto_position.advanced_day_number,
          max_value: this.form_config_auto_position.advanced_max_value,
          max_price: this.form_config_auto_position.advanced_max_price,
          start_price: this.form_config_auto_position.advanced_start_price,
          max_type: this.form_config_auto_position.advanced_max_type,
          times: this.form_config_auto_position.advanced_times.map(
            i => `${i.advanced_start_time}-${i.advanced_end_time}`),
        })

        this.form_config_auto_position.advanced_day = ''
        this.form_config_auto_position.advanced_day_number = null
        this.form_config_auto_position.advanced_max_value = null
        this.form_config_auto_position.advanced_max_price = null
        this.form_config_auto_position.advanced_start_price = null
      }
    },

    m__remove_advanced_day(index) {
      this.form_config_auto_position.advanced_days.splice(index, 1)
    },

    m__edit_advanced_day(index) {
      const [data] = this.form_config_auto_position.advanced_days.splice(index, 1)

      this.form_config_auto_position.advanced_day = data.type
      this.form_config_auto_position.advanced_day_number = data.day_number
      this.form_config_auto_position.advanced_max_value = data.max_value
      this.form_config_auto_position.advanced_max_price = data.max_price
      this.form_config_auto_position.advanced_start_price = data.start_price
      this.form_config_auto_position.advanced_max_type = data.max_type
      this.form_config_auto_position.advanced_times = data.times.map(i => {
        return {
          advanced_start_time: i.split('-')[0],
          advanced_end_time: i.split('-')[1],
        }
      })

      this.scroll_to_top_element('#auto-position-advanced > .el-dialog')
    },

    async m__save_config_auto_campaign() {
      if (!this.m__check_times(this.form_config_auto_campaign.times)) {
        this.ntf_w(this.$t('required.select_runtime'))
        return
      }

      if (this.form_config_auto_campaign.stop_action === 2 && !this.form_config_auto_campaign.stop_action_2) {
        this.ntf_w(this.$t('required.percent_of_recommend_price'))
        return
      }

      if (this.form_config_auto_campaign.stop_action === 3 && !this.form_config_auto_campaign.stop_action_3) {
        this.ntf_w(this.$t('required.bid_price'))
        return
      }

      try {
        this.loading.config_auto_campaign = true
        await this.$confirm(this.$t('ads.just_select_only_one_2'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning',
        })

        try {
          for (const campaign of this.c__show_filter_campaign_list.filter(i => i.checked)) {
            await this.m__fix_missing_keywords(campaign)

            const placement0 = campaign.advertisements.find(i => i.placement === 0)
            if (placement0 && placement0.extinfo.keywords.length) {
              const keyword_list = placement0.extinfo.keywords.map(i => i.keyword)
              const form = {
                keywords: keyword_list,
                mipeeUserId: this.$store.state.userInfo.username,
                campaignId: campaign.campaign.campaignid,
                shopId: this.shop._id,
                times: this.form_config_auto_campaign.times.map(i => {
                  return {
                    startTime: i.start_time,
                    endTime: i.end_time,
                  }
                }),
                quotaType: this.form_config_auto_campaign.quota_type,
                reduceValue: this.form_config_auto_campaign.reduce_value,
                increaseValue: this.form_config_auto_campaign.increase_value,
                note: '',
                state: 'RUNNING',
                notExceed2: this.form_config_auto_campaign.not_exceed_2,
                notExceed2Value: this.form_config_auto_campaign.not_exceed_2_value,
                notExceed3: this.form_config_auto_campaign.not_exceed_3,
                notExceed3Value: this.form_config_auto_campaign.not_exceed_3_value,
                notExceed4: this.form_config_auto_campaign.not_exceed_4,
                notExceed4Value: this.form_config_auto_campaign.not_exceed_4_value,
                notExceed5: this.form_config_auto_campaign.not_exceed_5,
                notExceed5Value: this.form_config_auto_campaign.not_exceed_5_value,
                notExceed6: this.form_config_auto_campaign.not_exceed_6,
                notExceed6Value: this.form_config_auto_campaign.not_exceed_6_value,
                stopAction: this.form_config_auto_campaign.stop_action,
                stopAction2: this.form_config_auto_campaign.stop_action_2,
                stopAction3: this.form_config_auto_campaign.stop_action_3,
                isCPC: this.form_config_auto_campaign.type === 'cpc',
                cpcTime: this.form_config_auto_campaign.time,
                configStatus: 1,
              }

              await this.$http.post(this.API.URL_API_SRV_1 + '/auto_campaigns/v2', form, this.cf())
              await this.$http.post(this.API.URL_API_SRV_1 + '/auto_position/v2/delete/multiple', {
                mipeeUserId: this.$store.state.userInfo.username,
                campaignId: campaign.campaign.campaignid,
                keywords: keyword_list,
              }, this.cf())
              await this.$http.post(this.API.URL_API_SRV_1 + '/auto_cir/status', {
                mipeeUserId: this.$store.state.userInfo.username,
                campaignId: campaign.campaign.campaignid,
                keywords: keyword_list,
                status: 0,
              }, this.cf())
            }
          }

          this.ntf_s(this.$t('base.update_success'))
          this.show_dialog.config_auto_campaign = false
        } catch (e) {
          console.error(e)
          this.ntf_w(this.$t('base.has_an_occurred'))
        }
      } catch (e) {
      } finally {
        this.loading.config_auto_campaign = false
      }
    },

    async m__save_config_auto_position() {
      if (!this.m__check_times(this.form_config_auto_position.times)) {
        this.ntf_w(this.$t('required.select_runtime'))
        return
      }

      if (this.form_config_auto_position.type === 1 &&
        (!this.form_config_auto_position.fromValue || !this.form_config_auto_position.toValue)) {
        this.ntf_w(this.$t('required.full_data'))
        return
      }

      if (this.form_config_auto_position.type === 2 && !this.form_config_auto_position.upValue) {
        this.ntf_w(this.$t('required.full_data'))
        return
      }

      if (this.form_config_auto_position.type === 3 && !this.form_config_auto_position.downValue) {
        this.ntf_w(this.$t('required.full_data'))
        return
      }

      if (!this.form_config_auto_position.maxPrice) {
        this.ntf_w(this.$t('required.max_bid_price'))
        return
      }

      if (this.form_config_auto_position.stop_action === 2 && !this.form_config_auto_position.stop_action_2) {
        this.ntf_w(this.$t('required.percent_of_recommend_price'))
        return
      }

      if (this.form_config_auto_position.stop_action === 3 && !this.form_config_auto_position.stop_action_3) {
        this.ntf_w(this.$t('required.bid_price'))
        return
      }

      this.loading.auto_position = true
      try {
        await this.$confirm(this.$t('ads.just_select_only_one_3'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning',
        })

        for (const campaign of this.c__show_filter_campaign_list.filter(i => i.checked)) {
          if (campaign.campaign.type === 'all') {
            await this.m__fix_missing_keywords(campaign)
          }
          if (campaign.campaign.type === 'keyword') {
            await this.m__fix_missing_keywords(campaign)
          }
          if (campaign.campaign.type === 'targeting') {
            await this.m__fix_missing_placement(campaign)
          }

          const placement0 = campaign.advertisements.find(i => i.placement === 0)
          if (placement0 && placement0.extinfo.keywords.length) {
            const keyword_list = this.form_config_auto_position.exact_only
              ? placement0.extinfo.keywords.filter(i => i.match_type === 0).map(i => i.keyword)
              : placement0.extinfo.keywords.map(i => i.keyword)

            await this.$http.post(this.API.URL_API_SRV_1 + '/auto_position/v2', {
              ...this.form_config_auto_position,
              keywords: keyword_list,
              mipeeUserId: this.$store.state.userInfo.username,
              campaignId: campaign.campaign.campaignid,
              shopId: this.shop._id,
              times: this.form_config_auto_position.times.map(i => {
                i.startTime = i.start_time
                i.endTime = i.end_time
                return i
              }),
              stopAction: this.form_config_auto_position.stop_action,
              stopAction2: this.form_config_auto_position.stop_action_2,
              stopAction3: this.form_config_auto_position.stop_action_3,

              advanced: this.form_config_auto_position.advanced,
              advancedTimes: this.form_config_auto_position.advanced_times.map(
                i => `${i.advanced_start_time}-${i.advanced_end_time}`),
              advancedDays: this.form_config_auto_position.advanced_days.map(i => JSON.stringify(i)),

              device: this.form_config_auto_position.device,
              reduceIf: this.form_config_auto_position.reduce_if,
              configStatus: 1,
            }, this.cf())

            await this.$http.post(this.API.URL_API_SRV_1 + '/auto_campaigns/v2/delete/multiple', {
              mipeeUserId: this.$store.state.userInfo.username,
              campaignId: campaign.campaign.campaignid,
              keywords: keyword_list,
            }, this.cf())
            await this.$http.post(this.API.URL_API_SRV_1 + '/auto_cir/status', {
              mipeeUserId: this.$store.state.userInfo.username,
              campaignId: campaign.campaign.campaignid,
              keywords: keyword_list,
              status: 0,
            }, this.cf())
          }

          const placement2 = campaign.advertisements.find(i => i.placement === 2)
          if (placement2) {
            await this.$http.post(this.API.URL_API_SRV_1 + '/targeting_auto_position', {
              ...this.form_config_auto_position,
              mipeeUserId: this.$store.state.userInfo.username,
              campaignId: campaign.campaign.campaignid,
              shopId: this.shop._id,
              times: this.form_config_auto_position.times.map(i => {
                i.startTime = i.start_time
                i.endTime = i.end_time
                return i
              }),
              placements: [2, 5],
              stopAction: this.form_config_auto_position.stop_action,
              stopAction2: this.form_config_auto_position.stop_action_2,
              stopAction3: this.form_config_auto_position.stop_action_3,
              device: this.form_config_auto_position.device,
              reduceIf: this.form_config_auto_position.reduce_if,
              configStatus: 1,
            }, this.cf())
          }
        }

        this.ntf_s(this.$t('base.update_success'))
        this.show_dialog.config_auto_campaign = false
      } catch (e) {
        console.error(e)
      } finally {
        this.loading.auto_position = false
      }
    },

    m__confirm_advanced() {
      if (!this.form_config_auto_position.advanced_times || !this.form_config_auto_position.advanced_times.length) {
        this.ntf_w(this.$t('required.select_advanced_runtime'))
        return
      }

      this.show_dialog.auto_position_advanced = false
    },

    m__show_advanced_dialog() {
      this.show_dialog.auto_position_advanced = true
    },

    async m__show_config_auto_campaign_multiple() {
      if (!this.check_role(this.shop, 'keyword_ads', 'auto_campaign')) {
        return
      }

      this.show_dialog.config_auto_campaign = true
      this.config_tab = 2
    },

    m__product_sort_change({
                             prop,
                             order,
                           }) {
      this.product_not_campaign_list = JSON.parse(JSON.stringify(this.product_not_campaign_list_clone))

      if (order === null) {
        return
      }

      order === 'ascending' &&
      (this.product_not_campaign_list = _orderBy(this.product_not_campaign_list, [prop], ['asc']))
      order === 'descending' &&
      (this.product_not_campaign_list = _orderBy(this.product_not_campaign_list, [prop], ['desc']))
    },

    m__is_allow_keyword_tool() {
      const extent_package = this.$store.state.package.extend_package ? this.$store.state.package.extend_package.find(
        i => i.channel === 'shopee_marketing') : null
      if (extent_package) {
        return !!(this.dayjs().isBefore(this.dayjs(new Date(extent_package.license_to)), 's') &&
          extent_package.package.extra_data && extent_package.package.extra_data.marketing &&
          extent_package.package.extra_data.marketing.keyword_tool)
      } else {
        return false
      }
    },

    m__child_change_state(state) {
      if (this.selected_campaign) {
        this.selected_campaign.campaign.state = state
      }
    },

    async m__reload_saved_keyword() {
      await this.m__get_keyword_file()
    },

    async m__get_keyword_file() {
      const response = await this.$http.get(this.API.marketing.keyword_file.list, this.cf())
      this.keyword_file_list = response.body.data
    },

    m__select_top_100_keywords() {
      this.EB.$emit('m__select_top_100_keywords')
    },

    m__uncheck_all_keywords() {
      this.EB.$emit('m__uncheck_all_keywords')
    },

    m__export_excel() {
      this.loading.export_excel = true
      this.EB.$emit('m__export_excel_keyword')
      this.loading.export_excel = false
    },

    m__add_to_recent_keyword(keyword_file) {
      this.keyword_manager.show = false

      for (const item of keyword_file.keyword_json) {
        const selected_item = this.selected_keyword.find(i => i.keyword === item.keyword)
        if (selected_item) {
          Object.assign(selected_item, { ...item })
        } else {
          this.selected_keyword.push(item)
        }
      }
    },

    m__try_add_item_key(keyword) {
      let new_keyword = JSON.parse(JSON.stringify(keyword))
      if (new_keyword.item) {
        this.selected_keyword.push({
          ...new_keyword.item,
          price: new_keyword.item.sp_price,
        })
      } else {
        this.selected_keyword.push({
          ...new_keyword,
          price: new_keyword.sp_price,
        })
      }

      if (keyword.move) {
        this.fff_tab = 2
      }
    },

    m__add_selected_keyword() {
      this.add_keyword.show = false
      let keyword_text_list = this.selected_keyword.map(e => e.keyword)
      this.c__add_keyword__data_checked.forEach(e => {
        if (!keyword_text_list.includes(e.keyword)) {
          this.m__try_add_item_key(e)
        }
      })
    },

    m__initial_save_keyword_file() {
      if (this.selected_keyword.length > 0) {
        this.save_keyword_file.filename = `${this.$t(
          'keyword.file')} ${this.selected_keyword[0].keyword} (${this.selected_keyword.length} ${this.$t(
          'base.keyword')} - ${this.$t('base.at')} ${this.timeFormat(new Date())})`
        this.save_keyword_file.show = true
      } else {
        this.ntf_w(this.$t('keyword.empty_to_save'))
      }
    },

    async m__search_sp_keyword(keyword) {
      this.add_keyword.data = []

      const search_keyword = keyword && keyword.value ? keyword.value : this.keyword
      if (!search_keyword) return

      const campaign = this.c__show_filter_campaign_list.find(i => i.checked && i.product && i.product.itemid)
      if (campaign) {
        let suggest_keywords_resp = await this.sp_user.marketing_suggest_keywords(search_keyword,
          campaign.product.itemid)
        while (!suggest_keywords_resp || !suggest_keywords_resp.data) {
          await this.sleep(1000)
          suggest_keywords_resp = await this.sp_user.marketing_suggest_keywords(search_keyword, campaign.product.itemid)
        }

        for (const item of suggest_keywords_resp.data) {
          this.add_keyword.data.push({
            ...item,
            checked: false,
            sp_volume: item.search_volume,
            sp_price: this.m__calculate(item.recommend_price),
          })
        }
      } else {
        let suggest_keywords_resp = await this.sp_user.shop_ads_search_keywords(search_keyword)
        while (!suggest_keywords_resp || !suggest_keywords_resp.data) {
          await this.sleep(1000)
          suggest_keywords_resp = await this.sp_user.shop_ads_search_keywords(search_keyword)
        }

        for (const item of suggest_keywords_resp.data) {
          this.add_keyword.data.push({
            ...item,
            checked: false,
            sp_volume: item.search_volume,
            sp_price: this.m__calculate(item.recommend_price),
          })
        }
        this.add_keyword.data.forEach(e => {
          this.m__get_sp_keyword_info(e)
        })
      }
    },

    async m__get_sp_keyword_info(keyword) {
      try {
        try {
          const temp_product = this.c__show_filter_campaign_list.find(i => i.checked && i.product && i.product.itemid)
          const info = temp_product
            ? await this.sp_user.marketing_get_keyword_volume(keyword.keyword, temp_product.product.itemid)
            : await this.sp_user.marketing_get_keyword_volume(keyword.keyword, null, '3')
          if (info !== null) {
            keyword.sp_volume = info.search_volume
            keyword.sp_price = this.m__calculate(info.recommend_price)
          }
        } catch (e) {
        }
      } catch (e) {
      }
    },

    m__try_save_keyword_file() {
      this.confirm(this.$t('keyword.confirm_save_file_x_name', { x: this.save_keyword_file.filename }), () => {
        this.save_keyword_file.loading = true

        const source = 'added_keywords'

        this.$http.post(this.API.marketing.keyword_file.add, {
          filename: this.save_keyword_file.filename,
          keyword_json: this[source].map(i => {
            return {
              checked: true,
              keyword: i.keyword,
              keyword_source_type: 0,
              price: i.price || i.recommend_price,
              record_type: 0,
              rnum: 0,
              sp_price: i.price || i.recommend_price,
              sp_volume: 0,
            }
          }),
        }, this.cf()).then(async (resp) => {
          this.ntf_s(resp)
          this.save_keyword_file.loading = false
          this.save_keyword_file.show = false

          this.$emit('m__reload_saved_keyword')
        }).catch(error => {
          console.log(error)
          this.ntf_w(error)
          this.save_keyword_file.loading = false
        })
      })
    },

    m__apply_config_for_new_price() {
      this.selected_keyword.forEach(e => {
        let start_value = this.change_price.apply_field === 'sp_price' ? e.sp_price : e.price
        let func_value = this.change_price.type === 'PERCENT' ? this.m__calculate(
          start_value / 100 * this.change_price.percent) : this.change_price.value
        let result = start_value + (this.change_price.func === 'ADD' ? func_value : 0) -
          (this.change_price.func === 'SUB' ? func_value : 0)
        e.price = result < 0 ? 0 : result
      })
      this.ntf_s('Đã áp dụng giá mới')
      this.change_price.show = false
    },

    async m__confirm_show_add_campaign_dialog() {
      if (!this.product_not_campaign_list.filter(i => i.checked).length) {
        this.ntf_w(this.$t('required.select_products_for_creating_ad'))
        return
      }
      this.show_dialog.add_new_campaign = false
      this.current_component = 'create'
      this.EB.$emit('product_selector_change')
    },

    async m__on_change_type_product() {
      if (this.type_product === 'shop_category') {
        const response = await this.sp_user.get_product_by_shop_category(this.selected_shop_category)
        this.product_list = this.product_not_campaign_list.filter(i => response.data.result.find(is => is.id === i.id))
      } else {
        this.product_list = JSON.parse(JSON.stringify(this.product_not_campaign_list))
      }
    },

    async m__get_keyword_file_detail() {
      const response = await this.$http.get(
        this.API.marketing.keyword_file.detail.replace('_id', this.selected_keyword_file), this.cf())
      for (const i of response.body.data.keyword_json) {
        this.m__get_keyword_sp_info(i).catch(console.error)
      }
      this.mipee_suggest_keywords = response.body.data.keyword_json
    },

    async m__get_keyword_sp_info(keyword) {
      try {
        if (keyword.sp_volume) {
          keyword.now_volume = keyword.sp_volume
          keyword.recommend_price = keyword.now_price = this.m__calculate(keyword.sp_price)
        } else {
          const temp_product = this.c__show_filter_campaign_list.find(i => i.product && i.product.itemid && i.checked)
          const info = temp_product
            ? await this.sp_user.marketing_get_keyword_volume(keyword.keyword, temp_product.product.itemid)
            : await this.sp_user.marketing_get_keyword_volume(keyword.keyword, null, null, '3')
          keyword.now_volume = keyword.sp_volume = info.search_volume
          keyword.recommend_price = keyword.now_price = keyword.sp_price = this.m__calculate(info.recommend_price)
        }
      } catch (error) {
        console.log(error)
      }
    },

    m__show_config_anti_click() {
      if (!this.c__show_filter_campaign_list.filter(i => i.checked).length) {
        this.ntf_w(this.$t('required.select_product'))
        return
      }

      this.show_dialog.config_anti_click = true
      this.config_tab = 4
    },

    async m__confirm_update_anti_click() {
      if (this.form_anti_click.type === '1') {
        if (!this.form_anti_click.ratio || this.form_anti_click.ratio < 0) {
          this.ntf_w(this.$t('base.y_gt_x', {
            y: this.$t('base.expected_cir'),
            x: '0',
          }))
          return
        }

        if (!this.form_anti_click.click_minimum_number || this.form_anti_click.click_minimum_number < 1) {
          this.ntf_w(this.$t('base.y_gt_x', {
            y: this.$t('base.min_clicks'),
            x: '0',
          }))
          return
        }

        if (!this.form_anti_click.click_maximum_number || this.form_anti_click.click_maximum_number < 1) {
          this.ntf_w(this.$t('base.y_gt_x', {
            y: this.$t('base.max_clicks'),
            x: '0',
          }))
          return
        }
      } else {
        if (!this.form_anti_click.cir || this.form_anti_click.cir < 0) {
          this.ntf_w(this.$t('base.y_gt_x', {
            y: this.$t('base.ratio'),
            x: '0',
          }))
          return
        }

        if (this.form_anti_click.time_type === 'custom') {
          if (!this.form_anti_click.start_time) {
            this.ntf_w(this.$t('required.start_time'))
            return
          }
          if (!this.form_anti_click.end_time) {
            this.ntf_w(this.$t('required.end_time'))
            return
          }
        }
      }

      if (this.form_anti_click.detect_type === 2 && !this.form_anti_click.detect_value_2) {
        this.ntf_w(this.$t('required.percent'))
        return
      }

      if (this.form_anti_click.detect_type === 3 && !this.form_anti_click.detect_value_3) {
        this.ntf_w(this.$t('required.bid_price'))
        return
      }

      if (this.form_anti_click.not_order &&
        (!this.form_anti_click.min_cost || this.m__calculate(this.form_anti_click.min_cost) === 0)) {
        this.ntf_w(this.$t('required.max_cost_if_gmv_by_0'))
        return
      }

      if (this.form_anti_click.not_order && !this.form_anti_click.min_cost) {
        await this.$confirm(this.$t('ads.anti_click_label.confirm_1'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning',
        })
      } else if (this.form_anti_click.not_order && this.form_anti_click.min_cost < 1000) {
        await this.$confirm(this.$t('ads.anti_click_label.confirm_2'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning',
        })
      }

      try {
        await this.$confirm(this.$t('base.save_config_confirm'), this.$t('base.attention'), {
          type: 'warning',
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
        })
      } catch (e) {
        return
      }

      this.loading.config_anti_click = true

      try {
        for (const campaign of this.c__show_filter_campaign_list.filter(i => i.checked)) {
          if (campaign.campaign.type === 'keyword') {
            await this.m__fix_missing_keywords(campaign)
          }
          if (campaign.campaign.type === 'shop') {
            await this.m__fix_missing_keywords(campaign)
          }
          if (campaign.campaign.type === 'targeting') {
            await this.m__fix_missing_placement(campaign)
          }

          const placement_0_3 = campaign.advertisements.find(i => i.placement === 0 || i.placement === 3)
          if (placement_0_3 && placement_0_3.extinfo.keywords.length) {
            const form = {
              keywords: placement_0_3.extinfo.keywords.map(i => i.keyword),
              shopId: this.shop._id,
              mipeeUserId: this.$store.state.userInfo.username,
              campaignId: campaign.campaign.campaignid,
              clickNumber: this.form_anti_click.click_number,
              orderAmount: this.form_anti_click.order_amount,
              ratio: this.form_anti_click.type === '1' ? this.form_anti_click.ratio : null,
              clickMinimumNumber: this.form_anti_click.click_minimum_number,
              clickMaximumNumber: this.form_anti_click.click_maximum_number,
              detectType: this.form_anti_click.detect_type,
              detectValue2: this.form_anti_click.detect_value_2,
              detectValue3: this.form_anti_click.detect_value_3,
              cir: this.form_anti_click.type === '2' ? this.form_anti_click.cir : null,
              timeType: this.form_anti_click.time_type,
              startTime: this.form_anti_click.start_time
                ? this.dayjs(this.form_anti_click.start_time).toISOString()
                : '',
              endTime: this.form_anti_click.end_time ? this.dayjs(this.form_anti_click.end_time).toISOString() : '',
              minCost: this.form_anti_click.not_order ? (this.form_anti_click.min_cost || 0) : null,
              maxCost: this.form_anti_click.max_cost,
              isDirectCir: this.form_anti_click.is_direct_cir,
            }
            await this.$http.post(this.API.URL_API_SRV_1 + '/anti_click/v2', form)
          }

          const placement2 = campaign.advertisements.find(i => i.placement === 2)
          if (placement2) {
            const form = {
              placements: [2, 5],
              shopId: this.shop._id,
              mipeeUserId: this.$store.state.userInfo.username,
              campaignId: campaign.campaign.campaignid,
              clickNumber: this.form_anti_click.click_number,
              orderAmount: this.form_anti_click.order_amount,
              ratio: this.form_anti_click.type === '1' ? this.form_anti_click.ratio : null,
              clickMinimumNumber: this.form_anti_click.click_minimum_number,
              clickMaximumNumber: this.form_anti_click.click_maximum_number,
              detectType: this.form_anti_click.detect_type,
              detectValue2: this.form_anti_click.detect_value_2,
              detectValue3: this.form_anti_click.detect_value_3,
              cir: this.form_anti_click.type === '2' ? this.form_anti_click.cir : null,
              timeType: this.form_anti_click.time_type,
              startTime: this.form_anti_click.start_time
                ? this.dayjs(this.form_anti_click.start_time).toISOString()
                : '',
              endTime: this.form_anti_click.end_time ? this.dayjs(this.form_anti_click.end_time).toISOString() : '',
              minCost: this.form_anti_click.not_order ? (this.form_anti_click.min_cost || 0) : null,
              maxCost: this.form_anti_click.max_cost,
              isDirectCir: this.form_anti_click.is_direct_cir,
            }
            await this.$http.post(this.API.URL_API_SRV_1 + '/targeting_anti_click', form)
          }
        }
      } catch (e) {
        console.error(e)
      }

      this.ntf_s(this.$t('base.save_config_success'))
      this.show_dialog.config_anti_click = false
      this.loading.config_anti_click = false
    },

    m__add_optimize_advanced_day_targeting() {
      if (!this.form_config_auto_optimize_targeting.advanced_day) {
        this.ntf_w(this.$t('select.active_day'))
        return
      }
      if (!this.form_config_auto_optimize_targeting.advanced_cir) {
        this.ntf_w(this.$t('required.expected_cir'))
        return
      }

      if (!this.form_config_auto_optimize_targeting.advanced_max_price) {
        this.ntf_w(this.$t('required.max_bid_price'))
        return
      }

      if (!this.form_config_auto_optimize_targeting.advanced_max_cost) {
        this.ntf_w(this.$t('required.max_cost_if_gmv_by_0'))
        return
      }

      if (!this.m__check_advanced_times(this.form_config_auto_optimize_targeting.advanced_times)) {
        this.ntf_w(this.$t('required.select_runtime'))
        return
      }

      if (['mini_spike_day', 'flash_sale', 'remain'].includes(this.form_config_auto_optimize_targeting.advanced_day)) {
        if (this.form_config_auto_optimize_targeting.advanced_days.some(
          i => i.type === this.form_config_auto_optimize_targeting.advanced_day)) {
          this.ntf_w(this.$t('base.runtime_is_used'))
          return
        }

        this.form_config_auto_optimize_targeting.advanced_days.push({
          ...this.clone(_omit(this.form_config_auto_optimize_targeting, ['advanced_days', 'advanced_times'])),
          type: this.form_config_auto_optimize_targeting.advanced_day,
          day_number: null,
          cir: this.form_config_auto_optimize_targeting.advanced_cir,
          cir_type: this.form_config_auto_optimize_targeting.advanced_cir_type,
          price: this.form_config_auto_optimize_targeting.advanced_price,
          max_price: this.form_config_auto_optimize_targeting.advanced_max_price,
          min_price: this.form_config_auto_optimize_targeting.advanced_min_price,
          start_price: this.form_config_auto_optimize_targeting.advanced_start_price,
          max_type: this.form_config_auto_optimize_targeting.advanced_max_type,
          max_cost: this.form_config_auto_optimize_targeting.advanced_max_cost,
          max_cost_type: this.form_config_auto_optimize_targeting.advanced_max_cost_type,
          max_cost_value: this.form_config_auto_optimize_targeting.advanced_max_cost_value,
          times: this.form_config_auto_optimize_targeting.advanced_times.map(
            i => `${i.advanced_start_time}-${i.advanced_end_time}`),
        })

        this.form_config_auto_optimize_targeting.advanced_day = ''
        this.form_config_auto_optimize_targeting.advanced_day_number = null
        this.form_config_auto_optimize_targeting.advanced_cir = null
        this.form_config_auto_optimize_targeting.advanced_price = null
        this.form_config_auto_optimize_targeting.advanced_max_price = null
        this.form_config_auto_optimize_targeting.advanced_min_price = null
        this.form_config_auto_optimize_targeting.advanced_start_price = null
        this.form_config_auto_optimize_targeting.advanced_max_cost = null
        this.form_config_auto_optimize_targeting.advanced_times = []
      } else {
        if (!this.form_config_auto_optimize_targeting.advanced_day_number) {
          this.ntf_w(this.$t('required.specific_day'))
          return
        }
        if (this.form_config_auto_optimize_targeting.advanced_days.some(
          i => i.type === this.form_config_auto_optimize_targeting.advanced_day && i.day_number ===
            this.form_config_auto_optimize_targeting.advanced_day_number)) {
          this.ntf_w(this.$t('required.specific_day'))
          return
        }

        this.form_config_auto_optimize_targeting.advanced_days.push({
          ...this.clone(_omit(this.form_config_auto_optimize_targeting, ['advanced_days', 'advanced_times'])),
          type: this.form_config_auto_optimize_targeting.advanced_day,
          day_number: this.form_config_auto_optimize_targeting.advanced_day_number,
          cir: this.form_config_auto_optimize_targeting.advanced_cir,
          cir_type: this.form_config_auto_optimize_targeting.advanced_cir_type,
          price: this.form_config_auto_optimize_targeting.advanced_price,
          max_price: this.form_config_auto_optimize_targeting.advanced_max_price,
          min_price: this.form_config_auto_optimize_targeting.advanced_min_price,
          start_price: this.form_config_auto_optimize_targeting.advanced_start_price,
          max_type: this.form_config_auto_optimize_targeting.advanced_max_type,
          max_cost: this.form_config_auto_optimize_targeting.advanced_max_cost,
          max_cost_type: this.form_config_auto_optimize_targeting.advanced_max_cost_type,
          max_cost_value: this.form_config_auto_optimize_targeting.advanced_max_cost_value,
          times: this.form_config_auto_optimize_targeting.advanced_times.map(
            i => `${i.advanced_start_time}-${i.advanced_end_time}`),
        })

        this.form_config_auto_optimize_targeting.advanced_day = ''
        this.form_config_auto_optimize_targeting.advanced_day_number = null
        this.form_config_auto_optimize_targeting.advanced_cir = null
        this.form_config_auto_optimize_targeting.advanced_price = null
        this.form_config_auto_optimize_targeting.advanced_max_price = null
        this.form_config_auto_optimize_targeting.advanced_min_price = null
        this.form_config_auto_optimize_targeting.advanced_start_price = null
        this.form_config_auto_optimize_targeting.advanced_max_cost = null
        this.form_config_auto_optimize_targeting.advanced_times = []
      }
    },

    m__edit_optimize_advanced_day_targeting(index) {
      const [data] = this.form_config_auto_optimize_targeting.advanced_days.splice(index, 1)

      Object.assign(this.form_config_auto_optimize_targeting, _omit(data, ['advanced_days']))
      this.form_config_auto_optimize_targeting.advanced_day = data.type
      this.form_config_auto_optimize_targeting.advanced_day_number = data.day_number
      this.form_config_auto_optimize_targeting.advanced_cir = data.cir
      this.form_config_auto_optimize_targeting.advanced_cir_type = data.cir_type
      this.form_config_auto_optimize_targeting.advanced_price = data.price
      this.form_config_auto_optimize_targeting.advanced_max_price = data.max_price || data.max_price_0 || data.max_price_1
      this.form_config_auto_optimize_targeting.advanced_min_price = data.min_price
      this.form_config_auto_optimize_targeting.advanced_start_price = data.start_price
      this.form_config_auto_optimize_targeting.advanced_max_type = data.max_type
      this.form_config_auto_optimize_targeting.advanced_max_cost = data.max_cost
      this.form_config_auto_optimize_targeting.advanced_max_cost_type = data.max_cost_type || 'value'
      this.form_config_auto_optimize_targeting.advanced_max_cost_value = data.max_cost_value || 0
      this.form_config_auto_optimize_targeting.advanced_times = data.times.map(i => {
        return {
          advanced_start_time: i.split('-')[0],
          advanced_end_time: i.split('-')[1],
        }
      })

      this.scroll_to_top_element('#targeting-auto-optimize > .el-dialog')
    },

    m__remove_optimize_advanced_day_targeting(index) {
      this.form_config_auto_optimize_targeting.advanced_days.splice(index, 1)
    },

    async m__update_config_auto_optimize_targeting() {
      if (!this.form_config_auto_optimize_targeting.advanced_days ||
        !this.form_config_auto_optimize_targeting.advanced_days.length) {
        return this.ntf_w(this.$t('required.add_config'))
      }

      try {
        await this.$confirm(this.$t('base.save_config_confirm'), this.$t('base.attention'), {
          type: 'warning',
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
        })
      } catch (e) {
        return
      }

      const source = this.selected_campaign
        ? [this.selected_campaign]
        : this.c__show_filter_campaign_list.filter(i => i.checked)

      this.loading.config_auto_optimize = true
      try {
        for (const campaign of source) {
          await this.$http.post(this.API.URL_API_SRV_1 + '/targeting_auto_optimize', {
            shopId: this.shop._id,
            mipeeUserId: this.$store.state.userInfo.username,
            campaignId: campaign.campaign.campaignid,
            campaignType: 'targeting',
            maxCir: this.form_config_auto_optimize_targeting.max_cir,
            cirType: this.form_config_auto_optimize_targeting.cir_type,
            maxCost: this.form_config_auto_optimize_targeting.max_cost,
            maxBasePrice: this.form_config_auto_optimize_targeting.max_base_price,
            advancedDays: this.form_config_auto_optimize_targeting.advanced_days.map(i => JSON.stringify(i)),
          }, this.cf())

          campaign.auto_optimize = campaign.auto_optimize_targeting = {
            maxCir: this.form_config_auto_optimize_targeting.max_cir,
            cirType: this.form_config_auto_optimize_targeting.cir_type,
            maxCost: this.form_config_auto_optimize_targeting.max_cost,
            maxBasePrice: this.form_config_auto_optimize_targeting.max_base_price,
            advancedDays: this.form_config_auto_optimize_targeting.advanced_days.map(i => JSON.stringify(i)),
            campaignType: 'targeting',
          }
        }

        this.show_dialog.config_auto_optimize_targeting = false
        this.ntf_s(this.$t('base.save_config_success'))
      } catch (e) {
        console.error(e)
        this.ntf_w(e)
      } finally {
        this.loading.config_auto_optimize = false
      }
    },
  }
}
</script>

<style>
#old_actions {
  display: none;
}

#new_actions {
  display: block;
}
</style>
<style lang="scss" src="./style/index.scss"></style>




// WEBPACK FOOTER //
// src/pages/pas/campaign.vue